/*! For license information please see frontegg.production.min.js.LICENSE.txt */ !function(e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Frontegg = t() : e.Frontegg = t();
}(window, ()=>(()=>{
        var e = {
            3952: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createConditionEvaluator = void 0;
                const n = a(2904), s = a(9475);
                t.createConditionEvaluator = function(e) {
                    const t = (0, s.useSanitizer)(e.condition.op);
                    if (!t) return ()=>!1;
                    const { isSanitized: a, sanitizedValue: i } = t(e.condition.value);
                    if (!a || void 0 === i) return ()=>!1;
                    const o = (0, n.useOperation)(e.condition.op, i);
                    return (t)=>{
                        const a = t[e.condition.attribute];
                        if (void 0 === a || !o) return !1;
                        const { isValid: n } = o(a);
                        return e.condition.negate ? !n : n;
                    };
                };
            },
            9838: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(3952), t), s(a(963), t);
            },
            963: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            3998: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.evaluateFeatureFlag = void 0;
                const n = a(9243);
                t.evaluateFeatureFlag = function(e, t) {
                    if (!e.on) return {
                        treatment: e.offTreatment
                    };
                    const a = function(e, t) {
                        var a;
                        return null === (a = e.rules) || void 0 === a ? void 0 : a.find((e)=>(0, n.createRuleEvaluator)({
                                rule: e
                            })(t) === n.RuleEvaluationResultEnum.Treatable);
                    }(e, t);
                    return a ? {
                        treatment: a.treatment
                    } : {
                        treatment: e.defaultTreatment
                    };
                };
            },
            2152: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(3998), t);
            },
            5875: (e, t, a)=>{
                "use strict";
                t.Me = t.a_ = void 0;
                a(2152), a(3856), a(9243), a(2752);
                var n = a(7254);
                Object.defineProperty(t, "a_", {
                    enumerable: !0,
                    get: function() {
                        return n.evaluateIsEntitledToFeature;
                    }
                }), Object.defineProperty(t, "Me", {
                    enumerable: !0,
                    get: function() {
                        return n.evaluateIsEntitledToPermissions;
                    }
                });
            },
            6849: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BooleanOperationsMapper = void 0;
                const i = a(2752), o = a(6715);
                s(a(6715), t), s(a(4965), t), t.BooleanOperationsMapper = {
                    [i.OperationEnum.Is]: (e)=>(0, o.useIsOperation)(e)
                };
            },
            6715: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useIsOperation = void 0, t.useIsOperation = function(e) {
                    return (t)=>({
                            isValid: t === e.boolean
                        });
                };
            },
            4965: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BooleanSanitizersMapper = t.singleBooleanSanitizer = void 0;
                const n = a(2752);
                t.singleBooleanSanitizer = (e)=>{
                    const t = void 0 !== e.boolean && ((e)=>"boolean" == typeof e)(e.boolean) ? {
                        boolean: e.boolean
                    } : void 0;
                    return {
                        isSanitized: !!t,
                        sanitizedValue: t
                    };
                }, t.BooleanSanitizersMapper = {
                    [n.OperationEnum.Is]: t.singleBooleanSanitizer
                };
            },
            2904: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useOperation = void 0;
                const n = a(5018), s = a(3922), i = a(3147), o = a(6849), r = {
                    ...n.StringOperationsMapper,
                    ...s.NumericOperationsMapper,
                    ...i.DateOperationsMapper,
                    ...o.BooleanOperationsMapper
                };
                t.useOperation = function(e, t) {
                    const a = r[e];
                    return a ? a(t) : void 0;
                };
            },
            9475: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useSanitizer = void 0;
                const n = a(6849), s = a(1016), i = a(6891), o = a(3922), r = {
                    ...s.StringSanitizersMapper,
                    ...o.NumericSanitizersMapper,
                    ...i.DateSanitizersMapper,
                    ...n.BooleanSanitizersMapper
                };
                t.useSanitizer = function(e) {
                    return r[e];
                };
            },
            3147: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.DateOperationsMapper = void 0;
                const i = a(2752), o = a(1641);
                s(a(1641), t), s(a(1626), t), t.DateOperationsMapper = {
                    [i.OperationEnum.On]: (e)=>(0, o.useDateOnOperation)(e),
                    [i.OperationEnum.OnOrAfter]: (e)=>(0, o.useDateOnOrAfterOperation)(e),
                    [i.OperationEnum.OnOrBefore]: (e)=>(0, o.useDateOnOrBeforeOperation)(e),
                    [i.OperationEnum.BetweenDate]: (e)=>(0, o.useDateBetweenOperation)(e)
                };
            },
            1641: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useDateBetweenOperation = t.useDateOnOrBeforeOperation = t.useDateOnOrAfterOperation = t.useDateOnOperation = void 0, t.useDateOnOperation = function(e) {
                    return (t)=>({
                            isValid: t.getTime() === e.date.getTime()
                        });
                }, t.useDateOnOrAfterOperation = function(e) {
                    return (t)=>({
                            isValid: t.getTime() >= e.date.getTime()
                        });
                }, t.useDateOnOrBeforeOperation = function(e) {
                    return (t)=>({
                            isValid: t.getTime() <= e.date.getTime()
                        });
                }, t.useDateBetweenOperation = function(e) {
                    return (t)=>({
                            isValid: t.getTime() >= e.start.getTime() && t.getTime() <= e.end.getTime()
                        });
                };
            },
            6891: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.DateSanitizersMapper = t.sanitizeDateRange = t.sanitizeSingleDate = t.isValidDate = t.sanitizeDateValue = void 0;
                const n = a(2752);
                t.sanitizeDateValue = (e)=>new Date(e), t.isValidDate = (e)=>e instanceof Date && !isNaN(e), t.sanitizeSingleDate = (e)=>{
                    const a = e.date ? (0, t.sanitizeDateValue)(e.date) : void 0, n = a && (0, t.isValidDate)(a) ? {
                        date: a
                    } : void 0;
                    return {
                        isSanitized: !!n,
                        sanitizedValue: n
                    };
                }, t.sanitizeDateRange = (e)=>{
                    const a = e.start ? (0, t.sanitizeDateValue)(e.start) : void 0, n = e.end ? (0, t.sanitizeDateValue)(e.end) : void 0, s = a && n && (0, t.isValidDate)(a) && (0, t.isValidDate)(n) ? {
                        start: a,
                        end: n
                    } : void 0;
                    return {
                        isSanitized: !!s,
                        sanitizedValue: s
                    };
                }, t.DateSanitizersMapper = {
                    [n.OperationEnum.On]: t.sanitizeSingleDate,
                    [n.OperationEnum.OnOrAfter]: t.sanitizeSingleDate,
                    [n.OperationEnum.OnOrBefore]: t.sanitizeSingleDate,
                    [n.OperationEnum.BetweenDate]: t.sanitizeDateRange
                };
            },
            1626: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            3922: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NumericOperationsMapper = void 0;
                const i = a(2752), o = a(9194);
                t.NumericOperationsMapper = {
                    [i.OperationEnum.Equal]: (e)=>(0, o.useEqualsOperation)(e),
                    [i.OperationEnum.GreaterThan]: (e)=>(0, o.useGreaterThanOperation)(e),
                    [i.OperationEnum.GreaterThanEqual]: (e)=>(0, o.useGreaterThanEqualOperation)(e),
                    [i.OperationEnum.LesserThan]: (e)=>(0, o.useLesserThanOperation)(e),
                    [i.OperationEnum.LesserThanEqual]: (e)=>(0, o.useLesserThanEqualOperation)(e),
                    [i.OperationEnum.BetweenNumeric]: (e)=>(0, o.useBetweenNumericOperation)(e)
                }, s(a(9194), t), s(a(5168), t), s(a(7695), t);
            },
            9194: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useBetweenNumericOperation = t.useLesserThanEqualOperation = t.useLesserThanOperation = t.useGreaterThanEqualOperation = t.useGreaterThanOperation = t.useEqualsOperation = void 0, t.useEqualsOperation = function(e) {
                    return (t)=>({
                            isValid: t === e.number
                        });
                }, t.useGreaterThanOperation = function(e) {
                    return (t)=>({
                            isValid: t > e.number
                        });
                }, t.useGreaterThanEqualOperation = function(e) {
                    return (t)=>({
                            isValid: t >= e.number
                        });
                }, t.useLesserThanOperation = function(e) {
                    return (t)=>({
                            isValid: t < e.number
                        });
                }, t.useLesserThanEqualOperation = function(e) {
                    return (t)=>({
                            isValid: t <= e.number
                        });
                }, t.useBetweenNumericOperation = function(e) {
                    return (t)=>({
                            isValid: t >= e.start && t <= e.end
                        });
                };
            },
            5168: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NumericSanitizersMapper = t.sanitizeNumericRange = t.sanitizeSingleNumber = void 0;
                const n = a(2752), s = (e)=>"number" == typeof e;
                t.sanitizeSingleNumber = (e)=>{
                    const t = void 0 !== e.number && s(e.number) ? {
                        number: e.number
                    } : void 0;
                    return {
                        isSanitized: !!t,
                        sanitizedValue: t
                    };
                }, t.sanitizeNumericRange = (e)=>{
                    const t = void 0 !== e.start && void 0 !== e.end && s(e.start) && s(e.end) ? {
                        start: e.start,
                        end: e.end
                    } : void 0;
                    return {
                        isSanitized: !!t,
                        sanitizedValue: t
                    };
                }, t.NumericSanitizersMapper = {
                    [n.OperationEnum.Equal]: t.sanitizeSingleNumber,
                    [n.OperationEnum.GreaterThan]: t.sanitizeSingleNumber,
                    [n.OperationEnum.GreaterThanEqual]: t.sanitizeSingleNumber,
                    [n.OperationEnum.LesserThan]: t.sanitizeSingleNumber,
                    [n.OperationEnum.LesserThanEqual]: t.sanitizeSingleNumber,
                    [n.OperationEnum.BetweenNumeric]: t.sanitizeNumericRange
                };
            },
            7695: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5018: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.StringOperationsMapper = void 0;
                const i = a(2752), o = a(5154);
                s(a(5154), t), s(a(4503), t), t.StringOperationsMapper = {
                    [i.OperationEnum.StartsWith]: (e)=>(0, o.useStartsWithOperation)(e),
                    [i.OperationEnum.EndsWith]: (e)=>(0, o.useEndsWithOperation)(e),
                    [i.OperationEnum.Contains]: (e)=>(0, o.useContainsOperation)(e),
                    [i.OperationEnum.InList]: (e)=>(0, o.useInListOperation)(e),
                    [i.OperationEnum.Matches]: (e)=>(0, o.useMatchesOperation)(e)
                };
            },
            5154: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useMatchesOperation = t.useInListOperation = t.useContainsOperation = t.useEndsWithOperation = t.useStartsWithOperation = void 0, t.useStartsWithOperation = function(e) {
                    return (t)=>({
                            isValid: e.list.some((e)=>t.startsWith(e))
                        });
                }, t.useEndsWithOperation = function(e) {
                    return (t)=>({
                            isValid: e.list.some((e)=>t.endsWith(e))
                        });
                }, t.useContainsOperation = function(e) {
                    return (t)=>({
                            isValid: e.list.some((e)=>t.includes(e))
                        });
                }, t.useInListOperation = function(e) {
                    return (t)=>({
                            isValid: e.list.includes(t)
                        });
                }, t.useMatchesOperation = function(e) {
                    return (t)=>{
                        let a;
                        try {
                            a = new RegExp(e.string);
                        } catch (e) {
                            return {
                                isValid: !1
                            };
                        }
                        return {
                            isValid: a.test(t)
                        };
                    };
                };
            },
            1016: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.StringSanitizersMapper = t.sanitizeListString = t.sanitizeSingleString = void 0;
                const n = a(2752), s = (e)=>"string" == typeof e;
                t.sanitizeSingleString = (e)=>{
                    const t = void 0 !== e.string && s(e.string) ? {
                        string: e.string
                    } : void 0;
                    return {
                        isSanitized: !!t,
                        sanitizedValue: t
                    };
                }, t.sanitizeListString = (e)=>{
                    const t = void 0 !== e.list && e.list.every((e)=>s(e)) ? {
                        list: e.list
                    } : void 0;
                    return {
                        isSanitized: !!t,
                        sanitizedValue: t
                    };
                }, t.StringSanitizersMapper = {
                    [n.OperationEnum.Matches]: t.sanitizeSingleString,
                    [n.OperationEnum.Contains]: t.sanitizeListString,
                    [n.OperationEnum.StartsWith]: t.sanitizeListString,
                    [n.OperationEnum.EndsWith]: t.sanitizeListString,
                    [n.OperationEnum.InList]: t.sanitizeListString
                };
            },
            4503: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            2752: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(7158), t);
            },
            7158: (e, t)=>{
                "use strict";
                var a;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.OperationEnum = void 0, (a = t.OperationEnum || (t.OperationEnum = {})).InList = "in_list", a.StartsWith = "starts_with", a.EndsWith = "ends_with", a.Contains = "contains", a.Matches = "matches", a.Equal = "equal", a.GreaterThan = "greater_than", a.GreaterThanEqual = "greater_than_equal", a.LesserThan = "lower_than", a.LesserThanEqual = "lower_than_equal", a.BetweenNumeric = "between_numeric", a.Is = "is", a.On = "on", a.BetweenDate = "between_date", a.OnOrAfter = "on_or_after", a.OnOrBefore = "on_or_before";
            },
            3856: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(6334), t);
            },
            6334: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.evaluatePlan = void 0;
                const n = a(9243);
                t.evaluatePlan = function(e, t) {
                    const a = function(e, t) {
                        var a;
                        return null === (a = e.rules) || void 0 === a ? void 0 : a.find((e)=>(0, n.createRuleEvaluator)({
                                rule: e
                            })(t) === n.RuleEvaluationResultEnum.Treatable);
                    }(e, t);
                    return a ? {
                        treatment: a.treatment
                    } : {
                        treatment: e.defaultTreatment
                    };
                };
            },
            9243: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(5546), t), s(a(4874), t);
            },
            4874: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createRuleEvaluator = void 0;
                const n = a(5546), s = a(9838);
                t.createRuleEvaluator = function(e) {
                    return (t)=>e.rule.conditions.every((e)=>(0, s.createConditionEvaluator)({
                                condition: e
                            })(t)) ? n.RuleEvaluationResultEnum.Treatable : n.RuleEvaluationResultEnum.Insufficient;
                };
            },
            5546: (e, t)=>{
                "use strict";
                var a, n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RuleEvaluationResultEnum = t.TreatmentEnum = t.ConditionLogicEnum = void 0, (t.ConditionLogicEnum || (t.ConditionLogicEnum = {})).And = "and", (n = t.TreatmentEnum || (t.TreatmentEnum = {})).True = "true", n.False = "false", (a = t.RuleEvaluationResultEnum || (t.RuleEvaluationResultEnum = {})).Treatable = "treatable", a.Insufficient = "insufficient";
            },
            7254: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(7416), t), s(a(3817), t), s(a(395), t), s(a(6816), t);
            },
            1711: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.directEntitlementEvalutor = void 0;
                const n = a(395);
                t.directEntitlementEvalutor = function(e, t, a = {}) {
                    const s = t.features[e];
                    let i = !1;
                    return s && null !== s.expireTime && (i = s.expireTime !== n.NO_EXPIRATION_TIME && s.expireTime < Date.now(), !i) ? {
                        isEntitled: !0
                    } : {
                        isEntitled: !1,
                        justification: i ? n.NotEntitledJustification.BUNDLE_EXPIRED : n.NotEntitledJustification.MISSING_FEATURE
                    };
                };
            },
            1343: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.featureFlagEvaluator = void 0;
                const n = a(395), s = a(2152), i = a(8552), o = a(9243);
                t.featureFlagEvaluator = function(e, t, a = {}) {
                    const r = t.features[e];
                    if (r && r.featureFlag) {
                        const e = (0, i.prepareAttributes)(a), { treatment: t } = (0, s.evaluateFeatureFlag)(r.featureFlag, e);
                        if (t === o.TreatmentEnum.True) return {
                            isEntitled: !0
                        };
                    }
                    return {
                        isEntitled: !1,
                        justification: n.NotEntitledJustification.MISSING_FEATURE
                    };
                };
            },
            2031: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getIsEntitledEvaluators = void 0;
                const n = a(1711), s = a(1343), i = a(3155);
                t.getIsEntitledEvaluators = function() {
                    return [
                        n.directEntitlementEvalutor,
                        s.featureFlagEvaluator,
                        i.planTargetingRulesEvalutor
                    ];
                };
            },
            3155: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.planTargetingRulesEvalutor = void 0;
                const n = a(395), s = a(8552), i = a(9243), o = a(3856);
                t.planTargetingRulesEvalutor = function(e, t, a = {}) {
                    const r = t.features[e];
                    if (r && r.planIds && r.planIds.length > 0) {
                        const e = (0, s.prepareAttributes)(a), n = t.plans;
                        for (const t of r.planIds){
                            const a = n[t];
                            if (a) {
                                const { treatment: t } = (0, o.evaluatePlan)(a, e);
                                if (t === i.TreatmentEnum.True) return {
                                    isEntitled: !0
                                };
                            }
                        }
                    }
                    return {
                        isEntitled: !1,
                        justification: n.NotEntitledJustification.MISSING_FEATURE
                    };
                };
            },
            7416: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(9398), t);
            },
            9398: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.evaluateIsEntitledToFeature = void 0;
                const n = a(395), s = a(6816), i = a(2031);
                t.evaluateIsEntitledToFeature = function(e, t, a = {}) {
                    if (!t) return {
                        isEntitled: !1,
                        justification: n.NotEntitledJustification.MISSING_FEATURE
                    };
                    const o = [];
                    for (const n of (0, i.getIsEntitledEvaluators)())if (o.push(n(e, t, a)), !(0, s.shouldContinue)(o)) break;
                    return (0, s.getResult)(o);
                };
            },
            3817: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(1474), t);
            },
            1474: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.evaluateIsEntitledToPermissions = void 0;
                const n = a(9398), s = a(395), i = a(6816), o = a(7943);
                t.evaluateIsEntitledToPermissions = function(e, t, a) {
                    if (!t) return {
                        isEntitled: !1,
                        justification: s.NotEntitledJustification.MISSING_PERMISSION
                    };
                    if (!(0, o.checkPermission)(t.permissions, e)) return {
                        isEntitled: !1,
                        justification: s.NotEntitledJustification.MISSING_PERMISSION
                    };
                    const r = function(e, t) {
                        return Object.keys(t.features).filter((a)=>t.features[a].linkedPermissions.includes(e));
                    }(e, t);
                    if (!r.length) return {
                        isEntitled: !0
                    };
                    const l = [];
                    for (const e of r)if (l.push((0, n.evaluateIsEntitledToFeature)(e, t, a)), !(0, i.shouldContinue)(l)) break;
                    return (0, i.getResult)(l);
                };
            },
            395: (e, t)=>{
                "use strict";
                var a;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NO_EXPIRATION_TIME = t.NotEntitledJustification = void 0, (a = t.NotEntitledJustification || (t.NotEntitledJustification = {})).MISSING_FEATURE = "MISSING_FEATURE", a.MISSING_PERMISSION = "MISSING_PERMISSION", a.BUNDLE_EXPIRED = "BUNDLE_EXPIRED", t.NO_EXPIRATION_TIME = -1;
            },
            8552: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.modifyObjectKeysWithPrefix = t.defaultFronteggAttributesMapper = t.prepareAttributes = void 0;
                const n = a(1857);
                function s(e) {
                    return {
                        email: e.email,
                        emailVerified: e.email_verified,
                        tenantId: e.tenantId,
                        userId: e.id
                    };
                }
                function i(e, t) {
                    return Object.keys(e).reduce((a, n)=>(a[`${t}${n}`] = e[n], a), {});
                }
                t.prepareAttributes = function(e = {}, t) {
                    const { custom: a = {}, jwt: o = {} } = e, r = (0, n.flatten)(o);
                    return {
                        ...a,
                        ...i(t ? t(o) : s(o), "frontegg."),
                        ...i(r, "jwt.")
                    };
                }, t.defaultFronteggAttributesMapper = s, t.modifyObjectKeysWithPrefix = i;
            },
            8843: (e, t, a)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.shouldContinue = t.getResult = void 0;
                const n = a(395);
                t.getResult = function(e) {
                    let t = !1;
                    for (const a of e){
                        if (a.isEntitled) return a;
                        a.justification === n.NotEntitledJustification.BUNDLE_EXPIRED && (t = !0);
                    }
                    return {
                        isEntitled: !1,
                        justification: t ? n.NotEntitledJustification.BUNDLE_EXPIRED : n.NotEntitledJustification.MISSING_FEATURE
                    };
                }, t.shouldContinue = function(e) {
                    return e.every(({ isEntitled: e })=>!e);
                };
            },
            1857: (e, t)=>{
                "use strict";
                function a(e) {
                    return e;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.flatten = void 0, t.flatten = function(e, t) {
                    const n = (null == (t = t || {}) ? void 0 : t.delimiter) || ".", s = null == t ? void 0 : t.maxDepth, i = (null == t ? void 0 : t.transformKey) || a, o = {};
                    return function e(a, r, l) {
                        l = l || 1, Object.keys(a).forEach(function(c) {
                            const u = a[c], d = (null == t ? void 0 : t.safe) && Array.isArray(u), g = Object.prototype.toString.call(u), p = (h = u) && h.constructor && "function" == typeof h.constructor.isBuffer && h.constructor.isBuffer(h);
                            var h;
                            const y = "[object Object]" === g || "[object Array]" === g, S = r ? r + n + i(c) : i(c);
                            if (!d && !p && y && Object.keys(u).length && (!(null == t ? void 0 : t.maxDepth) || s && l < s)) return e(u, S, l + 1);
                            o[S] = u;
                        });
                    }(e), o;
                };
            },
            6816: function(e, t, a) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, a, n) {
                    void 0 === n && (n = a);
                    var s = Object.getOwnPropertyDescriptor(t, a);
                    s && !("get" in s ? !t.__esModule : s.writable || s.configurable) || (s = {
                        enumerable: !0,
                        get: function() {
                            return t[a];
                        }
                    }), Object.defineProperty(e, n, s);
                } : function(e, t, a, n) {
                    void 0 === n && (n = a), e[n] = t[a];
                }), s = this && this.__exportStar || function(e, t) {
                    for(var a in e)"default" === a || Object.prototype.hasOwnProperty.call(t, a) || n(t, e, a);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), s(a(7943), t), s(a(8552), t), s(a(8843), t);
            },
            7943: (e, t)=>{
                "use strict";
                function a(e) {
                    return new RegExp("^" + e.replace(/\./g, "\\.").replace(/\*/g, ".*") + "$", "gs");
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createPermissionCheckRegex = t.checkPermission = void 0, t.checkPermission = function(e, t) {
                    return Object.keys(e).some((e)=>a(e).test(t));
                }, t.createPermissionCheckRegex = a;
            },
            2743: (e)=>{
                "use strict";
                var t = function(e) {
                    return function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && !function(e) {
                        var t = Object.prototype.toString.call(e);
                        return "[object RegExp]" === t || "[object Date]" === t || function(e) {
                            return e.$$typeof === a;
                        }(e);
                    }(e);
                }, a = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;
                function n(e, t) {
                    var a;
                    return !1 !== t.clone && t.isMergeableObject(e) ? r((a = e, Array.isArray(a) ? [] : {}), e, t) : e;
                }
                function s(e, t, a) {
                    return e.concat(t).map(function(e) {
                        return n(e, a);
                    });
                }
                function i(e) {
                    return Object.keys(e).concat(function(e) {
                        return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
                            return e.propertyIsEnumerable(t);
                        }) : [];
                    }(e));
                }
                function o(e, t) {
                    try {
                        return t in e;
                    } catch (e) {
                        return !1;
                    }
                }
                function r(e, a, l) {
                    (l = l || {}).arrayMerge = l.arrayMerge || s, l.isMergeableObject = l.isMergeableObject || t, l.cloneUnlessOtherwiseSpecified = n;
                    var c = Array.isArray(a);
                    return c === Array.isArray(e) ? c ? l.arrayMerge(e, a, l) : function(e, t, a) {
                        var s = {};
                        return a.isMergeableObject(e) && i(e).forEach(function(t) {
                            s[t] = n(e[t], a);
                        }), i(t).forEach(function(i) {
                            (function(e, t) {
                                return o(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
                            })(e, i) || (o(e, i) && a.isMergeableObject(t[i]) ? s[i] = (function(e, t) {
                                if (!t.customMerge) return r;
                                var a = t.customMerge(e);
                                return "function" == typeof a ? a : r;
                            })(i, a)(e[i], t[i], a) : s[i] = n(t[i], a));
                        }), s;
                    }(e, a, l) : n(a, l);
                }
                r.all = function(e, t) {
                    if (!Array.isArray(e)) throw new Error("first argument should be an array");
                    return e.reduce(function(e, a) {
                        return r(e, a, t);
                    }, {});
                };
                var l = r;
                e.exports = l;
            },
            8792: (e)=>{
                "use strict";
                e.exports = function e(t, a) {
                    if (t === a) return !0;
                    if (t && a && "object" == typeof t && "object" == typeof a) {
                        if (t.constructor !== a.constructor) return !1;
                        var n, s, i;
                        if (Array.isArray(t)) {
                            if ((n = t.length) != a.length) return !1;
                            for(s = n; 0 != s--;)if (!e(t[s], a[s])) return !1;
                            return !0;
                        }
                        if (t.constructor === RegExp) return t.source === a.source && t.flags === a.flags;
                        if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === a.valueOf();
                        if (t.toString !== Object.prototype.toString) return t.toString() === a.toString();
                        if ((n = (i = Object.keys(t)).length) !== Object.keys(a).length) return !1;
                        for(s = n; 0 != s--;)if (!Object.prototype.hasOwnProperty.call(a, i[s])) return !1;
                        for(s = n; 0 != s--;){
                            var o = i[s];
                            if (!e(t[o], a[o])) return !1;
                        }
                        return !0;
                    }
                    return t != t && a != a;
                };
            },
            5302: (e, t, a)=>{
                const n = a(9537);
                function s(e, t, a) {
                    return "function" == typeof a.join ? a.join(e) : e[0] + t + e[1];
                }
                function i(e, t, a) {
                    return "function" != typeof a.isValid || a.isValid(e, t);
                }
                function o(e) {
                    return n(e) || Array.isArray(e) || "function" == typeof e;
                }
                e.exports = function(e, t, a) {
                    if (n(a) || (a = {
                        default: a
                    }), !o(e)) return void 0 !== a.default ? a.default : e;
                    "number" == typeof t && (t = String(t));
                    const r = Array.isArray(t), l = "string" == typeof t, c = a.separator || ".", u = a.joinChar || ("string" == typeof c ? c : ".");
                    if (!l && !r) return e;
                    if (l && t in e) return i(t, e, a) ? e[t] : a.default;
                    let d = r ? t : function(e, t, a) {
                        return "function" == typeof a.split ? a.split(e) : e.split(t);
                    }(t, c, a), g = d.length, p = 0;
                    do {
                        let t = d[p];
                        for("number" == typeof t && (t = String(t)); t && "\\" === t.slice(-1);)t = s([
                            t.slice(0, -1),
                            d[++p] || ""
                        ], u, a);
                        if (t in e) {
                            if (!i(t, e, a)) return a.default;
                            e = e[t];
                        } else {
                            let n = !1, o = p + 1;
                            for(; o < g;)if (t = s([
                                t,
                                d[o++]
                            ], u, a), n = t in e) {
                                if (!i(t, e, a)) return a.default;
                                e = e[t], p = o - 1;
                                break;
                            }
                            if (!n) return a.default;
                        }
                    }while (++p < g && o(e));
                    return p === g ? e : a.default;
                };
            },
            2685: (e, t, a)=>{
                "use strict";
                var n = a(9537);
                function s(e) {
                    return !0 === n(e) && "[object Object]" === Object.prototype.toString.call(e);
                }
                e.exports = function(e) {
                    var t, a;
                    return !1 !== s(e) && "function" == typeof (t = e.constructor) && !1 !== s(a = t.prototype) && !1 !== a.hasOwnProperty("isPrototypeOf");
                };
            },
            5858: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return "object" == typeof e ? null === e : "function" != typeof e;
                };
            },
            9537: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return null != e && "object" == typeof e && !1 === Array.isArray(e);
                };
            },
            1098: (e, t, a)=>{
                "use strict";
                const { deleteProperty: n } = Reflect, s = a(5858), i = a(2685), o = (e)=>"object" == typeof e && null !== e || "function" == typeof e, r = (e)=>{
                    if (!s(e)) throw new TypeError("Object keys must be strings or symbols");
                    if (((e)=>"__proto__" === e || "constructor" === e || "prototype" === e)(e)) throw new Error(`Cannot set unsafe key: "${e}"`);
                }, l = (e, t)=>t && "function" == typeof t.split ? t.split(e) : "symbol" == typeof e ? [
                        e
                    ] : Array.isArray(e) ? e : ((e, t, a)=>{
                        const n = ((e)=>Array.isArray(e) ? e.flat().map(String).join(",") : e)(t ? ((e, t)=>{
                            if ("string" != typeof e || !t) return e;
                            let a = e + ";";
                            return void 0 !== t.arrays && (a += `arrays=${t.arrays};`), void 0 !== t.separator && (a += `separator=${t.separator};`), void 0 !== t.split && (a += `split=${t.split};`), void 0 !== t.merge && (a += `merge=${t.merge};`), void 0 !== t.preservePaths && (a += `preservePaths=${t.preservePaths};`), a;
                        })(e, t) : e);
                        r(n);
                        const s = u.cache.get(n) || a();
                        return u.cache.set(n, s), s;
                    })(e, t, ()=>((e, t = {})=>{
                            const a = t.separator || ".", n = "/" !== a && t.preservePaths;
                            if ("string" == typeof e && !1 !== n && /\//.test(e)) return [
                                e
                            ];
                            const s = [];
                            let i = "";
                            const o = (e)=>{
                                let t;
                                "" !== e.trim() && Number.isInteger(t = Number(e)) ? s.push(t) : s.push(e);
                            };
                            for(let t = 0; t < e.length; t++){
                                const n = e[t];
                                "\\" !== n ? n !== a ? i += n : (o(i), i = "") : i += e[++t];
                            }
                            return i && o(i), s;
                        })(e, t)), c = (e, t, a, s)=>{
                    if (r(t), void 0 === a) n(e, t);
                    else if (s && s.merge) {
                        const n = "function" === s.merge ? s.merge : Object.assign;
                        n && i(e[t]) && i(a) ? e[t] = n(e[t], a) : e[t] = a;
                    } else e[t] = a;
                    return e;
                }, u = (e, t, a, n)=>{
                    if (!t || !o(e)) return e;
                    const s = l(t, n);
                    let i = e;
                    for(let e = 0; e < s.length; e++){
                        const t = s[e], l = s[e + 1];
                        if (r(t), void 0 === l) {
                            c(i, t, a, n);
                            break;
                        }
                        "number" != typeof l || Array.isArray(i[t]) ? (o(i[t]) || (i[t] = {}), i = i[t]) : i = i[t] = [];
                    }
                    return e;
                };
                u.split = l, u.cache = new Map, u.clear = ()=>{
                    u.cache = new Map;
                }, e.exports = u;
            },
            7048: (e, t, a)=>{
                var n = a(4319).default;
                function s() {
                    "use strict";
                    e.exports = s = function() {
                        return t;
                    }, e.exports.__esModule = !0, e.exports.default = e.exports;
                    var t = {}, a = Object.prototype, i = a.hasOwnProperty, o = Object.defineProperty || function(e, t, a) {
                        e[t] = a.value;
                    }, r = "function" == typeof Symbol ? Symbol : {}, l = r.iterator || "@@iterator", c = r.asyncIterator || "@@asyncIterator", u = r.toStringTag || "@@toStringTag";
                    function d(e, t, a) {
                        return Object.defineProperty(e, t, {
                            value: a,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        d({}, "");
                    } catch (e) {
                        d = function(e, t, a) {
                            return e[t] = a;
                        };
                    }
                    function g(e, t, a, n) {
                        var s = t && t.prototype instanceof y ? t : y, i = Object.create(s.prototype), r = new k(n || []);
                        return o(i, "_invoke", {
                            value: E(e, a, r)
                        }), i;
                    }
                    function p(e, t, a) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, a)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    t.wrap = g;
                    var h = {};
                    function y() {}
                    function S() {}
                    function v() {}
                    var f = {};
                    d(f, l, function() {
                        return this;
                    });
                    var m = Object.getPrototypeOf, b = m && m(m(_([])));
                    b && b !== a && i.call(b, l) && (f = b);
                    var A = v.prototype = y.prototype = Object.create(f);
                    function w(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            d(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function T(e, t) {
                        function a(s, o, r, l) {
                            var c = p(e[s], e, o);
                            if ("throw" !== c.type) {
                                var u = c.arg, d = u.value;
                                return d && "object" == n(d) && i.call(d, "__await") ? t.resolve(d.__await).then(function(e) {
                                    a("next", e, r, l);
                                }, function(e) {
                                    a("throw", e, r, l);
                                }) : t.resolve(d).then(function(e) {
                                    u.value = e, r(u);
                                }, function(e) {
                                    return a("throw", e, r, l);
                                });
                            }
                            l(c.arg);
                        }
                        var s;
                        o(this, "_invoke", {
                            value: function(e, n) {
                                function i() {
                                    return new t(function(t, s) {
                                        a(e, n, t, s);
                                    });
                                }
                                return s = s ? s.then(i, i) : i();
                            }
                        });
                    }
                    function E(e, t, a) {
                        var n = "suspendedStart";
                        return function(s, i) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === s) throw i;
                                return {
                                    value: void 0,
                                    done: !0
                                };
                            }
                            for(a.method = s, a.arg = i;;){
                                var o = a.delegate;
                                if (o) {
                                    var r = P(o, a);
                                    if (r) {
                                        if (r === h) continue;
                                        return r;
                                    }
                                }
                                if ("next" === a.method) a.sent = a._sent = a.arg;
                                else if ("throw" === a.method) {
                                    if ("suspendedStart" === n) throw n = "completed", a.arg;
                                    a.dispatchException(a.arg);
                                } else "return" === a.method && a.abrupt("return", a.arg);
                                n = "executing";
                                var l = p(e, t, a);
                                if ("normal" === l.type) {
                                    if (n = a.done ? "completed" : "suspendedYield", l.arg === h) continue;
                                    return {
                                        value: l.arg,
                                        done: a.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", a.method = "throw", a.arg = l.arg);
                            }
                        };
                    }
                    function P(e, t) {
                        var a = t.method, n = e.iterator[a];
                        if (void 0 === n) return t.delegate = null, "throw" === a && e.iterator.return && (t.method = "return", t.arg = void 0, P(e, t), "throw" === t.method) || "return" !== a && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + a + "' method")), h;
                        var s = p(n, e.iterator, t.arg);
                        if ("throw" === s.type) return t.method = "throw", t.arg = s.arg, t.delegate = null, h;
                        var i = s.arg;
                        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
                    }
                    function I(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function O(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function k(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(I, this), this.reset(!0);
                    }
                    function _(e) {
                        if (e) {
                            var t = e[l];
                            if (t) return t.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var a = -1, n = function t() {
                                    for(; ++a < e.length;)if (i.call(e, a)) return t.value = e[a], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return n.next = n;
                            }
                        }
                        return {
                            next: R
                        };
                    }
                    function R() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return S.prototype = v, o(A, "constructor", {
                        value: v,
                        configurable: !0
                    }), o(v, "constructor", {
                        value: S,
                        configurable: !0
                    }), S.displayName = d(v, u, "GeneratorFunction"), t.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === S || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, d(e, u, "GeneratorFunction")), e.prototype = Object.create(A), e;
                    }, t.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, w(T.prototype), d(T.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = T, t.async = function(e, a, n, s, i) {
                        void 0 === i && (i = Promise);
                        var o = new T(g(e, a, n, s), i);
                        return t.isGeneratorFunction(a) ? o : o.next().then(function(e) {
                            return e.done ? e.value : o.next();
                        });
                    }, w(A), d(A, u, "Generator"), d(A, l, function() {
                        return this;
                    }), d(A, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e) {
                        var t = Object(e), a = [];
                        for(var n in t)a.push(n);
                        return a.reverse(), function e() {
                            for(; a.length;){
                                var n = a.pop();
                                if (n in t) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, t.values = _, k.prototype = {
                        constructor: k,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(O), !e) for(var t in this)"t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var t = this;
                            function a(a, n) {
                                return o.type = "throw", o.arg = e, t.next = a, n && (t.method = "next", t.arg = void 0), !!n;
                            }
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var s = this.tryEntries[n], o = s.completion;
                                if ("root" === s.tryLoc) return a("end");
                                if (s.tryLoc <= this.prev) {
                                    var r = i.call(s, "catchLoc"), l = i.call(s, "finallyLoc");
                                    if (r && l) {
                                        if (this.prev < s.catchLoc) return a(s.catchLoc, !0);
                                        if (this.prev < s.finallyLoc) return a(s.finallyLoc);
                                    } else if (r) {
                                        if (this.prev < s.catchLoc) return a(s.catchLoc, !0);
                                    } else {
                                        if (!l) throw new Error("try statement without catch or finally");
                                        if (this.prev < s.finallyLoc) return a(s.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var a = this.tryEntries.length - 1; a >= 0; --a){
                                var n = this.tryEntries[a];
                                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var s = n;
                                    break;
                                }
                            }
                            s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                            var o = s ? s.completion : {};
                            return o.type = e, o.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, h) : this.complete(o);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var a = this.tryEntries[t];
                                if (a.finallyLoc === e) return this.complete(a.completion, a.afterLoc), O(a), h;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var a = this.tryEntries[t];
                                if (a.tryLoc === e) {
                                    var n = a.completion;
                                    if ("throw" === n.type) {
                                        var s = n.arg;
                                        O(a);
                                    }
                                    return s;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, t, a) {
                            return this.delegate = {
                                iterator: _(e),
                                resultName: t,
                                nextLoc: a
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, t;
                }
                e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            4319: (e)=>{
                function t(a) {
                    return e.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(a);
                }
                e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            5799: (e, t, a)=>{
                var n = a(7048)();
                e.exports = n;
                try {
                    regeneratorRuntime = n;
                } catch (e) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
                }
            }
        }, t = {};
        function a(n) {
            var s = t[n];
            if (void 0 !== s) return s.exports;
            var i = t[n] = {
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, a), i.exports;
        }
        a.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return a.d(t, {
                a: t
            }), t;
        }, a.d = (e, t)=>{
            for(var n in t)a.o(t, n) && !a.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, a.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), a.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            a.r(n), a.d(n, {
                AdminPortal: ()=>Fg,
                AdminPortalRenderer: ()=>Gg,
                AppHolder: ()=>c,
                CheckoutDialog: ()=>xg,
                FronteggApp: ()=>Ng,
                HostedLogin: ()=>Mg,
                LoginBoxRenderer: ()=>Bg,
                createElement: ()=>kg,
                defaultTheme: ()=>jg,
                formatName: ()=>Og,
                getOverriddenMetadata: ()=>Dg,
                getThemeAdminByName: ()=>$g,
                getThemeByName: ()=>Vg,
                initialize: ()=>Yg,
                mockFlagsList: ()=>Lg,
                restoreSearchParams: ()=>Rg,
                waitThemeSetter: ()=>_g
            });
            var e = {};
            a.r(e), a.d(e, {
                ApplicationAccessType: ()=>ln,
                AuthStrategyEnum: ()=>M,
                ContextHolder: ()=>L,
                DirectoryApi: ()=>ya,
                EIdentifierType: ()=>$,
                FRONTEGG_SEPARATE_TABS_BY_TENANT: ()=>lt,
                FeatureFlags: ()=>it,
                FeatureFlagsApi: ()=>ot,
                FetchClient: ()=>He,
                FronteggApiError: ()=>K,
                FronteggContext: ()=>D,
                FronteggFrameworks: ()=>We,
                GENERIC_ERROR_CODE: ()=>je,
                GENERIC_ERROR_MESSAGE: ()=>Ge,
                GetUsersFilterPreset: ()=>Za,
                GroupManagedByEnum: ()=>Qa,
                GroupRelations: ()=>Ja,
                ISubscriptionCancellationPolicy: ()=>B,
                ISubscriptionStatus: ()=>j,
                InsightCode: ()=>nn,
                LOAD_AUTHORIZATION_FF: ()=>at,
                MFAStrategyEnum: ()=>tt,
                MachineToMachineAuthStrategy: ()=>F,
                NotEntitledJustification: ()=>tn,
                PaginationOrderEnum: ()=>ze,
                PasswordRecoveryStrategyEnum: ()=>G,
                PaymentMethodType: ()=>V,
                PermissionAssignmentTypeEnum: ()=>Ga,
                ProviderType: ()=>W,
                RecommendationActionKey: ()=>sn,
                RecommendationCode: ()=>an,
                RecommendationSeverity: ()=>on,
                RequestSource: ()=>Be,
                RestrictionType: ()=>Xe,
                ScimConnectionSource: ()=>Ya,
                SecondaryAuthStrategy: ()=>Ze,
                SecurityCategory: ()=>rn,
                SignUpStrategyEnum: ()=>x,
                SocialLoginProviders: ()=>N,
                SortByEnum: ()=>Xa,
                SubAccountAccessTypeEnum: ()=>ja,
                TenantSortByEnum: ()=>xa,
                TenantType: ()=>$a,
                UserManagedByEnum: ()=>Fa,
                WebAuthnDeviceType: ()=>et,
                api: ()=>cn,
                createApiClient: ()=>un,
                default: ()=>dn,
                fetch: ()=>Ke,
                fronteggAuthApiRoutesRegex: ()=>Va,
                fronteggEntitlementsV2Url: ()=>qa,
                fronteggHeaders: ()=>Ve,
                fronteggRefreshTokenUrl: ()=>Ba,
                fronteggSilentRefreshTokenUrl: ()=>Wa,
                fronteggTenantsUrl: ()=>Ha,
                fronteggTenantsV3Url: ()=>Ka,
                fronteggUsersUrl: ()=>za,
                getCurrentUserTenantsFunction: ()=>yt,
                getTabTenantFromSessionStorage: ()=>ht,
                providersArray: ()=>en,
                removeTabTenantFromSessionStorage: ()=>pt,
                setTabTenantInSessionStorage: ()=>gt
            });
            var t = {};
            a.r(t), a.d(t, {
                ACR_VALUE: ()=>wn,
                AMR_ADDITIONAL_VALUE: ()=>En,
                AMR_MFA_VALUE: ()=>Tn,
                AcceptInvitationStep: ()=>yn,
                ActivateAccountStep: ()=>Zn,
                AdminPortalPages: ()=>os,
                AdminPortalPagesForEvents: ()=>is,
                AllAccountsStateKeys: ()=>nr,
                ApiStateKeys: ()=>ti,
                ApprovalFlowStep: ()=>Ks,
                AuthStrategyEnum: ()=>M,
                AuthenticationTypes: ()=>ss,
                DEFAULT_RETRY_CONFIG: ()=>Nn,
                EditEmailView: ()=>fc,
                FORGOT_PASSWORD_ERROR_KEYS: ()=>pi,
                FRONTEGG_AFTER_AUTH_REDIRECT_URL: ()=>Cn,
                ForgotPasswordStep: ()=>ui,
                FronteggNativeModule: ()=>S,
                GTMEventAction: ()=>rs,
                GroupRelations: ()=>Ti,
                GroupsStateKeys: ()=>wi,
                HOSTED_LOGIN_VERIFIER_KEY: ()=>Dn,
                ImpersonateStep: ()=>_i,
                LoginActionTypes: ()=>Rn,
                LoginFlow: ()=>kn,
                LoginStep: ()=>On,
                MFAStep: ()=>ls,
                MachineToMachineAuthStrategy: ()=>F,
                PasswordRotationStep: ()=>Si,
                PaymentMethodType: ()=>Rc,
                PaymentProvider: ()=>Cc,
                QuickLoginStrategy: ()=>_n,
                REQUEST_NAME: ()=>as,
                ResetPhoneNumberStep: ()=>Er,
                RolesStateKeys: ()=>Cr,
                SHOULD_STEP_UP_KEY: ()=>Pn,
                SSOStateKeys: ()=>Eo,
                STEP_UP_MAX_AGE_PARAM_NAME: ()=>In,
                SamlVendors: ()=>Po,
                SecurityCenterStateKeys: ()=>Jr,
                SignUpStage: ()=>hl,
                SubscriptionCancellationPolicy: ()=>Nc,
                SubscriptionStatus: ()=>Dc,
                TENANT_ID_PARAM_KEY: ()=>ys,
                TeamStateKeys: ()=>Ns,
                UserVerifiedOriginTypes: ()=>ns,
                authStrategyLoginStepMap: ()=>Un,
                base64ToFormData: ()=>Hi,
                base64urlDecode: ()=>zi,
                base64urlEncode: ()=>Wi,
                buildAuditsActions: ()=>wu,
                buildAuthActions: ()=>wc,
                buildConnectivityActions: ()=>_c,
                buildSubscriptionsActions: ()=>du,
                buildVendorActions: ()=>hu,
                createAuditsState: ()=>Au,
                createAuthState: ()=>Ac,
                createConnectivityState: ()=>Ec,
                createFronteggStore: ()=>Jd,
                createProxy: ()=>hn,
                createRandomString: ()=>yo,
                createStore: ()=>Qd,
                createSubscriptionsState: ()=>uu,
                createVendorState: ()=>pu,
                deepClone: ()=>Bn,
                deepResetState: ()=>Wn,
                defaultFronteggRoutes: ()=>Ln,
                delay: ()=>Mn,
                errorHandler: ()=>Kn,
                errorTraceId: ()=>Gn,
                generateCodeChallenge: ()=>ho,
                generateCodeChallengeNative: ()=>po,
                generateCodeChallengePureJs: ()=>go,
                getBaseNameWithoutSlashSuffix: ()=>ws,
                getEntitlements: ()=>wo,
                getFeatureEntitlements: ()=>Ao,
                getMfaStepForEnrolledUsers: ()=>vs,
                getMfaStepForNotEnrolledUsers: ()=>fs,
                getNumberOfMfaDevices: ()=>Ss,
                getPathAndSearchParamsFromUrl: ()=>ps,
                getPermissionEntitlements: ()=>bo,
                getRedirectUrl: ()=>ds,
                getSearchParam: ()=>hs,
                getSearchParamsFromUrl: ()=>gs,
                getUri: ()=>Ls,
                hmac: ()=>uo,
                isAbsoluteUrl: ()=>us,
                isAuthRoute: ()=>Ds,
                isEmailPayload: ()=>bs,
                isEntitlementsDeeplyEqual: ()=>To,
                isError: ()=>Hn,
                isFronteggApiError: ()=>zn,
                isMfaRequired: ()=>_s,
                isOauthCallbackRoute: ()=>ms,
                isProxy: ()=>Vn,
                isResetPasswordRequired: ()=>Rs,
                isSteppedUp: ()=>Es,
                isUsernamePayload: ()=>As,
                mapMetaDataObjectToActions: ()=>Us,
                omitProps: ()=>jn,
                prepareIdentifiersForSignup: ()=>Cs,
                publicKeyCredentialToJSON: ()=>Ki,
                readFileAsText: ()=>qi,
                redirectByStepUpUrl: ()=>Is,
                ref: ()=>_,
                reportGTMEvent: ()=>cs,
                retry: ()=>Fn,
                retryIfNeeded: ()=>xn,
                setAfterAuthRedirectUrlForStepUp: ()=>Ps,
                sha256: ()=>co,
                shouldShowPasswordRotationPromptFunc: ()=>Ts,
                snapshot: ()=>k,
                subscribe: ()=>O,
                withRetryConfig: ()=>$n
            });
            var s = {};
            function i(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function o(e) {
                return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, o(e);
            }
            function r(e, t) {
                for(var a = 0; a < t.length; a++){
                    var n = t[a];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (s = n.key, i = void 0, i = function(e) {
                        if ("object" !== o(e) || null === e) return e;
                        var t = e[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var a = t.call(e, "string");
                            if ("object" !== o(a)) return a;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(s), "symbol" === o(i) ? i : String(i)), n);
                }
                var s, i;
            }
            function l(e, t, a) {
                return t && r(e.prototype, t), a && r(e, a), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            }
            a.r(s), a.d(s, {
                AccountDetailsPageTabs: ()=>dg,
                AccountPageFields: ()=>ng,
                COUNTRY_FILTER_TYPE: ()=>Zd,
                DomainRestrictionsTabFields: ()=>ug,
                GeneralSettingsTabFields: ()=>lg,
                InviteUserModalFields: ()=>ag,
                IpRestrictionsTabFields: ()=>cg,
                Metadata: ()=>Ig,
                PrivacyPageFields: ()=>tg,
                ProfilePageFields: ()=>eg,
                SecurityPageTabs: ()=>og,
                SessionManagementTabFields: ()=>rg,
                SignupFields: ()=>Xd,
                SubscriptionsPageFields: ()=>ig,
                UsersTableColumns: ()=>sg,
                alpha: ()=>mg,
                columnVisibility: ()=>hg,
                fieldAppearance: ()=>gg,
                tabAppearance: ()=>pg
            });
            var c = function() {
                function e() {
                    i(this, e);
                }
                return l(e, null, [
                    {
                        key: "setInstance",
                        value: function(t, a) {
                            e._apps[t] = a;
                        }
                    },
                    {
                        key: "getInstance",
                        value: function(t) {
                            var a = e._apps[t];
                            if (!a) throw Error("[".concat(t, "] FronteggApp not found"));
                            return a;
                        }
                    }
                ]), e;
            }();
            function u(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var a = 0, n = new Array(t); a < t; a++)n[a] = e[a];
                return n;
            }
            function d(e, t) {
                return function(e) {
                    if (Array.isArray(e)) return e;
                }(e) || function(e, t) {
                    var a = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != a) {
                        var n, s, i, o, r = [], l = !0, c = !1;
                        try {
                            if (i = (a = a.call(e)).next, 0 === t) {
                                if (Object(a) !== a) return;
                                l = !1;
                            } else for(; !(l = (n = i.call(a)).done) && (r.push(n.value), r.length !== t); l = !0);
                        } catch (e) {
                            c = !0, s = e;
                        } finally{
                            try {
                                if (!l && null != a.return && (o = a.return(), Object(o) !== o)) return;
                            } finally{
                                if (c) throw s;
                            }
                        }
                        return r;
                    }
                }(e, t) || function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return u(e, t);
                        var a = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? u(e, t) : void 0;
                    }
                }(e, t) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function g(e, t, a, n, s, i, o) {
                try {
                    var r = e[i](o), l = r.value;
                } catch (e) {
                    return void a(e);
                }
                r.done ? t(l) : Promise.resolve(l).then(n, s);
            }
            function p(e) {
                return function() {
                    var t = this, a = arguments;
                    return new Promise(function(n, s) {
                        var i = e.apply(t, a);
                        function o(e) {
                            g(i, n, s, o, r, "next", e);
                        }
                        function r(e) {
                            g(i, n, s, o, r, "throw", e);
                        }
                        o(void 0);
                    });
                };
            }
            c._apps = {};
            var h = a(5799), y = a.n(h);
            const S = new class {
                constructor(){
                    this.backToLoginImpl = void 0, this.loginWithSSO = (e)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var t, a, n;
                            null == (t = window.webkit) || null == (a = t.messageHandlers) || null == (n = a.FronteggNativeBridge) || n.postMessage(JSON.stringify({
                                action: "loginWithSSO",
                                payload: e
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var s;
                            null == (s = window.FronteggNativeBridge) || s.loginWithSSO(e);
                        }
                    }, this.loginWithSocialLogin = (e)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var t, a, n;
                            null == (t = window.webkit) || null == (a = t.messageHandlers) || null == (n = a.FronteggNativeBridge) || n.postMessage(JSON.stringify({
                                action: "loginWithSocialLogin",
                                payload: e
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var s;
                            null == (s = window.FronteggNativeBridge) || s.loginWithSocialLogin(e);
                        }
                    }, this.loginWithSocialLoginProvider = (e)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var t, a, n;
                            null == (t = window.webkit) || null == (a = t.messageHandlers) || null == (n = a.FronteggNativeBridge) || n.postMessage(JSON.stringify({
                                action: "loginWithSocialLoginProvider",
                                payload: e
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var s;
                            null == (s = window.FronteggNativeBridge) || s.loginWithSocialLoginProvider(e);
                        }
                    }, this.loginWithCustomSocialLoginProvider = (e)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var t, a, n;
                            null == (t = window.webkit) || null == (a = t.messageHandlers) || null == (n = a.FronteggNativeBridge) || n.postMessage(JSON.stringify({
                                action: "loginWithCustomSocialLoginProvider",
                                payload: e
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var s;
                            null == (s = window.FronteggNativeBridge) || s.loginWithCustomSocialLoginProvider(e);
                        }
                    }, this.suggestSavePassword = (e, t)=>{
                        if (this.isIOSNativeBridgeAvailable()) {
                            var a, n, s;
                            null == (a = window.webkit) || null == (n = a.messageHandlers) || null == (s = n.FronteggNativeBridge) || s.postMessage(JSON.stringify({
                                action: "suggestSavePassword",
                                payload: JSON.stringify({
                                    email: e,
                                    password: t
                                })
                            }));
                        } else {
                            if (!this.isAndroidNativeBridgeAvailable()) throw new Error("FronteggNativeBridge is not available");
                            var i;
                            null == (i = window.FronteggNativeBridge) || i.suggestSavePassword(e, t);
                        }
                    }, this.promptSocialLoginConsent = ()=>{
                        var e, t;
                        return null != (e = null == (t = window.FronteggNativeBridgeFunctions) ? void 0 : t.shouldPromptSocialLoginConsent) && e;
                    };
                }
                isIOSNativeBridgeAvailable() {
                    var e, t;
                    return null != (null == (e = window.webkit) || null == (t = e.messageHandlers) ? void 0 : t.FronteggNativeBridge);
                }
                isAndroidNativeBridgeAvailable() {
                    return null != window.FronteggNativeBridge;
                }
                isExternalMobileBrowser() {
                    return null !== sessionStorage.getItem("frontegg_external_mobile_browser") && null != this.backToLoginImpl;
                }
                setBackToLogin(e) {
                    this.backToLoginImpl = e;
                }
                backToLogin() {
                    this.backToLoginImpl && this.backToLoginImpl();
                }
                isSocialLoginAvailable() {
                    return this.isAvailable("loginWithSocialLogin");
                }
                isSocialLoginProviderAvailable() {
                    return this.isAvailable("loginWithSocialLoginProvider");
                }
                isCustomSocialLoginProviderAvailable() {
                    return this.isAvailable("loginWithCustomSocialLoginProvider");
                }
                isLoginWithSSOAvailable() {
                    return this.isAvailable("loginWithSSO");
                }
                isSuggestSavePasswordAvailable() {
                    return this.isAvailable("suggestSavePassword");
                }
                isAvailable(e) {
                    var t, a;
                    return !(!this.isIOSNativeBridgeAvailable() && !this.isAndroidNativeBridgeAvailable()) && null != (t = null == (a = window.FronteggNativeBridgeFunctions) ? void 0 : a[e]) && t;
                }
            };
            function v() {
                return v = Object.assign ? Object.assign.bind() : function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var a = arguments[t];
                        for(var n in a)Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
                    }
                    return e;
                }, v.apply(this, arguments);
            }
            function f(e, t) {
                if (null == e) return {};
                var a, n, s = {}, i = Object.keys(e);
                for(n = 0; n < i.length; n++)a = i[n], t.indexOf(a) >= 0 || (s[a] = e[a]);
                return s;
            }
            Symbol();
            const m = Symbol(), b = Object.getPrototypeOf, A = new WeakMap, w = (e, t = !0)=>{
                A.set(e, t);
            }, T = (e)=>"object" == typeof e && null !== e, E = new WeakMap, P = new WeakSet;
            const [I] = function(e = Object.is, t = (e, t)=>new Proxy(e, t), a = (e)=>T(e) && !P.has(e) && (Array.isArray(e) || !(Symbol.iterator in e)) && !(e instanceof WeakMap) && !(e instanceof WeakSet) && !(e instanceof Error) && !(e instanceof Number) && !(e instanceof Date) && !(e instanceof String) && !(e instanceof RegExp) && !(e instanceof ArrayBuffer), n = (e)=>{
                switch(e.status){
                    case "fulfilled":
                        return e.value;
                    case "rejected":
                        throw e.reason;
                    default:
                        throw e;
                }
            }, s = new WeakMap, i = (e, t, a = n)=>{
                const o = s.get(e);
                if ((null == o ? void 0 : o[0]) === t) return o[1];
                const r = Array.isArray(e) ? [] : Object.create(Object.getPrototypeOf(e));
                return w(r, !0), s.set(e, [
                    t,
                    r
                ]), Reflect.ownKeys(e).forEach((t)=>{
                    if (Object.getOwnPropertyDescriptor(r, t)) return;
                    const n = Reflect.get(e, t), { enumerable: s } = Reflect.getOwnPropertyDescriptor(e, t), o = {
                        value: n,
                        enumerable: s,
                        configurable: !0
                    };
                    if (P.has(n)) w(n, !1);
                    else if (n instanceof Promise) delete o.value, o.get = ()=>a(n);
                    else if (E.has(n)) {
                        const [e, t] = E.get(n);
                        o.value = i(e, t(), a);
                    }
                    Object.defineProperty(r, t, o);
                }), Object.preventExtensions(r);
            }, o = new WeakMap, r = [
                1,
                1
            ], l = (n)=>{
                if (!T(n)) throw new Error("object required");
                const s = o.get(n);
                if (s) return s;
                let c = r[0];
                const u = new Set, d = (e, t = ++r[0])=>{
                    c !== t && (c = t, u.forEach((a)=>a(e, t)));
                };
                let g = r[1];
                const p = (e)=>(t, a)=>{
                        const n = [
                            ...t
                        ];
                        n[1] = [
                            e,
                            ...n[1]
                        ], d(n, a);
                    }, h = new Map, y = (e)=>{
                    const t = h.get(e);
                    var a;
                    t && (h.delete(e), null == (a = t[1]) || a.call(t));
                }, S = Array.isArray(n) ? [] : Object.create(Object.getPrototypeOf(n)), v = t(S, {
                    deleteProperty (e, t) {
                        const a = Reflect.get(e, t);
                        y(t);
                        const n = Reflect.deleteProperty(e, t);
                        return n && d([
                            "delete",
                            [
                                t
                            ],
                            a
                        ]), n;
                    },
                    set (t, n, s, i) {
                        const r = Reflect.has(t, n), c = Reflect.get(t, n, i);
                        if (r && (e(c, s) || o.has(s) && e(c, o.get(s)))) return !0;
                        var g;
                        y(n), T(s) && (s = ((e)=>e && (A.has(e) ? A.get(e) : b(e) === Object.prototype || b(e) === Array.prototype))(g = s) && g[m] || s);
                        let S = s;
                        if (s instanceof Promise) s.then((e)=>{
                            s.status = "fulfilled", s.value = e, d([
                                "resolve",
                                [
                                    n
                                ],
                                e
                            ]);
                        }).catch((e)=>{
                            s.status = "rejected", s.reason = e, d([
                                "reject",
                                [
                                    n
                                ],
                                e
                            ]);
                        });
                        else {
                            !E.has(s) && a(s) && (S = l(s));
                            const e = !P.has(S) && E.get(S);
                            e && ((e, t)=>{
                                if (u.size) {
                                    const a = t[3](p(e));
                                    h.set(e, [
                                        t,
                                        a
                                    ]);
                                } else h.set(e, [
                                    t
                                ]);
                            })(n, e);
                        }
                        return Reflect.set(t, n, S, i), d([
                            "set",
                            [
                                n
                            ],
                            s,
                            c
                        ]), !0;
                    }
                });
                o.set(n, v);
                const f = [
                    S,
                    (e = ++r[1])=>(g === e || u.size || (g = e, h.forEach(([t])=>{
                            const a = t[1](e);
                            a > c && (c = a);
                        })), c),
                    i,
                    (e)=>(u.add(e), 1 === u.size && h.forEach(([e, t], a)=>{
                            const n = e[3](p(a));
                            h.set(a, [
                                e,
                                n
                            ]);
                        }), ()=>{
                            u.delete(e), 0 === u.size && h.forEach(([e, t], a)=>{
                                t && (t(), h.set(a, [
                                    e
                                ]));
                            });
                        })
                ];
                return E.set(v, f), Reflect.ownKeys(n).forEach((e)=>{
                    const t = Object.getOwnPropertyDescriptor(n, e);
                    "value" in t && (v[e] = n[e], delete t.value, delete t.writable), Object.defineProperty(S, e, t);
                }), v;
            }) {
                return [
                    l,
                    E,
                    P,
                    e,
                    t,
                    a,
                    n,
                    s,
                    i,
                    o,
                    r
                ];
            }();
            function O(e, t, a) {
                const n = E.get(e);
                let s;
                const i = [], o = n[3];
                let r = !1;
                const l = o((e)=>{
                    i.push(e), a ? t(i.splice(0)) : s || (s = Promise.resolve().then(()=>{
                        s = void 0, r && t(i.splice(0));
                    }));
                });
                return r = !0, ()=>{
                    r = !1, l();
                };
            }
            function k(e, t) {
                const a = E.get(e), [n, s, i] = a;
                return i(n, s(), t);
            }
            function _(e) {
                return P.add(e), e;
            }
            const R = [
                "enabled",
                "name"
            ], U = Symbol();
            class L {
                constructor(){
                    this.context = null, this.accessToken = null, this.user = null, this.requestSource = null, this.onRedirectTo = (e)=>window.location.href = e, this.logout = ()=>window.location.href = "/account/logout", this.entitlementsOptions = null, this.appName = null, this.sessionContext = void 0, this.basename = null, this.cdnUrl = null, this.assetsUrl = null, this.setContext = (e)=>{
                        this.context = e;
                    }, this.setAccessToken = (e)=>{
                        this.accessToken = e;
                    }, this.setUser = (e)=>{
                        this.user = e;
                    }, this.setRequestSource = (e)=>{
                        this.requestSource = e;
                    }, this.setOnRedirectTo = (e)=>{
                        this.onRedirectTo = e;
                    }, this.setLogout = (e)=>{
                        this.logout = e;
                    }, this.setEntitlementsOptions = (e)=>{
                        this.entitlementsOptions = e;
                    }, this.setSessionContext = (e)=>{
                        this.sessionContext = e;
                    }, this.setAppName = (e)=>{
                        this.appName = e;
                    }, this.getContext = ()=>{
                        var e;
                        return null != (e = this.context) ? e : {
                            baseUrl: window.location.href,
                            tokenResolver: ()=>"my-authentication-token",
                            logLevel: "error"
                        };
                    }, this.getAccessToken = ()=>this.accessToken, this.getRequestSource = ()=>this.requestSource, this.getUser = ()=>this.user, this.shouldLoadEntitlements = ()=>{
                        var e;
                        return (null == (e = this.entitlementsOptions) ? void 0 : e.enabled) || !1;
                    }, this.isSessionPerTenantEnabled = ()=>{
                        var e;
                        return (null == (e = this.sessionContext) ? void 0 : e.enableSessionPerTenant) || !1;
                    }, this.shouldSkipUserLoad = ()=>{
                        var e;
                        return (null == (e = this.sessionContext) ? void 0 : e.skipUserLoading) || !1;
                    }, this.getAppName = ()=>this.appName, this.setCdnUrl = (e)=>{
                        this.cdnUrl = e;
                    }, this.getCdnUrl = ()=>this.cdnUrl, this.setAssetsUrl = (e)=>{
                        this.assetsUrl = e;
                    }, this.getAssetsUrl = ()=>this.assetsUrl;
                }
                static default() {
                    return L.getInstance(C);
                }
                static for(e) {
                    return L.getInstance(e);
                }
                static getInstance(e = "default") {
                    return L._apps || (L._apps = {}), L._apps[e] || (L._apps[e] = new L), L._apps[e];
                }
                static createInstance(e = "default") {
                    return L._apps[e] = new L, L._apps[e].appName = e, L._apps[e];
                }
                static setContext(e, t = "default") {
                    L.for(t).context = e;
                }
                static setAccessToken(e, t = C) {
                    L.for(t).accessToken = e;
                }
                static setUser(e, t = "default") {
                    L.for(t).user = e;
                }
                static setRequestSource(e, t = "default") {
                    L.for(t).requestSource = e;
                }
                static setOnRedirectTo(e, t = "default") {
                    L.for(t).onRedirectTo = e;
                }
                static setLogout(e, t, a = "default") {
                    const n = L.for(a);
                    n.logout = (a)=>{
                        a ? e(a) : n.onRedirectTo(t, void 0);
                    };
                }
                static setEntitlementsOptions(e, t = "default") {
                    L.for(t).entitlementsOptions = e;
                }
                static setSessionContext(e, t = "default") {
                    L.for(t).sessionContext = e;
                }
                static setAppName(e) {
                    L.for(e).appName = e;
                }
                static getContext(e = "default") {
                    var t;
                    return null != (t = L.for(e).context) ? t : {
                        baseUrl: window.location.href,
                        tokenResolver: ()=>"my-authentication-token",
                        logLevel: "error"
                    };
                }
                static getAccessToken(e = "default") {
                    return L.for(e).accessToken;
                }
                static getRequestSource(e = "default") {
                    return L.for(e).requestSource;
                }
                static getBasename(e = "default") {
                    return L.for(e).basename;
                }
                getBasename() {
                    return this.basename;
                }
                static setBasename(e, t = C) {
                    L.for(t).basename = e;
                }
                setBasename(e) {
                    this.basename = e;
                }
                static getUser(e = "default") {
                    return L.for(e).user;
                }
                static onRedirectTo(e, t, a = "default") {
                    return L.for(a).onRedirectTo(e, t);
                }
                static logout(e, t = "default") {
                    return L.for(t).logout(e);
                }
                static shouldLoadEntitlements(e = "default") {
                    var t;
                    return (null == (t = L.for(e).entitlementsOptions) ? void 0 : t.enabled) || !1;
                }
                static isSessionPerTenantEnabled(e = "default") {
                    var t;
                    return (null == (t = L.for(e).sessionContext) ? void 0 : t.enableSessionPerTenant) || !1;
                }
                static getAppName(e = "default") {
                    return L.for(e).appName;
                }
            }
            L._apps = void 0;
            const C = "default", D = {
                getContext: ()=>L.getContext(C),
                getAccessToken: ()=>L.getAccessToken(C),
                setAccessToken: (e)=>L.setAccessToken(e, C),
                getUser: ()=>L.getUser(C),
                setUser: (e)=>L.setUser(e, C),
                onRedirectTo: (e, t)=>L.onRedirectTo(e, t, C),
                setOnRedirectTo: (e)=>L.setOnRedirectTo(e, C),
                logout: (e)=>L.logout(e, C),
                getRequestSource: ()=>L.getRequestSource(C),
                setRequestSource: (e)=>L.setRequestSource(e, C),
                isSessionPerTenantEnabled: ()=>L.isSessionPerTenantEnabled(C),
                shouldLoadEntitlements: ()=>L.shouldLoadEntitlements(C),
                getAppName: ()=>L.getAppName(C),
                setEntitlementsOptions: (e)=>L.setEntitlementsOptions(e, C),
                setSessionContext: (e)=>L.setSessionContext(e, C),
                getBasename: ()=>L.getBasename(C),
                setBasename: (e)=>L.setBasename(e, C)
            };
            let N, M, F, x, $, G, j, V, B, W, z, H;
            !function(e) {
                e.Microsoft = "microsoft", e.Facebook = "facebook", e.Google = "google", e.Github = "github", e.Slack = "slack", e.Apple = "apple", e.Linkedin = "linkedin";
            }(N || (N = {})), function(e) {
                e.EmailAndPassword = "EmailAndPassword", e.MagicLink = "MagicLink", e.Code = "Code", e.NoLocalAuthentication = "NoLocalAuthentication", e.SmsCode = "SmsCode", e.WebAuthN = "WebAuthN", e.UsernameAndPassword = "UsernameAndPassword", e.UsernameAndMagicLink = "UsernameAndMagicLink", e.UsernameAndCode = "UsernameAndCode", e.UsernameAndSms = "UsernameAndSms";
            }(M || (M = {})), function(e) {
                e.ClientCredentials = "ClientCredentials", e.AccessToken = "AccessToken";
            }(F || (F = {})), function(e) {
                e.Email = "email", e.PhoneNumber = "phoneNumber", e.Username = "username";
            }(x || (x = {})), function(e) {
                e.email = "email", e.phoneNumber = "phoneNumber", e.username = "username";
            }($ || ($ = {})), function(e) {
                e.Email = "email", e.Sms = "sms";
            }(G || (G = {})), function(e) {
                e.ACTIVE = "active", e.CANCELED = "canceled", e.INCOMPLETE = "incomplete", e.EXPIRED = "expired", e.TRIALING = "trialing", e.TRIAL_ENDED = "trialEnded";
            }(j || (j = {})), function(e) {
                e.UNKNWON = "unknown", e.CARD = "card";
            }(V || (V = {})), function(e) {
                e.AT_PERIOD_END = "atPeriodEnd";
            }(B || (B = {})), function(e) {
                e.Stripe = "Stripe";
            }(W || (W = {})), function(e) {
                e.CHANGE_TO_DEFAULT = "change_to_default", e.RETAIN_TRIAL = "retain_trial";
            }(z || (z = {})), function(e) {
                e.CREATE = "create_customer";
            }(H || (H = {}));
            class K extends Error {
                constructor(e, t, a, n, s){
                    super(e), this._statusCode = void 0, this._traceId = void 0, this._errorCode = void 0, this._errorContext = void 0, this._statusCode = t, this._traceId = a, this._errorCode = n, this._errorContext = s;
                }
                get statusCode() {
                    return this._statusCode;
                }
                get traceId() {
                    return this._traceId;
                }
                get errorCode() {
                    return this._errorCode;
                }
                get errorContext() {
                    return this._errorContext;
                }
            }
            const q = {
                v1: {
                    strategies: "/identity/resources/configurations/v1/sign-up/strategies"
                }
            }, Y = {
                v1: "/identity/resources/users/webauthn/v1/devices"
            }, J = {
                v1: "/identity/resources/auth/v1",
                v2: "/identity/resources/auth/v2"
            }, Q = {
                v1: "/identity/resources/users/v1",
                v2: "/identity/resources/users/v2",
                v3: "/identity/resources/users/v3",
                roles: {
                    v3: "/identity/resources/users/v3/roles"
                },
                groups: {
                    v3: "/identity/resources/users/v3/groups"
                },
                tenants: {
                    me: {
                        v1: "/identity/resources/users/v1/me/tenants",
                        v3: "/identity/resources/users/v3/me/tenants"
                    }
                },
                apiTokens: {
                    v1: "/identity/resources/users/api-tokens/v1"
                },
                accessTokens: {
                    v1: "/identity/resources/users/access-tokens/v1"
                },
                sessions: {
                    v1: "/identity/resources/users/sessions/v1",
                    currentUser: {
                        v1: "/identity/resources/users/sessions/v1/me"
                    },
                    configurations: {
                        v1: "/identity/resources/configurations/sessions/v1"
                    }
                },
                invitation: {
                    resendAll: {
                        v1: "/identity/resources/users/v1/invitation/reset/all"
                    }
                },
                passwords: {
                    resetBreachedPasswords: {
                        v1: "/identity/resources/users/v1/passwords/breached/reset/bulk"
                    }
                },
                authorization: {
                    v1: "/identity/resources/users/v1/me/authorization"
                },
                temporary: {
                    v1: "/identity/resources/users/temporary/v1",
                    configuration: {
                        v1: "/identity/resources/users/temporary/v1/configuration"
                    }
                },
                phoneNumbers: {
                    v1: "/identity/resources/users/phone-numbers/v1",
                    v2: "/identity/resources/users/phone-numbers/v2"
                }
            }, X = {
                v1: "/identity/resources/configurations/v1"
            }, Z = {
                emailDomain: {
                    v1: "/identity/resources/configurations/restrictions/v1/email-domain"
                },
                ip: {
                    v1: "/identity/resources/configurations/v1/restrictions/ip"
                }
            }, ee = {
                v1: "/identity/resources/sso/v1",
                v2: "/identity/resources/sso/v2",
                custom: {
                    v1: "/identity/resources/sso/custom/v1"
                }
            }, te = {
                v1: "/identity/resources/permissions/v1"
            }, ae = {
                apiTokens: {
                    v1: "/identity/resources/tenants/api-tokens/v1",
                    v2: "/identity/resources/tenants/api-tokens/v2"
                },
                accessTokens: {
                    v1: "/identity/resources/tenants/access-tokens/v1"
                },
                invites: {
                    user: {
                        v1: "/identity/resources/tenants/invites/v1/user",
                        v2: "/identity/resources/tenants/invites/v2/user"
                    },
                    verify: {
                        v1: "/identity/resources/tenants/invites/v1/verify"
                    },
                    configuration: {
                        v1: "/identity/resources/tenants/invites/v1/configuration"
                    }
                },
                users: {
                    v1: "/identity/resources/tenants/users/v1"
                }
            }, ne = {
                v1: "/identity/resources/roles/v1",
                v2: "/identity/resources/roles/v2"
            }, se = {
                v1: "/identity/resources/sub-tenants/users/v1",
                v2: "/identity/resources/sub-tenants/users/v2"
            }, ie = {
                v1: "/identity/resources/impersonation/v1"
            }, oe = {
                v1: "/identity/resources/applications/v1"
            }, re = {
                v1: "/identity/resources/groups/v1",
                configurations: {
                    v1: "/identity/resources/groups/v1/config"
                },
                getByIds: {
                    v1: "/identity/resources/groups/v1/bulkGet"
                }
            }, le = {
                v1: "/identity/resources/users/phone-numbers/v1"
            }, ce = {
                v1: "/identity/resources/users/emails/v1"
            }, ue = {
                v1: "/identity/resources/usernames/v1"
            }, de = {
                v1: "/identity/resources/approval-flows/v1"
            }, ge = {
                v1: "/team/resources/sso/v1",
                v2: "/team/resources/sso/v2"
            }, pe = {
                v1: "/team/resources/members/v1"
            }, he = {
                v1: "/team/resources/roles/v1"
            }, ye = {
                v1: "/team/resources/stats/v1"
            }, Se = {
                v1: "/team/resources/profile"
            }, ve = {
                v1: "/tenants/resources/account-settings/v1"
            }, fe = {
                v1: "/tenants/resources/hierarchy/v1",
                tree: {
                    v1: "/tenants/resources/hierarchy/v1/tree"
                },
                parents: {
                    v1: "/tenants/resources/hierarchy/v1/parents"
                },
                v2: "/tenants/resources/hierarchy/v2",
                metadata: {
                    v2: "/tenants/resources/hierarchy/v2/metadata"
                }
            }, me = {
                v1: "/tenants/resources/sub-tenants/v1"
            }, be = {
                v1: "/integrations/resources/configurations/v1",
                v2: "/integrations/resources/configurations/v2"
            }, Ae = {
                subscriptions: {
                    v1: "/subscriptions/resources/billing/subscriptions/v1"
                },
                plans: {
                    v1: "/subscriptions/resources/billing/plans/v1"
                },
                invoices: {
                    v1: "/subscriptions/resources/billing/invoices/v1"
                },
                paymentMethods: {
                    v1: "/subscriptions/resources/billing/payment-methods/v1"
                },
                summaries: {
                    v1: "/subscriptions/resources/billing/summaries/v1"
                },
                tenantConfiguration: {
                    v1: "/subscriptions/resources/billing/tenant-configurations/v1"
                },
                configurations: {
                    vendorPublicConfigurations: {
                        v1: "/subscriptions/resources/billing/configurations/vendor-public-configurations/v1"
                    }
                },
                paymentProviders: {
                    stripe: {
                        customers: {
                            v1: "/subscriptions/resources/billing/payment-providers/stripe/customers/v1"
                        },
                        publicConfigurations: {
                            v1: "/subscriptions/resources/billing/payment-providers/stripe/public-configurations/v1"
                        },
                        subscriptions: {
                            v1: "/subscriptions/resources/billing/payment-providers/stripe/subscriptions/v1"
                        },
                        setupIntents: {
                            v1: "/subscriptions/resources/billing/payment-providers/stripe/setup-intents/v1"
                        }
                    }
                }
            }, we = {
                v1: "/subscriptions/resources/payment-providers/v1"
            }, Te = {
                v1: "/subscriptions/resources/subscriptions/v1"
            }, Ee = {
                v1: "/reports/resources/reports/v1",
                v2: "/reports/resources/reports/v2"
            }, Pe = {
                v1: "/reports/engine/resources/triggers/v1"
            }, Ie = "/notification", Oe = "/audits", ke = {
                v1: "/event/resources/configurations/v1"
            }, _e = "/webhook", Re = "/oauth", Ue = "/flags", Le = "/directory/resources/v1/configurations/scim2", Ce = "/directory/resources/scim/temp", De = "/entitlements/api/v2/user-entitlements", Ne = {
                v1: "/security-center/resources/recommendations/v1"
            }, Me = {
                v1: "/security-center/resources/insights/v1"
            }, Fe = "/applications/resources/applications/v1", xe = {
                v1: "/applications/resources/applications/tenant-assignments/v1",
                v2: "/applications/resources/applications/tenant-assignments/v2"
            }, $e = "http://localhost:3037/resources/velo/v1", Ge = "We're facing some difficulties, Please try again", je = "ER-ADMIN-PORTAL-GENERIC-ERROR", Ve = {
                frameWork: "x-frontegg-framework",
                fronteggSdkVersion: "x-frontegg-sdk",
                contentType: "Content-Type",
                source: "frontegg-source",
                scopedTenant: "frontegg-scoped-tenant"
            };
            let Be, We, ze;
            !function(e) {
                e.AdminPortal = "admin-portal", e.LoginBox = "login-box";
            }(Be || (Be = {})), function(e) {
                e.Nextjs = "nextjs", e.React = "react", e.Angular = "angular", e.Vuejs = "vuejs", e.Flutter = "flutter", e.Ios = "ios", e.Android = "android", e.Vanillajs = "vanillajs";
            }(We || (We = {})), function(e) {
                e.ASC = "ASC", e.DESC = "DESC";
            }(ze || (ze = {}));
            class He {
                constructor(e){
                    this.appName = void 0, this.getFronteggContext = ()=>L.for(this.appName), this.prepareUrl = async (e, t)=>{
                        const a = this.getFronteggContext().getContext(), n = this.getContextBaseUrl(e), s = await this.buildQueryParams(a, t);
                        let i = e.startsWith("http") ? e : `${n}${e}`;
                        const o = Object.keys(s).length > 0;
                        return s && o && (i += `?${new URLSearchParams(s)}`), i;
                    }, this.buildQueryParams = async (e, t)=>{
                        t || (t = {});
                        const a = await this.getAdditionalQueryParams(e);
                        for (const e of a)t[e.key] = e.value;
                        const n = Object.keys(t);
                        for (const e of n){
                            const a = t[e];
                            t[e] = "object" == typeof a ? JSON.stringify(a) : a;
                        }
                        return t;
                    }, this.getAdditionalQueryParams = async (e)=>{
                        let t = [];
                        return e.additionalQueryParamsResolver && (t = await e.additionalQueryParamsResolver()), t;
                    }, this.getAdditionalHeaders = async (e)=>{
                        let t = [];
                        if (e.additionalHeadersResolver && (t = await e.additionalHeadersResolver()), e.tenantResolver) {
                            const a = await e.tenantResolver();
                            null != a && a.tenant && t.push({
                                key: "frontegg-login-alias",
                                value: a.tenant
                            });
                        }
                        return e.appId && t.push({
                            key: "frontegg-requested-application-id",
                            value: e.appId
                        }), t;
                    }, this.buildRequestHeaders = async (e)=>{
                        var t;
                        const a = this.getFronteggContext(), n = a.getContext(), s = He.getMetadataHeaders(n), i = await (null != (t = null == n ? void 0 : n.tokenResolver) ? t : a.getAccessToken)(), o = a.getRequestSource(), r = He.getScopedTenant();
                        e && (s[Ve.contentType] = e), o && (s[Ve.source] = o), i && (s.Authorization = `Bearer ${i}`), r && (s[Ve.scopedTenant] = r);
                        for (const e of (await this.getAdditionalHeaders(n)))s[`${e.key}`] = `${e.value}`;
                        return s;
                    }, this.getResponseTraceId = (e)=>{
                        var t, a;
                        return null == e || null == (t = e.headers) || null == (a = t.get) ? void 0 : a.call(t, "frontegg-trace-id");
                    }, this.sendRequest = async (e)=>{
                        var t, a, n;
                        const s = this.getFronteggContext().getContext(), i = await this.buildRequestHeaders(e.contentType), o = await this.prepareUrl(e.url, e.params), r = s.beforeRequestInterceptor, l = {
                            body: e.body ? "application/json" === e.contentType ? JSON.stringify(e.body) : e.body : null,
                            method: null != (t = e.method) ? t : "GET",
                            headers: v({}, i, e.headers),
                            credentials: null != (a = null != (n = e.credentials) ? n : s.requestCredentials) ? a : "same-origin"
                        }, c = r ? r(l, o) : l, u = await fetch(o, c);
                        if (302 === u.status) return window.location.href = await u.text(), new Promise(()=>{});
                        if (!u.ok) {
                            var d, g, p, h, y;
                            if (413 === u.status) throw new K("Error request is too large", u.status, this.getResponseTraceId(u), void 0);
                            let e, t, a, n = !0;
                            try {
                                e = await u.text(), e = JSON.parse(e);
                            } catch (e) {
                                n = !1;
                            }
                            throw null != (d = e) && d.errorCode && (t = e.errorCode), null != (g = e) && g.context && "object" == typeof e.context && (a = e.context), e.errors ? e = e.errors.join(", ") : "string" != typeof e && (e = `Error ${u.status} - ${u.statusText}`), u.status >= 400 && u.status < 500 && [
                                "warn"
                            ].includes(null != (p = s.logLevel) ? p : "") ? console.warn(e) : 500 === u.status && [
                                "warn",
                                "error"
                            ].includes(null != (h = s.logLevel) ? h : "") && console.error(e), new K(n ? e : Ge, u.status, this.getResponseTraceId(u), null != (y = t) ? y : je, a);
                        }
                        if ("stream" === e.responseType) return u.body;
                        if (e.responseType && "json" !== e.responseType) {
                            if ("blob" === e.responseType) {
                                const { outputFileName: t } = e.params;
                                return await u.blob().then((e)=>URL.createObjectURL(e)).then((e)=>{
                                    const a = document.createElement("a");
                                    a.href = e, a.setAttribute("download", t || "output"), a.click();
                                });
                            }
                            return await u.text();
                        }
                        try {
                            return await u.json();
                        } catch (e) {
                            return {};
                        }
                    }, this.get = async (e, t, a)=>this.sendRequest(v({
                            url: e,
                            method: "GET",
                            contentType: "application/json",
                            params: t
                        }, a)), this.post = async (e, t, a)=>this.sendRequest(v({
                            url: e,
                            method: "POST",
                            contentType: "application/json",
                            body: t
                        }, a)), this.patch = async (e, t, a)=>this.sendRequest(v({
                            url: e,
                            method: "PATCH",
                            contentType: "application/json",
                            body: t
                        }, a)), this.put = async (e, t, a)=>this.sendRequest(v({
                            url: e,
                            method: "PUT",
                            contentType: "application/json",
                            body: t
                        }, a)), this.delete = async (e, t, a)=>this.sendRequest(v({
                            url: e,
                            method: "DELETE",
                            contentType: "application/json",
                            body: t
                        }, a)), this.postDownload = async (e, t, a, n)=>this.sendRequest(v({
                            url: e,
                            method: "POST",
                            contentType: "application/json",
                            responseType: "blob",
                            body: t,
                            params: a
                        }, n)), this.extractHeadersFromOptions = (e = {})=>v({}, e.jwt ? {
                            Authorization: e.jwt
                        } : {}), this.getBaseUrl = (e, t, a = !0)=>He.getBaseUrl(e, t, a), this.getContextBaseUrl = (e, t = !0)=>{
                        const a = this.getFronteggContext().getContext();
                        return this.getBaseUrl(a, e, t);
                    }, this.getMetadataHeaders = (e)=>He.getMetadataHeaders(e), this.getContextMetadataHeaders = ()=>{
                        const e = this.getFronteggContext().getContext();
                        return He.getMetadataHeaders(e);
                    }, this.appName = e;
                }
            }
            He.getBaseUrl = (e, t, a = !0)=>{
                let n;
                n = "function" == typeof e.baseUrl ? e.baseUrl(t) : e.baseUrl;
                const s = e.urlPrefix || "frontegg", i = "frontegg" === s && !a;
                return n.endsWith("/") || (n += "/"), n.endsWith(s) || i || (n += s), n;
            }, He.getMetadataHeaders = (e)=>{
                var t, a;
                const n = {};
                return null != e && null != (t = e.metadataHeaders) && t.fronteggSdkVersion && (n[Ve.fronteggSdkVersion] = e.metadataHeaders.fronteggSdkVersion), null != e && null != (a = e.metadataHeaders) && a.framework && (n[Ve.frameWork] = e.metadataHeaders.framework), n;
            }, He.getScopedTenant = ()=>new URLSearchParams(window.location.search).get("tenantId") || null;
            const Ke = new He("default");
            class qe extends Error {
                constructor(e){
                    super(e);
                }
            }
            const Ye = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(e) {
                const t = String(e).replace(/=+$/, "");
                if (t.length % 4 == 1) throw new qe("'atob' failed: The string to be decoded is not correctly encoded.");
                let a = "";
                for(let e, n, s = 0, i = 0; n = t.charAt(i++); ~n && (e = s % 4 ? 64 * e + n : n, s++ % 4) && (a += String.fromCharCode(255 & e >> (-2 * s & 6))))n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
                return a;
            };
            class Je extends Error {
                constructor(e){
                    super(e);
                }
            }
            const Qe = (e, t = {})=>{
                const a = t.header ? 0 : 1;
                try {
                    return JSON.parse(((e)=>{
                        let t = e.replace(/-/g, "+").replace(/_/g, "/");
                        switch(t.length % 4){
                            case 0:
                                break;
                            case 2:
                                t += "==";
                                break;
                            case 3:
                                t += "=";
                                break;
                            default:
                                throw new Error("Illegal base64url string!");
                        }
                        try {
                            return function(e) {
                                return decodeURIComponent(Ye(e).replace(/(.)/g, (e, t)=>{
                                    let a = t.charCodeAt(0).toString(16).toUpperCase();
                                    return a.length < 2 && (a = "0" + a), "%" + a;
                                }));
                            }(t);
                        } catch (e) {
                            return Ye(t);
                        }
                    })(e.split(".")[a]));
                } catch (e) {
                    throw new Je("Invalid token specified: " + e.message);
                }
            };
            let Xe, Ze, et, tt;
            !function(e) {
                e.ALLOW = "ALLOW", e.BLOCK = "BLOCK";
            }(Xe || (Xe = {})), function(e) {
                e.WebAuthnPlatform = "WebAuthnPlatform", e.WebAuthnCrossPlatform = "WebAuthnCrossPlatform", e.SmsCode = "SmsCode", e.SmsCodeV2 = "SmsCodeV2", e.Passkeys = "Passkeys", e.UsernameAndPassword = "UsernameAndPassword", e.UsernameAndMagicLink = "UsernameAndMagicLink", e.UsernameAndCode = "UsernameAndCode", e.UsernameAndSms = "UsernameAndSms";
            }(Ze || (Ze = {})), function(e) {
                e.Platform = "Platform", e.CrossPlatform = "CrossPlatform";
            }(et || (et = {})), function(e) {
                e.AuthenticatorApp = "AuthenticatorApp", e.WebAuthnPlatform = "WebAuthnPlatform", e.WebAuthnCrossPlatform = "WebAuthnCrossPlatform", e.SMS = "SMS", e.EmailCode = "EmailCode";
            }(tt || (tt = {}));
            const at = "admin_portal_should_load_authorization";
            class nt {
                constructor(e){
                    this.appName = void 0, this.fetchClient = void 0, this.get = async (e, t, a)=>this.fetchClient.get(e, t, a), this.post = async (e, t, a)=>this.fetchClient.post(e, t, a), this.patch = async (e, t, a)=>this.fetchClient.patch(e, t, a), this.put = async (e, t, a)=>this.fetchClient.put(e, t, a), this.delete = async (e, t, a)=>this.fetchClient.delete(e, t, a), this.postDownload = async (e, t, a, n)=>this.fetchClient.postDownload(e, t, a, n), this.extractHeadersFromOptions = (e = {})=>this.fetchClient.extractHeadersFromOptions(e), this.appName = e, this.fetchClient = new He(e);
                }
            }
            const st = {
                flags: {}
            };
            class it {
                constructor(){
                    var e;
                    this._flags = {}, this._flags = null != (e = st.flags) ? e : {};
                }
                static getInstance(e = "default") {
                    return this._instances[e];
                }
                static set(e, t = "default") {
                    const a = new it;
                    return a.set(e), it._instances[t] = a, a;
                }
                static getFeatureFlags(e, t) {
                    const a = this.getInstance(t);
                    return e.map((e)=>"on" === (null == a ? void 0 : a._flags[e]));
                }
                get flags() {
                    var e;
                    return null != (e = this.flags) ? e : {};
                }
                set(e) {
                    var t;
                    this._flags = v({}, null != (t = null == st ? void 0 : st.flags) ? t : {}, null != e ? e : {});
                }
            }
            it._instances = {};
            class ot extends nt {
                constructor(e){
                    super(e), this.loadFeatureFlags = async ()=>this.get(Ue);
                }
            }
            const rt = new ot("default"), lt = "FRONTEGG_SEPARATE_TABS_BY_TENANT", ct = "admin_portal_use_current_user_tenants_v1_endpoint";
            class ut extends nt {
                constructor(e){
                    super(e), this.GetUserJwt = async (e)=>this.post(`${Q.v3}/me/token`, e), this.getUsersV2 = async (e, t)=>this.get(Q.v2, e, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getUsersV3 = async (e, t)=>this.get(Q.v3, e, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getUsersRoles = async (e, t)=>this.get(Q.roles.v3, v({}, e, {
                            ids: e.ids.join(",")
                        }), {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getUsersUsernames = async (e)=>this.get(ue.v1, v({}, e, {
                            userIds: e.userIds.join(",")
                        })), this.getUsersGroups = async (e, t)=>this.get(Q.groups.v3, v({}, e, {
                            ids: e.ids.join(",")
                        }), {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getCurrentUserTenantsV3 = async (e)=>this.get(Q.tenants.me.v3, void 0, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getCurrentUserTenantsV1 = async (e)=>this.get(Q.tenants.me.v1, void 0, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.sendResetBreachedPasswordEmails = async ()=>this.post(Q.passwords.resetBreachedPasswords.v1), this.updateUserProfileV2 = async (e)=>this.put(`${Q.v2}/me`, e), this.unlockMe = async (e)=>this.post(`${Q.v3}/me/unlock`, e);
                }
            }
            const dt = new ut("default");
            function gt(e) {
                e && sessionStorage.setItem(lt, e);
            }
            function pt() {
                sessionStorage.removeItem(lt);
            }
            function ht(e) {
                return L.for(e).isSessionPerTenantEnabled() ? sessionStorage.getItem(lt) : null;
            }
            function yt(e) {
                if (L.for(e).shouldSkipUserLoad()) return async ()=>({
                        tenants: [],
                        activeTenant: {}
                    });
                const t = new ut(e), [a] = it.getFeatureFlags([
                    ct
                ], e);
                return L.for(e).isSessionPerTenantEnabled() || a ? t.getCurrentUserTenantsV1 : t.getCurrentUserTenantsV3;
            }
            class St extends nt {
                constructor(e){
                    super(e), this.switchTenant = async (e)=>(L.for(this.appName).isSessionPerTenantEnabled() && gt(e.tenantId), this.put(`${Q.v1}/tenant`, e)), this.getTenants = async ()=>this.get(`${Q.v2}/me/tenants`), this.getSubTenants = async (e)=>this.get(fe.v1, void 0, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getSubTenantsAsTree = async (e)=>this.get(fe.tree.v1, void 0, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getParentTenants = async (e)=>this.get(fe.parents.v1, void 0, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getParentTenantsById = async (e, t)=>this.get(`${fe.parents.v1}/${e}`, void 0, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getTenantsUsersCount = async (e, t)=>this.post(`${ae.users.v1}/count`, e, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.searchSubTenants = async (e, t)=>this.get(fe.v2, e, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getHierarchyMetadata = async (e, t)=>this.get(fe.metadata.v2, v({}, e, {
                            _tenantIds: e._tenantIds.join(",")
                        }), {
                            headers: this.extractHeadersFromOptions(t)
                        });
                }
            }
            const vt = new St("default");
            class ft extends nt {
                constructor(e){
                    super(e), this.loadEntitlementsV2 = async ()=>this.get(De);
                }
            }
            const mt = new ft("default");
            class bt extends nt {
                constructor(e){
                    super(e), this.getGlobalSecurityPolicy = async ()=>this.get(X.v1), this.getMfaPolicy = async ()=>this.get(`${X.v1}/mfa-policy`), this.getVendorMfaPolicy = async ()=>this.get(`${X.v1}/mfa-policy/vendor`), this.saveMfaPolicy = async (e)=>e.id ? this.patch(`${X.v1}/mfa-policy`, e) : this.post(`${X.v1}/mfa-policy`, e), this.getLockoutPolicy = async ()=>this.get(`${X.v1}/lockout-policy`), this.getVendorLockoutPolicy = async ()=>this.get(`${X.v1}/lockout-policy/vendor`), this.saveLockoutPolicy = async (e)=>e.id ? this.patch(`${X.v1}/lockout-policy`, e) : this.post(`${X.v1}/lockout-policy`, e), this.getCaptchaPolicy = async ()=>{
                        try {
                            return await this.get(`${X.v1}/captcha-policy/public`);
                        } catch  {
                            return null;
                        }
                    }, this.getPasswordHistoryPolicy = async ()=>this.get(`${X.v1}/password-history-policy`), this.getVendorPasswordHistoryPolicy = async ()=>this.get(`${X.v1}/password-history-policy/vendor`), this.savePasswordHistoryPolicy = async (e)=>e.id ? this.patch(`${X.v1}/password-history-policy`, e) : this.post(`${X.v1}/password-history-policy`, e), this.getPasswordRotationPolicy = async ()=>{
                        try {
                            return await this.get(`${X.v1}/password-rotation`);
                        } catch (e) {
                            return {};
                        }
                    }, this.getVendorPasswordRotationPolicy = async ()=>{
                        try {
                            return await this.get(`${X.v1}/password-rotation/vendor`);
                        } catch (e) {
                            return {};
                        }
                    }, this.savePasswordRotationPolicy = async (e)=>this.post(`${X.v1}/password-rotation`, e), this.getPasswordConfigPolicy = async ()=>this.get(`${X.v1}/password`), this.getDomainRestrictions = async ()=>this.get(`${Z.emailDomain.v1}`), this.getDomainRestrictionsConfig = async ()=>this.get(`${Z.emailDomain.v1}/config`), this.createDomainRestriction = async (e)=>this.post(`${Z.emailDomain.v1}`, e), this.updateDomainRestrictionConfig = async (e)=>this.post(`${Z.emailDomain.v1}/config`, e), this.deleteDomainRestriction = async (e)=>this.delete(`${Z.emailDomain.v1}/${e}`), this.getIPRestrictions = async (e)=>this.get(`${Z.ip.v1}`, e), this.getIPRestrictionsConfig = async ()=>this.get(`${Z.ip.v1}/config`), this.createIPRestriction = async (e)=>this.post(`${Z.ip.v1}`, e), this.bulkCreateIPRestriction = async (e)=>this.post(`${Z.ip.v1}/bulk`, e), this.updateIPRestrictionConfig = async (e)=>this.post(`${Z.ip.v1}/config`, e), this.deleteIPRestriction = async (e)=>this.delete(`${Z.ip.v1}/${e}`), this.testCurrentIp = async ()=>this.post(`${Z.ip.v1}/verify`), this.testCurrentIpInAllowList = async ()=>this.post(`${Z.ip.v1}/verify/allow`);
                }
            }
            const At = new bt("default"), wt = [
                "type"
            ], Tt = [
                "type"
            ], Et = [
                "type"
            ];
            class Pt extends nt {
                constructor(e){
                    super(e), this.tenantsApi = new St(this.appName), this.entitlementsApi = new ft(this.appName), this.securityPolicy = new bt(this.appName), this.generateLoginResponse = async (e)=>{
                        if (!e.accessToken) return e;
                        const t = L.for(this.appName);
                        t.setAccessToken(e.accessToken);
                        const a = await this.getMeAndEntitlements(), n = v({}, e, e.accessToken ? Qe(e.accessToken) : {}, a);
                        return t.setUser(n), n;
                    }, this.generateLoginResponseV2 = async (e)=>{
                        if (!e.accessToken) return {
                            user: e
                        };
                        const t = L.for(this.appName);
                        t.setAccessToken(e.accessToken);
                        const [a, n] = await Promise.all([
                            this.getMeAndEntitlements(),
                            this.tenantsApi.getTenants()
                        ]), s = v({}, e, e.accessToken ? Qe(e.accessToken) : {}, a);
                        return t.setUser(s), {
                            user: s,
                            tenants: n
                        };
                    }, this.generateLoginResponseV3 = async (e)=>{
                        const { accessToken: t } = e;
                        if (!t) return {
                            user: e
                        };
                        const a = L.for(this.appName);
                        a.setAccessToken(t);
                        const [n, s] = await Promise.all([
                            this.getMeAndEntitlements(),
                            yt(this.appName)()
                        ]), i = v({}, e, t ? Qe(t) : {}, n);
                        return a.isSessionPerTenantEnabled() && gt(i.tenantId), a.setUser(i), {
                            user: i,
                            tenants: s.tenants,
                            activeTenant: s.activeTenant
                        };
                    }, this.generateLoginResponseFromOAuthResponse = async (e)=>{
                        const t = L.for(this.appName);
                        t.setAccessToken(e.id_token);
                        const a = await this.getMeAndEntitlements(), n = e.id_token ? Qe(e.id_token) : {}, s = v({
                            mfaRequired: !1,
                            accessToken: e.id_token,
                            refreshToken: e.refresh_token
                        }, n, a, {
                            expiresIn: e.expires_in || 300
                        });
                        return t.setUser(s), s;
                    }, this.generateLoginResponseFromOAuthResponseV2 = async (e)=>{
                        const t = L.for(this.appName);
                        t.setAccessToken(e.id_token);
                        const [a, n] = await Promise.all([
                            this.getMeAndEntitlements(),
                            yt(this.appName)()
                        ]), s = e.id_token ? Qe(e.id_token) : {}, i = v({
                            mfaRequired: !1,
                            accessToken: e.id_token,
                            refreshToken: e.refresh_token
                        }, s, a, {
                            expiresIn: e.expires_in || 300
                        });
                        return t.isSessionPerTenantEnabled() && gt(i.tenantId), t.setUser(i), {
                            user: i,
                            tenants: n.tenants,
                            activeTenant: n.activeTenant
                        };
                    }, this.preLogin = async (e)=>{
                        try {
                            const { address: t } = await this.post(`${J.v1}/user/saml/prelogin`, e);
                            return t;
                        } catch  {
                            return null;
                        }
                    }, this.preLoginWithIdpType = async (e)=>this.post(`${J.v1}/user/saml/prelogin`, e), this.postLogin = async (e)=>{
                        const t = await this.post(`${J.v1}/user/saml/postlogin`, e);
                        return this.generateLoginResponse(t);
                    }, this.oidcPostLogin = async (e)=>{
                        const t = await this.post(`${J.v1}/user/oidc/postlogin`, e);
                        return this.generateLoginResponse(t);
                    }, this.login = async (e)=>{
                        const t = await this.post(`${J.v1}/user`, e);
                        return this.generateLoginResponse(t);
                    }, this.loginv2 = async (e)=>{
                        const t = await this.post(`${J.v1}/user`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.loginWithMfa = async (e)=>{
                        const t = await this.post(`${J.v1}/user/mfa/verify`, e);
                        return this.generateLoginResponse(t);
                    }, this.loginWithMfaV2 = async (e)=>{
                        const t = await this.post(`${J.v1}/user/mfa/verify`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.activateAccount = async (e)=>this.post(`${Q.v1}/activate`, e), this.activateAccountV2 = async (e)=>{
                        const t = await this.post(`${Q.v1}/activate`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.activateAccountWithOTC = async (e)=>{
                        const t = await this.post(`${Q.v1}/activate/code`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.submitApprovalAction = async (e)=>this.post(`${de.v1}/approver-action`, e), this.getApprovalExecutionData = async (e)=>this.get(`${de.v1}/execution-data`, e), this.getActivateAccountStrategy = async (e)=>this.get(`${Q.v1}/activate/strategy`, e), this.resendActivationEmail = async (e)=>this.post(`${Q.v1}/activate/reset`, e), this.resendInvitationEmail = async (e)=>this.post(`${Q.v1}/invitation/reset`, e), this.acceptInvitation = async (e)=>this.post(`${Q.v1}/invitation/accept`, e), this.acceptInvitationWithOTC = async (e)=>this.post(`${Q.v1}/invitation/accept/code`, e), this.refreshToken = async ()=>{
                        const e = ht(this.appName), t = await this.post(`${J.v1}/user/token/refresh`, {
                            tenantId: e
                        });
                        return this.generateLoginResponse(t);
                    }, this.refreshTokenV2 = async ()=>{
                        const e = ht(this.appName), t = await this.post(`${J.v1}/user/token/refresh`, {
                            tenantId: e
                        });
                        return this.generateLoginResponseV2(t);
                    }, this.refreshTokenV3 = async ()=>{
                        const e = ht(this.appName), t = await this.post(`${J.v1}/user/token/refresh`, {
                            tenantId: e
                        });
                        return this.generateLoginResponseV3(t);
                    }, this.logout = async ()=>this.post(`${J.v1}/logout`), this.OAuthLogout = async (e)=>this.get(`${Re}/logout`, e), this.forgotPassword = async (e)=>this.post(`${Q.v1}/passwords/reset`, e), this.resetPassword = async (e)=>this.post(`${Q.v1}/passwords/reset/verify`, e), this.resetPasswordViaEmail = async (e)=>this.post(`${Q.v2}/passwords/reset/email`, e), this.resetPasswordViaSms = async (e)=>this.post(`${Q.v2}/passwords/reset/sms`, e), this.verifyPasswordViaSms = async (e)=>this.post(`${Q.v2}/passwords/reset/sms/verify`, e), this.getPasswordRecoveryStrategies = async ()=>this.get(`${X.v1}/password-recovery/strategies`), this.loadPasswordConfig = async (e)=>this.get(`${Q.v1}/passwords/config`, e), this.getSignUpStrategies = async ()=>this.get(`${q.v1.strategies}`), this.recoverMfaToken = async (e)=>this.post(`${J.v1}/user/mfa/recover`, e), this.enrollMfa = async ()=>this.post(`${Q.v1}/mfa/enroll`), this.preEnrollMFAAuthenticatorApp = async ()=>this.post(`${Q.v1}/mfa/authenticator/enroll`), this.enrollMFAAuthenticatorApp = async (e)=>this.post(`${Q.v1}/mfa/authenticator/enroll/verify`, e), this.preEnrollMFASMS = async (e)=>this.post(`${Q.v1}/mfa/sms/enroll`, e), this.enrollMFASMS = async (e)=>this.post(`${Q.v1}/mfa/sms/enroll/verify`, e), this.preEnrollMFAWebAuthn = async ()=>this.post(`${Q.v1}/mfa/webauthn/enroll`), this.enrollMFAWebAuthn = async (e)=>this.post(`${Q.v1}/mfa/webauthn/enroll/verify`, e), this.verifyMfa = async (e)=>this.post(`${Q.v1}/mfa/enroll/verify`, e), this.disableMfa = async (e)=>this.post(`${Q.v1}/mfa/disable`, e), this.disableMFAAuthenticatorApp = async (e, t)=>this.post(`${Q.v1}/mfa/authenticator/${e}/disable/verify`, t), this.preDisableMFASMS = async (e)=>this.post(`${Q.v1}/mfa/sms/${e}/disable`), this.disableMFASMS = async (e, t)=>this.post(`${Q.v1}/mfa/sms/${e}/disable/verify`, t), this.preDisableMFAWebAuthn = async (e)=>this.post(`${Q.v1}/mfa/webauthn/${e}/disable`), this.disableMFAWebAuthn = async (e, t)=>this.post(`${Q.v1}/mfa/webauthn/${e}/disable/verify`, t), this.getMFADevices = async ()=>this.get(`${Q.v1}/mfa/devices`), this.preEnrollMFAAuthenticatorAppForLogin = async (e)=>this.post(`${J.v1}/user/mfa/authenticator/enroll`, e), this.enrollMFAAuthenticatorAppForLogin = async (e)=>this.post(`${J.v1}/user/mfa/authenticator/enroll/verify`, e), this.enrollMFAAuthenticatorAppForLoginV2 = async (e)=>{
                        const t = await this.post(`${J.v1}/user/mfa/authenticator/enroll/verify`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.verifyMFAAuthenticatorAppForLogin = async (e, t)=>this.post(`${J.v1}/user/mfa/authenticator/${e}/verify`, t), this.preVerifyMFAEmailCode = async (e)=>this.post(`${J.v1}/user/mfa/emailcode`, e), this.verifyMFAEmailCode = async (e)=>this.post(`${J.v1}/user/mfa/emailcode/verify`, e), this.verifyMFAEmailCodeV2 = async (e)=>{
                        const t = await this.post(`${J.v1}/user/mfa/emailcode/verify`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.preEnrollMFASMSForLogin = async (e)=>this.post(`${J.v1}/user/mfa/sms/enroll`, e), this.enrollMFASMSForLogin = async (e)=>this.post(`${J.v1}/user/mfa/sms/enroll/verify`, e), this.enrollMFASMSForLoginV2 = async (e)=>{
                        const t = await this.post(`${J.v1}/user/mfa/sms/enroll/verify`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.preVerifyMFASMSForLogin = async (e, t)=>this.post(`${J.v1}/user/mfa/sms/${e}`, t), this.verifyMFASMSForLogin = async (e, t)=>this.post(`${J.v1}/user/mfa/sms/${e}/verify`, t), this.verifyMFASMSForLoginV2 = async (e, t)=>{
                        const a = await this.post(`${J.v1}/user/mfa/sms/${e}/verify`, t);
                        return this.generateLoginResponseV3(a);
                    }, this.preEnrollMFAWebAuthnForLogin = async (e)=>this.post(`${J.v1}/user/mfa/webauthn/enroll`, e), this.enrollMFAWebAuthnForLogin = async (e)=>this.post(`${J.v1}/user/mfa/webauthn/enroll/verify`, e), this.enrollMFAWebAuthnForLoginV2 = async (e)=>{
                        const t = await this.post(`${J.v1}/user/mfa/webauthn/enroll/verify`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.preVerifyMFAWebAuthnForLogin = async (e, t)=>this.post(`${J.v1}/user/mfa/webauthn/${e}`, t), this.verifyMFAWebAuthnForLogin = async (e, t)=>this.post(`${J.v1}/user/mfa/webauthn/${e}/verify`, t), this.verifyMFAWebAuthnForLoginV2 = async (e, t)=>{
                        const a = await this.post(`${J.v1}/user/mfa/webauthn/${e}/verify`, t);
                        return this.generateLoginResponseV3(a);
                    }, this.getSamlConfiguration = async ()=>this.get(`${ge.v1}/saml/configurations`), this.updateSamlConfiguration = async (e)=>this.post(`${ge.v1}/saml/configurations`, e), this.getSamlVendorConfiguration = async ()=>this.get(`${ge.v1}/saml/configurations/vendor-config`), this.updateSamlVendorMetadata = async (e)=>this.put(`${ge.v1}/saml/configurations/metadata`, e), this.validateSamlDomain = async ()=>this.put(`${ge.v1}/saml/validations/domain`), this.getSamlRoles = async ()=>this.get(`${ge.v1}/saml/configurations/roles/default`), this.getSamlRolesGroups = async ()=>this.get(`${ge.v2}/saml/configurations/groups`), this.updateSamlRoles = async ({ roleIds: e })=>this.post(`${ge.v1}/saml/configurations/roles/default`, {
                            roleIds: e
                        }), this.createSamlGroup = async ({ roleIds: e, group: t })=>this.post(`${ge.v2}/saml/configurations/groups`, {
                            group: t,
                            roleIds: e
                        }), this.updateSamlGroup = async ({ roleIds: e, group: t, id: a })=>this.patch(`${ge.v2}/saml/configurations/groups/${a}`, {
                            group: t,
                            roleIds: e
                        }), this.deleteSamlGroup = async ({ id: e })=>this.delete(`${ge.v2}/saml/configurations/groups/${e}`), this.getOidcConfiguration = async ()=>this.get(`${ge.v1}/oidc/configurations`), this.getSSOPublicConfiguration = async ()=>this.get(`${ge.v2}/configurations/public`), this.getSocialLoginProviders = async ()=>this.get(ee.v1), this.getSocialLoginProvidersV2 = async ()=>this.get(ee.v2), this.getSocialLoginProvidersV2ForAuthenticatedUser = async ()=>this.get(`${ee.v2}/authenticated`), this.getCustomSocialLoginProvidersV1 = async ()=>this.get(ee.custom.v1), this.loginViaSocialLogin = async (e)=>{
                        const t = {};
                        return e.code && (t.code = e.code), e.idToken && (t.id_token = e.idToken), e.redirectUri && (t.redirectUri = e.redirectUri), e.codeVerifier && (t.code_verifier = e.codeVerifier), e.codeVerifierPkce && (t.code_verifier_pkce = e.codeVerifierPkce), e.state && (t.state = e.state), this.post(`${J.v1}/user/sso/${e.provider}/postlogin`, {
                            metadata: e.metadata,
                            invitationToken: e.invitationToken
                        }, {
                            params: t
                        });
                    }, this.getVendorConfig = async ()=>this.get(`${X.v1}/public`), this.signUp = async (e, t)=>{
                        const { shouldActivate: a, authResponse: n, userId: s, tenantId: i, activationToken: o } = await this.post(e, t), r = {
                            shouldActivate: a,
                            userId: s,
                            tenantId: i
                        };
                        if (!a && n) {
                            const { user: e, tenants: t, activeTenant: a } = await this.generateLoginResponseV3(n);
                            return v({}, r, {
                                user: e,
                                tenants: t,
                                activeTenant: a
                            });
                        }
                        return v({}, r, {
                            activationToken: o
                        });
                    }, this.signUpUser = async (e)=>this.signUp(`${Q.v1}/signUp`, e), this.signUpUserWithPhoneNumber = async (e)=>this.signUp(`${Q.v1}/signUp/phoneNumber`, e), this.signUpUserWithUsername = async (e)=>this.signUp(`${Q.v1}/signUp/username`, e), this.getCurrentUserSessions = async ()=>this.get(Q.sessions.currentUser.v1), this.getCurrentUserSession = async ()=>this.get(`${Q.sessions.currentUser.v1}/current`), this.revokeSessionsForUser = async (e)=>this.post(`${Q.sessions.v1}/revoke`, {
                            userId: e
                        }), this.getSessionConfigurations = async ()=>this.get(Q.sessions.configurations.v1), this.createOrUpdateSessionConfigrations = async (e)=>{
                        await this.post(Q.sessions.configurations.v1, e);
                    }, this.deleteSessionForUser = async (e)=>{
                        await this.delete(`${Q.sessions.currentUser.v1}/${e}`);
                    }, this.deleteAllSessionsForUser = async ()=>{
                        await this.delete(`${Q.sessions.currentUser.v1}/all`);
                    }, this.getUserAccessTokensData = async ()=>this.get(Q.accessTokens.v1), this.getTenantAccessTokensData = async ()=>this.get(ae.accessTokens.v1), this.deleteTenantAccessToken = async ({ id: e })=>{
                        await this.delete(`${ae.accessTokens.v1}/${e}`);
                    }, this.deleteUserAccessToken = async ({ id: e })=>{
                        await this.delete(`${Q.accessTokens.v1}/${e}`);
                    }, this.createUserAccessToken = async (e)=>this.post(Q.accessTokens.v1, e), this.createTenantAccessToken = async (e)=>this.post(ae.accessTokens.v1, e), this.getUserApiTokensData = async ()=>this.get(Q.apiTokens.v1), this.getTenantApiTokensData = async ()=>this.get(ae.apiTokens.v1), this.updateUserApiTokensData = async (e)=>this.post(Q.apiTokens.v1, e), this.updateTenantApiTokensData = async (e)=>this.post(ae.apiTokens.v2, e), this.deleteTenantApiToken = async ({ tokenId: e })=>{
                        await this.delete(`${ae.apiTokens.v1}/${e}`);
                    }, this.deleteUserApiToken = async ({ tokenId: e })=>{
                        await this.delete(`${Q.apiTokens.v1}/${e}`);
                    }, this.getUserById = async ({ userId: e })=>this.get(`${Q.v1}/${e}`), this.checkIfAllowToRememberMfaDevice = async (e)=>this.get(`${X.v1}/mfa-policy/allow-remember-device`, {
                            mfaToken: e
                        }), this.passwordlessPreLogin = async (e)=>{
                        var t;
                        let { type: a } = e, n = f(e, wt);
                        const s = (null == (t = ({
                            [M.UsernameAndCode]: M.Code,
                            [M.UsernameAndMagicLink]: M.MagicLink,
                            [M.UsernameAndSms]: M.SmsCode,
                            [M.UsernameAndPassword]: M.EmailAndPassword
                        })[a]) ? void 0 : t.toLowerCase()) || a.toLowerCase();
                        return this.post(`${J.v1}/passwordless/${s}/prelogin`, n);
                    }, this.passwordlessPostLoginV2 = async (e)=>{
                        let { type: t } = e, a = f(e, Tt);
                        const n = await this.post(`${J.v1}/passwordless/${t.toLocaleLowerCase()}/postlogin`, a);
                        return this.generateLoginResponseV3(n);
                    }, this.passwordlessPostLogin = async (e)=>{
                        let { type: t } = e, a = f(e, Et);
                        return this.post(`${J.v1}/passwordless/${t.toLocaleLowerCase()}/postlogin`, a);
                    }, this.verifyInviteToken = async ({ token: e })=>this.post(ae.invites.verify.v1, {
                            token: e
                        }), this.getSSOConfigurations = async ()=>this.get(`${ge.v1}/configurations`), this.createSSOConfiguration = async (e)=>this.post(`${ge.v1}/configurations`, e), this.updateSSOConfiguration = async (e, t)=>this.patch(`${ge.v1}/configurations/${e}`, t), this.deleteSSOConfiguration = async (e)=>{
                        await this.delete(`${ge.v1}/configurations/${e}`);
                    }, this.createSSOConfigurationByMetadata = async (e)=>this.post(`${ge.v1}/configurations/metadata`, e), this.updateSSOConfigurationByMetadata = async (e, t)=>this.put(`${ge.v1}/configurations/${e}/metadata`, t), this.createSSOConfigurationByMetadataUrl = async (e)=>this.post(`${ge.v1}/configurations/metadata-url`, e), this.updateSSOConfigurationByMetadataUrl = async (e, t)=>this.put(`${ge.v1}/configurations/${e}/metadata-url`, t), this.createSSODomain = async (e, t)=>this.post(`${ge.v1}/configurations/${e}/domains`, t), this.deleteSSODomain = async (e, t)=>this.delete(`${ge.v1}/configurations/${e}/domains/${t}`), this.validateSSODomain = async (e, t)=>this.put(`${ge.v1}/configurations/${e}/domains/${t}/validate`), this.validateSSODomainV2 = async (e, t)=>this.put(`${ge.v2}/configurations/${e}/domains/${t}/validate`), this.getSSODefaultRoles = async (e)=>this.get(`${ge.v1}/configurations/${e}/roles`), this.setSSODefaultRoles = async (e, t)=>this.put(`${ge.v1}/configurations/${e}/roles`, t), this.createSSOGroup = async (e, t)=>this.post(`${ge.v1}/configurations/${e}/groups`, t), this.updateSSOGroup = async (e, { roleIds: t, group: a, id: n })=>this.patch(`${ge.v1}/configurations/${e}/groups/${n}`, {
                            group: a,
                            roleIds: t
                        }), this.deleteSSOGroup = async (e, t)=>this.delete(`${ge.v1}/configurations/${e}/groups/${t}`), this.getSSOGroups = async (e)=>this.get(`${ge.v1}/configurations/${e}/groups`), this.preLoginV2 = async (e)=>this.post(`${J.v2}/user/sso/prelogin`, e), this.oidcPostLoginV2 = async (e)=>{
                        const t = await this.post(`${J.v2}/user/oidc/postlogin`, e);
                        return this.generateLoginResponse(t);
                    }, this.exchangeOAuthTokensV2 = async (e)=>{
                        const t = await this.post(`${Re}/token`, e);
                        return this.generateLoginResponseFromOAuthResponseV2(t);
                    }, this.silentOAuthRefreshTokenV2 = async ()=>{
                        const e = ht(this.appName), t = await this.post(`${Re}/authorize/silent`, {
                            tenantId: e
                        });
                        return this.generateLoginResponseFromOAuthResponseV2(t);
                    }, this.exchangeOAuthTokens = async (e)=>{
                        const t = await this.post(`${Re}/token`, e);
                        return this.generateLoginResponseFromOAuthResponse(t);
                    }, this.silentOAuthRefreshToken = async ()=>{
                        const e = ht(this.appName), t = await this.post(`${Re}/authorize/silent`, {
                            tenantId: e
                        });
                        return this.generateLoginResponseFromOAuthResponse(t);
                    }, this.resetPhoneNumber = async (e)=>this.post(`${Q.v1}/phone/reset`, e), this.verifyResetPhoneNumber = async (e)=>this.post(`${Q.v1}/phone/reset/verify`, e), this.changePhoneNumberWithVerification = async (e)=>this.post(`${Q.v1}/phone`, e), this.verifyChangePhoneNumber = async (e)=>this.post(`${Q.v1}/phone/verify`, e), this.changePhoneNumber = async (e)=>this.put(`${Q.v1}/phone/change`, e), this.webAuthnPreLogin = async (e)=>this.post(`${J.v1}/webauthn/prelogin`, e), this.webAuthnPostLogin = async (e)=>this.post(`${J.v1}/webauthn/postlogin`, e), this.webAuthnPostLoginV2 = async (e)=>{
                        const t = await this.post(`${J.v1}/webauthn/postlogin`, e);
                        return this.generateLoginResponseV3(t);
                    }, this.webAuthnCreateNewDeviceSession = async ()=>this.post(Y.v1), this.getWebAuthnDevices = async ()=>this.get(Y.v1), this.deleteWebAuthnDevice = async (e)=>this.delete(`${Y.v1}/${e}`), this.verifyNewDeviceSession = async (e)=>this.post(`${Y.v1}/verify`, e), this.getVendorPublicAuthStrategiesConfig = async ()=>this.get(`${X.v1}/auth/strategies/public`), this.getPublicAuthStrategiesConfigForAuthenticatedUser = async ()=>this.get(`${X.v1}/auth/strategies`), this.getMFAStrategiesConfig = async ()=>this.get(`${X.v1}/mfa/strategies`), this.getUserAuthorization = async ()=>this.get(`${Q.authorization.v1}`), this.getMeV2 = async ()=>this.get(`${Q.v2}/me`), this.noThrowLoadEntitlements = async ()=>{
                        try {
                            return await this.entitlementsApi.loadEntitlementsV2();
                        } catch (e) {}
                    }, this.getMeAndEntitlements = async ()=>{
                        if (L.for(this.appName).shouldSkipUserLoad()) return {
                            roles: [],
                            permissions: [],
                            groups: [],
                            tenants: []
                        };
                        const e = [
                            {
                                action: this.getMeV2,
                                shouldLoad: !0
                            },
                            {
                                action: this.noThrowLoadEntitlements,
                                shouldLoad: this.shouldLoadEntitlements()
                            },
                            {
                                action: this.getUserAuthorization,
                                shouldLoad: this.shouldLoadMeAuthorization()
                            }
                        ].map((e)=>(async function({ shouldLoad: e, action: t }) {
                                if (e) return await t();
                            })(e)), [t, a, n] = await Promise.all(e), s = ht(this.appName);
                        return s && (t.tenantId = s), v({}, t, null != n ? n : {}, {
                            entitlements: a
                        });
                    }, this.generateStepupSession = async (e)=>{
                        const t = await this.post(`${J.v1}/user/step-up/generate`, e);
                        return t.accessToken ? this.generateLoginResponseV3(t) : t;
                    }, this.getGlobalSecurityPolicy = this.securityPolicy.getGlobalSecurityPolicy.bind(this.securityPolicy), this.getMfaPolicy = this.securityPolicy.getMfaPolicy.bind(this.securityPolicy), this.getVendorMfaPolicy = this.securityPolicy.getVendorMfaPolicy.bind(this.securityPolicy), this.saveMfaPolicy = this.securityPolicy.saveMfaPolicy.bind(this.securityPolicy), this.getLockoutPolicy = this.securityPolicy.getLockoutPolicy.bind(this.securityPolicy), this.getVendorLockoutPolicy = this.securityPolicy.getVendorLockoutPolicy.bind(this.securityPolicy), this.saveLockoutPolicy = this.securityPolicy.saveLockoutPolicy.bind(this.securityPolicy), this.getCaptchaPolicy = this.securityPolicy.getCaptchaPolicy.bind(this.securityPolicy), this.getPasswordHistoryPolicy = this.securityPolicy.getPasswordHistoryPolicy.bind(this.securityPolicy), this.getVendorPasswordHistoryPolicy = this.securityPolicy.getVendorPasswordHistoryPolicy.bind(this.securityPolicy), this.savePasswordHistoryPolicy = this.securityPolicy.savePasswordHistoryPolicy.bind(this.securityPolicy), this.getPasswordConfigPolicy = this.securityPolicy.getPasswordConfigPolicy.bind(this.securityPolicy), this.getDomainRestrictions = this.securityPolicy.getDomainRestrictions.bind(this.securityPolicy), this.getDomainRestrictionsConfig = this.securityPolicy.getDomainRestrictionsConfig.bind(this.securityPolicy), this.createDomainRestriction = this.securityPolicy.createDomainRestriction.bind(this.securityPolicy), this.updateDomainRestrictionConfig = this.securityPolicy.updateDomainRestrictionConfig.bind(this.securityPolicy), this.deleteDomainRestriction = this.securityPolicy.deleteDomainRestriction.bind(this.securityPolicy), this.getIPRestrictions = this.securityPolicy.getIPRestrictions.bind(this.securityPolicy), this.getIPRestrictionsConfig = this.securityPolicy.getIPRestrictionsConfig.bind(this.securityPolicy), this.createIPRestriction = this.securityPolicy.createIPRestriction.bind(this.securityPolicy), this.bulkCreateIPRestriction = this.securityPolicy.bulkCreateIPRestriction.bind(this.securityPolicy), this.updateIPRestrictionConfig = this.securityPolicy.updateIPRestrictionConfig.bind(this.securityPolicy), this.deleteIPRestriction = this.securityPolicy.deleteIPRestriction.bind(this.securityPolicy), this.testCurrentIp = this.securityPolicy.testCurrentIp.bind(this.securityPolicy), this.testCurrentIpInAllowList = this.securityPolicy.testCurrentIpInAllowList.bind(this.securityPolicy);
                }
                shouldLoadEntitlements() {
                    return L.for(this.appName).shouldLoadEntitlements();
                }
                shouldLoadMeAuthorization() {
                    const [e] = it.getFeatureFlags([
                        at
                    ], this.appName);
                    return e;
                }
            }
            const It = new Pt("default");
            class Ot extends nt {
                constructor(e){
                    super(e), this.getProfile = async (e)=>this.get(`${Q.v2}/me`, null != e ? e : {
                            addRoles: !0
                        }), this.updateEmail = async (e)=>this.post(`${Q.v1}/email/me`, {
                            email: e
                        }), this.verifyEmail = async (e, t)=>this.post(`${Q.v1}/email/me/verify`, {
                            email: e,
                            code: t
                        }), this.updateProfile = async (e)=>this.put(`${Q.v2}/me`, e), this.updateProfileImage = async (e)=>this.put(`${Se.v1}/me/image/v1`, e, {
                            responseType: "plain",
                            contentType: void 0
                        }), this.changePassword = async (e)=>this.post(`${Q.v1}/passwords/change`, e), this.loadUsers = async (e)=>{
                        var t, a, n, s, i, o;
                        const r = (e.filter || []).reduce((e, t)=>v({}, e, {
                                [t.id]: t.value
                            }), {}), l = null != (t = e.sort) && t.length ? {
                            sortBy: null != (a = null == (n = e.sort) || null == (s = n[0]) ? void 0 : s.id) ? a : "name",
                            sortDirection: null != (i = e.sort) && null != (o = i[0]) && o.desc ? "desc" : "asc"
                        } : null;
                        return this.get(pe.v1, v({
                            pageOffset: e.pageOffset,
                            pageSize: e.pageSize
                        }, r, l));
                    }, this.addUser = async (e)=>this.post(Q.v2, v({}, e, {
                            provider: "local"
                        })), this.deleteUser = async (e)=>this.delete(`${pe.v1}/${e.userId}`), this.updateUser = async (e)=>this.put(pe.v1, e), this.updateUserExpirationTime = async (e)=>{
                        const { userId: t, expirationInSeconds: a } = e;
                        return this.put(`${Q.temporary.v1}/${t}`, {
                            expirationInSeconds: a
                        });
                    }, this.setPermanentUser = async (e)=>this.delete(`${Q.temporary.v1}/${e}`), this.getTemporaryUserConfiguration = async ()=>this.get(Q.temporary.configuration.v1), this.createInviteUserLink = async (e)=>this.post(ae.invites.user.v1, v({}, e)), this.createInviteUserLinkV2 = async (e)=>this.post(ae.invites.user.v2, v({}, e)), this.updateInviteUserLink = async (e)=>this.patch(ae.invites.user.v1, v({}, e)), this.deleteInviteUserLink = async ()=>this.delete(ae.invites.user.v1), this.getInviteUserLink = async ()=>this.get(ae.invites.user.v1), this.getInviteLinkConfiguration = async ()=>this.get(ae.invites.configuration.v1), this.loadAvailableRoles = async ()=>this.get(he.v1), this.loadAvailablePermissions = async ()=>this.get(te.v1), this.loadStats = async ()=>this.get(`${ye.v1}/members`), this.resendActivationLink = async (e)=>this.post(`${pe.v1}/${e.userId}/resendActivationEmail`, {}), this.resendInvitationLink = async (e)=>this.post(Q.v2, v({}, e, {
                            provider: "local"
                        })), this.resendInvitationLinkToAllTenants = async (e)=>this.post(Q.invitation.resendAll.v1, v({}, e)), this.disableUser = async (e)=>this.post(`${ae.users.v1}/${e}/disable`), this.enableUser = async (e)=>this.post(`${ae.users.v1}/${e}/enable`);
                }
            }
            const kt = new Ot("default");
            class _t extends nt {
                constructor(e){
                    super(e), this.getMetadata = async (e)=>{
                        var t, a;
                        const n = await this.get("/metadata", e);
                        if (null != n && null != (t = n.rows) && t[0]) return null == n || null == (a = n.rows) ? void 0 : a[0];
                        throw new Error(`metadata not found: ${e.entityName}`);
                    }, this.getAdminBoxMetadata = async ()=>this.get("/metadata/admin-box"), this.updateAdminBoxMetadata = async (e)=>this.post("/metadata/admin-box", e), this.getIpMetadata = async (e)=>{
                        const t = await this.get(`/metadata/ip/${e}`);
                        if (t) return t;
                        throw new Error("ip metadata not found");
                    }, this.getCurrentUserIpMetadata = async ()=>{
                        const e = await this.get("/metadata/ipme");
                        if (e) return e;
                        throw new Error("ip metadata not found");
                    }, this.getNotificationsMetadata = async ()=>this.getMetadata({
                            entityName: "notifications"
                        }), this.getSamlMetadata = async ()=>this.getMetadata({
                            entityName: "saml"
                        }), this.getAuditsMetadata = async ()=>this.getMetadata({
                            entityName: "audits"
                        }), this.getIpAdressMetadata = async (e)=>this.getIpMetadata(e);
                }
            }
            const Rt = new _t("default"), Ut = [
                "dataFilters"
            ], Lt = [
                "templateId",
                "dataFilters"
            ], Ct = [
                "dataFilters"
            ];
            class Dt extends nt {
                constructor(e){
                    super(e), this.getReports = async (e)=>this.get(`${Ee.v2}/tenant-reports`, e), this.getReport = async (e)=>this.get(`${Ee.v2}/${e.id}/tenant-reports`), this.renderReport = async (e)=>{
                        let { dataFilters: t } = e, a = f(e, Ut);
                        return {
                            html: await this.get(`${Pe.v1}/preview-report`, v({}, a, {
                                dataFilters: btoa(JSON.stringify(t || {})),
                                responseType: "html"
                            }), {
                                responseType: "plain"
                            })
                        };
                    }, this.scheduleReport = async (e)=>{
                        let { templateId: t, dataFilters: a } = e, n = f(e, Lt);
                        return this.post(`${Ee.v2}/${t}/tenant-reports`, v({}, n, {
                            dataFilters: btoa(JSON.stringify(a || {}))
                        }));
                    }, this.downloadReport = async (e)=>{
                        let { dataFilters: t } = e, a = f(e, Ct);
                        const n = await this.get(`${Pe.v1}/preview-report`, v({}, a, {
                            dataFilters: btoa(JSON.stringify(t || {}))
                        }), {
                            responseType: "blob"
                        });
                        let s = "text/html", i = "html";
                        "pdf" === a.responseType ? (s = "application/pdf", i = "pdf") : "image" === a.responseType && (s = "image/jpeg", i = "jpg");
                        const o = new Blob([
                            n
                        ], {
                            type: s
                        }), r = URL.createObjectURL(o), l = document.createElement("a");
                        l.href = r, l.setAttribute("download", `report_${a.name || ""}.${i}`), l.click(), setTimeout(l.remove.bind(l));
                    }, this.sendReport = async (e)=>this.post(`${Pe.v1}/tenant-reports`, e);
                }
            }
            const Nt = new Dt("default"), Mt = [
                "eventKey"
            ], Ft = [
                "eventKey"
            ];
            class xt extends nt {
                constructor(e){
                    super(e), this.getSlackConfiguration = ()=>this.get(`${be.v1}/slack`), this.getSlackScope = ()=>this.get(`${be.v1}/slack/applications`), this.getSlackChannels = ()=>this.get(`${be.v1}/slack/channels`), this.postSlackConfiguration = (e)=>e.id ? this.patch(`${be.v1}/slack/subscription/${e.id}`, e) : this.post(`${be.v1}/slack/subscriptions`, e), this.deleteSlackConfiguration = (e)=>this.delete(`${be.v1}/slack/subscriptions/${e.id}`), this.postSlackCode = (e)=>this.post(`${be.v1}/slack/applications/registrations`, {
                            code: e
                        }), this.getEmailConfiguration = ()=>this.get(`${be.v1}/emails`), this.postEmailConfiguration = (e)=>{
                        let { eventKey: t } = e, a = f(e, Mt);
                        return this.post(`${be.v1}/emails/${t}`, a);
                    }, this.patchEmailConfiguration = ({ eventKey: e, enabled: t })=>this.patch(`${be.v1}/emails/${e}`, {
                            enabled: t
                        }), this.deleteEmailSubscriptions = (e, t)=>this.delete(`${be.v1}/emails/${e}/subscriptions/${t}`), this.putEmailSubscriptions = (e, t, a)=>this.put(`${be.v1}/emails/${t}/subscriptions/${e}`, a), this.deleteEmailConfiguration = (e)=>this.delete(`${be.v1}/emails/${e}`), this.getSMSConfiguration = ()=>this.get(`${be.v2}/sms`), this.postSMSConfiguration = (e)=>{
                        let { eventKey: t } = e, a = f(e, Ft);
                        return this.post(`${be.v2}/sms/${t}`, a);
                    }, this.patchSMSConfiguration = ({ eventKey: e, enabled: t })=>this.patch(`${be.v2}/sms/${e}`, {
                            enabled: t
                        }), this.deleteSMSSubscriptions = (e, t)=>this.delete(`${be.v2}/sms/${e}/subscriptions/${t}`), this.putSMSSubscriptions = (e, t, a)=>this.put(`${be.v2}/sms/${t}/subscriptions/${e}`, a), this.deleteSMSConfiguration = (e)=>this.delete(`${be.v2}/sms/${e}`), this.getWebhooksConfigurations = ()=>this.get(_e), this.postWebhooksConfiguration = (e)=>e._id ? this.patch(`${_e}/${e._id}`, e) : this.post(`${_e}/custom`, e), this.deleteWebhooksConfiguration = (e)=>this.delete(`${_e}/${e}`), this.getWebhookLog = (e, t = 0, a = 10)=>{
                        const n = new URLSearchParams({
                            id: e,
                            offset: `${t}`,
                            limit: `${a}`
                        });
                        return this.get(`${_e}/logs/?${n.toString()}`);
                    }, this.postWebhookTest = (e)=>this.post(`${_e}/test`, e), this.postWebhookRetry = (e)=>this.post(`${_e}/logs/${e}/retries`), this.getCategories = ()=>this.get(`${ke.v1}/categories`), this.getChannelMaps = (e)=>this.get(ke.v1, {
                            channels: e
                        });
                }
            }
            const $t = new xt("default");
            class Gt extends nt {
                constructor(e){
                    super(e), this.getNotifications = async (e)=>this.get(Ie, {
                            params: e
                        }), this.updateNotificationStatus = async (e)=>this.put(`${Ie}/status`, {
                            params: e
                        }), this.updateNotificationIsPinned = async (e)=>{
                        const { notificationId: t, pinStatus: a } = e;
                        return this.put(`${Ie}/${a}`, {
                            notificationId: t
                        });
                    }, this.markAllAsRead = async ()=>this.post(`${Ie}/status/mark-all-read`);
                }
            }
            const jt = new Gt("default"), Vt = [
                "endpoint",
                "headerProps"
            ];
            class Bt extends nt {
                constructor(e){
                    super(e), this.getAudits = async (e)=>this.get(Oe, e), this.getAuditsStats = async (e)=>this.get(`${Oe}/stats`, e), this.exportAudits = async (e)=>{
                        const { endpoint: t, headerProps: a } = e, n = f(e, Vt);
                        return this.postDownload(`${Oe}/export/${t}`, {
                            properties: a
                        }, n);
                    };
                }
            }
            const Wt = new Bt("default");
            class zt extends nt {
                constructor(e){
                    super(e), this.updateSettings = async (e, t)=>this.put(ve.v1, e, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getSettings = async (e)=>this.get(ve.v1, void 0, {
                            headers: this.extractHeadersFromOptions(e)
                        }), this.getPublicSettings = async ()=>this.get(`${ve.v1}/public`);
                }
            }
            const Ht = new zt("default"), Kt = [
                "roleId"
            ], qt = [
                "roleId"
            ], Yt = [
                "permissionId"
            ];
            class Jt extends nt {
                constructor(e){
                    super(e), this.getRoles = async ()=>this.get(ne.v1), this.addRole = async (e)=>this.post(ne.v1, e), this.deleteRole = async ({ roleId: e })=>this.delete(`${ne.v1}/${e}`), this.updateRole = async (e)=>{
                        let { roleId: t } = e, a = f(e, Kt);
                        return this.patch(`${ne.v1}/${t}`, a);
                    }, this.attachPermissionsToRole = async (e)=>{
                        let { roleId: t } = e, a = f(e, qt);
                        return this.put(`${ne.v1}/${t}/permissions`, a);
                    }, this.getPermissions = async ()=>this.get(te.v1), this.attachPermissionToRoles = async (e)=>{
                        let { permissionId: t } = e, a = f(e, Yt);
                        return this.put(`${te.v1}/${t}/roles`, a);
                    }, this.getPermissionCategories = async ()=>this.get(`${te.v1}/categories`), this.addRoleV2 = async (e)=>this.post(ne.v2, e);
                }
            }
            const Qt = new Jt("default");
            class Xt extends nt {
                constructor(...e){
                    super(...e), this.getSubscriptionInvoices = async ()=>this.get(Ae.invoices.v1), this.getSubscriptionInvoice = async (e)=>this.get(`${Ae.invoices.v1}/${e}`), this.getSubscriptionInvoicePdf = async (e, t)=>this.get(`${Ae.invoices.v1}/${e}/pdf`, {
                            outputFileName: t
                        }, {
                            responseType: "blob"
                        });
                }
            }
            class Zt extends nt {
                constructor(...e){
                    super(...e), this.getManagedSubscription = async (e)=>this.get(`${Te.v1}/${e}`), this.getManagedSubscriptions = async ()=>this.get(Te.v1), this.cancelManagedSubscription = async (e)=>this.put(`${Te.v1}/${e}/cancellations/`, {}), this.renewManagedSubscription = async (e)=>this.put(`${Te.v1}/${e}/renewals/`, {}), this.updateManagedSubscription = async (e, { paymentMethodId: t, planId: a })=>this.put(`${Te.v1}/${e}`, {
                            paymentMethodId: t,
                            planId: a
                        });
                }
            }
            const ea = [
                "email"
            ];
            class ta extends nt {
                constructor(...e){
                    super(...e), this.getPaymentMethods = async ()=>this.get(Ae.paymentMethods.v1), this.getPaymentMethod = async (e)=>this.get(`${Ae.paymentMethods.v1}/${e}`), this.updatePaymentMethodBillingDetails = async (e, t)=>{
                        let { email: a } = t, n = f(t, ea);
                        return this.patch(`${Ae.paymentMethods.v1}/${e}/billing-details`, {
                            email: a,
                            address: n
                        });
                    };
                }
            }
            class aa extends nt {
                constructor(...e){
                    super(...e), this.getPaymentProviders = async ()=>this.get(we.v1);
                }
            }
            class na extends nt {
                constructor(...e){
                    super(...e), this.getSubscriptionPlans = async ()=>this.get(Ae.plans.v1), this.getSubscriptionPlan = async (e)=>this.get(`${Ae.plans.v1}/${e}`);
                }
            }
            class sa extends nt {
                constructor(...e){
                    super(...e), this.getSubscriptions = async ()=>this.get(Ae.subscriptions.v1), this.getSubscription = async (e)=>this.get(`${Ae.subscriptions.v1}/${e}`), this.cancelSubscription = async (e)=>this.put(`${Ae.subscriptions.v1}/${e}/cancellations/`, {}), this.renewSubscription = async (e)=>this.put(`${Ae.subscriptions.v1}/${e}/renewals/`, {}), this.updateSubscription = async (e, { paymentMethodId: t, planId: a })=>this.put(`${Ae.subscriptions.v1}/${e}`, {
                            paymentMethodId: t,
                            planId: a
                        });
                }
            }
            class ia extends nt {
                constructor(...e){
                    super(...e), this.getSubscriptionSummaries = async (e)=>this.get(`${Ae.summaries.v1}/${e}`);
                }
            }
            class oa extends nt {
                constructor(...e){
                    super(...e), this.getTenantConfiguration = async (e)=>this.get(`${Ae.tenantConfiguration.v1}/${e}`), this.createTenantConfiguration = async (e)=>this.post(Ae.tenantConfiguration.v1, e);
                }
            }
            class ra extends nt {
                constructor(...e){
                    super(...e), this.getVendorPublicConfigurations = async ()=>this.get(Ae.configurations.vendorPublicConfigurations.v1);
                }
            }
            class la extends nt {
                constructor(...e){
                    super(...e), this.createSubscription = async (e)=>this.post(Ae.paymentProviders.stripe.subscriptions.v1, e), this.getStripeCustomer = async (e)=>this.get(`${Ae.paymentProviders.stripe.customers.v1}/${e}`), this.createStripeCustomer = async (e)=>this.post(Ae.paymentProviders.stripe.customers.v1, e), this.getStripePaymentProviderConfiguration = async ()=>this.get(Ae.paymentProviders.stripe.publicConfigurations.v1), this.createStripePaymentMethodSetupIntentSecret = async (e)=>this.post(Ae.paymentProviders.stripe.setupIntents.v1, e);
                }
            }
            class ca extends nt {
                constructor(e){
                    super(e), this.invoicesApi = new Xt(this.appName), this.managedSubscriptionApi = new Zt(this.appName), this.paymentMethodsApi = new ta(this.appName), this.paymentProvidersApi = new aa(this.appName), this.plansApi = new na(this.appName), this.subscriptionApi = new sa(this.appName), this.summariesApi = new ia(this.appName), this.subscriptionTenantConfigApi = new oa(this.appName), this.vendorPublicConfigApi = new ra(this.appName), this.stripeProviderApi = new la(this.appName), this.getSubscriptionInvoices = this.invoicesApi.getSubscriptionInvoices.bind(this.invoicesApi), this.getSubscriptionInvoice = this.invoicesApi.getSubscriptionInvoice.bind(this.invoicesApi), this.getSubscriptionInvoicePdf = this.invoicesApi.getSubscriptionInvoicePdf.bind(this.invoicesApi), this.getManagedSubscription = this.managedSubscriptionApi.getManagedSubscription.bind(this.managedSubscriptionApi), this.getManagedSubscriptions = this.managedSubscriptionApi.getManagedSubscriptions.bind(this.managedSubscriptionApi), this.cancelManagedSubscription = this.managedSubscriptionApi.cancelManagedSubscription.bind(this.managedSubscriptionApi), this.renewManagedSubscription = this.managedSubscriptionApi.renewManagedSubscription.bind(this.managedSubscriptionApi), this.updateManagedSubscription = this.managedSubscriptionApi.updateManagedSubscription.bind(this.managedSubscriptionApi), this.getPaymentMethods = this.paymentMethodsApi.getPaymentMethods.bind(this.paymentMethodsApi), this.getPaymentMethod = this.paymentMethodsApi.getPaymentMethod.bind(this.paymentMethodsApi), this.updatePaymentMethodBillingDetails = this.paymentMethodsApi.updatePaymentMethodBillingDetails.bind(this.paymentMethodsApi), this.getPaymentProviders = this.paymentProvidersApi.getPaymentProviders.bind(this.paymentProvidersApi), this.getSubscriptionPlans = this.plansApi.getSubscriptionPlans.bind(this.plansApi), this.getSubscriptionPlan = this.plansApi.getSubscriptionPlan.bind(this.plansApi), this.getSubscriptions = this.subscriptionApi.getSubscriptions.bind(this.subscriptionApi), this.getSubscription = this.subscriptionApi.getSubscription.bind(this.subscriptionApi), this.cancelSubscription = this.subscriptionApi.cancelSubscription.bind(this.subscriptionApi), this.renewSubscription = this.subscriptionApi.renewSubscription.bind(this.subscriptionApi), this.updateSubscription = this.subscriptionApi.updateSubscription.bind(this.subscriptionApi), this.getSubscriptionSummaries = this.summariesApi.getSubscriptionSummaries.bind(this.summariesApi), this.getTenantConfiguration = this.subscriptionTenantConfigApi.getTenantConfiguration.bind(this.subscriptionTenantConfigApi), this.createTenantConfiguration = this.subscriptionTenantConfigApi.createTenantConfiguration.bind(this.subscriptionTenantConfigApi), this.getVendorPublicConfigurations = this.vendorPublicConfigApi.getVendorPublicConfigurations.bind(this.vendorPublicConfigApi), this.createSubscription = this.stripeProviderApi.createSubscription.bind(this.stripeProviderApi), this.getStripeCustomer = this.stripeProviderApi.getStripeCustomer.bind(this.stripeProviderApi), this.createStripeCustomer = this.stripeProviderApi.createStripeCustomer.bind(this.stripeProviderApi), this.getStripePaymentProviderConfiguration = this.stripeProviderApi.getStripePaymentProviderConfiguration.bind(this.stripeProviderApi), this.createStripePaymentMethodSetupIntentSecret = this.stripeProviderApi.createStripePaymentMethodSetupIntentSecret.bind(this.stripeProviderApi);
                }
            }
            const ua = new ca("default");
            class da extends nt {
                constructor(e){
                    super(e), this.getVendorPublicInfo = async ()=>this.get("/vendors/public");
                }
            }
            const ga = new da("default");
            class pa extends nt {
                constructor(e){
                    super(e), this.loadAllUsers = async (e)=>this.get(se.v1, e), this.addUserToTenantAndSubTenants = async (e)=>this.post(se.v1, e), this.removeUserFromTenantAndSubTenants = async (e, t)=>this.delete(se.v1, e, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.addUserRolesForSubTenants = async (e, t, a)=>this.post(`${se.v1}/${e}/roles`, t, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.removeUserRolesFromSubTenants = async (e, t, a)=>this.delete(`${se.v1}/${e}/roles`, t, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.setUserRolesForSubTenants = async (e, t, a)=>this.patch(`${se.v1}/${e}/roles`, t, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.createSubTenant = async (e, t)=>this.post(me.v1, e, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.deleteSubTenant = async (e, t)=>this.delete(`${me.v1}/${e}`, void 0, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.updateSubTenant = async ({ tenantId: e }, t, a)=>this.patch(`${me.v1}/${e}`, t, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.updateSubTenantManagement = async ({ tenantId: e }, t, a)=>this.put(`${me.v1}/${e}/management`, t, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.updateSubAccountAccess = async (e, t, a)=>this.put(`${se.v1}/${e}/access`, t, {
                            headers: this.extractHeadersFromOptions(a)
                        }), this.addUsersToSubTenant = async (e, t)=>this.post(`${se.v2}/`, e, {
                            headers: this.extractHeadersFromOptions(t)
                        });
                }
                updateSubTenantHierarchySettings({ tenantId: e }, t, a) {
                    return this.put(`${me.v1}/${e}/hierarchy-settings`, t, {
                        headers: this.extractHeadersFromOptions(a)
                    });
                }
            }
            const ha = new pa("default");
            class ya extends nt {
                constructor(e){
                    super(e), this.getConfigs = async ()=>this.get(`${Le}`), this.updateConfiguration = async (e, t)=>this.patch(`${Le}/${e}`, t), this.createConfiguration = async (e)=>this.post(`${Le}`, e), this.deleteConfiguration = async (e, t)=>this.delete(`${Le}/${e}`, {
                            deleteAll: t
                        }), this.countConfigurationUsers = async (e)=>this.get(`${Ce}/${e}/Users/count`);
                }
            }
            const Sa = new ya("default");
            class va extends nt {
                constructor(e){
                    super(e), this.impersonate = async (e)=>this.post(`${ie.v1}`, e);
                }
            }
            const fa = new va("default"), ma = [
                "groupId"
            ];
            class ba extends nt {
                constructor(e){
                    super(e), this.getGroupById = async ({ groupId: e }, t)=>this.get(`${re.v1}/${e}`, v({}, t)), this.getGroups = async (e)=>this.get(`${re.v1}`, v({}, e)), this.getGroupsByIds = async (e, t)=>this.post(`${re.getByIds.v1}`, e, {
                            params: t
                        }), this.createGroup = async (e)=>this.post(`${re.v1}`, e), this.updateGroup = async (e)=>{
                        let { groupId: t } = e, a = f(e, ma);
                        return this.patch(`${re.v1}/${t}`, a);
                    }, this.deleteGroup = async (e)=>this.delete(`${re.v1}/${e}`), this.addRolesToGroup = async (e, t)=>this.post(`${re.v1}/${e}/roles`, t), this.deleteRolesFromGroup = async (e, t)=>this.delete(`${re.v1}/${e}/roles`, t), this.addUsersToGroup = async (e, t)=>this.post(`${re.v1}/${e}/users`, t), this.deleteUsersFromGroup = async (e, t)=>this.delete(`${re.v1}/${e}/users`, t), this.getGroupConfiguration = async ()=>this.get(`${re.configurations.v1}`), this.updateGroupConfiguration = async (e)=>this.post(`${re.configurations.v1}`, e);
                }
            }
            const Aa = new ba("default");
            class wa extends nt {
                constructor(e){
                    super(e), this.getRecommendations = async ()=>this.get(Ne.v1), this.getInsights = async ()=>this.get(Me.v1);
                }
            }
            const Ta = new wa("default");
            class Ea extends nt {
                constructor(e){
                    super(e), this.getUserPhoneNumbers = async (e)=>this.get(`${le.v1}`, e), this.getUserOwnPhoneNumbers = async ()=>this.get(`${le.v1}/me`), this.createPhoneNumber = async (e)=>this.post(`${le.v1}`, e), this.deletePhoneNumber = async (e)=>this.delete(`${le.v1}/${e}`), this.preVerifyPhoneNumber = async (e)=>this.post(`${le.v1}/preverify`, e), this.verifyPhoneNumber = async (e)=>this.post(`${le.v1}/verify`, e), this.verifyDeletePhoneNumber = async (e, t)=>this.post(`${le.v1}/${e}/delete/verify`, t), this.getUsersPhoneNumberV2 = async (e, t)=>this.get(Q.phoneNumbers.v2, e, {
                            headers: this.extractHeadersFromOptions(t)
                        });
                }
            }
            const Pa = new Ea("default");
            class Ia extends nt {
                constructor(e){
                    super(e), this.getUsersEmailsV1 = async (e, t)=>this.get(ce.v1, e, {
                            headers: this.extractHeadersFromOptions(t)
                        });
                }
            }
            const Oa = new Ia("default");
            class ka extends nt {
                constructor(e){
                    super(e), this.getUserApplicationsId = async ({ userId: e })=>this.get(`${oe.v1}/${e}/apps`), this.getUsersApplicationsId = async ({ userIds: e })=>this.get(`${oe.v1}/users-apps`, {
                            userIds: e.join(",")
                        }), this.getTenantsApplications = async ()=>this.get(xe.v1), this.getTenantsApplicationsV2 = async ()=>this.get(xe.v2), this.getApplicationsData = async ({ appIds: e, includeFreeAccess: t = !0 })=>this.get(Fe, {
                            ids: e.join(","),
                            _includeFreeAccess: t
                        }), this.assignUserToApplications = async (e)=>this.post(`${oe.v1}/apps-user`, e), this.unassignUserFromApplications = async (e)=>this.delete(`${oe.v1}/user-apps`, e), this.getUsersOfApplications = async ({ appIds: e })=>this.get(`${oe.v1}/apps-users`, {
                            appIds: e.join(",")
                        });
                }
            }
            const _a = new ka("default"), Ra = {
                "x-frontegg-api-key": "my-frontegg-api-key",
                "frontegg-vendor-id": "04ae2174-d8d9-4a90-8bab-2548e210a508",
                "frontegg-tenant-id": "02e6ab6f-8b25-48e4-b06d-2c53745ce213",
                "frontegg-user-id": "e5c397a1-7120-4753-9216-e5d7f35d1f2d"
            };
            class Ua extends nt {
                constructor(e){
                    super(e), this.getAgentsConfig = async ()=>this.get(`${$e}/config`, void 0, {
                            headers: Ra
                        }), this.getConversations = async ()=>this.get(`${$e}/conversations`, void 0, {
                            headers: Ra
                        }), this.getConversationById = async (e)=>this.get(`${$e}/conversation/${e.id}`, void 0, {
                            headers: Ra
                        }), this.createConversation = async (e)=>this.post(`${$e}/conversations`, {
                            message: e.message,
                            stream: e.stream
                        }, {
                            responseType: !1 === e.stream ? "json" : "stream",
                            headers: Ra
                        }), this.sendMessage = async (e)=>this.post(`${$e}/conversation/${e.conversationId}/messages`, {
                            message: e.message,
                            stream: e.stream
                        }, {
                            responseType: !1 === e.stream ? "json" : "stream",
                            headers: Ra
                        }), this.sendApiResponse = async (e)=>this.post(`${$e}/conversation/${e.conversationId}/response/${e.callId}`, {
                            data: e.data,
                            status: e.status,
                            stream: e.stream
                        }, {
                            responseType: !1 === e.stream ? "json" : "stream",
                            headers: Ra
                        }), this.getConversationResource = async (e)=>this.get(`${$e}/conversation/${e.conversationId}/resource/${e.resourceId}`, void 0, {
                            headers: Ra
                        });
                }
            }
            const La = new Ua("default");
            class Ca extends nt {
                constructor(e){
                    super(e), this.getUsernamesV1 = async (e, t)=>this.get(`${ue.v1}`, e, {
                            headers: this.extractHeadersFromOptions(t)
                        }), this.getUserOwnUsername = async ()=>this.get(`${ue.v1}/me`), this.createUsername = async (e)=>this.post(`${ue.v1}`, e), this.deleteUsername = async (e)=>this.delete(`${ue.v1}/${e}`);
                }
            }
            const Da = new Ca("default");
            class Na extends nt {
                constructor(e){
                    super(e), this.getUserEmailPolicyConfig = async ()=>this.get(`${X.v1}/user-emails-policy`);
                }
            }
            const Ma = new Na("default");
            let Fa, xa, $a, Ga, ja;
            !function(e) {
                e.FRONTEGG = "frontegg", e.SCIM2 = "scim2";
            }(Fa || (Fa = {})), function(e) {
                e.createdAt = "createdAt", e.name = "name", e.tenantId = "tenantId";
            }(xa || (xa = {})), function(e) {
                e.CUSTOMER = "customer", e.SPAM = "spam", e.TEST = "test", e.RESELLER = "reseller", e.HEADQUARTER = "headquarter";
            }($a || ($a = {})), function(e) {
                e.NEVER = "NEVER", e.ALWAYS = "ALWAYS", e.ASSIGNABLE = "ASSIGNABLE";
            }(Ga || (Ga = {})), function(e) {
                e.DEFAULT_OFF = "defaultOff", e.DEFAULT_ON = "defaultOn", e.ALWAYS_ON = "alwaysOn";
            }(ja || (ja = {}));
            const Va = [
                /^(.*)\/logout$/g,
                "/logout",
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/[^\/]*\/postlogin$/g,
                /^\/identity\/resources\/impersonation\/v[0-9]$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/passwordless\/[^\/]*\/postlogin$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/webauthn\/postlogin$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/token\/refresh$/g,
                /^\/identity\/resources\/users\/v[0-9]*\/signUp$/g,
                /^\/identity\/resources\/users\/v[0-9]*\/activate$/g,
                /^\/identity\/resources\/users\/v[0-9]*\/invitation\/accept$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/mfa\/verify$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/mfa\/[^\/]*\/[^\/]*\/verify$/g,
                /^\/identity\/resources\/auth\/v[0-9]*\/user\/mfa\/[^\/]*\/verify$/g,
                /^\/oauth\/token$/g,
                /^\/oauth\/authorize\/silent$/g
            ], Ba = `${J.v1}/user/token/refresh`, Wa = `${Re}/authorize/silent`, za = `${Q.v2}/me`, Ha = `${Q.v2}/me/tenants`, Ka = `${Q.v3}/me/tenants`, qa = De;
            let Ya, Ja, Qa, Xa, Za;
            !function(e) {
                e.FRONTEGG = "frontegg", e.OKTA = "okta", e.AZURE_AD = "azure-ad", e.OTHER = "other";
            }(Ya || (Ya = {})), function(e) {
                e.roles = "roles", e.users = "users", e.rolesAndUsers = "rolesAndUsers";
            }(Ja || (Ja = {})), function(e) {
                e.FRONTEGG = "frontegg", e.SCIM2 = "scim2";
            }(Qa || (Qa = {})), function(e) {
                e.createdAt = "createdAt", e.name = "name", e.email = "email", e.id = "id", e.verified = "verified", e.isLocked = "isLocked", e.provider = "provider", e.tenantId = "tenantId";
            }(Xa || (Xa = {})), function(e) {
                e.MFA_UNENROLLED = "mfa-unenrolled", e.BREACHED_PASSWORDS = "breached-passwords", e.INACTIVE = "inactive";
            }(Za || (Za = {}));
            const en = [
                "local",
                "saml",
                "google",
                "github",
                "facebook",
                "microsoft",
                "scim2",
                "slack"
            ];
            let tn, an, nn, sn, on, rn, ln;
            !function(e) {
                e.MISSING_PERMISSION = "MISSING_PERMISSION", e.MISSING_FEATURE = "MISSING_FEATURE", e.BUNDLE_EXPIRED = "BUNDLE_EXPIRED";
            }(tn || (tn = {})), function(e) {
                e.FORCE_MFA = "FORCE_MFA", e.BREACHED_PASSWORDS_EXIST = "BREACHED_PASSWORDS_EXIST", e.ENABLE_USER_LOCKOUT = "ENABLE_USER_LOCKOUT", e.STRENGTHEN_USER_LOCKOUT = "STRENGTHEN_USER_LOCKOUT", e.ENABLE_PASSWORD_HISTORY = "ENABLE_PASSWORD_HISTORY", e.STRENGTHEN_PASSWORD_HISTORY = "STRENGTHEN_PASSWORD_HISTORY", e.ENABLE_FORCE_RELOGIN = "ENABLE_FORCE_RELOGIN", e.SET_FORCE_RELOGIN = "SET_FORCE_RELOGIN", e.ENABLE_SESSION_CONCURRENCY = "ENABLE_SESSION_CONCURRENCY", e.SET_SESSION_CONCURRENCY = "SET_SESSION_CONCURRENCY", e.ENABLE_IDLE_SESSION = "ENABLE_IDLE_SESSION", e.SET_IDLE_SESSION = "SET_IDLE_SESSION", e.ENABLE_IP_RESTRICTIONS = "ENABLE_IP_RESTRICTIONS", e.CHANGE_IP_TO_ALLOWLIST = "CHANGE_IP_TO_ALLOWLIST", e.ENABLE_DOMAIN_RESTRICTIONS = "ENABLE_DOMAIN_RESTRICTIONS", e.CHANGE_DOMAIN_TO_ALLOWLIST = "CHANGE_DOMAIN_TO_ALLOWLIST", e.CONFIGURE_SSO = "CONFIGURE_SSO";
            }(an || (an = {})), function(e) {
                e.MFA_FORCED = "MFA_FORCED", e.PARTIALLY_FORCED_MFA = "PARTIALLY_FORCED_MFA", e.PARTIAL_MFA_USAGE = "PARTIAL_MFA_USAGE", e.FULL_MFA_USAGE = "FULL_MFA_USAGE", e.BREACHED_PASSWORD_USERS_EXIST = "BREACHED_PASSWORD_USERS_EXIST", e.IMPROVE_LOCKOUT_POLICY = "IMPROVE_LOCKOUT_POLICY", e.IMPROVE_PASSWORD_HISTORY_POLICY = "IMPROVE_PASSWORD_HISTORY_POLICY", e.NO_SESSION_SETTINGS = "NO_SESSION_SETTINGS", e.PARTIAL_SESSION_SETTINGS = "PARTIAL_SESSION_SETTINGS", e.FULL_SESSION_SETTINGS = "FULL_SESSION_SETTINGS", e.NO_IP_RESTRICTIONS = "NO_IP_RESTRICTIONS", e.IP_ALLOWLIST = "IP_ALLOWLIST", e.IP_DENYLIST = "IP_DENYLIST", e.NO_DOMAIN_RESTRICTIONS = "NO_DOMAIN_RESTRICTIONS", e.DOMAIN_ALLOWLIST = "DOMAIN_ALLOWLIST", e.DOMAIN_DENYLIST = "DOMAIN_DENYLIST", e.FULL_PASSWORD_SETTINGS = "FULL_PASSWORD_SETTINGS";
            }(nn || (nn = {})), function(e) {
                e.SEND_RESET_BREACHED_PASSWORD_EMAIL = "SEND_RESET_BREACHED_PASSWORD_EMAIL", e.ADJUST_FORCE_RELOGIN = "ADJUST_FORCE_RELOGIN", e.ADJUST_MAX_CONCURRENT_SESSIONS = "ADJUST_MAX_CONCURRENT_SESSIONS", e.ADJUST_IDLE_TIMEOUT = "ADJUST_IDLE_TIMEOUT";
            }(sn || (sn = {})), function(e) {
                e.SEVERE = "SEVERE", e.WARNING = "WARNING", e.INFO = "INFO";
            }(on || (on = {})), function(e) {
                e.MFA = "MFA", e.SESSIONS = "SESSIONS", e.PASSWORD = "PASSWORD", e.INACTIVITY = "INACTIVITY", e.IP = "IP", e.DOMAIN = "DOMAIN", e.SSO = "SSO";
            }(rn || (rn = {})), function(e) {
                e.FREE_ACCESS = "FREE_ACCESS", e.MANAGED_ACCESS = "MANAGED_ACCESS";
            }(ln || (ln = {}));
            const cn = {
                auth: It,
                securityPolicy: At,
                teams: kt,
                metadata: Rt,
                reports: Nt,
                connectivity: $t,
                notifications: jt,
                audits: Wt,
                tenants: vt,
                accountSettings: Ht,
                roles: Qt,
                subscriptions: ua,
                vendor: ga,
                subTenants: ha,
                featureFlags: rt,
                directory: Sa,
                impersonate: fa,
                groups: Aa,
                users: dt,
                entitlements: mt,
                securityCenter: Ta,
                userPhoneNumbers: Pa,
                usersEmails: Oa,
                applications: _a,
                velo: La,
                usernames: Da,
                userEmailPolicy: Ma
            }, un = (e)=>({
                    auth: new Pt(e),
                    securityPolicy: new bt(e),
                    teams: new Ot(e),
                    metadata: new _t(e),
                    reports: new Dt(e),
                    connectivity: new xt(e),
                    notifications: new Gt(e),
                    audits: new Bt(e),
                    tenants: new St(e),
                    accountSettings: new zt(e),
                    roles: new Jt(e),
                    subscriptions: new ca(e),
                    vendor: new da(e),
                    subTenants: new pa(e),
                    featureFlags: new ot(e),
                    directory: new ya(e),
                    impersonate: new va(e),
                    groups: new ba(e),
                    users: new ut(e),
                    entitlements: new ft(e),
                    securityCenter: new wa(e),
                    userPhoneNumbers: new Ea(e),
                    usersEmails: new Ia(e),
                    applications: new ka(e),
                    velo: new Ua(e),
                    usernames: new Ca(e),
                    userEmailPolicy: new Na(e)
                }), dn = {
                fetch: Ke,
                FetchClient: He,
                ContextHolder: L,
                FronteggContext: D,
                api: cn,
                createApiClient: un,
                FronteggApiError: K,
                AuthStrategyEnum: M,
                MachineToMachineAuthStrategy: F,
                SocialLoginProviders: N,
                ISubscriptionCancellationPolicy: B,
                ISubscriptionStatus: j,
                PaymentMethodType: V,
                ProviderType: W,
                EIdentifierType: $
            };
            var gn = a(2743), pn = a.n(gn);
            const hn = (e, t)=>{
                const a = pn()(e, v({}, t));
                return function(e = {}) {
                    return I(e);
                }(v({
                    __isProxy: !0
                }, a));
            };
            let yn;
            !function(e) {
                e.validate = "validate", e.invalid = "invalid", e.pending = "pending", e.success = "success", e.failed = "failed";
            }(yn || (yn = {}));
            const Sn = {
                step: yn.validate
            }, vn = (e)=>hn(Sn, e);
            var fn = a(5302), mn = a.n(fn), bn = a(1098), An = a.n(bn);
            const wn = "http://schemas.openid.net/pape/policies/2007/06/multi-factor", Tn = "mfa", En = [
                "otp",
                "sms",
                "hwk"
            ], Pn = "SHOULD_STEP_UP", In = "maxAge";
            let On, kn, _n, Rn;
            !function(e) {
                e.preLogin = "preLogin", e.magicLinkPreLoginSuccess = "magicLinkPreLoginSuccess", e.loginWithSmsOtc = "loginWithSmsOtc", e.loginWithQuickSmsOtc = "loginWithQuickSmsOtc", e.loginWithOtc = "loginWithOtc", e.loginWithPassword = "loginWithPassword", e.loginWithTwoFactor = "loginWithTwoFactor", e.redirectToSSO = "redirectToSSO", e.loginWithSSOFailed = "loginWithSSOFailed", e.success = "success", e.forceTwoFactor = "forceTwoFactor", e.recoverTwoFactor = "recoverTwoFactor", e.promptPasskeys = "promptPasskeys", e.breachedPassword = "breachedPassword", e.breachedPasswordSuccess = "breachedPasswordSuccess", e.passwordRotationExpired = "passwordRotationExpired", e.passwordRotationNotification = "passwordRotationNotification", e.magicLinkPostLoginSuccess = "magicLinkPostLoginSuccess";
            }(On || (On = {})), function(e) {
                e.Login = "login", e.RegisterQuickLogin = "registerQuickLogin";
            }(kn || (kn = {})), function(e) {
                e.Internal = "internal", e.UsbKey = "usb-key", e.Android = "android", e.Sms = "sms";
            }(_n || (_n = {})), function(e) {
                e["social-login"] = "social-login", e["custom-social-login"] = "custom-social-login", e.direct = "direct", e.signup = "signup";
            }(Rn || (Rn = {}));
            const Un = {
                [M.Code]: On.loginWithOtc,
                [M.EmailAndPassword]: On.loginWithPassword,
                [M.MagicLink]: On.magicLinkPreLoginSuccess,
                [M.SmsCode]: On.loginWithSmsOtc,
                [M.UsernameAndPassword]: On.loginWithPassword,
                [M.UsernameAndMagicLink]: On.magicLinkPreLoginSuccess,
                [M.UsernameAndCode]: On.loginWithOtc,
                [M.UsernameAndSms]: On.loginWithSmsOtc
            }, Ln = {
                authenticatedUrl: "/",
                loginUrl: "/account/login",
                stepUpUrl: "/account/step-up",
                logoutUrl: "/account/logout",
                activateUrl: "/account/activate",
                impersonationUrl: "/account/impersonate",
                acceptInvitationUrl: "/account/invitation/accept",
                forgetPasswordUrl: "/account/forget-password",
                resetPhoneNumberUrl: "/account/reset-phone-number",
                resetPasswordUrl: "/account/reset-password",
                socialLoginCallbackUrl: "/account/social/success",
                signUpUrl: "/account/sign-up",
                oidcRedirectUrl: "/account/oidc/callback",
                samlCallbackUrl: "/account/saml/callback",
                magicLinkCallbackUrl: "/account/login/magic-link",
                hostedLoginRedirectUrl: "/oauth/callback",
                openAppUrl: "/account/redirect",
                unlockAccountUrl: "/account/unlock",
                activateWithOTCUrl: "/account/activate/code",
                acceptInvitationWithOTCUrl: "/account/invitation/code",
                approvalFlowUrl: "/account/approval-flow",
                mfaMobileAuthenticator: "/account/mfa-mobile-authenticator"
            }, Cn = "FRONTEGG_AFTER_AUTH_REDIRECT_URL", Dn = "HOSTED_LOGIN_VERIFIER_KEY", Nn = {
                retryCount: 3
            }, Mn = (e = 500)=>new Promise((t)=>{
                    setTimeout(t, e);
                }), Fn = async (e, t, a, n)=>{
                let s = 0;
                for(; s < t - 1;)try {
                    const i = await e();
                    if (!n || null !== i) return i;
                    if (s++, s >= t) return i;
                    await new Promise((e)=>setTimeout(e, a));
                } catch (e) {
                    if (s++, s >= t) throw e;
                    await new Promise((e)=>setTimeout(e, a));
                }
                return await e();
            }, xn = async (e, t)=>t ? Fn(e, t.retryCount, t.delay || 500, t.shouldRetryWhenNull) : e(), $n = (e)=>v({}, e, {
                    retryConfig: Nn
                }), Gn = (e)=>(null == e ? void 0 : e.traceId) || void 0;
            function jn(e, t) {
                const a = v({}, e);
                return t.forEach((e)=>{
                    delete a[e];
                }), a;
            }
            function Vn(e) {
                if (null != e) return function(e) {
                    const t = typeof e;
                    return (null == e ? void 0 : e.constructor) === ({}).constructor || "undefined" === t || null === e || "boolean" === t || "number" === t || "string" === t || e instanceof Date || e instanceof RegExp || e instanceof Blob || e instanceof File || e instanceof FileList || e instanceof ArrayBuffer || e instanceof ImageData || e instanceof ImageBitmap || e instanceof Array || e instanceof Map || e instanceof Set;
                }(e) && void 0 !== e.__isProxy;
            }
            const Bn = (e)=>JSON.parse(JSON.stringify(e)), Wn = (e, t, a)=>{
                const n = Bn(a), s = mn()(e, t);
                for(const a in s)"__isProxy" !== a && (a in n ? An()(e, [
                    ...t,
                    a
                ], n[a]) : An()(e, [
                    ...t,
                    a
                ], void 0));
            }, zn = (e)=>Boolean(null == e ? void 0 : e.statusCode), Hn = (e)=>e instanceof Error || (null == e ? void 0 : e.message) && (null == e ? void 0 : e.stack) && "Error" === (null == e ? void 0 : e.name), Kn = (e, t)=>e ? zn(e) ? (console.error(e.message), e) : (Hn(e) ? console.error(e.message) : "string" == typeof e && console.error(e), null != t ? t : new K(Ge, 500, null, je)) : t, qn = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.acceptInvitationState, t);
                };
                return {
                    setAcceptInvitationState: n,
                    resetAcceptInvitationState: ()=>{
                        Wn(e, [
                            "auth",
                            "acceptInvitationState"
                        ], Sn);
                    },
                    acceptInvitation: async (e)=>{
                        if (e.token && e.userId) try {
                            n({
                                error: void 0,
                                step: yn.pending
                            }), await t.auth.acceptInvitation(e), n({
                                step: yn.success
                            });
                        } catch (e) {
                            n({
                                step: yn.failed,
                                error: Kn(e)
                            });
                        }
                        else n({
                            error: void 0,
                            step: yn.invalid
                        });
                    },
                    acceptInvitationWithOTC: async (e)=>{
                        if (e.token && e.userId && e.code) try {
                            n({
                                error: void 0,
                                step: yn.pending
                            }), await t.auth.acceptInvitationWithOTC(e), n({
                                step: yn.success
                            });
                        } catch (e) {
                            n({
                                step: yn.validate,
                                error: Kn(e)
                            });
                        }
                        else n({
                            error: void 0,
                            step: yn.invalid
                        });
                    }
                };
            }, Yn = {
                loading: !1
            }, Jn = (e)=>hn(Yn, e), Qn = [
                "activeTenant",
                "tenants"
            ], Xn = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.accountSettingsState, t);
                };
                return {
                    setAccountSettingsState: n,
                    resetAccountSettingsState: ()=>{
                        Wn(e, [
                            "auth",
                            "accountSettingsState"
                        ], Yn);
                    },
                    saveAccountSettings: async (s)=>{
                        try {
                            var i;
                            n({
                                loading: !0
                            });
                            const { address: o, timezone: r, dateFormat: l, timeFormat: c, currency: u, logo: d } = e.auth.accountSettingsState, g = await t.accountSettings.updateSettings(v({
                                address: o,
                                timezone: r,
                                dateFormat: l,
                                timeFormat: c,
                                currency: u,
                                logo: d
                            }, s));
                            (({ newSettingValues: t })=>{
                                const n = e.auth.tenantsState, { activeTenant: s, tenants: i } = n, o = f(n, Qn), r = i.map((e)=>e.id !== (null == s ? void 0 : s.id) ? e : v({}, e, t)), l = v({}, s, t);
                                a.setTenantsState(v({}, o, {
                                    tenants: r,
                                    activeTenant: l
                                }));
                            })({
                                newSettingValues: g
                            }), n(v({}, g, {
                                loading: !1
                            })), null == (i = s.callback) || i.call(s, g);
                        } catch (e) {
                            var o;
                            n({
                                loading: !1,
                                error: Kn(e)
                            }), null == (o = s.callback) || o.call(s, null, e);
                        }
                    },
                    loadAccountSettings: async (e)=>{
                        n({
                            loading: !(null != e && e.silentLoading),
                            error: null
                        });
                        try {
                            const a = await xn(()=>t.accountSettings.getSettings(), null == e ? void 0 : e.retryConfig);
                            n(v({}, a, {
                                loading: !1
                            }));
                        } catch (e) {
                            n({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    }
                };
            };
            let Zn;
            !function(e) {
                e.activating = "activating", e.success = "success", e.resend = "resend", e.activatingForm = "activatingForm";
            }(Zn || (Zn = {}));
            const es = {
                step: Zn.activating,
                loading: !1,
                submitting: !1,
                resentEmail: !1,
                activationStrategy: {
                    loading: !1
                }
            }, ts = (e)=>hn(es, e);
            let as, ns, ss, is;
            !function(e) {
                e.LOAD_FEATURE_FLAGS = "LOAD_FEATURE_FLAGS,", e.LOAD_ADMIN_BOX_METADATA = "LOAD_ADMIN_BOX_METADATA,", e.LOAD_SSO_PUBLIC_CONFIGURATION = "LOAD_SSO_PUBLIC_CONFIGURATION,", e.LOAD_PUBLIC_AUTH_STRATEGIES_POLICY = "LOAD_PUBLIC_AUTH_STRATEGIES_POLICY,", e.LOAD_ALLOW_SIGNUPS = "LOAD_ALLOW_SIGNUPS,", e.LOAD_CUSTOM_LOGIN_ROUTES = "LOAD_CUSTOM_LOGIN_ROUTES", e.LOAD_PASSWORD_CONFIGURATION = "LOAD_PASSWORD_CONFIGURATION";
            }(as || (as = {})), function(e) {
                e.SOCIAL_LOGIN = "SOCIAL_LOGIN", e.PASSWORDLESS = "PASSWORDLESS", e.ACTIVATION_LINK = "ACTIVATION_LINK";
            }(ns || (ns = {})), function(e) {
                e.SOCIAL_LOGIN = "SOCIAL_LOGIN", e.PASSWORD = "PASSWORD", e.PHONE_NUMBER = "PHONE_NUMBER", e.USERNAME = "USERNAME";
            }(ss || (ss = {})), function(e) {
                e.profile = "profile", e.privacy = "privacy", e.personalApiTokens = "personalApiTokens", e.account = "account", e.users = "users", e.groups = "groups", e.security = "security", e.sso = "sso", e.audits = "audits", e.webhooks = "webhooks", e.apiTokens = "apiTokens", e.roles = "roles", e.subscriptions = "subscription", e.allAccounts = "allAccounts";
            }(is || (is = {}));
            const os = {
                profile: is.profile,
                privacy: is.privacy,
                personalApiTokens: is.personalApiTokens,
                account: is.account,
                users: is.users,
                groups: is.groups,
                security: is.security,
                sso: is.sso,
                audits: is.audits,
                webhooks: is.webhooks,
                apiTokens: is.apiTokens,
                roles: is.roles,
                subscriptions: is.subscriptions,
                allAccounts: is.allAccounts
            };
            let rs, ls;
            function cs(e, t) {
                var a, n;
                null == (a = (n = window).onFronteggEvent) || a.call(n, e, t);
            }
            !function(e) {
                e.SIGNUP_COMPLETED = "signup_completed", e.USER_VERIFIED = "user_verified";
            }(rs || (rs = {})), function(e) {
                e.verify = "verify", e.recoveryCode = "recoveryCode", e.authenticatorApp = "authenticatorApp", e.smsSetPhoneNumber = "smsSetPhoneNumber", e.smsVerifyCode = "smsVerifyCode", e.emailVerifyCode = "emailVerifyCode", e.noMFAEnrolledStepUp = "noMFAEnrolledStepUp";
            }(ls || (ls = {}));
            const us = (e)=>{
                try {
                    return new URL(e), !0;
                } catch (e) {
                    return !1;
                }
            }, ds = ({ authenticatedUrl: e, enforceRedirectToSameSite: t, allowedRedirectOrigins: a, includeQueryParam: n })=>{
                let s = e;
                const i = new URL(window.location.href).searchParams.get("redirectUrl");
                return i ? t && us(i) ? ((e, t)=>{
                    const a = new URL(window.location.href), n = new URL(e), s = n.origin === a.origin;
                    return t.includes(n.origin) || s;
                })(i, a) ? s = i : console.warn("The redirect url param is not valid, the origin is a different site") : s = i : n && (s += window.location.search), s;
            }, gs = (e)=>{
                const { searchParams: t } = new URL(e), a = t.toString();
                if (a) return `?${a}`;
            }, ps = (e, t = !1)=>{
                const { pathname: a, href: n } = new URL(e);
                if (t) return n;
                const s = gs(e);
                return s ? a + s : a;
            }, hs = (e)=>{
                const t = new URLSearchParams(window.location.search).get(e);
                return null != t ? t : void 0;
            }, ys = "tenantId", Ss = (e)=>{
                const t = +Boolean(e.webauthn.length), a = +Boolean(e.phones.length), n = +Boolean(e.authenticators.length), s = +Boolean(e.emails.length);
                return {
                    numberOfWebAuthnDevices: t,
                    numberOfPhoneDevices: a,
                    numberOfAuthenticators: n,
                    numberOfEmails: s,
                    totalDevices: t + a + n + s
                };
            }, vs = (e)=>{
                const { numberOfPhoneDevices: t, numberOfAuthenticators: a, numberOfEmails: n, totalDevices: s } = Ss(e);
                if (1 === s) {
                    if (a) return ls.authenticatorApp;
                    if (t) return ls.smsVerifyCode;
                    if (n) return ls.emailVerifyCode;
                }
                return ls.verify;
            }, fs = (e)=>{
                if (1 === e.length) {
                    const [t] = e;
                    if (t === tt.AuthenticatorApp) return ls.authenticatorApp;
                    if (t === tt.SMS) return ls.smsSetPhoneNumber;
                    if (t === tt.EmailCode) return ls.emailVerifyCode;
                }
                return ls.verify;
            }, ms = (e)=>"/oauth/callback" === e;
            function bs(e) {
                return "email" in e && "string" == typeof e.email;
            }
            function As(e) {
                return "username" in e && "string" == typeof e.username;
            }
            const ws = (e)=>{
                const t = L.for(e.root.appName).getBasename();
                return null != t && t.endsWith("/") ? t.slice(0, -1) : t;
            }, Ts = (e)=>void 0 !== e.passwordExpiresIn && void 0 !== e.notificationPeriod && e.passwordExpiresIn <= e.notificationPeriod, Es = (e, { maxAge: t } = {})=>{
                if (!e) return !1;
                const { amr: a = [], acr: n = "", auth_time: s } = e;
                if (t && s && !(Date.now() / 1e3 - s <= t)) return !1;
                const i = n === wn, o = -1 !== a.indexOf(Tn), r = void 0 !== En.find((e)=>a.indexOf(e));
                return i && o && r;
            };
            function Ps() {
                const e = window.location.pathname + window.location.search;
                window.localStorage.setItem(Cn, e);
            }
            const Is = (e, t, a)=>{
                Ps();
                const n = new URLSearchParams(window.location.search);
                a && n.set(In, a.toString()), t(`${e}${n ? `?${n}` : ""}`, {
                    refresh: !1
                });
            }, Os = [
                "phoneNumber",
                "email",
                "username"
            ], ks = [
                "authenticatedUrl"
            ], _s = (e, t)=>{
                const a = L.for(t);
                return e.mfaRequired && e.mfaToken ? (a.setAccessToken(null), a.setUser(null), !0) : (a.setAccessToken(e.accessToken), a.setUser(e), !1);
            }, Rs = (e, t)=>{
                const a = L.for(t);
                return e.resetPasswordToken ? (a.setAccessToken(null), !0) : (a.setAccessToken(e.accessToken), a.setUser(e), !1);
            }, Us = (e, t = [])=>Object.entries(e).reduce((e, [a, n])=>"object" == typeof n ? [
                        ...e,
                        ...Us(n, [
                            ...t,
                            a
                        ])
                    ] : [
                        ...e,
                        {
                            type: [
                                ...t,
                                a
                            ].join("/"),
                            payload: n
                        }
                    ], []), Ls = (e)=>{
                var t;
                if ("path" === e) return (null != (t = window) ? t : document).location.pathname;
                {
                    var a;
                    const e = ((null != (a = window) ? a : document).location.hash || "#").substring(1);
                    return -1 !== e.indexOf("?") ? e.substring(0, e.indexOf("?")) : e;
                }
            }, Cs = (e)=>{
                const { phoneNumber: t, email: a, username: n } = e, s = f(e, Os);
                return null != a && a.length && Object.assign(s, {
                    email: a
                }), null != t && t.length && Object.assign(s, {
                    phoneNumber: t
                }), null != n && n.length && Object.assign(s, {
                    username: n
                }), s;
            }, Ds = (e, t)=>{
                const a = f(v({}, Ln, t), ks);
                return Object.values(a).includes(e);
            };
            let Ns;
            !function(e) {
                e.USERS = "USERS", e.STATS = "STATS", e.UPDATE_USER = "UPDATE_USER", e.DELETE_USER = "DELETE_USER", e.RESEND_ACTIVATE_LINK = "RESEND_ACTIVATE_LINK", e.RESEND_INVITATION_LINK = "RESEND_INVITATION_LINK", e.ROLES_AND_PERMISSIONS = "ROLES_AND_PERMISSIONS", e.CREATE_TOKEN_LINK = "CREATE_TOKEN_LINK", e.GET_TOKEN_LINK = "GET_TOKEN_LINK", e.UPDATE_TOKEN_LINK = "UPDATE_TOKEN_LINK", e.DELETE_TOKEN_LINK = "DELETE_TOKEN_LINK", e.CONFIG_TOKEN_LINK = "CONFIG_TOKEN_LINK", e.CONFIG_TEMPORARY_USERS = "CONFIG_TEMPORARY_USERS", e.UPDATE_USER_EXPIRATION_TIME = "UPDATE_USER_EXPIRATION_TIME";
            }(Ns || (Ns = {}));
            const Ms = [
                "user"
            ], Fs = [
                "callback",
                "events"
            ], xs = [
                "user"
            ], $s = [
                "callback",
                "events"
            ], Gs = [
                "user"
            ], js = [
                "callback"
            ], Vs = [
                "callback"
            ], Bs = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.activateAccountState, t);
                }, i = ()=>{
                    Wn(e, [
                        "auth",
                        "activateAccountState"
                    ], es);
                }, o = (t)=>{
                    Object.assign(e.auth.activateAccountState.activationStrategy, t);
                }, r = async ({ loginResponse: t, events: a, onRedirectTo: o, routes: r })=>{
                    const { user: l } = t, c = f(t, Ms);
                    if (l.redirectLocation) window.location.href = l.redirectLocation;
                    else if (_s(l, e.root.appName)) {
                        s({
                            step: Zn.success
                        });
                        const e = await n.getMfaRequiredState(l);
                        n.setAuthState(e), await Mn(1e3), o(r.loginUrl, {
                            preserveQueryParams: !0
                        });
                    } else {
                        var u;
                        s({
                            step: Zn.success
                        });
                        const e = {
                            email: l.email,
                            origin: ns.ACTIVATION_LINK,
                            id: l.id,
                            tenantId: l.tenantId,
                            name: l.name,
                            createdAt: new Date
                        };
                        null == a || null == (u = a.userVerified) || u.call(a, e), cs(rs.USER_VERIFIED, e), n.afterAuthenticationStateUpdate(v({
                            user: l
                        }, c), {
                            isAuthenticated: !0
                        }), await Mn(5e3), await n.afterAuthNavigation(), i();
                    }
                };
                return {
                    setActivateState: s,
                    resetActivateState: i,
                    setActivateStrategyState: o,
                    activateAccount: async (a)=>{
                        const { callback: n, events: i } = a, o = f(a, Fs);
                        s({
                            loading: !0,
                            submitting: !0
                        });
                        try {
                            const a = L.for(e.root.appName).onRedirectTo, l = e.auth.routes, c = await t.auth.activateAccountV2(o), { user: u } = c, d = f(c, xs);
                            s({
                                submitting: !1
                            }), await r({
                                loginResponse: v({
                                    user: u
                                }, d),
                                events: i,
                                onRedirectTo: a,
                                routes: l
                            }), null == n || n(!0);
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    preActivateAccount: async (a)=>{
                        const { userId: i, token: r } = a;
                        s({
                            loading: !0,
                            step: Zn.activating
                        });
                        try {
                            e.auth.isAuthenticated && await n.silentLogout();
                            const a = await t.auth.getActivateAccountStrategy({
                                userId: i,
                                token: r
                            });
                            o({
                                strategy: a,
                                loading: !1,
                                error: void 0
                            }), a.shouldSetPassword && s({
                                loading: !1,
                                step: Zn.activatingForm
                            });
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    getActivateAccountStrategy: async (e)=>{
                        const { callback: a } = e, n = f(e, js);
                        o({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.getActivateAccountStrategy(n);
                            o({
                                strategy: e,
                                loading: !1,
                                error: void 0
                            }), null == a || a(e);
                        } catch (e) {
                            o({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    resendActivationEmail: async (e)=>{
                        const { callback: a } = e, i = f(e, Vs);
                        n.setTeamLoader({
                            key: Ns.RESEND_ACTIVATE_LINK,
                            value: i.email
                        }), s({
                            loading: !0
                        });
                        try {
                            await t.auth.resendActivationEmail(i), s({
                                loading: !1,
                                error: void 0,
                                resentEmail: !0
                            }), null == a || a(!0);
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        } finally{
                            n.setTeamLoader({
                                key: Ns.RESEND_ACTIVATE_LINK,
                                value: !1
                            });
                        }
                    },
                    activateAccountWithCode: async (a)=>{
                        const { callback: n, events: i } = a, o = f(a, $s);
                        s({
                            loading: !0,
                            submitting: !0
                        });
                        try {
                            const a = L.for(e.root.appName).onRedirectTo, l = e.auth.routes, c = await t.auth.activateAccountWithOTC(o), { user: u } = c, d = f(c, Gs);
                            s({
                                submitting: !1
                            }), await r({
                                loginResponse: v({
                                    user: u
                                }, d),
                                events: i,
                                onRedirectTo: a,
                                routes: l
                            }), null == n || n(!0);
                        } catch (e) {
                            s({
                                submitting: !1,
                                loading: !1,
                                error: Kn(e),
                                step: Zn.activating
                            });
                        }
                    }
                };
            }, Ws = {
                loading: !1,
                error: void 0,
                unlockAccountSuccess: !1
            }, zs = (e)=>hn(Ws, e), Hs = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.unlockAccountState, t);
                };
                return {
                    setUnlockAccountState: n,
                    resetUnlockAccountState: ()=>{
                        Wn(e, [
                            "auth",
                            "activateAccountState"
                        ], Ws);
                    },
                    unlockAccount: async (a)=>{
                        const { token: s } = a, i = L.for(e.root.appName).onRedirectTo, o = e.auth.routes;
                        n({
                            loading: !0
                        });
                        try {
                            await t.users.unlockMe({
                                token: s
                            }), n({
                                loading: !1,
                                error: void 0,
                                unlockAccountSuccess: !0
                            }), await Mn(5e3), i(o.loginUrl);
                        } catch (e) {
                            n({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    }
                };
            };
            let Ks;
            !function(e) {
                e.form = "form", e.success = "success", e.failed = "failed";
            }(Ks || (Ks = {}));
            const qs = {
                loading: !1,
                submitting: !1,
                error: void 0,
                step: Ks.form,
                executionData: void 0,
                loadingExecutionData: !1,
                executionDataError: void 0
            }, Ys = (e)=>hn(qs, e), Js = [
                "callback"
            ], Qs = [
                "callback"
            ], Xs = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.approvalFlowState, t);
                };
                return {
                    setApprovalFlowState: n,
                    resetApprovalFlowState: ()=>{
                        Wn(e, [
                            "auth",
                            "approvalFlowState"
                        ], qs);
                    },
                    submitApprovalAction: async (e)=>{
                        const { callback: a } = e, s = f(e, Js);
                        n({
                            submitting: !0,
                            error: void 0
                        });
                        try {
                            await t.auth.submitApprovalAction(s), n({
                                submitting: !1,
                                step: Ks.success,
                                error: void 0
                            }), null == a || a(!0);
                        } catch (e) {
                            n({
                                submitting: !1,
                                step: Ks.failed,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    getApprovalExecutionData: async (e)=>{
                        const { callback: a } = e, s = f(e, Qs);
                        n({
                            loadingExecutionData: !0,
                            executionDataError: void 0
                        });
                        try {
                            const e = await t.auth.getApprovalExecutionData(s);
                            n({
                                loadingExecutionData: !1,
                                executionData: e,
                                executionDataError: void 0
                            }), null == a || a(!0);
                        } catch (e) {
                            n({
                                loadingExecutionData: !1,
                                executionDataError: Kn(e)
                            }), null == a || a(null, e);
                        }
                    }
                };
            }, Zs = {
                apiTokenType: null,
                showAddTokenDialog: !1,
                createdByUserIdColumn: "show",
                deleteTokenDialog: {
                    open: !1,
                    clientId: ""
                },
                successDialog: {
                    open: !1,
                    secret: "",
                    clientId: ""
                },
                loaders: {},
                apiTokensDataTenant: [],
                apiTokensDataUser: [],
                roles: [],
                permissions: [],
                errors: {}
            }, ei = (e)=>hn(Zs, e);
            let ti;
            !function(e) {
                e.LOAD_API_TOKENS = "LOAD_API_TOKENS", e.ADD_API_TOKEN = "ADD_API_TOKEN", e.DELETE_API_TOKEN = "DELETE_API_TOKEN";
            }(ti || (ti = {}));
            const ai = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.apiTokensState, {
                        loaders: v({}, e.auth.apiTokensState.loaders, {
                            [t.key]: t.value
                        })
                    });
                }, s = (t)=>{
                    Object.assign(e.auth.apiTokensState, {
                        errors: v({}, e.auth.apiTokensState.errors, {
                            [t.key]: t.value
                        }),
                        loaders: v({}, e.auth.apiTokensState.loaders, {
                            [t.key]: !1
                        })
                    });
                }, i = (t)=>{
                    Object.assign(e.auth.apiTokensState, t);
                };
                return {
                    setApiTokensLoader: n,
                    setApiTokensError: s,
                    setApiTokensState: i,
                    resetApiTokensState: ()=>{
                        Wn(e, [
                            "auth",
                            "apiTokensState"
                        ], Zs);
                    },
                    loadApiTokens: async (e)=>{
                        null != e && e.silentLoading || n({
                            key: ti.LOAD_API_TOKENS,
                            value: !0
                        });
                        try {
                            var a;
                            const [s = [], o = []] = await Promise.all([
                                t.auth.getUserApiTokensData(),
                                t.auth.getTenantApiTokensData()
                            ]);
                            i({
                                apiTokensDataUser: s,
                                apiTokensDataTenant: o
                            }), n({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (a = e.callback) || a.call(e, !0);
                        } catch (t) {
                            var o;
                            s({
                                key: ti.LOAD_API_TOKENS,
                                value: Kn(t)
                            }), n({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (o = e.callback) || o.call(e, null, t);
                        }
                    },
                    loadUserApiTokens: async (e)=>{
                        null != e && e.silentLoading || n({
                            key: ti.LOAD_API_TOKENS,
                            value: !0
                        });
                        try {
                            var a, o;
                            const [s = [], r] = await Promise.all([
                                xn(()=>t.auth.getUserApiTokensData(), null == e ? void 0 : e.retryConfig),
                                xn(()=>t.auth.getUserAccessTokensData(), null == e ? void 0 : e.retryConfig)
                            ]), l = (null != (a = r.accessTokens) ? a : []).map((e)=>v({}, e, {
                                    type: F.AccessToken
                                })).concat(s.map((e)=>v({}, e, {
                                    type: F.ClientCredentials
                                }))).sort((e, t)=>new Date(t.createdAt) - new Date(e.createdAt));
                            i({
                                apiTokensDataUser: null != l ? l : []
                            }), n({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (o = e.callback) || o.call(e, !0);
                        } catch (t) {
                            var r;
                            s({
                                key: ti.LOAD_API_TOKENS,
                                value: Kn(t)
                            }), n({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (r = e.callback) || r.call(e, null, t);
                        }
                    },
                    loadTenantApiTokens: async (e)=>{
                        null != e && e.silentLoading || n({
                            key: ti.LOAD_API_TOKENS,
                            value: !0
                        });
                        try {
                            var a, o;
                            const [s = [], r] = await Promise.all([
                                xn(()=>t.auth.getTenantApiTokensData(), null == e ? void 0 : e.retryConfig),
                                xn(()=>t.auth.getTenantAccessTokensData(), null == e ? void 0 : e.retryConfig)
                            ]), l = (null != (a = null == r ? void 0 : r.accessTokens) ? a : []).map((e)=>v({}, e, {
                                    type: F.AccessToken
                                })).concat(s.map((e)=>v({}, e, {
                                    type: F.ClientCredentials
                                }))).sort((e, t)=>new Date(t.createdAt) - new Date(e.createdAt));
                            i({
                                apiTokensDataTenant: null != l ? l : []
                            }), n({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (o = e.callback) || o.call(e, !0);
                        } catch (t) {
                            var r;
                            s({
                                key: ti.LOAD_API_TOKENS,
                                value: Kn(t)
                            }), n({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (r = e.callback) || r.call(e, null, t);
                        }
                    },
                    addTenantApiToken: async (a)=>{
                        const { description: o, roleIds: r, expires: l, callback: c } = a, u = ti.ADD_API_TOKEN;
                        n({
                            key: u,
                            value: !0
                        });
                        try {
                            const { policy: a } = e.auth.securityPolicyState.publicPolicy, n = (null == a ? void 0 : a.machineToMachineAuthStrategy) === F.AccessToken;
                            let s, u = null;
                            l && (u = 1440 * l), s = n ? await t.auth.createTenantAccessToken({
                                description: o,
                                expiresInMinutes: u,
                                roleIds: r
                            }) : await t.auth.updateTenantApiTokensData({
                                description: o,
                                roleIds: r,
                                expiresInMinutes: u
                            }), i({
                                showAddTokenDialog: !1
                            }), await Mn(200);
                            const d = n ? F.AccessToken : F.ClientCredentials;
                            e.auth.apiTokensState.apiTokensDataTenant.unshift(v({}, s, {
                                type: d
                            })), e.auth.apiTokensState.successDialog = {
                                open: !0,
                                secret: s.secret,
                                clientId: n ? void 0 : s.clientId
                            }, null == c || c(null);
                        } catch (e) {
                            s({
                                key: u,
                                value: Kn(e)
                            }), null == c || c(null, e);
                        } finally{
                            n({
                                key: u,
                                value: !1
                            });
                        }
                    },
                    addUserApiToken: async (a)=>{
                        const { description: o, expires: r, callback: l } = a, c = ti.ADD_API_TOKEN;
                        n({
                            key: c,
                            value: !0
                        });
                        try {
                            const { policy: a } = e.auth.securityPolicyState.publicPolicy, n = (null == a ? void 0 : a.machineToMachineAuthStrategy) === F.AccessToken;
                            let s, c = null;
                            r && (c = 1440 * r), s = n ? await t.auth.createUserAccessToken({
                                description: o,
                                expiresInMinutes: c
                            }) : await t.auth.updateUserApiTokensData({
                                description: o,
                                expiresInMinutes: c
                            }), i({
                                showAddTokenDialog: !1
                            }), await Mn(200);
                            const u = n ? F.AccessToken : F.ClientCredentials;
                            e.auth.apiTokensState.apiTokensDataUser.unshift(v({}, s, {
                                type: u
                            })), e.auth.apiTokensState.successDialog = {
                                open: !0,
                                secret: s.secret,
                                clientId: n ? void 0 : s.clientId
                            }, null == l || l(null);
                        } catch (e) {
                            s({
                                key: c,
                                value: Kn(e)
                            }), null == l || l(null, e);
                        } finally{
                            n({
                                key: c,
                                value: !1
                            });
                        }
                    },
                    deleteUserApiToken: async (a)=>{
                        const o = ti.DELETE_API_TOKEN;
                        n({
                            key: o,
                            value: !0
                        });
                        try {
                            const n = e.auth.apiTokensState.apiTokensDataUser;
                            n.some((e)=>e.id === a) ? (await t.auth.deleteUserAccessToken({
                                id: a
                            }), i({
                                apiTokensDataUser: n.filter((e)=>e.id !== a),
                                deleteTokenDialog: {
                                    open: !1,
                                    id: a
                                }
                            })) : (await t.auth.deleteUserApiToken({
                                tokenId: a
                            }), i({
                                apiTokensDataUser: n.filter((e)=>e.clientId !== a),
                                deleteTokenDialog: {
                                    open: !1,
                                    clientId: a
                                }
                            }));
                        } catch (e) {
                            s({
                                key: o,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: o,
                                value: !1
                            });
                        }
                    },
                    deleteTenantApiToken: async (a)=>{
                        const o = ti.DELETE_API_TOKEN;
                        n({
                            key: o,
                            value: !0
                        });
                        try {
                            const n = e.auth.apiTokensState.apiTokensDataTenant;
                            n.some((e)=>e.id === a) ? (await t.auth.deleteTenantAccessToken({
                                id: a
                            }), i({
                                apiTokensDataTenant: n.filter((e)=>e.id !== a),
                                deleteTokenDialog: {
                                    open: !1,
                                    id: a
                                }
                            })) : (await t.auth.deleteTenantApiToken({
                                tokenId: a
                            }), i({
                                apiTokensDataTenant: n.filter((e)=>e.clientId !== a),
                                deleteTokenDialog: {
                                    open: !1,
                                    id: a
                                }
                            }));
                        } catch (e) {
                            s({
                                key: o,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: o,
                                value: !1
                            });
                        }
                    }
                };
            }, ni = {
                loading: !0,
                fetching: !0,
                error: null,
                userApplications: [],
                accountApplications: [],
                combinedUserApplications: []
            }, si = (e)=>hn(ni, e), ii = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.applicationsState, t);
                }, i = ()=>{
                    const { userApplications: t, accountApplications: a } = e.auth.applicationsState, n = ((e, t)=>{
                        if (!e && !t) return [];
                        const a = new Set((null == e ? void 0 : e.map((e)=>e.id)) || []);
                        return [
                            ...e || [],
                            ...((null == t ? void 0 : t.filter((e)=>e.tenantApplicationAccessType === ln.FREE_ACCESS)) || []).filter((e)=>!a.has(e.id))
                        ];
                    })(t, a);
                    s({
                        combinedUserApplications: n
                    });
                }, o = async ({ userIds: e, retryConfig: a })=>{
                    try {
                        const [s, i] = await Promise.all([
                            xn(()=>t.applications.getUsersApplicationsId({
                                    userIds: e
                                }), a),
                            xn(()=>t.applications.getTenantsApplicationsV2(), a)
                        ]), o = i.flatMap((e)=>e.assignments).filter((e)=>e.accessType === ln.FREE_ACCESS).map((e)=>e.appId), r = null != (n = s.map(({ appIds: e })=>e).reduce((e, t)=>(null == t || t.forEach((t)=>{
                                e && !e.includes(t) && e.push(t);
                            }), e), [])) ? n : [], l = [
                            ...new Set([
                                ...r,
                                ...o
                            ])
                        ];
                        let c = new Map;
                        if (l.length > 0) {
                            const e = await xn(()=>t.applications.getApplicationsData({
                                    appIds: l
                                }), a);
                            c = new Map(e.map((e)=>[
                                    e.id,
                                    e
                                ]));
                        }
                        return e.reduce((e, t)=>{
                            var a, n;
                            const i = [], r = new Set(null != (a = null == (n = s.find((e)=>e.userId === t)) ? void 0 : n.appIds) ? a : []);
                            return c.forEach((e, t)=>{
                                (r.has(t) || e.accessType === ln.FREE_ACCESS || o.includes(t)) && i.push(e);
                            }), e[t] = i, e;
                        }, {});
                    } catch (e) {
                        s({
                            error: Kn(e)
                        });
                    }
                    var n;
                }, r = "Assignment action failed. Try again or contact support.";
                return {
                    setApplicationsState: s,
                    resetApplicationsState: ()=>{
                        Wn(e, [
                            "auth",
                            "applicationsState"
                        ], ni);
                    },
                    loadUserApplications: async (a)=>{
                        s({
                            loading: !0,
                            fetching: !0
                        });
                        try {
                            var n, o;
                            const r = null != (n = null == (o = e.auth.user) ? void 0 : o.id) ? n : "", l = null == a ? void 0 : a.retryConfig, c = await xn(()=>t.applications.getUserApplicationsId({
                                    userId: r
                                }), l), u = await xn(()=>t.applications.getApplicationsData({
                                    appIds: c
                                }), l);
                            s({
                                userApplications: u,
                                fetching: !1,
                                loading: !1
                            }), i();
                        } catch (e) {
                            s({
                                loading: !1,
                                fetching: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    loadAccountApplications: async (e)=>{
                        const a = null == e ? void 0 : e.retryConfig;
                        s({
                            loading: !0,
                            fetching: !0
                        });
                        try {
                            const e = await xn(()=>t.applications.getTenantsApplicationsV2(), a), n = [
                                ...new Set(e.flatMap((e)=>e.assignments.map((e)=>e.appId)))
                            ], o = await xn(()=>t.applications.getApplicationsData({
                                    appIds: n
                                }), a), r = await xn(()=>t.applications.getUsersOfApplications({
                                    appIds: n
                                }), a), l = new Map;
                            e.forEach((e)=>{
                                e.assignments.forEach((e)=>{
                                    l.set(e.appId, e.accessType);
                                });
                            });
                            const c = o.map((e)=>{
                                var t;
                                return v({}, e, {
                                    userIds: null == (t = r.find((t)=>t.appId === e.id)) ? void 0 : t.userIds,
                                    tenantApplicationAccessType: l.get(e.id)
                                });
                            });
                            s({
                                accountApplications: c,
                                fetching: !1,
                                loading: !1
                            }), i();
                        } catch (e) {
                            s({
                                loading: !1,
                                fetching: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    loadMultipleUsersApplications: o,
                    assignUserToApps: async (n)=>{
                        const { userId: i, appIds: o, callback: l } = n;
                        try {
                            var c, u, d, g, p, h, y, S, f;
                            const n = null != (c = null == (u = e.auth) || null == (d = u.user) ? void 0 : d.tenantId) ? c : "";
                            await t.applications.assignUserToApplications({
                                userId: i,
                                appIds: o,
                                tenantId: n
                            });
                            const s = null == (g = e.auth) || null == (p = g.applicationsState) ? void 0 : p.accountApplications, r = null != (h = null == (y = e.auth) || null == (S = y.teamState) ? void 0 : S.users) ? h : [], m = null != (f = null == s ? void 0 : s.filter((e)=>o.includes(e.id))) ? f : [];
                            null != m && m.length && a.setTeamState({
                                users: r.map((e)=>{
                                    var t;
                                    return e.id === i ? v({}, e, {
                                        applications: [
                                            ...null != (t = e.applications) ? t : [],
                                            ...m
                                        ]
                                    }) : e;
                                })
                            }), null == l || l(!0);
                        } catch (e) {
                            s({
                                error: Kn(e, r)
                            }), null == l || l(!1);
                        }
                    },
                    unassignUserFromApps: async (n)=>{
                        const { userId: i, appIds: o, callback: l } = n;
                        try {
                            var c, u, d, g, p, h, y;
                            const n = null != (c = null == (u = e.auth) || null == (d = u.user) ? void 0 : d.tenantId) ? c : "";
                            await t.applications.unassignUserFromApplications({
                                userId: i,
                                appIds: o,
                                tenantId: n
                            });
                            const s = null != (g = null == (p = e.auth) || null == (h = p.teamState) ? void 0 : h.users) ? g : [], r = null == (y = s.find((e)=>e.id === i)) ? void 0 : y.applications;
                            null != r && r.length && o.length && a.setTeamState({
                                users: s.map((e)=>e.id === i ? v({}, e, {
                                        applications: r.filter((e)=>!o.includes(e.id))
                                    }) : e)
                            }), null == l || l(!0);
                        } catch (e) {
                            s({
                                error: Kn(e, r)
                            }), null == l || l(!1);
                        }
                    },
                    assignNewUserToApps: async ({ appIds: a, user: s })=>{
                        var i, o, r;
                        const [l] = await n.getFeatureFlags([
                            "multi-apps-admin-portal"
                        ]);
                        if (!l) return;
                        const c = null == (i = e.auth) || null == (o = i.applicationsState) ? void 0 : o.accountApplications, u = null != (r = null == c ? void 0 : c.filter((e)=>e.accessType === ln.FREE_ACCESS || e.tenantApplicationAccessType === ln.FREE_ACCESS)) ? r : [];
                        if (null != a && a.length) {
                            var d, g, p;
                            const n = null != (d = null == (g = e.auth) || null == (p = g.user) ? void 0 : p.tenantId) ? d : "";
                            return await t.applications.assignUserToApplications({
                                userId: s.id,
                                appIds: a,
                                tenantId: n
                            }), a.map((e)=>{
                                var t;
                                return null != (t = null == c ? void 0 : c.find((t)=>t.id === e)) ? t : [];
                            }).concat(u);
                        }
                        return u;
                    },
                    mapUsersWithApplicationData: async ({ shouldLoadApps: e, users: t, retryConfig: n })=>{
                        const [s] = await a.getFeatureFlags([
                            "multi-apps-admin-portal"
                        ]);
                        if (!s || !e) return t;
                        const i = t.map((e)=>e.id), r = await o({
                            userIds: i,
                            retryConfig: n
                        });
                        return r ? t.map((e)=>null != r && r[e.id] ? v({}, e, {
                                applications: r[e.id]
                            }) : e) : t;
                    }
                };
            }, oi = {
                loading: !0,
                error: null
            }, ri = (e)=>hn(oi, e), li = [
                "callback"
            ], ci = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.customLoginState, t);
                }, i = async ()=>{
                    var t, a, n, s, i;
                    return e.auth.isAuthenticated ? null != (s = null == (i = e.auth.tenantsState.activeTenant) ? void 0 : i.hasCustomLogin) && s : !!(null == (t = await (null == (a = L.for(e.root.appName).getContext()) || null == (n = a.tenantResolver) ? void 0 : n.call(a))) ? void 0 : t.tenant);
                };
                return {
                    setCustomLoginState: s,
                    resetCustomLoginState: ()=>{
                        Wn(e, [
                            "auth",
                            "customLoginState"
                        ], oi);
                    },
                    loadTenantMetadata: async ()=>{
                        s({
                            loading: !0
                        });
                        try {
                            const e = await t.metadata.getAdminBoxMetadata();
                            s({
                                tenantMetadata: e,
                                loading: !1
                            });
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    updateTenantMetadata: async (e)=>{
                        const { callback: a } = e, n = f(e, li);
                        try {
                            s({
                                error: null,
                                saving: !0
                            });
                            const e = Us(n);
                            if (0 === e.length) throw new Error("No changes to update");
                            await t.metadata.updateAdminBoxMetadata({
                                actions: e
                            });
                            const i = await t.metadata.getAdminBoxMetadata();
                            s({
                                tenantMetadata: i,
                                saving: !1
                            }), null == a || a(!0);
                        } catch (e) {
                            s({
                                error: Kn(e, "No changes to update"),
                                saving: !1
                            }), null == a || a(null, e);
                        }
                    },
                    customLoginEnabled: i,
                    loadCustomLoginRoutes: async (a)=>{
                        try {
                            var o, r, l;
                            if (!await i()) return void (null == a || null == (l = a.callback) || l.call(a, !0));
                            const u = e.auth.isAuthenticated, { getSettings: d, getPublicSettings: g } = t.accountSettings, { applicationUrl: p } = await xn(u ? d : g, null == a ? void 0 : a.retryConfig);
                            var c;
                            if (!p) return void (null == a || null == (c = a.callback) || c.call(a, !0));
                            const h = e.auth.routes, y = null != (o = gs(p)) ? o : "";
                            n.setAuthState({
                                routes: v({}, h, {
                                    customLoginAuthenticatedUrl: p,
                                    customLoginUrl: h.loginUrl + y
                                })
                            }), s({
                                customLoginSearchParams: null != y ? y : void 0
                            }), null == a || null == (r = a.callback) || r.call(a, !0);
                        } catch (e) {
                            var u;
                            null == a || null == (u = a.callback) || u.call(a, null, e);
                        }
                    }
                };
            };
            let ui;
            !function(e) {
                e.forgotPassword = "forgotPassword", e.resetPasswordViaSms = "resetPasswordViaSms", e.passwordRecoverySelector = "passwordRecoverySelector", e.resetPasswordPage = "resetPasswordPage", e.forgotPasswordEmailSuccess = "forgotPasswordEmailSuccess", e.resetPasswordSuccess = "resetPasswordSuccess";
            }(ui || (ui = {}));
            const di = {
                step: ui.forgotPassword,
                loading: !1,
                identifier: "",
                identifierType: $.email,
                sessionId: "",
                userId: "",
                token: "",
                passwordConfig: null
            }, gi = (e)=>hn(di, e), pi = {
                UNKNOWN_ERROR: "unknownError",
                SENDING_RECOVERY_EMAIL_ERROR: "sendingRecoveryEmailError",
                SENDING_RECOVERY_SMS_ERROR: "sendingRecoverySmsError",
                SESSION_ID_NOT_FOUND: "sessionIdNotFound",
                INVALID_SERVER_RESPONSE: "invalidServerResponse",
                VERIFYING_SMS_ERROR: "verifyingSmsError",
                NO_ACTIVE_RECOVERY_METHODS: "noActiveRecoveryMethods",
                DETERMINING_RECOVERY_STRATEGY_ERROR: "determiningRecoveryStrategyError"
            }, hi = [
                "callback"
            ], yi = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.forgotPasswordState, t);
                }, s = async ()=>{
                    const { identifier: a, identifierType: s } = e.auth.forgotPasswordState;
                    n({
                        loading: !0
                    });
                    try {
                        await t.auth.resetPasswordViaEmail({
                            identifier: a,
                            identifierType: s
                        }), n({
                            loading: !1,
                            error: void 0,
                            step: ui.forgotPasswordEmailSuccess
                        });
                    } catch (e) {
                        n({
                            loading: !1,
                            error: Kn(e, pi.SENDING_RECOVERY_EMAIL_ERROR)
                        });
                    }
                };
                return {
                    loadPasswordRecoveryStrategies: async ()=>{
                        n({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.getPasswordRecoveryStrategies();
                            n({
                                loading: !1,
                                activeStrategies: e
                            });
                        } catch (e) {
                            n({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    setForgotPasswordState: n,
                    resetForgotPasswordState: ()=>{
                        Wn(e, [
                            "auth",
                            "forgotPasswordState"
                        ], di);
                    },
                    forgotPassword: async (e)=>{
                        n({
                            loading: !0
                        });
                        try {
                            var a;
                            await t.auth.forgotPassword(e), n({
                                loading: !1,
                                error: void 0,
                                step: ui.forgotPasswordEmailSuccess
                            }), null == (a = e.callback) || a.call(e, !0);
                        } catch (t) {
                            var s;
                            n({
                                loading: !1,
                                error: Kn(t, pi.UNKNOWN_ERROR)
                            }), null == (s = e.callback) || s.call(e, !1, t);
                        }
                    },
                    resetPassword: async (e)=>{
                        const { callback: a } = e, s = f(e, hi);
                        n({
                            loading: !0
                        });
                        try {
                            await t.auth.resetPassword(s), n({
                                loading: !1,
                                error: void 0,
                                step: ui.resetPasswordSuccess
                            }), null == a || a(!0);
                        } catch (e) {
                            n({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(!1, e);
                        }
                    },
                    loadPasswordConfig: async (e)=>{
                        n({
                            loading: !0
                        });
                        try {
                            const a = await t.auth.loadPasswordConfig(e);
                            n({
                                loading: !1,
                                passwordConfig: a
                            });
                        } catch (e) {
                            n({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    determinePasswordRecoveryStrategy: async (e)=>{
                        n({
                            loading: !0,
                            error: void 0,
                            identifier: e.identifier,
                            identifierType: e.identifierType
                        });
                        try {
                            const e = await t.auth.getPasswordRecoveryStrategies(), a = e.some((e)=>e.strategy === G.Email && e.isActive), i = e.some((e)=>e.strategy === G.Sms && e.isActive);
                            a && i ? n({
                                loading: !1,
                                step: ui.passwordRecoverySelector,
                                activeStrategies: e
                            }) : a ? await s() : n(i ? {
                                loading: !1,
                                step: ui.resetPasswordViaSms,
                                activeStrategies: e
                            } : {
                                loading: !1,
                                error: pi.NO_ACTIVE_RECOVERY_METHODS,
                                activeStrategies: e
                            });
                        } catch (e) {
                            n({
                                loading: !1,
                                error: Kn(e, pi.DETERMINING_RECOVERY_STRATEGY_ERROR)
                            });
                        }
                    },
                    sendPasswordRecoveryEmail: s,
                    sendPasswordRecoverySms: async ()=>{
                        const { identifier: a, identifierType: s } = e.auth.forgotPasswordState;
                        n({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.resetPasswordViaSms({
                                identifier: a,
                                identifierType: s
                            });
                            n({
                                loading: !1,
                                error: void 0,
                                sessionId: e.sessionId
                            });
                        } catch (e) {
                            n({
                                loading: !1,
                                error: Kn(e, pi.SENDING_RECOVERY_SMS_ERROR)
                            });
                        }
                    },
                    verifyPasswordViaSms: async (a)=>{
                        const { sessionId: s } = e.auth.forgotPasswordState;
                        if (s) {
                            n({
                                loading: !0
                            });
                            try {
                                const e = await t.auth.verifyPasswordViaSms({
                                    otcToken: a.otcToken,
                                    sessionId: s
                                });
                                if (!e.userId || !e.token) throw new Error(pi.INVALID_SERVER_RESPONSE);
                                n({
                                    loading: !1,
                                    error: void 0,
                                    userId: e.userId,
                                    token: e.token,
                                    step: ui.resetPasswordPage
                                });
                            } catch (e) {
                                n({
                                    loading: !1,
                                    error: Kn(e, pi.VERIFYING_SMS_ERROR)
                                });
                            }
                        } else n({
                            loading: !1,
                            error: pi.SESSION_ID_NOT_FOUND
                        });
                    }
                };
            };
            let Si;
            !function(e) {
                e.success = "success", e.notification = "notification";
            }(Si || (Si = {}));
            const vi = {
                step: Si.notification
            }, fi = (e)=>hn(vi, e), mi = (e, t, a)=>({
                    setStep: (t)=>{
                        var a;
                        a = {
                            step: t
                        }, Object.assign(e.auth.passwordRotationState, a);
                    }
                }), bi = {
                loaders: {},
                errors: {},
                groups: [],
                groupsConfiguration: {}
            }, Ai = (e)=>hn(bi, e);
            let wi, Ti;
            !function(e) {
                e.CREATE_GROUP = "CREATE_GROUP", e.GET_GROUP = "GET_GROUP", e.GET_GROUPS = "GET_GROUPS", e.DELETE_GROUP = "DELETE_GROUP", e.UPDATE_GROUP = "UPDATE_GROUP", e.ADD_USERS_TO_GROUP = "ADD_USERS_TO_GROUP", e.DELETE_USERS_FROM_GROUP = "DELETE_USERS_FROM_GROUP", e.ADD_ROLES_TO_GROUP = "ADD_ROLES_TO_GROUP", e.DELETE_ROLES_FROM_GROUP = "DELETE_ROLES_FROM_GROUP", e.GET_GROUP_CONFIGURATION = "GET_GROUP_CONFIGURATION", e.UPDATE_GROUP_CONFIGURATION = "UPDATE_GROUP_CONFIGURATION", e.GET_TEAM_USERS = "GET_TEAM_USERS";
            }(wi || (wi = {})), function(e) {
                e.roles = "roles", e.users = "users", e.rolesAndUsers = "rolesAndUsers";
            }(Ti || (Ti = {}));
            const Ei = [
                "roleIds",
                "userIds"
            ], Pi = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.groupsState, {
                        loaders: v({}, e.auth.groupsState.loaders, {
                            [t.key]: t.value
                        })
                    });
                }, s = (t)=>{
                    Object.assign(e.auth.groupsState, {
                        errors: v({}, e.auth.groupsState.errors, {
                            [t.key]: t.value
                        }),
                        loaders: v({}, e.auth.groupsState.loaders, {
                            [t.key]: !1
                        })
                    });
                }, i = (t)=>{
                    Object.assign(e.auth.groupsState, t);
                }, o = async (a)=>{
                    const o = wi.GET_GROUPS, r = e.auth.groupsState;
                    n({
                        key: o,
                        value: !0
                    });
                    try {
                        const { groups: e } = await xn(()=>t.groups.getGroups({
                                _groupsRelations: Ti.rolesAndUsers
                            }), null == a ? void 0 : a.retryConfig);
                        i(v({
                            groups: e
                        }, r.selectedGroup && {
                            selectedGroup: e.find((e)=>{
                                var t;
                                return e.id === (null == (t = r.selectedGroup) ? void 0 : t.id);
                            })
                        }));
                    } catch (e) {
                        s({
                            key: o,
                            value: Kn(e)
                        });
                    } finally{
                        n({
                            key: o,
                            value: !1
                        });
                    }
                }, r = async (e)=>{
                    const a = wi.ADD_ROLES_TO_GROUP;
                    n({
                        key: a,
                        value: !0
                    });
                    try {
                        var i;
                        await t.groups.addRolesToGroup(e.groupId, {
                            roleIds: e.roleIds
                        }), await o(), null == e || null == (i = e.callback) || i.call(e, !0);
                    } catch (t) {
                        var r;
                        s({
                            key: a,
                            value: Kn(t)
                        }), null == e || null == (r = e.callback) || r.call(e, !1);
                    } finally{
                        n({
                            key: a,
                            value: !1
                        });
                    }
                }, l = async (e)=>{
                    const a = wi.ADD_USERS_TO_GROUP;
                    n({
                        key: a,
                        value: !0
                    });
                    try {
                        var i;
                        await t.groups.addUsersToGroup(e.groupId, {
                            userIds: e.userIds
                        }), await o(), null == e || null == (i = e.callback) || i.call(e, !0);
                    } catch (t) {
                        var r;
                        null == e || null == (r = e.callback) || r.call(e, !1), s({
                            key: a,
                            value: Kn(t)
                        });
                    } finally{
                        n({
                            key: a,
                            value: !1
                        });
                    }
                }, c = async (e)=>{
                    const a = wi.GET_GROUP_CONFIGURATION;
                    n({
                        key: a,
                        value: !0
                    });
                    try {
                        const a = await xn(()=>t.groups.getGroupConfiguration(), null == e ? void 0 : e.retryConfig);
                        i({
                            groupsConfiguration: a
                        });
                    } catch (e) {
                        s({
                            key: a,
                            value: Kn(e)
                        });
                    } finally{
                        n({
                            key: a,
                            value: !1
                        });
                    }
                };
                return {
                    setUsersGroupsLoader: n,
                    setUsersGroupsError: s,
                    setGroupsState: i,
                    resetUsersGroupsState: ()=>{
                        Wn(e, [
                            "auth",
                            "groupsState"
                        ], bi);
                    },
                    loadGroups: o,
                    getGroupById: async (e)=>{
                        const a = wi.GET_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            const a = await t.groups.getGroupById({
                                groupId: e.groupId
                            }, {
                                _groupsRelations: Ti.rolesAndUsers
                            });
                            i({
                                selectedGroup: a
                            });
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    createGroup: async (e)=>{
                        const a = wi.CREATE_GROUP, { roleIds: i, userIds: c } = e, u = f(e, Ei);
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var d;
                            const a = await t.groups.createGroup(v({
                                name: u.name
                            }, !!u.description && {
                                description: u.description
                            }, {
                                color: u.color
                            }));
                            null != c && c.length && l({
                                groupId: a.id,
                                userIds: c
                            }), null != i && i.length && r({
                                groupId: a.id,
                                roleIds: i
                            }), await o(), null == e || null == (d = e.callback) || d.call(e, !0);
                        } catch (t) {
                            var g;
                            s({
                                key: a,
                                value: Kn(t)
                            }), null == e || null == (g = e.callback) || g.call(e, !1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    updateGroup: async (e)=>{
                        const a = wi.UPDATE_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var i;
                            await t.groups.updateGroup(e), await o(), null == e || null == (i = e.callback) || i.call(e, !0);
                        } catch (t) {
                            var r;
                            s({
                                key: a,
                                value: Kn(t)
                            }), null == e || null == (r = e.callback) || r.call(e, !1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    deleteGroup: async (e)=>{
                        const a = wi.DELETE_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var i;
                            await t.groups.deleteGroup(e.groupId), await o(), null == e || null == (i = e.callback) || i.call(e, !0);
                        } catch (t) {
                            var r;
                            s({
                                key: a,
                                value: Kn(t)
                            }), null == e || null == (r = e.callback) || r.call(e, !1, t);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    addRolesToGroup: r,
                    deleteRolesFromGroup: async (e)=>{
                        const a = wi.DELETE_ROLES_FROM_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var i;
                            await t.groups.deleteRolesFromGroup(e.groupId, {
                                roleIds: e.roleIds
                            }), await o(), null == e || null == (i = e.callback) || i.call(e, !0);
                        } catch (t) {
                            var r;
                            s({
                                key: a,
                                value: Kn(t)
                            }), null == e || null == (r = e.callback) || r.call(e, !1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    addUsersToGroup: l,
                    deleteUsersFromGroup: async (e)=>{
                        const a = wi.DELETE_USERS_FROM_GROUP;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            var i;
                            await t.groups.deleteUsersFromGroup(e.groupId, {
                                userIds: e.userIds
                            }), await o(), null == e || null == (i = e.callback) || i.call(e, !0);
                        } catch (t) {
                            var r;
                            s({
                                key: a,
                                value: Kn(t)
                            }), null == e || null == (r = e.callback) || r.call(e, !1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    getGroupConfiguration: c,
                    updateGroupConfiguration: async (e)=>{
                        const a = wi.UPDATE_GROUP_CONFIGURATION;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            await t.groups.updateGroupConfiguration(e), await c();
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    getTeamUsers: async (e)=>{
                        const a = wi.GET_TEAM_USERS;
                        n({
                            key: a,
                            value: !0
                        });
                        try {
                            const { items: a } = await t.users.getUsersV2({
                                _filter: e.filter,
                                _offset: e.pageOffset,
                                _limit: e.pageSize,
                                _includeSubTenants: !1
                            });
                            i({
                                teamUsers: a
                            });
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    }
                };
            }, Ii = {
                addGroupDialogState: {
                    loading: !1,
                    open: !1
                },
                editGroupDialogState: {
                    loading: !1,
                    open: !1
                },
                deleteGroupDialogState: {
                    loading: !1,
                    open: !1
                },
                addMembersToGroupDialogState: {
                    loading: !1,
                    open: !1,
                    userIds: []
                },
                deleteMemberFromGroupDialogState: {
                    loading: !1,
                    open: !1
                }
            }, Oi = (e)=>hn(Ii, e), ki = (e, t, a)=>({
                    setGroupsDialogsState: (t)=>{
                        Object.assign(e.auth.groupsDialogsState, t);
                    },
                    resetGroupsDialogsState: ()=>{
                        Wn(e, [
                            "auth",
                            "groupsDialogsState"
                        ], Ii);
                    },
                    openAddGroupDialog: ()=>{
                        e.auth.groupsDialogsState.addGroupDialogState.open = !0;
                    },
                    closeAddGroupDialog: ()=>{
                        Object.assign(e.auth.groupsDialogsState.addGroupDialogState, {
                            open: !1,
                            group: void 0
                        });
                    },
                    openAddMembersToGroupDialog: ()=>{
                        e.auth.groupsDialogsState.addMembersToGroupDialogState.open = !0;
                    },
                    closeAddMembersToGroupDialog: ()=>{
                        Object.assign(e.auth.groupsDialogsState.addMembersToGroupDialogState, {
                            open: !1,
                            userIds: []
                        });
                    },
                    openEditGroupDialog: (t)=>{
                        Object.assign(e.auth.groupsDialogsState.editGroupDialogState, v({}, t, {
                            open: !0
                        }));
                    },
                    closeEditGroupDialog: ()=>{
                        Object.assign(e.auth.groupsDialogsState.editGroupDialogState, {
                            open: !1,
                            loading: !1,
                            group: void 0
                        });
                    },
                    openDeleteGroupDialog: (t)=>{
                        Object.assign(e.auth.groupsDialogsState.deleteGroupDialogState, v({}, t, {
                            open: !0
                        }));
                    },
                    closeDeleteGroupDialog: ()=>{
                        Object.assign(e.auth.groupsDialogsState.deleteGroupDialogState, {
                            open: !1,
                            loading: !1,
                            group: void 0
                        });
                    },
                    openDeleteMemberFromGroupDialog: (t)=>{
                        Object.assign(e.auth.groupsDialogsState.deleteMemberFromGroupDialogState, t);
                    },
                    closeDeleteMemberFromGroupDialog: ()=>{
                        Object.assign(e.auth.groupsDialogsState.deleteMemberFromGroupDialogState, {
                            open: !1,
                            userId: void 0,
                            email: void 0
                        });
                    }
                });
            let _i;
            !function(e) {
                e.impersonating = "impersonating", e.success = "success";
            }(_i || (_i = {}));
            const Ri = {
                step: _i.impersonating,
                loading: !1
            }, Ui = (e)=>hn(Ri, e), Li = [
                "callback",
                "events"
            ], Ci = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.impersonateState, t);
                }, i = ()=>{
                    Wn(e, [
                        "auth",
                        "impersonateState"
                    ], Ri);
                };
                return {
                    setImpersonateState: s,
                    resetImpersonateState: i,
                    impersonate: async (e)=>{
                        const { callback: a } = e, o = f(e, Li);
                        s({
                            loading: !0
                        });
                        try {
                            await t.impersonate.impersonate(o), s({
                                step: _i.success
                            }), await Mn(1e3), await n.afterAuthNavigation({
                                preventRedirectUrlOriginCleaning: !0
                            }), i(), null == a || a(!0);
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    }
                };
            }, Di = {
                flow: kn.Login,
                step: On.preLogin,
                loading: !1,
                email: "",
                tenants: []
            }, Ni = (e)=>hn(Di, e), Mi = (e, t, a)=>{
                const n = a;
                const s = async (t, a = {})=>{
                    const { customLoginAuthenticatedUrl: n, forceStepUpUrl: s, shouldStepUpDuringLogin: i, preventRedirectUrlOriginCleaning: o = !1 } = a, r = e.auth.onRedirectTo;
                    let l;
                    if (s) l = s;
                    else {
                        var c;
                        if (i) {
                            const e = window.localStorage.getItem(Cn);
                            e && !us(e) && (l = e);
                        }
                        l || (l = await async function({ customLoginAuthenticatedUrl: t, preventRedirectUrlOriginCleaning: a }) {
                            const { routes: n, includeQueryParam: s = !1, enforceRedirectToSameSite: i = !1, allowedRedirectOrigins: o = [] } = e.auth, r = window.localStorage.getItem(Cn);
                            if (t && !r) return ps(t, a);
                            const { authenticatedUrl: l, loginUrl: c, logoutUrl: u, socialLoginCallbackUrl: d, activateUrl: g, activateWithOTCUrl: p } = n;
                            let h = r;
                            h && ![
                                c,
                                u,
                                d,
                                g,
                                p
                            ].includes(h) || (h = l);
                            const y = ds({
                                authenticatedUrl: h,
                                includeQueryParam: s,
                                enforceRedirectToSameSite: i,
                                allowedRedirectOrigins: o
                            });
                            var S, v, f;
                            return a ? y : (S = y).startsWith(null == (v = window) ? void 0 : v.location.origin) ? S.replace(null == (f = window) ? void 0 : f.location.origin, "") : S;
                        }({
                            customLoginAuthenticatedUrl: n,
                            preventRedirectUrlOriginCleaning: o
                        })), null == (c = window) || c.localStorage.removeItem(Cn);
                    }
                    await Mn(200), await t(), r(l, {
                        refresh: l.startsWith("http")
                    });
                };
                return {
                    afterAuthNavigationUtil: s,
                    afterAuthNavigation: async (t)=>{
                        var a, i;
                        const { customLoginAuthenticatedUrl: o, stepUpUrl: r } = e.auth.routes, l = null == (a = window) ? void 0 : a.localStorage.getItem(Pn), c = e.auth.user;
                        var u;
                        if (l && (null == (u = window) || u.localStorage.removeItem(Pn)), r && l && !Es(c)) return s(n.resetLoginState, {
                            forceStepUpUrl: r
                        });
                        let d = o;
                        var g;
                        return o || (await n.loadCustomLoginRoutes(), d = null == (g = e.auth.routes) ? void 0 : g.customLoginAuthenticatedUrl), s(n.resetLoginState, {
                            customLoginAuthenticatedUrl: d,
                            shouldStepUpDuringLogin: !!l,
                            preventRedirectUrlOriginCleaning: null != (i = null == t ? void 0 : t.preventRedirectUrlOriginCleaning) && i
                        });
                    },
                    afterStepUpAuthNavigation: async ()=>s(n.resetStepUpState),
                    afterAuthenticationStateUpdate: function({ user: t, tenants: a = [], activeTenant: s }, i = {}) {
                        const o = e.auth.tenantsState;
                        n.setAuthState(v({
                            user: t,
                            tenantsState: v({}, o, {
                                tenants: a,
                                activeTenant: s,
                                loading: !1
                            })
                        }, i));
                    }
                };
            }, Fi = [
                "callback"
            ], xi = [
                "callback"
            ], $i = [
                "callback"
            ], Gi = [
                "callback",
                "deviceId"
            ], ji = [
                "callback",
                "deviceId"
            ], Vi = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", Bi = new Uint8Array(256);
            for(let e = 0; e < 64; e++)Bi[Vi.charCodeAt(e)] = e;
            const Wi = (e)=>{
                const t = new Uint8Array(e), a = t.length;
                let n, s = "";
                for(n = 0; n < a; n += 3)s += Vi[t[n] >> 2], s += Vi[(3 & t[n]) << 4 | t[n + 1] >> 4], s += Vi[(15 & t[n + 1]) << 2 | t[n + 2] >> 6], s += Vi[63 & t[n + 2]];
                return a % 3 == 2 ? s = s.substring(0, s.length - 1) : a % 3 == 1 && (s = s.substring(0, s.length - 2)), s;
            }, zi = (e)=>{
                const t = .75 * e.length, a = e.length;
                let n, s, i, o, r, l = 0;
                const c = new Uint8Array(t);
                for(n = 0; n < a; n += 4)s = Bi[e.charCodeAt(n)], i = Bi[e.charCodeAt(n + 1)], o = Bi[e.charCodeAt(n + 2)], r = Bi[e.charCodeAt(n + 3)], c[l++] = s << 2 | i >> 4, c[l++] = (15 & i) << 4 | o >> 2, c[l++] = (3 & o) << 6 | 63 & r;
                return c.buffer;
            };
            function Hi(e, t = "file") {
                const a = e.match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
                if (null == a) return null;
                const n = `image/${a[1]}`, s = ((e, t)=>{
                    const a = atob(e), n = [];
                    for(let e = 0; e < a.length; e += 512){
                        const t = a.slice(e, e + 512), s = new Array(t.length);
                        for(let e = 0; e < t.length; e++)s[e] = t.charCodeAt(e);
                        n.push(new Uint8Array(s));
                    }
                    return new Blob(n, {
                        type: t
                    });
                })(a[2], n), i = new FormData;
                return i.append(t, new File([
                    s
                ], t, {
                    type: n
                })), i;
            }
            const Ki = (e)=>{
                if (e instanceof Array) {
                    const t = [];
                    for (const a of e)t.push(Ki(a));
                    return t;
                }
                if (e instanceof ArrayBuffer) return Wi(e);
                if (e instanceof Object) {
                    const t = {};
                    for(const a in e)t[a] = Ki(e[a]);
                    return t;
                }
                return e;
            }, qi = (e)=>new Promise((t, a)=>{
                    const n = new FileReader;
                    n.readAsText(e), n.onload = ()=>t(n.result), n.onerror = a;
                }), Yi = [
                "callback",
                "deviceId"
            ], Ji = [
                "callback",
                "deviceId"
            ], Qi = "input is invalid type", Xi = "undefined" != typeof ArrayBuffer, Zi = "0123456789abcdef".split(""), eo = [
                -2147483648,
                8388608,
                32768,
                128
            ], to = [
                24,
                16,
                8,
                0
            ], ao = [
                1116352408,
                1899447441,
                3049323471,
                3921009573,
                961987163,
                1508970993,
                2453635748,
                2870763221,
                3624381080,
                310598401,
                607225278,
                1426881987,
                1925078388,
                2162078206,
                2614888103,
                3248222580,
                3835390401,
                4022224774,
                264347078,
                604807628,
                770255983,
                1249150122,
                1555081692,
                1996064986,
                2554220882,
                2821834349,
                2952996808,
                3210313671,
                3336571891,
                3584528711,
                113926993,
                338241895,
                666307205,
                773529912,
                1294757372,
                1396182291,
                1695183700,
                1986661051,
                2177026350,
                2456956037,
                2730485921,
                2820302411,
                3259730800,
                3345764771,
                3516065817,
                3600352804,
                4094571909,
                275423344,
                430227734,
                506948616,
                659060556,
                883997877,
                958139571,
                1322822218,
                1537002063,
                1747873779,
                1955562222,
                2024104815,
                2227730452,
                2361852424,
                2428436474,
                2756734187,
                3204031479,
                3329325298
            ], no = [
                "hex",
                "array",
                "digest",
                "arrayBuffer"
            ], so = [];
            Array.isArray || (Array.isArray = function(e) {
                return "[object Array]" === Object.prototype.toString.call(e);
            }), Xi && !ArrayBuffer.isView && (ArrayBuffer.isView = function(e) {
                return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
            });
            const io = function(e) {
                return function(t) {
                    const a = new ro(!0).update(t);
                    return null == a ? void 0 : a[e]();
                };
            }, oo = function(e) {
                return function(t, a) {
                    const n = new lo(t, !0).update(a);
                    return null == n ? void 0 : n[e]();
                };
            };
            class ro {
                constructor(e = !1){
                    this.blocks = void 0, this.h0 = void 0, this.h1 = void 0, this.h2 = void 0, this.h3 = void 0, this.h4 = void 0, this.h5 = void 0, this.h6 = void 0, this.h7 = void 0, this.block = void 0, this.start = void 0, this.bytes = void 0, this.hBytes = void 0, this.finalized = void 0, this.hashed = void 0, this.first = void 0, this.lastByteIndex = void 0, this.sharedMemory = !1, this.toString = ()=>this.hex(), this.array = ()=>ro.prototype.digest(), e ? (so[0] = so[16] = so[1] = so[2] = so[3] = so[4] = so[5] = so[6] = so[7] = so[8] = so[9] = so[10] = so[11] = so[12] = so[13] = so[14] = so[15] = 0, this.blocks = so) : this.blocks = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.sharedMemory = e;
                }
                update(e) {
                    if (this.finalized) return;
                    let t;
                    const a = typeof e;
                    if ("string" !== a) {
                        if ("object" !== a) throw new Error(Qi);
                        if (null === e) throw new Error(Qi);
                        if (Xi && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                        else if (!(Array.isArray(e) || Xi && ArrayBuffer.isView(e))) throw new Error(Qi);
                        t = !0;
                    }
                    let n, s, i = 0;
                    const o = e.length, r = this.blocks;
                    for(; i < o;){
                        if (this.hashed && (this.hashed = !1, r[0] = this.block, r[16] = r[1] = r[2] = r[3] = r[4] = r[5] = r[6] = r[7] = r[8] = r[9] = r[10] = r[11] = r[12] = r[13] = r[14] = r[15] = 0), t) for(s = this.start; i < o && s < 64; ++i)r[s >> 2] |= e[i] << to[3 & s++];
                        else for(s = this.start; i < o && s < 64; ++i)n = e.charCodeAt(i), n < 128 ? r[s >> 2] |= n << to[3 & s++] : n < 2048 ? (r[s >> 2] |= (192 | n >> 6) << to[3 & s++], r[s >> 2] |= (128 | 63 & n) << to[3 & s++]) : n < 55296 || n >= 57344 ? (r[s >> 2] |= (224 | n >> 12) << to[3 & s++], r[s >> 2] |= (128 | n >> 6 & 63) << to[3 & s++], r[s >> 2] |= (128 | 63 & n) << to[3 & s++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++i)), r[s >> 2] |= (240 | n >> 18) << to[3 & s++], r[s >> 2] |= (128 | n >> 12 & 63) << to[3 & s++], r[s >> 2] |= (128 | n >> 6 & 63) << to[3 & s++], r[s >> 2] |= (128 | 63 & n) << to[3 & s++]);
                        this.lastByteIndex = s, this.bytes += s - this.start, s >= 64 ? (this.block = r[16], this.start = s - 64, this.hash(), this.hashed = !0) : this.start = s;
                    }
                    return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 | 0, this.bytes = this.bytes % 4294967296), this;
                }
                finalize() {
                    if (this.finalized) return;
                    this.finalized = !0;
                    const e = this.blocks, t = this.lastByteIndex;
                    e[16] = this.block, e[t >> 2] |= eo[3 & t], this.block = e[16], t >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
                }
                hash() {
                    let e, t, a, n, s, i, o, r, l, c, u, d = this.h0, g = this.h1, p = this.h2, h = this.h3, y = this.h4, S = this.h5, v = this.h6, f = this.h7;
                    const m = this.blocks;
                    for(e = 16; e < 64; ++e)s = m[e - 15], t = (s >>> 7 | s << 25) ^ (s >>> 18 | s << 14) ^ s >>> 3, s = m[e - 2], a = (s >>> 17 | s << 15) ^ (s >>> 19 | s << 13) ^ s >>> 10, m[e] = m[e - 16] + t + m[e - 7] + a | 0;
                    for(u = g & p, e = 0; e < 64; e += 4)this.first ? (r = 704751109, s = m[0] - 210244248, f = s - 1521486534 | 0, h = s + 143694565 | 0, this.first = !1) : (t = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10), a = (y >>> 6 | y << 26) ^ (y >>> 11 | y << 21) ^ (y >>> 25 | y << 7), r = d & g, n = r ^ d & p ^ u, o = y & S ^ ~y & v, s = f + a + o + ao[e] + m[e], i = t + n, f = h + s | 0, h = s + i | 0), t = (h >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10), a = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7), l = h & d, n = l ^ h & g ^ r, o = f & y ^ ~f & S, s = v + a + o + ao[e + 1] + m[e + 1], i = t + n, v = p + s | 0, p = s + i | 0, t = (p >>> 2 | p << 30) ^ (p >>> 13 | p << 19) ^ (p >>> 22 | p << 10), a = (v >>> 6 | v << 26) ^ (v >>> 11 | v << 21) ^ (v >>> 25 | v << 7), c = p & h, n = c ^ p & d ^ l, o = v & f ^ ~v & y, s = S + a + o + ao[e + 2] + m[e + 2], i = t + n, S = g + s | 0, g = s + i | 0, t = (g >>> 2 | g << 30) ^ (g >>> 13 | g << 19) ^ (g >>> 22 | g << 10), a = (S >>> 6 | S << 26) ^ (S >>> 11 | S << 21) ^ (S >>> 25 | S << 7), u = g & p, n = u ^ g & h ^ c, o = S & v ^ ~S & f, s = y + a + o + ao[e + 3] + m[e + 3], i = t + n, y = d + s | 0, d = s + i | 0;
                    this.h0 = this.h0 + d | 0, this.h1 = this.h1 + g | 0, this.h2 = this.h2 + p | 0, this.h3 = this.h3 + h | 0, this.h4 = this.h4 + y | 0, this.h5 = this.h5 + S | 0, this.h6 = this.h6 + v | 0, this.h7 = this.h7 + f | 0;
                }
                hex() {
                    this.finalize();
                    const e = this.h0, t = this.h1, a = this.h2, n = this.h3, s = this.h4, i = this.h5, o = this.h6, r = this.h7;
                    let l = Zi[e >> 28 & 15] + Zi[e >> 24 & 15] + Zi[e >> 20 & 15] + Zi[e >> 16 & 15] + Zi[e >> 12 & 15] + Zi[e >> 8 & 15] + Zi[e >> 4 & 15] + Zi[15 & e] + Zi[t >> 28 & 15] + Zi[t >> 24 & 15] + Zi[t >> 20 & 15] + Zi[t >> 16 & 15] + Zi[t >> 12 & 15] + Zi[t >> 8 & 15] + Zi[t >> 4 & 15] + Zi[15 & t] + Zi[a >> 28 & 15] + Zi[a >> 24 & 15] + Zi[a >> 20 & 15] + Zi[a >> 16 & 15] + Zi[a >> 12 & 15] + Zi[a >> 8 & 15] + Zi[a >> 4 & 15] + Zi[15 & a] + Zi[n >> 28 & 15] + Zi[n >> 24 & 15] + Zi[n >> 20 & 15] + Zi[n >> 16 & 15] + Zi[n >> 12 & 15] + Zi[n >> 8 & 15] + Zi[n >> 4 & 15] + Zi[15 & n] + Zi[s >> 28 & 15] + Zi[s >> 24 & 15] + Zi[s >> 20 & 15] + Zi[s >> 16 & 15] + Zi[s >> 12 & 15] + Zi[s >> 8 & 15] + Zi[s >> 4 & 15] + Zi[15 & s] + Zi[i >> 28 & 15] + Zi[i >> 24 & 15] + Zi[i >> 20 & 15] + Zi[i >> 16 & 15] + Zi[i >> 12 & 15] + Zi[i >> 8 & 15] + Zi[i >> 4 & 15] + Zi[15 & i] + Zi[o >> 28 & 15] + Zi[o >> 24 & 15] + Zi[o >> 20 & 15] + Zi[o >> 16 & 15] + Zi[o >> 12 & 15] + Zi[o >> 8 & 15] + Zi[o >> 4 & 15] + Zi[15 & o];
                    return l += Zi[r >> 28 & 15] + Zi[r >> 24 & 15] + Zi[r >> 20 & 15] + Zi[r >> 16 & 15] + Zi[r >> 12 & 15] + Zi[r >> 8 & 15] + Zi[r >> 4 & 15] + Zi[15 & r], l;
                }
                digest() {
                    this.finalize();
                    const e = this.h0, t = this.h1, a = this.h2, n = this.h3, s = this.h4, i = this.h5, o = this.h6, r = this.h7, l = [
                        e >> 24 & 255,
                        e >> 16 & 255,
                        e >> 8 & 255,
                        255 & e,
                        t >> 24 & 255,
                        t >> 16 & 255,
                        t >> 8 & 255,
                        255 & t,
                        a >> 24 & 255,
                        a >> 16 & 255,
                        a >> 8 & 255,
                        255 & a,
                        n >> 24 & 255,
                        n >> 16 & 255,
                        n >> 8 & 255,
                        255 & n,
                        s >> 24 & 255,
                        s >> 16 & 255,
                        s >> 8 & 255,
                        255 & s,
                        i >> 24 & 255,
                        i >> 16 & 255,
                        i >> 8 & 255,
                        255 & i,
                        o >> 24 & 255,
                        o >> 16 & 255,
                        o >> 8 & 255,
                        255 & o
                    ];
                    return l.push(r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r), l;
                }
                arrayBuffer() {
                    this.finalize();
                    const e = new ArrayBuffer(32), t = new DataView(e);
                    return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), t.setUint32(20, this.h5), t.setUint32(24, this.h6), t.setUint32(28, this.h7), e;
                }
            }
            class lo extends ro {
                constructor(e, t = !1){
                    let a;
                    super(t), this.inner = void 0, this.oKeyPad = void 0;
                    const n = typeof e;
                    if ("string" === n) {
                        const t = [], n = e.length;
                        let s, i = 0;
                        for(a = 0; a < n; ++a)s = e.charCodeAt(a), s < 128 ? t[i++] = s : s < 2048 ? (t[i++] = 192 | s >> 6, t[i++] = 128 | 63 & s) : s < 55296 || s >= 57344 ? (t[i++] = 224 | s >> 12, t[i++] = 128 | s >> 6 & 63, t[i++] = 128 | 63 & s) : (s = 65536 + ((1023 & s) << 10 | 1023 & e.charCodeAt(++a)), t[i++] = 240 | s >> 18, t[i++] = 128 | s >> 12 & 63, t[i++] = 128 | s >> 6 & 63, t[i++] = 128 | 63 & s);
                        e = t;
                    } else {
                        if ("object" !== n) throw new Error(Qi);
                        if (null === e) throw new Error(Qi);
                        if (Xi && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                        else if (!(Array.isArray(e) || Xi && ArrayBuffer.isView(e))) throw new Error(Qi);
                    }
                    var s;
                    e.length > 64 && (e = null == (s = new ro(!0).update(e)) ? void 0 : s.array());
                    const i = [], o = [];
                    for(a = 0; a < 64; ++a){
                        const t = e[a] || 0;
                        i[a] = 92 ^ t, o[a] = 54 ^ t;
                    }
                    ro.call(this, t), this.update(o), this.oKeyPad = i, this.inner = !0, this.sharedMemory = t;
                }
                finalize() {
                    if (super.finalize(), this.inner) {
                        this.inner = !1;
                        const e = this.array();
                        ro.call(this, this.sharedMemory), this.update(this.oKeyPad), this.update(e), ro.prototype.finalize.call(this);
                    }
                }
            }
            const co = function() {
                const e = io("hex");
                e.create = function() {
                    return new ro;
                }, e.update = function(t) {
                    return e.create().update(t);
                };
                for(let t = 0; t < no.length; ++t){
                    const a = no[t];
                    e[a] = io(a);
                }
                return e;
            }(), uo = function() {
                const e = oo("hex");
                e.create = function(e) {
                    return new lo(e);
                }, e.update = function(t, a) {
                    return e.create(t).update(a);
                };
                for(let t = 0; t < no.length; ++t){
                    const a = no[t];
                    e[a] = oo(a);
                }
                return e;
            }();
            async function go(e) {
                const t = co.digest((new TextEncoder).encode(e));
                return btoa(String.fromCharCode(...new Uint8Array(t))).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
            }
            async function po(e) {
                const t = await crypto.subtle.digest("SHA-256", (new TextEncoder).encode(e));
                return btoa(String.fromCharCode(...new Uint8Array(t))).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
            }
            async function ho(e) {
                var t, a;
                return null != (t = window.crypto) && null != (a = t.subtle) && a.digest ? po(e) : (console.warn("Generating CodeChallenge in non-secure domain:", window.location.origin), go(e));
            }
            function yo(e = 16) {
                let t = "";
                for(let a = 0; a < e; a++)t += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(62 * Math.random()));
                return t;
            }
            var So = a(8792), vo = a.n(So), fo = a(5875);
            const mo = (e = "default")=>{
                if (!L.for(e).shouldLoadEntitlements()) throw new Error("You must first enable entitlements via Frontegg options to use this function");
            }, bo = (e, t, a, n, s = "default")=>(mo(s), (0, fo.Me)(t, e, a)), Ao = (e, t, a, n, s = "default")=>(mo(s), (0, fo.a_)(t, e, a)), wo = (e, t, a, n, s = "default")=>"permissionKey" in t ? bo(e, t.permissionKey, a, n, s) : Ao(e, t.featureKey, a, n, s);
            function To(e, t) {
                return vo()(e, t);
            }
            let Eo, Po;
            !function(e) {
                e.LOAD_SSO_CONFIGURATIONS = "LOAD_SSO_CONFIGURATIONS", e.SAVE_SSO_CONFIGURATION = "SAVE_SSO_CONFIGURATION", e.UPDATE_SSO_CONFIGURATION = "UPDATE_SSO_CONFIGURATION", e.SAVE_SSO_CONFIGURATION_BY_METADATA = "SAVE_SSO_CONFIGURATION_BY_METADATA", e.UPDATE_SSO_CONFIGURATION_BY_METADATA = "UPDATE_SSO_CONFIGURATION", e.DELETE_SSO_CONFIGURATION = "DELETE_SSO_CONFIGURATION", e.SAVE_SSO_DOMAIN = "SAVE_SSO_DOMAIN", e.DELETE_SSO_DOMAIN = "DELETE_SSO_DOMAIN", e.VALIDATE_SSO_DOMAIN = "VALIDATE_SSO_DOMAIN", e.UPDATE_SSO_DEFAULT_ROLES = "UPDATE_SSO_DEFAULT_ROLES", e.DELETE_SSO_GROUPS = "DELETE_SSO_GROUPS", e.SAVE_SSO_GROUPS = "SAVE_SSO_GROUPS", e.GET_SSO_AUTHORIZATION_ROLES = "GET_SSO_AUTHORIZATION_ROLES";
            }(Eo || (Eo = {})), function(e) {
                e.Saml = "saml", e.Okta = "okta", e.Azure = "azure", e.Google = "google", e.Oidc = "oidc";
            }(Po || (Po = {}));
            const Io = [
                "callback",
                "error"
            ], Oo = [
                "callback"
            ], ko = [
                "callback"
            ], _o = [
                "callback"
            ], Ro = [
                "callback"
            ], Uo = [
                "callback",
                "events"
            ], Lo = [
                "callback"
            ], Co = [
                "callback"
            ], Do = [
                "user"
            ], No = [
                "callback"
            ], Mo = [
                "callback"
            ], Fo = [
                "callback"
            ], xo = [
                "callback"
            ], $o = [
                "callback"
            ], Go = [
                "callback"
            ], jo = (e, t, a)=>{
                const n = a, s = L.for(e.root.appName), i = (t)=>{
                    var a;
                    const { routes: n, loginState: s } = e.auth, i = null != (a = localStorage.getItem("register-quick-login")) ? a : s.quickLoginToRegister;
                    return i && "true" !== localStorage.getItem(`${t.id}-${i}`) && !window.location.pathname.endsWith(n.logoutUrl);
                }, o = async ()=>{
                    e.auth.hostedLoginBox ? await (async ()=>{
                        const a = e.auth.user;
                        if (null == a || !a.refreshToken) return s.setAccessToken(null), s.setUser(null), void n.setAuthState({
                            user: null,
                            isAuthenticated: !1
                        });
                        try {
                            const e = {
                                grant_type: "refresh_token",
                                refresh_token: null == a ? void 0 : a.refreshToken
                            }, s = await t.auth.exchangeOAuthTokensV2(e), i = await r(s.user);
                            n.afterAuthenticationStateUpdate(v({}, s, {
                                user: i
                            }), {
                                isAuthenticated: !0
                            });
                        } catch (e) {
                            s.setAccessToken(null), s.setUser(null), n.setAuthState({
                                user: null,
                                isAuthenticated: !1
                            });
                        }
                    })() : await (async ()=>{
                        try {
                            const { routes: s, loginState: o, onRedirectTo: c } = e.auth, { user: u, tenants: d = [], activeTenant: g } = await t.auth.refreshTokenV3();
                            if (_s(u, e.root.appName)) {
                                const e = await n.getMfaRequiredState(u);
                                n.setAuthState(e), c(s.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            } else {
                                var a;
                                u.id && localStorage.setItem("userId", u.id);
                                const e = null != (a = localStorage.getItem("register-quick-login")) ? a : o.quickLoginToRegister, t = i(u), s = await r(u);
                                n.afterAuthenticationStateUpdate({
                                    user: s,
                                    tenants: d,
                                    activeTenant: g
                                }, {
                                    loginState: v({}, o, {
                                        quickLoginToRegister: e,
                                        flow: t ? kn.RegisterQuickLogin : kn.Login
                                    }),
                                    isAuthenticated: !0
                                }), await l({
                                    shouldNavigateToRegisterQuickLogin: t
                                });
                            }
                        } catch (e) {
                            s.setAccessToken(null), s.setUser(null), n.setAuthState({
                                user: void 0,
                                isAuthenticated: !1
                            });
                        }
                    })();
                }, r = async (t)=>{
                    var a;
                    const n = null == (a = e.auth.user) ? void 0 : a.entitlements;
                    return To(n, null == t ? void 0 : t.entitlements) ? v({}, t, {
                        entitlements: n
                    }) : t;
                }, l = async ({ shouldNavigateToRegisterQuickLogin: t, isSocialLoginRefreshToken: a = !1 })=>{
                    var s;
                    const i = new URL(null == (s = window) ? void 0 : s.location.href), { routes: o, loginState: r, onRedirectTo: l } = e.auth, [c] = it.getFeatureFlags([
                        "prevent-auth-redirect-on-social-login"
                    ], e.root.appName), u = i.searchParams.get("invitationToken"), d = [
                        o.socialLoginCallbackUrl,
                        o.oidcRedirectUrl,
                        o.samlCallbackUrl,
                        o.magicLinkCallbackUrl
                    ];
                    if (u || d.push(o.loginUrl, o.signUpUrl), t) l(o.loginUrl);
                    else if (d.some((e)=>e && window.location.pathname.endsWith(e))) {
                        if (r.isNewUser && o.signUpSuccessUrl && o.socialLoginCallbackUrl === window.location.pathname) l(o.signUpSuccessUrl, {
                            refresh: o.signUpSuccessUrl.startsWith("http")
                        });
                        else {
                            const e = o.socialLoginCallbackUrl && window.location.pathname.endsWith(o.socialLoginCallbackUrl);
                            if (!a && c && e) return;
                            await n.afterAuthNavigation();
                        }
                    }
                }, c = async (e)=>{
                    try {
                        var a;
                        const { isActive: s } = await xn(t.auth.getSSOPublicConfiguration, null == e ? void 0 : e.retryConfig);
                        n.setAuthState({
                            isSSOAuth: s
                        }), null == e || null == (a = e.callback) || a.call(e, {
                            isSSOAuth: s
                        });
                    } catch (t) {
                        var s;
                        n.setAuthState({
                            isSSOAuth: !1
                        }), null == e || null == (s = e.callback) || s.call(e, null, t);
                    }
                }, u = async (e)=>{
                    let a;
                    try {
                        var s;
                        const n = await xn(t.metadata.getSamlMetadata, null == e ? void 0 : e.retryConfig);
                        a = null == n || null == (s = n.configuration) ? void 0 : s.acsUrl;
                    } catch (e) {
                        console.error(e);
                    }
                    n.setAuthState({
                        ssoACS: a
                    });
                }, d = (t)=>{
                    Object.assign(e.auth.loginState, t);
                }, g = (e)=>$n({
                        callback: (t, a)=>{
                            !a || a.statusCode < 500 || n.setErrorByRequestName({
                                requestName: e,
                                traceId: Gn(a)
                            });
                        }
                    }), p = async (t)=>{
                    let { callback: a, error: s } = t, i = f(t, Io);
                    const o = e.auth.securityPolicyState.publicPolicy.policy;
                    if (null == o || !o.authStrategy) return n.setLoginState({
                        step: On.loginWithPassword,
                        loading: !1
                    }), void (null == a || a());
                    (null == o ? void 0 : o.authStrategy) === M.EmailAndPassword ? (n.setLoginState({
                        step: On.loginWithPassword,
                        loading: !1
                    }), null == a || a()) : [
                        M.MagicLink,
                        M.Code,
                        M.SmsCode
                    ].includes(null == o ? void 0 : o.authStrategy) ? await n.passwordlessPreLogin(v({}, i, {
                        type: null == o ? void 0 : o.authStrategy,
                        callback: a
                    })) : (n.setLoginState({
                        step: On.loginWithPassword,
                        loading: !1,
                        error: Kn(s)
                    }), null == a || a());
                }, h = async (e)=>{
                    const { user: t, tenants: a = [], activeTenant: s } = e, i = {
                        step: ls.recoveryCode,
                        loading: !1,
                        error: void 0,
                        saving: !1
                    };
                    null != t && t.recoveryCode && (i.recoveryCode = t.recoveryCode), n.setMfaState(i), n.setUser(t), n.setTenantsState({
                        tenants: a,
                        activeTenant: s,
                        loading: !1
                    }), t.id && localStorage.setItem("userId", t.id);
                };
                return v({
                    setLoginState: d,
                    resetLoginState: ()=>{
                        Wn(e, [
                            "auth",
                            "loginState"
                        ], Di);
                    },
                    requestAuthorize: async (e)=>{
                        const t = [], a = [];
                        t.push(o()), e && (n.setAuthState({
                            isLoading: !0
                        }), t.push(n.loadSocialLoginsConfigurationV2($n())), t.push(n.loadAllowSignUps(g(as.LOAD_ALLOW_SIGNUPS))), t.push(n.loadPublicAuthStrategiesPolicy(g(as.LOAD_PUBLIC_AUTH_STRATEGIES_POLICY))), t.push(n.loadSignUpStrategies()), t.push(c(g(as.LOAD_SSO_PUBLIC_CONFIGURATION))), t.push(n.loadVendorPublicInfo($n())), t.push(u($n())), a.push(n.loadCustomLoginRoutes(g(as.LOAD_CUSTOM_LOGIN_ROUTES)))), await Promise.all(t), a.length > 0 && await Promise.all(a), n.setAuthState({
                            isLoading: !1
                        });
                    },
                    requestAuthorizeSSR: async (t)=>{
                        const a = [];
                        a.push(n.loadSocialLoginsConfigurationV2($n())), a.push(n.loadAllowSignUps(g(as.LOAD_ALLOW_SIGNUPS))), a.push(c(g(as.LOAD_SSO_PUBLIC_CONFIGURATION))), a.push(n.loadSignUpStrategies()), a.push(n.loadVendorPublicInfo($n())), a.push(u()), a.push((async ({ accessToken: t, user: a })=>{
                            if (!t) return void n.setAuthState({
                                user: void 0,
                                isAuthenticated: !1
                            });
                            const { onRedirectTo: s, routes: i } = e.auth;
                            if (_s(a, e.root.appName)) {
                                const e = await n.getMfaRequiredState(a, Nn, !0);
                                n.setAuthState(e), s(i.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            }
                        })(t)), a.push(n.loadCustomLoginRoutes(g(as.LOAD_CUSTOM_LOGIN_ROUTES))), await Promise.all(a);
                    },
                    preLogin: async (a)=>{
                        const { email: n, username: s, recaptchaToken: i, invitationToken: o, callback: r } = a;
                        d({
                            loading: !0
                        });
                        try {
                            const a = e.auth.onRedirectTo, u = hs(ys), g = await t.auth.preLoginV2(v({}, n ? {
                                email: n
                            } : {}, s ? {
                                username: s
                            } : {}, {
                                tenantId: u
                            })), { address: h, idpType: y } = null != g ? g : {};
                            if (h) {
                                let t = h;
                                if (y === Po.Oidc && !t.includes("redirect_uri")) {
                                    const { oidcRedirectUrl: a } = e.auth.routes;
                                    t += `&redirect_uri=${window.location.origin}${a}`;
                                }
                                var l;
                                S.isLoginWithSSOAvailable() ? (S.loginWithSSO(null != (l = null != n ? n : s) ? l : ""), d({
                                    loading: !1
                                }), null == r || r()) : (d({
                                    step: On.redirectToSSO,
                                    loading: !1,
                                    ssoRedirectUrl: t
                                }), setTimeout(()=>{
                                    a(t, {
                                        refresh: !0
                                    });
                                }, 2e3));
                            } else {
                                var c;
                                await p({
                                    email: null != (c = null != n ? n : s) ? c : "",
                                    recaptchaToken: i,
                                    callback: r,
                                    invitationToken: o
                                });
                            }
                        } catch (e) {
                            var u;
                            await p({
                                email: null != (u = null != n ? n : s) ? u : "",
                                recaptchaToken: i,
                                callback: r,
                                invitationToken: o,
                                error: e
                            });
                        }
                    },
                    postLogin: async (a)=>{
                        const { onRedirectTo: s, routes: i } = e.auth;
                        d({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.postLogin(a);
                            n.setAuthState({
                                user: e.accessToken ? e : void 0,
                                isAuthenticated: !!e.accessToken
                            }), await n.afterAuthNavigation();
                        } catch (e) {
                            setTimeout(()=>{
                                s(i.authenticatedUrl);
                            }, 1e3), d({
                                step: On.loginWithSSOFailed,
                                loading: !1
                            });
                        }
                    },
                    login: async (a)=>{
                        const { email: i, username: o, password: r, recaptchaToken: l, invitationToken: c, callback: u } = a;
                        d({
                            loading: !0
                        });
                        try {
                            const { user: a, tenants: s = [], activeTenant: g } = await t.auth.loginv2(v({}, i ? {
                                email: i
                            } : {}, o ? {
                                username: o
                            } : {}, {
                                password: r,
                                recaptchaToken: l,
                                invitationToken: c
                            })), { onRedirectTo: p, routes: h } = e.auth;
                            if (_s(a, e.root.appName)) {
                                const e = await n.getMfaRequiredState(a, Nn, !0, i);
                                n.setAuthState(e), p(h.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            } else {
                                const [t] = await n.getFeatureFlags([
                                    "security-center-show-login-flows"
                                ]);
                                if (Rs(a, e.root.appName)) d({
                                    step: On.passwordRotationExpired,
                                    loading: !1,
                                    resetPasswordToken: a.resetPasswordToken,
                                    userId: a.userId
                                });
                                else {
                                    const o = e.auth.loginState, r = !!a.accessToken;
                                    a.id && localStorage.setItem("userId", a.id), n.afterAuthenticationStateUpdate({
                                        user: a,
                                        tenants: s,
                                        activeTenant: g
                                    }, {
                                        loginState: {
                                            flow: o.flow,
                                            quickLoginToRegister: o.quickLoginToRegister,
                                            email: i,
                                            loading: !1,
                                            error: void 0,
                                            mfaToken: a.mfaToken,
                                            step: o.flow === kn.Login ? On.success : o.step,
                                            tenants: s,
                                            tenantsLoading: !0,
                                            isBreachedPassword: a.isBreachedPassword
                                        },
                                        isAuthenticated: r
                                    }), o.flow === kn.Login && (t && a.isBreachedPassword && !r ? d({
                                        step: On.breachedPassword,
                                        loading: !1
                                    }) : r && (Ts(a) ? d({
                                        step: On.passwordRotationNotification,
                                        loading: !1
                                    }) : await n.__shouldShowPromptPasskeys() ? (d({
                                        step: On.promptPasskeys,
                                        loading: !1
                                    }), p(h.loginUrl, {
                                        preserveQueryParams: !0
                                    })) : await n.afterAuthNavigation()));
                                }
                            }
                            S.isSuggestSavePasswordAvailable() && S.suggestSavePassword(i, r), localStorage.removeItem("register-quick-login"), null == u || u(!0);
                        } catch (e) {
                            s.setAccessToken(null), s.setUser(null), null == u || u(!1, e), d({
                                email: i,
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    logout: async (a)=>{
                        const i = e.auth.hostedLoginBox;
                        n.setAuthState({
                            isLoading: !0
                        });
                        try {
                            i ? await t.auth.OAuthLogout() : await t.auth.logout();
                        } catch  {}
                        s.isSessionPerTenantEnabled() && pt(), n.resetAuthState(), await n.requestAuthorize(!0), null == a || a();
                    },
                    silentLogout: async (e)=>{
                        var a;
                        try {
                            await t.auth.logout();
                        } catch  {}
                        s.isSessionPerTenantEnabled() && pt(), setTimeout(()=>{
                            var t;
                            return null == e || null == (t = e.callback) ? void 0 : t.call(e, !0);
                        }, null != (a = null == e ? void 0 : e.callbackTimeout) ? a : 500);
                    },
                    recoverMfa: async (e)=>{
                        d({
                            loading: !0
                        });
                        try {
                            var a;
                            await t.auth.recoverMfaToken(e), d({
                                loading: !1,
                                error: void 0,
                                step: On.preLogin
                            }), n.setAuthState({
                                user: void 0,
                                isAuthenticated: !1
                            }), null == (a = e.callback) || a.call(e, !0);
                        } catch (t) {
                            var s;
                            d({
                                error: Kn(t),
                                loading: !1
                            }), null == (s = e.callback) || s.call(e, !1, t);
                        }
                    },
                    quickSmsPasswordlessPreLogin: async (e)=>{
                        const { callback: a } = e, n = f(e, Oo);
                        try {
                            d({
                                loading: !0
                            });
                            const e = await t.auth.passwordlessPreLogin(v({}, n, {
                                type: M.SmsCode
                            }));
                            d({
                                step: On.loginWithQuickSmsOtc,
                                loading: !1,
                                phoneNumber: null == e ? void 0 : e.phoneNumber,
                                error: void 0
                            }), null == a || a(!0);
                        } catch (e) {
                            d({
                                error: Kn(e),
                                loading: !1
                            }), null == a || a(!1, e);
                        }
                    },
                    changePhoneNumberWithVerification: async (e)=>{
                        const { callback: a } = e, n = f(e, ko);
                        try {
                            d({
                                loading: !0
                            });
                            const e = await t.auth.changePhoneNumberWithVerification(n);
                            d({
                                phoneNumber: n.phoneNumber,
                                loading: !1,
                                changePhoneId: e.changePhoneId,
                                step: On.loginWithQuickSmsOtc,
                                error: void 0
                            }), null == a || a(!0);
                        } catch (e) {
                            d({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    verifyChangePhoneNumber: async (e)=>{
                        const { callback: a } = e, n = f(e, _o);
                        try {
                            d({
                                loading: !0
                            }), await t.auth.verifyChangePhoneNumber(n), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (e) {
                            d({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    passwordlessPreLogin: async (e)=>{
                        const { callback: a } = e, n = f(e, Ro);
                        try {
                            var s;
                            let e, i;
                            d({
                                loading: !0
                            }), bs(n) && (e = n.email), As(n) && (i = n.username);
                            const o = await t.auth.passwordlessPreLogin(v({}, n, {
                                email: e,
                                username: null != (s = i) ? s : ""
                            })), r = Un[n.type];
                            d({
                                step: r,
                                loading: !1,
                                phoneNumber: null == o ? void 0 : o.phoneNumber,
                                email: e,
                                error: void 0
                            }), null == a || a();
                        } catch (e) {
                            d({
                                error: Kn(e),
                                loading: !1
                            }), null == a || a(null, e);
                        }
                    },
                    passwordlessPostLogin: async (a)=>{
                        const { callback: s, events: i } = a, o = f(a, Uo);
                        try {
                            d({
                                loading: !0
                            });
                            const { user: l, tenants: c = [], activeTenant: u } = await t.auth.passwordlessPostLoginV2(o), { routes: g, onRedirectTo: p } = e.auth;
                            if (_s(l, e.root.appName)) {
                                const e = await n.getMfaRequiredState(l);
                                n.setAuthState(e), p(g.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            } else {
                                const t = e.auth.loginState;
                                if (l.emailVerified) {
                                    var r;
                                    const e = {
                                        email: l.email,
                                        origin: ns.PASSWORDLESS,
                                        id: l.id,
                                        tenantId: l.tenantId,
                                        createdAt: new Date,
                                        name: l.name
                                    };
                                    null == i || null == (r = i.userVerified) || r.call(i, e), cs(rs.USER_VERIFIED, e);
                                }
                                l.id && localStorage.setItem("userId", l.id), n.afterAuthenticationStateUpdate({
                                    user: l,
                                    tenants: c,
                                    activeTenant: u
                                }), d({
                                    error: void 0
                                }), n.setAuthState({
                                    isLoading: !1
                                }), t.flow === kn.Login ? await n.__shouldShowPromptPasskeys() ? (n.setLoginState({
                                    step: On.promptPasskeys,
                                    loading: !1
                                }), p(g.loginUrl, {
                                    preserveQueryParams: !0
                                })) : (n.setAuthState({
                                    isAuthenticated: !0
                                }), a.type === M.MagicLink && (n.setLoginState({
                                    step: On.magicLinkPostLoginSuccess,
                                    loading: !1
                                }), await Mn(5e3)), await n.afterAuthNavigation()) : p(g.loginUrl, {
                                    preserveQueryParams: !0
                                }), localStorage.removeItem("register-quick-login"), null == s || s(!0);
                            }
                        } catch (e) {
                            d({
                                error: Kn(e, "Failed to authenticate")
                            }), null == s || s(null, e);
                        } finally{
                            d({
                                loading: !1
                            });
                        }
                    },
                    verifyInviteToken: async (e)=>{
                        try {
                            d({
                                loading: !0
                            });
                            const { name: a } = await t.auth.verifyInviteToken(e);
                            d({
                                inviteTokenTenantName: a
                            });
                        } catch (e) {
                            d({
                                inviteTokenError: Kn(e, "We couldn't verify your invitation")
                            });
                        } finally{
                            d({
                                loading: !1
                            });
                        }
                    },
                    webAuthnPrelogin: async (e)=>{
                        const { callback: a } = e, s = f(e, Lo);
                        try {
                            var i;
                            n.setPasskeysState({
                                loading: !0
                            }), d({
                                loading: !0
                            });
                            const { options: e } = await t.auth.webAuthnPreLogin(s);
                            e.challenge = zi(e.challenge), e.allowCredentials = null == (i = e.allowCredentials) ? void 0 : i.map((e)=>v({}, e, {
                                    id: zi(e.id)
                                })), d({
                                error: void 0
                            }), null == a || a(e);
                        } catch (e) {
                            d({
                                error: Kn(e)
                            }), null == a || a(null);
                        } finally{
                            n.setPasskeysState({
                                loading: !1
                            }), d({
                                loading: !1
                            });
                        }
                    },
                    webAuthnPostLogin: async (a)=>{
                        const { callback: s } = a, i = f(a, Co);
                        try {
                            var o;
                            n.setPasskeysState({
                                loading: !0
                            }), d({
                                loading: !0
                            });
                            const a = Ki(i.publicKey), r = await t.auth.webAuthnPostLoginV2(v({}, a, {
                                response: v({}, a.response, {
                                    userHandle: null != (o = a.response.userHandle) ? o : void 0
                                }),
                                recaptchaToken: i.recaptchaToken,
                                invitationToken: i.invitationToken
                            })), { user: l } = r, c = f(r, Do);
                            if (_s(l, e.root.appName)) {
                                const { routes: t, onRedirectTo: a } = e.auth, s = await n.getMfaRequiredState(l);
                                n.setAuthState(s), a(t.loginUrl, {
                                    preserveQueryParams: !0
                                });
                            } else l.id && localStorage.setItem("userId", l.id), n.afterAuthenticationStateUpdate(v({
                                user: l
                            }, c), {
                                isAuthenticated: !0
                            }), d({
                                error: void 0
                            }), await n.afterAuthNavigation(), null == s || s(!0);
                        } catch (e) {
                            d({
                                error: Kn(e)
                            }), null == s || s(null);
                        } finally{
                            n.setPasskeysState({
                                loading: !1
                            }), d({
                                loading: !1
                            });
                        }
                    },
                    webAuthnCreateNewDeviceSession: async (e)=>{
                        const { callback: a } = e;
                        try {
                            d({
                                loading: !0
                            });
                            const { options: e } = await t.auth.webAuthnCreateNewDeviceSession();
                            e.user.id = zi(e.user.id), e.challenge = zi(e.challenge), e.excludeCredentials = [], null == a || a(e);
                        } catch (e) {
                            d({
                                error: Kn(e)
                            }), null == a || a(null);
                        } finally{
                            d({
                                loading: !1
                            });
                        }
                    },
                    webAuthnVerifyNewDeviceSession: async (e)=>{
                        const { callback: a } = e, n = f(e, No);
                        try {
                            d({
                                loading: !0
                            });
                            const e = Ki(n.publicKey), s = "platform" === (null == e ? void 0 : e.authenticatorAttachment) ? et.Platform : et.CrossPlatform;
                            await t.auth.verifyNewDeviceSession({
                                id: e.id,
                                response: e.response,
                                deviceType: s
                            }), null == a || a(!0);
                        } catch (e) {
                            d({
                                error: Kn(e)
                            }), null == a || a(null);
                        } finally{
                            d({
                                loading: !1
                            });
                        }
                    },
                    getUserIP: async (e)=>{
                        const { callback: a } = e;
                        try {
                            n.setAuthState({
                                userIpData: {
                                    loading: !0
                                }
                            });
                            const { ip: e, country_code: s } = await t.metadata.getCurrentUserIpMetadata();
                            n.setAuthState({
                                userIpData: {
                                    ip: e,
                                    countryCode: s,
                                    loading: !1
                                }
                            }), n.setAuthState({
                                userIp: e
                            }), null == a || a({
                                ip: e,
                                countryCode: s
                            });
                        } catch (e) {
                            n.setAuthState({
                                userIpData: {
                                    loading: !1
                                }
                            }), null == a || a(!1);
                        }
                    },
                    preEnrollMFAWebAuthnForLogin: async (e)=>{
                        const { callback: a } = e, n = f(e, Mo);
                        d({
                            loading: !0
                        });
                        try {
                            var s;
                            const e = await t.auth.preEnrollMFAWebAuthnForLogin(n), i = v({}, e.options, {
                                challenge: zi(e.options.challenge),
                                user: v({}, e.options.user, {
                                    id: zi(e.options.user.id)
                                }),
                                excludeCredentials: null == (s = e.options.excludeCredentials) ? void 0 : s.map((e)=>v({}, e, {
                                        id: zi(e.id)
                                    }))
                            });
                            d({
                                loading: !1
                            }), null == a || a({
                                options: i,
                                webauthnToken: e.webauthnToken
                            });
                        } catch (e) {
                            d({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null);
                        }
                    },
                    enrollMFAWebAuthnForLogin: async (e)=>{
                        const { callback: a } = e, n = f(e, Fo);
                        d({
                            loading: !0
                        });
                        try {
                            const e = Ki(n.publicKey), s = await t.auth.enrollMFAWebAuthnForLoginV2(v({}, n, {
                                options: e
                            }));
                            await h(s), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (e) {
                            d({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null);
                        }
                    },
                    enrollMFAAuthenticatorAppForLogin: async (e)=>{
                        const { callback: a } = e, n = f(e, xo);
                        d({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.enrollMFAAuthenticatorAppForLoginV2(n);
                            await h(e), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (e) {
                            d({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null);
                        }
                    },
                    preEnrollMFASMSForLogin: async (e)=>{
                        const { callback: a } = e, s = f(e, $o);
                        d({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.preEnrollMFASMSForLogin(s);
                            n.setMfaState({
                                otcToken: e.otcToken,
                                step: ls.smsVerifyCode,
                                phoneNumber: e.phoneNumber
                            }), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (e) {
                            d({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null);
                        }
                    },
                    enrollMFASMSForLogin: async (e)=>{
                        const { callback: a } = e, n = f(e, Go);
                        d({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.enrollMFASMSForLoginV2(n);
                            await h(e), d({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (e) {
                            d({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null);
                        }
                    },
                    handleEnrollMFAResponse: h,
                    resetBreachedPassword: async (e)=>{
                        d({
                            loading: !0
                        });
                        try {
                            await t.auth.forgotPassword(e), d({
                                loading: !1,
                                error: void 0,
                                step: On.breachedPasswordSuccess
                            }), n.setAuthState({
                                isAuthenticated: !1
                            });
                        } catch (e) {
                            d({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    refreshTokenForSocialLogins: async ()=>{
                        e.auth.hostedLoginBox ? await (async ()=>{
                            const { user: a } = e.auth;
                            if (null == a || !a.refreshToken) return s.setAccessToken(null), s.setUser(null), void n.setAuthState({
                                user: null,
                                isAuthenticated: !1
                            });
                            try {
                                const e = {
                                    grant_type: "refresh_token",
                                    refresh_token: null == a ? void 0 : a.refreshToken
                                }, s = await t.auth.exchangeOAuthTokensV2(e), i = await r(s.user);
                                n.afterAuthenticationStateUpdate(v({}, s, {
                                    user: i
                                }), {
                                    isAuthenticated: !0
                                });
                            } catch (e) {
                                s.setAccessToken(null), s.setUser(null), n.setAuthState({
                                    user: null,
                                    isAuthenticated: !1
                                });
                            }
                        })() : await (async ()=>{
                            try {
                                const { routes: s, loginState: o, onRedirectTo: c } = e.auth, { user: u, tenants: d = [], activeTenant: g } = await t.auth.refreshTokenV3();
                                if (_s(u, e.root.appName)) {
                                    const e = await n.getMfaRequiredState(u);
                                    n.setAuthState(e), c(s.loginUrl, {
                                        preserveQueryParams: !0
                                    });
                                } else {
                                    const e = await r(u);
                                    if (await n.__shouldShowPromptPasskeys()) n.setLoginState({
                                        step: On.promptPasskeys,
                                        loading: !1
                                    }), n.afterAuthenticationStateUpdate({
                                        user: e,
                                        tenants: d,
                                        activeTenant: g
                                    }, {
                                        isLoading: !1
                                    }), c(s.loginUrl, {
                                        preserveQueryParams: !0
                                    });
                                    else {
                                        var a;
                                        u.id && localStorage.setItem("userId", u.id);
                                        const t = null != (a = localStorage.getItem("register-quick-login")) ? a : o.quickLoginToRegister, s = i(u);
                                        n.afterAuthenticationStateUpdate({
                                            user: e,
                                            tenants: d,
                                            activeTenant: g
                                        }, {
                                            loginState: v({}, o, {
                                                quickLoginToRegister: t,
                                                flow: s ? kn.RegisterQuickLogin : kn.Login
                                            }),
                                            isAuthenticated: !0
                                        }), await l({
                                            shouldNavigateToRegisterQuickLogin: s,
                                            isSocialLoginRefreshToken: !0
                                        });
                                    }
                                }
                            } catch (e) {
                                s.setAccessToken(null), s.setUser(null), n.setAuthState({
                                    user: void 0,
                                    isAuthenticated: !1
                                });
                            }
                        })();
                    },
                    __refreshToken: o
                }, ((e, t, a)=>{
                    const n = a, s = async ()=>{
                        const e = await t.auth.silentOAuthRefreshTokenV2();
                        if (null == e || !e.user) throw new Error("couldn't refresh user token with oauth service");
                        await n.afterAuthenticationStateUpdate(e, {
                            isAuthenticated: !0,
                            isLoading: !1
                        });
                    }, i = async (a)=>{
                        var s;
                        const { routes: i, onRedirectTo: o } = e.auth, { context: r, urlStrategy: l } = e.root;
                        if (Ls(l) === i.hostedLoginRedirectUrl) return void console.debug("Calling loginWithRedirect while in hostedLoginCallback route");
                        n.setAuthState({
                            isLoading: !0
                        });
                        const c = yo(), u = yo(), d = await ho(u);
                        localStorage.setItem(Dn, u);
                        const g = ws(e);
                        let p = `${window.location.origin}${"path" === l ? "" : "#"}${null != g ? g : ""}${i.hostedLoginRedirectUrl}`;
                        await n.loadCustomLoginRoutes();
                        const h = null == (s = e.auth.customLoginState) ? void 0 : s.customLoginSearchParams;
                        h && (p.endsWith("/") && (p = p.slice(0, -1)), p += h);
                        const y = `${t.fetch.getBaseUrl(r, "/oauth/authorize")}/oauth/authorize`, S = v({
                            response_type: "code",
                            client_id: r.appId || r.clientId || "INVALID-CLIENT-ID",
                            scope: "openid email profile",
                            redirect_uri: p,
                            code_challenge: d,
                            code_challenge_method: "S256",
                            nonce: c
                        }, a);
                        if (r.tenantResolver) {
                            var f;
                            const e = await (null == (f = r.tenantResolver) ? void 0 : f.call(r));
                            null != e && e.tenant && (S.organization = e.tenant);
                        }
                        const m = hs(ys);
                        m && (S.tenantId = m), o(`${y}?${new URLSearchParams(S).toString()}`, {
                            refresh: !0
                        });
                    };
                    return {
                        requestHostedLoginAuthorize: async (t)=>{
                            var a;
                            null == (a = localStorage) || a.removeItem(Pn);
                            const n = e.auth.disableSilentRefresh;
                            if ("login" === (null == t ? void 0 : t.prompt)) return await i(t);
                            try {
                                if (n) throw new Error("silent refresh is disabled");
                                return await s();
                            } catch (e) {
                                return await i(t);
                            }
                        },
                        requestHostedLoginAuthorizeV2: async (t)=>{
                            var a, o;
                            const { shouldRedirectToLogin: r, firstTime: l, loginDirectAction: c } = null != t ? t : {};
                            let { additionalParams: u } = null != t ? t : {};
                            if (null == (a = localStorage) || a.removeItem(Pn), l) {
                                const t = e.root.urlStrategy, a = Ls(t);
                                if (n.setAuthState({
                                    isLoading: !0
                                }), ms(a)) return;
                            }
                            const d = e.auth.disableSilentRefresh;
                            if (c && (u = u || {}, u.login_direct_action = btoa(JSON.stringify(c))), "login" === (null == (o = u) ? void 0 : o.prompt)) return await i(u);
                            try {
                                if (d) throw new Error("silent refresh is disabled");
                                return await s();
                            } catch (e) {
                                return r ? await i(u) : void n.setAuthState({
                                    isLoading: !1
                                });
                            }
                        },
                        __requestHostedLoginAuthorize: i,
                        __requestHostedLoginSilentAuthorize: s,
                        handleHostedLoginCallback: async (a)=>{
                            var s;
                            const i = localStorage.getItem(Dn) || "INVALID-CODE-VERIFIER", o = e.auth.routes, r = e.root.urlStrategy, l = ws(e);
                            let c = `${window.location.origin}${"path" === r ? "" : "#"}${null != l ? l : ""}${o.hostedLoginRedirectUrl}`;
                            await n.loadCustomLoginRoutes();
                            const u = null == (s = e.auth.customLoginState) ? void 0 : s.customLoginSearchParams;
                            u && (c.endsWith("/") && (c = c.slice(0, -1)), c += u);
                            const d = {
                                code: a.code,
                                redirect_uri: c,
                                code_verifier: i,
                                grant_type: "authorization_code"
                            };
                            try {
                                const e = await t.auth.exchangeOAuthTokensV2(d);
                                n.afterAuthenticationStateUpdate(e, {
                                    isAuthenticated: !0,
                                    isLoading: !1
                                });
                            } catch (e) {
                                n.setAuthState({
                                    isLoading: !1
                                }), console.error("Failed to exchangeOAuthTokens", e);
                            } finally{
                                const t = e.auth.user, a = window.localStorage.getItem(Pn);
                                window.localStorage.removeItem(Pn), a && Es(t) ? await n.afterStepUpAuthNavigation() : await n.afterAuthNavigation();
                            }
                        }
                    };
                })(e, t, a), Mi(e, 0, a), function(e, t, a) {
                    const n = a, s = async ()=>await n.afterStepUpAuthNavigation(), i = async (t, a)=>{
                        const s = e.auth.loginState, i = e.auth.mfaState.step, [o] = await n.getFeatureFlags([
                            "security-center-show-login-flows"
                        ]);
                        if (s.flow === kn.Login) {
                            if (o && s.isBreachedPassword && !t) return void n.setLoginState({
                                step: On.breachedPassword,
                                loading: !1
                            });
                            if (Rs(a, e.root.appName)) return void n.setLoginState({
                                step: On.passwordRotationExpired,
                                loading: !1,
                                resetPasswordToken: a.resetPasswordToken,
                                userId: a.userId
                            });
                            if (Ts(a)) return void n.setLoginState({
                                step: On.passwordRotationNotification,
                                loading: !1
                            });
                            const r = await n.__shouldShowPromptPasskeys();
                            i === ls.smsVerifyCode && r ? n.setLoginState({
                                step: On.promptPasskeys,
                                loading: !1
                            }) : await n.afterAuthNavigation();
                        }
                    };
                    return {
                        postHandleVerifyMFAResponseForStepUp: s,
                        postHandleVerifyMFAResponseForLogin: i,
                        handleVerifyMFAResponse: async (e, t = !1)=>{
                            const { user: a, tenants: o, activeTenant: r } = e;
                            n.setUser(a), n.setTenantsState({
                                tenants: o,
                                activeTenant: r,
                                loading: !1
                            }), a.id && localStorage.setItem("userId", a.id);
                            const l = !!a.accessToken;
                            return n.setAuthState({
                                isAuthenticated: l
                            }), t ? await s() : await i(l, a);
                        },
                        getFeatureFlags: async (t)=>{
                            const a = e.root.appName;
                            return it.getFeatureFlags(t, a);
                        }
                    };
                }(e, 0, a), ((e, t)=>({
                        getMfaRequiredState: async (a, n, s = !1, i)=>{
                            var o, r, l;
                            let c = On.loginWithTwoFactor;
                            const u = {
                                step: ls.verify,
                                loading: !1,
                                saving: !1
                            }, d = e.auth.loginState;
                            let g, p;
                            try {
                                const e = await xn(()=>t.auth.checkIfAllowToRememberMfaDevice(a.mfaToken), n);
                                g = e.isAllowedToRemember, p = e.mfaDeviceExpiration;
                            } catch (e) {
                                if (!s) throw e;
                            }
                            !("mfaEnrolled" in a) || a.mfaEnrolled || (null == (o = a.mfaDevices) || null == (r = o.emails) ? void 0 : r.length) ? Object.assign(u, {
                                mfaDevices: a.mfaDevices,
                                mfaToken: a.mfaToken,
                                step: vs(a.mfaDevices)
                            }) : (Object.assign(u, {
                                step: fs(a.mfaStrategies),
                                qrCode: a.qrCode,
                                recoveryCode: a.recoveryCode,
                                loading: !1,
                                mfaToken: a.mfaToken,
                                mfaStrategies: a.mfaStrategies
                            }), c = On.forceTwoFactor);
                            let h = {};
                            const y = localStorage.getItem("register-quick-login");
                            return y && (h = {
                                quickLoginToRegister: y,
                                flow: kn.RegisterQuickLogin
                            }), {
                                user: void 0,
                                isAuthenticated: !1,
                                mfaState: u,
                                loginState: v({}, d, h, {
                                    mfaToken: a.mfaToken,
                                    mfaRequired: a.mfaRequired,
                                    loading: !1,
                                    error: void 0,
                                    step: c,
                                    tenantsLoading: !0,
                                    email: null != (l = a.userEmail) ? l : i,
                                    tenants: [],
                                    allowRememberMfaDevice: g,
                                    mfaDeviceExpiration: p,
                                    isBreachedPassword: a.isBreachedPassword
                                })
                            };
                        }
                    }))(e, t), ((e, t, a)=>{
                    const n = a, s = async (a, s, i)=>{
                        let { callback: o } = a, r = f(a, Fi);
                        s({
                            loading: !0,
                            error: void 0
                        });
                        try {
                            const { user: a, tenants: l = [], activeTenant: c } = await t.auth.loginWithMfaV2(r), u = !!a.accessToken, d = await async function(t, a, n) {
                                const s = e.auth.loginState;
                                let i = {};
                                if (!n) {
                                    const e = s.flow === kn.Login ? On.success : s.step;
                                    i = {
                                        loginState: {
                                            flow: s.flow,
                                            quickLoginToRegister: s.quickLoginToRegister,
                                            loading: !1,
                                            step: e,
                                            error: void 0,
                                            tenants: t
                                        }
                                    };
                                }
                                return v({}, i, {
                                    isAuthenticated: a
                                });
                            }(l, u, i);
                            return await n.afterAuthenticationStateUpdate({
                                user: a,
                                tenants: l,
                                activeTenant: c
                            }, d), a.id && localStorage.setItem("userId", a.id), s({
                                loading: !1,
                                error: void 0
                            }), i ? await async function(e) {
                                await n.afterStepUpAuthNavigation(), null == e || e(!0);
                            }(o) : await async function(t, a, s) {
                                const i = e.auth.loginState;
                                if (i.flow !== kn.Login) return;
                                const [o] = await n.getFeatureFlags([
                                    "security-center-show-login-flows"
                                ]);
                                return o && i.isBreachedPassword && !t ? (n.setLoginState({
                                    step: On.breachedPassword,
                                    loading: !1
                                }), void (null == s || s(!0))) : Rs(a, e.root.appName) ? (n.setLoginState({
                                    step: On.passwordRotationExpired,
                                    loading: !1,
                                    resetPasswordToken: a.resetPasswordToken,
                                    userId: a.userId
                                }), void (null == s || s(!0))) : Ts(a) ? (n.setLoginState({
                                    step: On.passwordRotationNotification,
                                    loading: !1
                                }), void (null == s || s(!0))) : (await n.__shouldShowPromptPasskeys() ? n.setLoginState({
                                    step: On.promptPasskeys,
                                    loading: !1
                                }) : await n.afterAuthNavigation(), void (null == s || s(!0)));
                            }(u, a, o);
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            }), null == o || o(!1, e);
                        }
                    };
                    return {
                        mfaWithAuthenticator: s,
                        loginWithMfa: async (e)=>await s(e, n.setLoginState, !1)
                    };
                })(e, t, a), ((e, t, a)=>{
                    const n = a, s = async (e, a)=>{
                        var s;
                        let { callback: i } = e, o = f(e, xi);
                        (a = null != (s = a) ? s : n.setLoginState)({
                            loading: !0,
                            error: void 0
                        });
                        try {
                            const e = await t.auth.preVerifyMFAEmailCode(o);
                            n.setMfaState({
                                otcToken: e.otcToken,
                                step: ls.emailVerifyCode
                            }), a({
                                loading: !1,
                                error: void 0
                            }), null == i || i(!0);
                        } catch (e) {
                            a({
                                error: Kn(e)
                            }), null == i || i(null);
                        }
                    }, i = async (e, a)=>{
                        var s;
                        let { callback: i } = e, o = f(e, $i);
                        (a = null != (s = a) ? s : n.setLoginState)({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.verifyMFAEmailCodeV2(o);
                            await n.handleVerifyMFAResponse(e), a({
                                loading: !1,
                                error: void 0
                            }), null == i || i(!0);
                        } catch (e) {
                            a({
                                loading: !1,
                                error: Kn(e)
                            }), null == i || i(null);
                        }
                    };
                    return {
                        preVerifyMFAEmailCode: s,
                        verifyMFAEmailCode: i,
                        preVerifyMFAEmailCodeForLogin: async (e)=>await s(e, n.setLoginState),
                        verifyMFAEmailCodeForLogin: async (e)=>await i(e, n.setLoginState)
                    };
                })(0, t, a), ((e, t, a)=>{
                    const n = a, s = async (e, a)=>{
                        let { callback: s, deviceId: i } = e, o = f(e, Gi);
                        a({
                            loading: !1,
                            error: void 0
                        });
                        try {
                            const e = await t.auth.preVerifyMFASMSForLogin(i, o);
                            n.setMfaState({
                                otcToken: e.otcToken,
                                step: ls.smsVerifyCode,
                                phoneNumber: e.phoneNumber
                            }), a({
                                loading: !1,
                                error: void 0
                            }), null == s || s(!0);
                        } catch (e) {
                            a({
                                loading: !1,
                                error: Kn(e)
                            }), null == s || s(null);
                        }
                    }, i = async (e, a, s = !1)=>{
                        let { callback: i, deviceId: o } = e, r = f(e, ji);
                        a({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.verifyMFASMSForLoginV2(o, r);
                            await n.handleVerifyMFAResponse(e, s), a({
                                loading: !1,
                                error: void 0
                            }), null == i || i(!0);
                        } catch (e) {
                            a({
                                loading: !1,
                                error: Kn(e)
                            }), null == i || i(null);
                        }
                    };
                    return {
                        preVerifyMFASMS: s,
                        verifyMFASMS: i,
                        preVerifyMFASMSForLogin: async (e)=>await s(e, n.setLoginState),
                        verifyMFASMSForLogin: async (e)=>await i(e, n.setLoginState, !1)
                    };
                })(0, t, a), ((e, t, a)=>{
                    const n = a, s = async (e, a)=>{
                        let { callback: n, deviceId: s } = e, i = f(e, Yi);
                        a({
                            loading: !0
                        });
                        try {
                            var o;
                            const e = await t.auth.preVerifyMFAWebAuthnForLogin(s, i), r = v({}, e.options, {
                                challenge: zi(e.options.challenge),
                                allowCredentials: null == (o = e.options.allowCredentials) ? void 0 : o.map((e)=>v({}, e, {
                                        id: zi(e.id)
                                    }))
                            });
                            a({
                                loading: !1,
                                error: void 0
                            }), null == n || n({
                                options: r,
                                webauthnToken: e.webauthnToken
                            });
                        } catch (e) {
                            a({
                                loading: !1,
                                error: Kn(e)
                            }), null == n || n(null);
                        }
                    }, i = async (e, a, s)=>{
                        let { callback: i, deviceId: o } = e, r = f(e, Ji);
                        a({
                            loading: !0
                        });
                        try {
                            const e = Ki(r.publicKey), l = await t.auth.verifyMFAWebAuthnForLoginV2(o, v({}, r, {
                                options: e
                            }));
                            await n.handleVerifyMFAResponse(l, s), a({
                                loading: !1,
                                error: void 0
                            }), null == i || i(!0);
                        } catch (e) {
                            a({
                                loading: !1,
                                error: Kn(e)
                            }), null == i || i(null);
                        }
                    };
                    return {
                        preVerifyMFAWebAuthn: s,
                        verifyMFAWebAuthn: i,
                        preVerifyMFAWebAuthnForLogin: async (e)=>await s(e, n.setLoginState),
                        verifyMFAWebAuthnForLogin: async (e)=>await i(e, n.setLoginState, !1)
                    };
                })(0, t, a));
            }, Vo = {
                step: ls.verify,
                loading: !1,
                saving: !1
            }, Bo = (e)=>hn(Vo, e), Wo = [
                "callback"
            ], zo = [
                "callback"
            ], Ho = [
                "user"
            ], Ko = [
                "deviceId"
            ], qo = [
                "deviceId"
            ], Yo = [
                "callback"
            ], Jo = [
                "callback"
            ], Qo = [
                "deviceId",
                "callback"
            ], Xo = (e, t, a)=>{
                const n = a;
                async function s(t) {
                    const a = e.auth.mfaState.step;
                    return {
                        step: t.recoveryCode ? ls.recoveryCode : a,
                        loading: !1,
                        saving: !1,
                        error: void 0,
                        recoveryCode: null == t ? void 0 : t.recoveryCode
                    };
                }
                const i = (t)=>{
                    Object.assign(e.auth.mfaState, t);
                };
                return {
                    setMfaState: i,
                    resetMfaState: ()=>{
                        Wn(e, [
                            "auth",
                            "mfaState"
                        ], Vo);
                    },
                    getMFADevices: async ()=>{
                        i({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.getMFADevices();
                            i({
                                loading: !1,
                                error: void 0,
                                mfaDevices: e
                            });
                        } catch (e) {
                            i({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    getMFAStrategies: async (e)=>{
                        i({
                            loading: !0
                        });
                        try {
                            const a = (await xn(()=>t.auth.getMFAStrategiesConfig(), null == e ? void 0 : e.retryConfig)).strategies.filter(({ isActive: e })=>e).map(({ strategy: e })=>e);
                            i({
                                loading: !1,
                                error: void 0,
                                mfaStrategies: a
                            });
                        } catch (e) {
                            i({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    enrollMfa: async ()=>{
                        i({
                            saving: !0
                        });
                        try {
                            const { qrCode: e } = await t.auth.enrollMfa();
                            i({
                                saving: !1,
                                error: void 0,
                                qrCode: e
                            });
                        } catch (e) {
                            i({
                                saving: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    verifyMfa: async (a)=>{
                        const { callback: o } = a, r = f(a, Wo);
                        i({
                            saving: !0
                        });
                        try {
                            const a = e.auth.user, l = await t.auth.verifyMfa(r), c = await t.auth.getMFADevices(), u = await s(l);
                            i(v({}, u, {
                                mfaDevices: c
                            })), n.setUser(v({}, a, {
                                mfaEnrolled: !0
                            })), null == o || o(u.recoveryCode);
                        } catch (e) {
                            i({
                                saving: !1,
                                error: Kn(e)
                            }), null == o || o(null, e);
                        }
                    },
                    verifyMfaAfterForce: async (e)=>{
                        const { callback: a } = e, s = f(e, zo);
                        i({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.loginWithMfaV2(s), { user: o } = e, r = f(e, Ho), l = {
                                step: ls.recoveryCode,
                                loading: !1,
                                saving: !1,
                                error: void 0
                            };
                            null != o && o.recoveryCode && (l.recoveryCode = o.recoveryCode), i(l), await n.afterAuthenticationStateUpdate(v({
                                user: o
                            }, r)), null == a || a(l.recoveryCode);
                        } catch (e) {
                            i({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    disableMfa: async (e)=>{
                        i({
                            saving: !0
                        });
                        try {
                            var a;
                            await t.auth.disableMfa(e);
                            const n = await t.auth.getMFADevices();
                            i({
                                saving: !1,
                                error: void 0,
                                mfaDevices: n
                            }), null == (a = e.callback) || a.call(e, !0);
                        } catch (t) {
                            var n;
                            i({
                                saving: !1,
                                error: Kn(t)
                            }), null == (n = e.callback) || n.call(e, !1, t);
                        }
                    },
                    preDisableMfaSms: async (e)=>{
                        const { deviceId: a } = e, n = f(e, Ko);
                        i({
                            saving: !0
                        });
                        try {
                            var s;
                            const e = await t.auth.preDisableMFASMS(a);
                            i({
                                saving: !1,
                                error: void 0,
                                otcToken: e.otcToken,
                                phoneNumber: e.phoneNumber
                            }), null == (s = n.callback) || s.call(n, !0);
                        } catch (e) {
                            var o;
                            i({
                                saving: !1,
                                error: Kn(e)
                            }), null == (o = n.callback) || o.call(n, !1, e);
                        }
                    },
                    disableMfaSms: async (e)=>{
                        const { deviceId: a } = e, n = f(e, qo);
                        i({
                            saving: !0
                        });
                        try {
                            var s;
                            await t.auth.disableMFASMS(a, n);
                            const e = await t.auth.getMFADevices();
                            i({
                                saving: !1,
                                error: void 0,
                                mfaDevices: e
                            }), null == (s = n.callback) || s.call(n, !0);
                        } catch (e) {
                            var o;
                            i({
                                saving: !1,
                                error: Kn(e)
                            }), null == (o = n.callback) || o.call(n, !1, e);
                        }
                    },
                    preEnrollMfaSms: async (e)=>{
                        i({
                            saving: !0
                        });
                        try {
                            var a;
                            const n = await t.auth.preEnrollMFASMS(e);
                            i({
                                saving: !1,
                                error: void 0,
                                otcToken: n.otcToken,
                                phoneNumber: n.phoneNumber
                            }), null == (a = e.callback) || a.call(e, !0);
                        } catch (t) {
                            var n;
                            i({
                                saving: !1,
                                error: Kn(t)
                            }), null == (n = e.callback) || n.call(e, !1, t);
                        }
                    },
                    enrollMfaSms: async (e)=>{
                        const { callback: a } = e, n = f(e, Yo);
                        i({
                            saving: !0
                        });
                        try {
                            const e = await t.auth.enrollMFASMS(n), o = await t.auth.getMFADevices(), r = await s(e);
                            i(v({}, r, {
                                mfaDevices: o
                            })), null == a || a(r.recoveryCode);
                        } catch (e) {
                            i({
                                saving: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    preEnrollMfaWebAuthn: async (e)=>{
                        i({
                            saving: !0
                        });
                        try {
                            var a, n;
                            const s = await t.auth.preEnrollMFAWebAuthn(), o = v({}, s.options, {
                                challenge: zi(s.options.challenge),
                                user: v({}, s.options.user, {
                                    id: zi(s.options.user.id)
                                }),
                                excludeCredentials: null == (a = s.options.excludeCredentials) ? void 0 : a.map((e)=>v({}, e, {
                                        id: zi(e.id)
                                    }))
                            });
                            i({
                                saving: !1
                            }), null == (n = e.callback) || n.call(e, {
                                options: o,
                                webauthnToken: s.webauthnToken
                            });
                        } catch (t) {
                            var s;
                            i({
                                saving: !1,
                                error: Kn(t)
                            }), null == (s = e.callback) || s.call(e, null, t);
                        }
                    },
                    enrollMfaWebAuthn: async (e)=>{
                        const { callback: a } = e, n = f(e, Jo);
                        i({
                            saving: !0
                        });
                        try {
                            const e = Ki(n.publicKey), o = await t.auth.enrollMFAWebAuthn(v({}, n, {
                                options: e
                            })), r = await t.auth.getMFADevices(), l = await s(o);
                            i(v({}, l, {
                                mfaDevices: r
                            })), null == a || a(l.recoveryCode);
                        } catch (e) {
                            i({
                                saving: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    preDisableMfaWebAuthn: async (e)=>{
                        const { deviceId: a, callback: n } = e;
                        i({
                            saving: !0
                        });
                        try {
                            var s;
                            const e = await t.auth.preDisableMFAWebAuthn(a), o = v({}, e.options, {
                                challenge: zi(e.options.challenge),
                                allowCredentials: null == (s = e.options.allowCredentials) ? void 0 : s.map((e)=>v({}, e, {
                                        id: zi(e.id)
                                    }))
                            });
                            i({
                                saving: !1
                            }), null == n || n({
                                options: o,
                                webauthnToken: e.webauthnToken
                            });
                        } catch (e) {
                            i({
                                saving: !1,
                                error: Kn(e)
                            }), null == n || n(null, e);
                        }
                    },
                    disableMfaWebAuthn: async (e)=>{
                        const { deviceId: a, callback: n } = e, s = f(e, Qo);
                        i({
                            saving: !0
                        });
                        try {
                            const e = Ki(s.publicKey);
                            await t.auth.disableMFAWebAuthn(a, v({}, s, {
                                options: e
                            }));
                            const o = await t.auth.getMFADevices();
                            i({
                                saving: !1,
                                error: void 0,
                                mfaDevices: o
                            }), null == n || n(!0);
                        } catch (e) {
                            i({
                                saving: !1,
                                error: Kn(e)
                            }), null == n || n(!1, e);
                        }
                    },
                    __getMfaStateAfterEnroll: s
                };
            }, Zo = {
                loaders: {},
                errors: {},
                accounts: {
                    tenantId: "",
                    children: []
                },
                accountsQueryParams: {
                    _limit: 50,
                    _offset: 0,
                    _filter: "",
                    _subTenantId: ""
                },
                searchAccountsData: [],
                rootAccount: {
                    tenantId: ""
                },
                selectedAccount: {
                    tenantId: "",
                    userJwt: {
                        accessToken: "",
                        expiresIn: 0,
                        expires: ""
                    },
                    users: [],
                    usersQueryParams: {
                        _offset: 0,
                        _limit: 10,
                        _order: ze.DESC,
                        _sortBy: Xa.name
                    },
                    usersPageOffset: 0,
                    accountSettings: {}
                }
            }, er = (e)=>hn(Zo, e), tr = {
                createSubAccountDialog: {
                    loading: !1,
                    open: !1,
                    error: !1,
                    jwt: "",
                    canSelectParentAccount: !1
                },
                updateSubAccountDialog: {
                    accountId: "",
                    accountName: "",
                    loading: !1,
                    open: !1,
                    error: !1,
                    jwt: ""
                },
                disableSubAccountManagementDialog: {
                    accountId: "",
                    accountName: "",
                    loading: !1,
                    open: !1,
                    error: !1
                },
                enableSubAccountManagementDialog: {
                    accountId: "",
                    accountName: "",
                    loading: !1,
                    open: !1,
                    error: !1
                },
                updateSubAccountHierarchySettingsDialog: {
                    accountId: "",
                    accountName: "",
                    subAccountAccessType: ja.DEFAULT_OFF,
                    loading: !1,
                    open: !1,
                    error: !1
                },
                deleteSubAccountDialog: {
                    accountId: "",
                    accountName: "",
                    isParentAccount: !1,
                    loading: !1,
                    open: !1,
                    error: !1,
                    jwt: ""
                },
                addUsersToAccountDialog: {
                    loading: !1,
                    open: !1,
                    accountName: "",
                    accountId: "",
                    permissionToGiveAccessToSubAccounts: !1,
                    jwt: ""
                },
                deleteUserFromAccountDialog: {
                    userId: "",
                    userName: "",
                    accountId: "",
                    loading: !1,
                    open: !1,
                    jwt: ""
                },
                editUserRolesDialog: {
                    loading: !1,
                    open: !1,
                    jwt: "",
                    accountId: "",
                    userId: "",
                    userName: "",
                    userRoles: []
                }
            }, ar = (e)=>hn(tr, e);
            let nr;
            !function(e) {
                e.GET_ACCOUNTS = "GET_ACCOUNTS", e.SEARCH_ACCOUNTS = "SEARCH_ACCOUNTS", e.SET_ROOT_ACCOUNT_DATA = "SET_ROOT_ACCOUNT_DATA", e.SET_SELECTED_SUB_ACCOUNT_DATA = "SET_SELECTED_SUB_ACCOUNT_DATA", e.LOAD_NUMBER_OF_USERS_FOR_ACCOUNT = "LOAD_NUMBER_OF_USERS_FOR_ACCOUNT", e.UPDATE_SUB_ACCOUNT_ACCESS_FOR_USER = "UPDATE_SUB_ACCOUNT_ACCESS_FOR_USER", e.CREATE_SUB_ACCOUNT = "CREATE_SUB_ACCOUNT", e.UPDATE_SUB_ACCOUNT = "UPDATE_SUB_ACCOUNT", e.DELETE_SUB_ACCOUNT = "DELETE_SUB_ACCOUNT", e.GET_ACCOUNT_USERS = "GET_ACCOUNT_USERS", e.ADD_USERS_TO_ACCOUNT = "ADD_USERS_TO_ACCOUNT", e.DELETE_USERS_FROM_ACCOUNT = "DELETE_USERS_FROM_ACCOUNT", e.SET_USER_ROLES_FOR_SUB_ACCOUNT = "SET_USER_ROLES_FOR_SUB_ACCOUNT", e.UPDATE_SUB_ACCOUNT_SETTINGS = "UPDATE_SUB_ACCOUNT_SETTINGS", e.UPDATE_SUB_ACCOUNT_MANAGEMENT = "UPDATE_SUB_ACCOUNT_MANAGEMENT", e.UPDATE_SUB_ACCOUNT_HIERARCHY_SETTINGS = "UPDATE_SUB_ACCOUNT_HIERARCHY_SETTINGS", e.GET_USER_JWT = "GET_USER_JWT", e.GET_TEAM_USERS = "GET_TEAM_USERS";
            }(nr || (nr = {}));
            const sr = ({ items: e }, t)=>e.map((e)=>{
                    var a, n;
                    return {
                        name: e.name,
                        tenantId: e.tenantId,
                        numberOfUsers: null != (a = null == (n = t.find((t)=>t.tenantId === e.tenantId)) ? void 0 : n.totalUsers) ? a : 0,
                        createdAt: e.createdAt,
                        metadata: e.metadata,
                        isReseller: e.isReseller,
                        subAccountAccessType: e.subAccountAccessType
                    };
                });
            function ir(e, t, a) {
                var n, s, i;
                return e.tenantId === t ? v({}, e, {
                    children: [
                        ...null != (i = null == e ? void 0 : e.children) ? i : [],
                        ...a
                    ].filter((e, t, a)=>t === a.findIndex((t)=>t.tenantId === e.tenantId))
                }) : v({}, e, {
                    children: null != (n = null == e || null == (s = e.children) ? void 0 : s.map((e)=>ir(e, t, a))) ? n : []
                });
            }
            function or(e, t) {
                var a;
                return v({}, e, {
                    children: null != (a = e.children) && a.length ? e.children.filter((e)=>e.tenantId !== t).map((e)=>or(e, t)) : []
                });
            }
            const rr = (e, t, a)=>{
                var n, s;
                return e.tenantId === t ? v({}, e, {
                    subAccountAccessType: a
                }) : v({}, e, {
                    children: null != (n = null == e || null == (s = e.children) ? void 0 : s.map((e)=>rr(e, t, a))) ? n : []
                });
            }, lr = (e, t, a)=>{
                var n, s;
                return e.tenantId === t ? v({}, e, {
                    name: a
                }) : v({}, e, {
                    children: null != (n = null == e || null == (s = e.children) ? void 0 : s.map((e)=>lr(e, t, a))) ? n : []
                });
            }, cr = (e, t, a)=>{
                var n, s;
                return e ? e.tenantId === t ? v({}, e, {
                    isReseller: a
                }) : v({}, e, {
                    children: null != (n = null == e || null == (s = e.children) ? void 0 : s.map((e)=>cr(e, t, a))) ? n : []
                }) : {};
            }, ur = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.allAccountsState, {
                        loaders: v({}, e.auth.allAccountsState.loaders, {
                            [t.key]: t.value
                        })
                    });
                }, s = (t)=>{
                    Object.assign(e.auth.allAccountsState, {
                        errors: v({}, e.auth.allAccountsState.errors, {
                            [t.key]: t.value
                        }),
                        loaders: v({}, e.auth.allAccountsState.loaders, {
                            [t.key]: !1
                        })
                    });
                }, i = (t)=>{
                    Object.assign(e.auth.allAccountsState, t);
                }, o = (t)=>{
                    Object.assign(e.auth.allAccountsState.selectedAccount, t);
                }, r = ()=>e.auth.allAccountsState, l = async (e)=>{
                    var a, i, l, c, u, d, g, p;
                    const { jwt: h, _tenantId: y, _email: S } = e, f = nr.GET_ACCOUNT_USERS;
                    n({
                        key: f,
                        value: !0
                    });
                    const m = r(), b = null != (a = null != (i = null == e ? void 0 : e._offset) ? i : null == m || null == (l = m.selectedAccount) || null == (c = l.usersQueryParams) ? void 0 : c._offset) ? a : 0, A = null != (u = null != (d = null == e ? void 0 : e._limit) ? d : null == m || null == (g = m.selectedAccount) || null == (p = g.usersQueryParams) ? void 0 : p._limit) ? u : 10, w = v({
                        _offset: b,
                        _limit: A,
                        _tenantId: y,
                        _includeSubTenants: !1
                    }, !!S && {
                        _email: S
                    });
                    try {
                        const { items: e, _metadata: { totalItems: a, totalPages: n } } = await t.users.getUsersV3(w, {
                            jwt: h
                        }), s = {
                            totalUsersItems: a,
                            totalUsersPages: n,
                            usersQueryParams: v({
                                _offset: null != b ? b : 0,
                                _limit: null != A ? A : 10
                            }, !!S && {
                                _email: S
                            })
                        };
                        if (e.length) {
                            const a = e.map((e)=>e.id), n = await t.roles.getRoles(), i = await t.users.getUsersRoles({
                                ids: a
                            }, {
                                jwt: h
                            }), r = e.map((e)=>{
                                var t, a;
                                const s = null == i || null == (t = i.find((t)=>t.userId === e.id)) ? void 0 : t.roleIds;
                                return v({}, e, {
                                    roles: null != (a = null == s ? void 0 : s.map((e)=>{
                                        var t;
                                        return null != (t = null == n ? void 0 : n.find((t)=>t.id === e)) ? t : [];
                                    })) ? a : []
                                });
                            });
                            o(v({
                                users: r
                            }, s));
                        } else o(v({
                            users: []
                        }, s));
                    } catch (e) {
                        s({
                            key: f,
                            value: Kn(e)
                        });
                    } finally{
                        n({
                            key: f,
                            value: !1
                        });
                    }
                };
                return {
                    setAllAccountsLoader: n,
                    setAllAccountsError: s,
                    setAllAccountsState: i,
                    setSelectedAccountState: o,
                    resetAllAccountsState: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsState"
                        ], Zo);
                    },
                    clearSelectedAccount: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsState",
                            "selectedAccount"
                        ], Zo.selectedAccount);
                    },
                    loadAccounts: async (e)=>{
                        const a = nr.GET_ACCOUNTS;
                        n({
                            key: a,
                            value: !0
                        });
                        const { accountsQueryParams: l } = r(), { jwt: c, _limit: u, _offset: d } = e, g = {
                            _offset: null != d ? d : l._offset,
                            _limit: null != u ? u : l._limit,
                            _subTenantId: null == e ? void 0 : e._subTenantId
                        };
                        try {
                            if (c) {
                                var p;
                                const { selectedAccount: a } = r(), { items: n, _links: s } = await t.tenants.searchSubTenants(g, {
                                    jwt: c
                                }), i = await t.tenants.getTenantsUsersCount({
                                    tenantIds: n.map((e)=>e.tenantId)
                                }, {
                                    jwt: c
                                }), l = sr({
                                    items: n
                                }, i), u = ir(a.accounts ? a.accounts : a, null != (p = null == e ? void 0 : e._subTenantId) ? p : "", l.map((e)=>({
                                        name: e.name,
                                        tenantId: e.tenantId,
                                        numberOfUsers: e.numberOfUsers,
                                        createdAt: e.createdAt,
                                        metadata: e.metadata,
                                        children: [],
                                        loadMoreLink: null == s ? void 0 : s.next,
                                        isReseller: e.isReseller
                                    })));
                                o({
                                    accounts: u
                                });
                            } else {
                                var h;
                                const { accounts: a } = r(), { items: n, _links: s } = await t.tenants.searchSubTenants(g), o = await t.tenants.getTenantsUsersCount({
                                    tenantIds: n.map((e)=>e.tenantId)
                                }), l = sr({
                                    items: n
                                }, o), c = ir(a, null != (h = null == e ? void 0 : e._subTenantId) ? h : "", l.map((e)=>({
                                        name: e.name,
                                        tenantId: e.tenantId,
                                        numberOfUsers: e.numberOfUsers,
                                        createdAt: e.createdAt,
                                        metadata: e.metadata,
                                        children: [],
                                        loadMoreLink: null == s ? void 0 : s.next,
                                        isReseller: e.isReseller
                                    })));
                                i({
                                    accounts: c
                                });
                            }
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    searchAccounts: async (e)=>{
                        const { jwt: a } = e, o = nr.SEARCH_ACCOUNTS;
                        n({
                            key: o,
                            value: !0
                        });
                        const { rootAccount: l } = r();
                        try {
                            if (null != e && e._subTenantId) {
                                var c;
                                const { items: n } = await t.tenants.searchSubTenants({
                                    _offset: 0,
                                    _limit: 50,
                                    _filter: null != (c = null == e ? void 0 : e._filter) ? c : "",
                                    _subTenantId: e._subTenantId
                                }, {
                                    jwt: a
                                });
                                i({
                                    searchAccountsData: [
                                        ...n,
                                        {
                                            name: l.name,
                                            tenantId: l.tenantId
                                        }
                                    ]
                                });
                            }
                        } catch (e) {
                            s({
                                key: o,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: o,
                                value: !1
                            });
                        }
                    },
                    updateSubAccountAccessForUser: async (e)=>{
                        const a = nr.UPDATE_SUB_ACCOUNT_ACCESS_FOR_USER;
                        n({
                            key: a,
                            value: !0
                        });
                        const { selectedAccount: i } = r(), { userId: l, allowAccess: c, jwt: u, callback: d } = e;
                        try {
                            var g;
                            await t.subTenants.updateSubAccountAccess(l, {
                                allowAccess: c
                            }, {
                                jwt: u
                            }), o({
                                users: null == i || null == (g = i.users) ? void 0 : g.map((e)=>e.id === l ? v({}, e, {
                                        subAccountAccessAllowed: c
                                    }) : e)
                            }), null == d || d(!0);
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            }), null == d || d(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    createSubAccount: async (e)=>{
                        const a = nr.CREATE_SUB_ACCOUNT;
                        n({
                            key: a,
                            value: !0
                        });
                        const { name: l, parentTenantId: c, tenantId: u, jwt: d, callback: g } = e;
                        try {
                            if (d) {
                                const { accounts: e, selectedAccount: a } = r(), n = await t.subTenants.createSubTenant({
                                    name: l,
                                    parentTenantId: c,
                                    tenantId: u
                                }, {
                                    jwt: d
                                }), s = ir(e, null != c ? c : "", [
                                    {
                                        name: n.name,
                                        tenantId: n.tenantId,
                                        numberOfUsers: 0,
                                        createdAt: new Date
                                    }
                                ]), g = ir(v({
                                    name: "",
                                    tenantId: ""
                                }, null == a ? void 0 : a.accounts), null != c ? c : "", [
                                    {
                                        name: n.name,
                                        tenantId: n.tenantId,
                                        numberOfUsers: 0,
                                        createdAt: new Date
                                    }
                                ]);
                                i({
                                    accounts: s
                                }), o({
                                    accounts: g
                                });
                            } else {
                                const { accounts: e } = r(), a = await t.subTenants.createSubTenant({
                                    name: l,
                                    tenantId: u,
                                    parentTenantId: c
                                }), n = ir(e, null != c ? c : "", [
                                    {
                                        name: a.name,
                                        tenantId: a.tenantId,
                                        numberOfUsers: 0,
                                        createdAt: new Date
                                    }
                                ]);
                                i({
                                    accounts: n
                                });
                            }
                            null == g || g(!0);
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            }), null == g || g(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    updateSubAccount: async (e)=>{},
                    deleteSubAccount: async (e)=>{
                        const a = nr.DELETE_SUB_ACCOUNT;
                        n({
                            key: a,
                            value: !0
                        });
                        const { jwt: l, tenantId: c, callback: u } = e;
                        try {
                            if (l) {
                                const { selectedAccount: e, accounts: a } = r();
                                await t.subTenants.deleteSubTenant(c, {
                                    jwt: l
                                });
                                const n = or(a, c), s = or(e.accounts, c);
                                i({
                                    accounts: n
                                }), o({
                                    accounts: s
                                });
                            } else {
                                const { accounts: e } = r();
                                await t.subTenants.deleteSubTenant(c);
                                const a = or(e, c);
                                i({
                                    accounts: a
                                });
                            }
                            null == u || u(!0);
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            }), null == u || u(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    updateSubAccountSettings: async (e)=>{
                        const a = nr.UPDATE_SUB_ACCOUNT_HIERARCHY_SETTINGS;
                        n({
                            key: a,
                            value: !0
                        });
                        const { jwt: l, name: c, callback: u, tenantId: d } = e;
                        try {
                            if (l) {
                                const { selectedAccount: e, accounts: a } = r();
                                await t.subTenants.updateSubTenant({
                                    tenantId: d
                                }, {
                                    name: c
                                }, {
                                    jwt: l
                                });
                                const n = lr(e.accounts, d, c);
                                o({
                                    name: c,
                                    accounts: n
                                });
                                const s = lr(a, d, c);
                                i({
                                    accounts: s
                                });
                            } else {
                                const { accounts: e } = r();
                                await t.subTenants.updateSubTenant({
                                    tenantId: d
                                }, {
                                    name: c
                                });
                                const a = lr(e, d, c);
                                i({
                                    accounts: a
                                });
                            }
                            null == u || u(!0);
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            }), null == u || u(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    updateSubAccountManagement: async (r)=>{
                        const l = nr.UPDATE_SUB_ACCOUNT_MANAGEMENT;
                        a.setAllAccountsLoader({
                            key: l,
                            value: !0
                        });
                        const { jwt: c, isReseller: u, callback: d, tenantId: g, shouldUpdateSelectedAccount: p } = r, h = !!c;
                        try {
                            if (p) {
                                const { selectedAccount: a, accounts: n } = e.auth.allAccountsState;
                                await t.subTenants.updateSubTenantManagement({
                                    tenantId: g
                                }, {
                                    isReseller: u
                                }, c ? {
                                    jwt: c
                                } : void 0);
                                const s = cr(a.accounts, g, null != u && u);
                                o({
                                    accounts: s
                                }), h || o({
                                    isReseller: u
                                });
                                const r = cr(n, g, null != u && u);
                                i({
                                    accounts: r
                                });
                            } else {
                                const { accounts: a } = e.auth.allAccountsState;
                                t.subTenants.updateSubTenantManagement({
                                    tenantId: g
                                }, {
                                    isReseller: u
                                }, c ? {
                                    jwt: c
                                } : void 0);
                                const n = cr(a, g, null != u && u);
                                i({
                                    accounts: n
                                });
                            }
                            null == d || d(!0);
                        } catch (e) {
                            s({
                                key: l,
                                value: Kn(e)
                            }), null == d || d(!1);
                        } finally{
                            n({
                                key: l,
                                value: !1
                            });
                        }
                    },
                    updateSubAccountHierarchySettings: async (e)=>{
                        const a = nr.UPDATE_SUB_ACCOUNT_HIERARCHY_SETTINGS;
                        n({
                            key: a,
                            value: !0
                        });
                        const { jwt: l, callback: c, tenantId: u, subAccountAccessType: d } = e;
                        if (d) try {
                            if (l) {
                                const { selectedAccount: e, accounts: a } = r();
                                await t.subTenants.updateSubTenantHierarchySettings({
                                    tenantId: u
                                }, {
                                    subAccountAccessType: d
                                }, {
                                    jwt: l
                                });
                                const n = rr(e.accounts, u, d);
                                o({
                                    subAccountAccessType: d,
                                    accounts: n
                                });
                                const s = rr(a, u, d);
                                i({
                                    accounts: s
                                });
                            } else {
                                const { accounts: e } = r();
                                await t.subTenants.updateSubTenantHierarchySettings({
                                    tenantId: u
                                }, {
                                    subAccountAccessType: d
                                });
                                const a = rr(e, u, d);
                                i({
                                    accounts: a
                                });
                            }
                            null == c || c(!0);
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            }), null == c || c(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    addUsersToAccount: async (e)=>{
                        const { users: a, tenantId: i, jwt: o, callback: r, allowSubAccountAccess: c = !1, roleIds: u } = e, d = nr.ADD_USERS_TO_ACCOUNT;
                        try {
                            n({
                                key: d,
                                value: !0
                            }), await t.subTenants.addUsersToSubTenant({
                                users: a,
                                tenantId: i,
                                allowSubAccountAccess: c,
                                roleIds: u
                            }, {
                                jwt: o
                            }), await l({
                                jwt: o,
                                _tenantId: i
                            }), null == r || r(!0);
                        } catch (e) {
                            s({
                                key: d,
                                value: Kn(e)
                            }), null == r || r(!1);
                        } finally{
                            n({
                                key: d,
                                value: !1
                            });
                        }
                    },
                    getAccountUsers: l,
                    deleteUsersFromAccount: async (e)=>{
                        const a = nr.DELETE_USERS_FROM_ACCOUNT;
                        n({
                            key: a,
                            value: !0
                        });
                        const { userId: i, subTenants: o, jwt: r, callback: c } = e;
                        try {
                            await t.subTenants.removeUserFromTenantAndSubTenants({
                                userId: i,
                                subTenants: o
                            }, {
                                jwt: r
                            }), await l({
                                jwt: r,
                                _tenantId: o[0].tenantId
                            }), null == c || c(!0);
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            }), null == c || c(!1);
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    setUserRolesForSubAccount: async (e)=>{
                        const { userId: a, subTenantsRoles: i, jwt: o, callback: c } = e, u = nr.SET_USER_ROLES_FOR_SUB_ACCOUNT;
                        try {
                            n({
                                key: u,
                                value: !0
                            });
                            const { selectedAccount: e } = r();
                            await t.subTenants.setUserRolesForSubTenants(a, {
                                subTenantsRoles: i
                            }, {
                                jwt: o
                            }), await l({
                                jwt: o,
                                _tenantId: e.tenantId
                            }), null == c || c(!0);
                        } catch (e) {
                            s({
                                key: u,
                                value: Kn(e)
                            }), null == c || c(!1);
                        } finally{
                            n({
                                key: u,
                                value: !1
                            });
                        }
                    },
                    getUserJwtForSubAccount: async (e)=>{
                        const { tenantId: a, callback: i } = e, r = nr.GET_USER_JWT;
                        try {
                            n({
                                key: r,
                                value: !0
                            });
                            const e = await t.users.GetUserJwt({
                                tenantId: a
                            });
                            o({
                                userJwt: e,
                                accessPermission: !0
                            }), null == i || i(!0);
                        } catch (e) {
                            s({
                                key: r,
                                value: Kn(e)
                            }), o({
                                accessPermission: !1
                            }), null == i || i(!1);
                        } finally{
                            n({
                                key: r,
                                value: !1
                            });
                        }
                    },
                    setRootAccountData: async ()=>{
                        const a = nr.SET_ROOT_ACCOUNT_DATA;
                        n({
                            key: a,
                            value: !0
                        });
                        const { activeTenant: o } = e.auth.tenantsState, { accounts: l } = r();
                        if (o) try {
                            var c;
                            const e = await t.tenants.getTenantsUsersCount({
                                tenantIds: [
                                    null == o ? void 0 : o.tenantId
                                ]
                            }), a = {
                                name: null == o ? void 0 : o.name,
                                tenantId: null == o ? void 0 : o.tenantId,
                                numberOfUsers: null == (c = e[0]) ? void 0 : c.totalUsers,
                                createdAt: null == o ? void 0 : o.createdAt
                            };
                            i({
                                rootAccount: a,
                                accounts: v({}, l, a)
                            });
                        } catch (e) {
                            s({
                                key: a,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    setSelectedSubAccountData: async (e)=>{
                        const { jwt: a } = e, i = nr.SET_SELECTED_SUB_ACCOUNT_DATA;
                        try {
                            var r, c, u, d, g, p, h;
                            n({
                                key: i,
                                value: !0
                            });
                            const e = await t.accountSettings.getSettings({
                                jwt: a
                            }), [s, y, S] = await Promise.all([
                                t.tenants.getTenantsUsersCount({
                                    tenantIds: [
                                        null != (r = null == e ? void 0 : e.tenantId) ? r : ""
                                    ]
                                }, {
                                    jwt: a
                                }),
                                t.tenants.getParentTenants({
                                    jwt: a
                                }),
                                t.tenants.getHierarchyMetadata({
                                    _tenantIds: [
                                        null != (c = null == e ? void 0 : e.tenantId) ? c : ""
                                    ]
                                }, {
                                    jwt: a
                                })
                            ]);
                            o({
                                tenantId: null != (u = e.tenantId) ? u : "",
                                name: e.name,
                                numberOfUsersObject: s[0],
                                parentsAccounts: y,
                                numberOfSubAccounts: null == (d = S[0]) ? void 0 : d.totalSubTenants,
                                accountSettings: e,
                                accounts: {
                                    name: e.name,
                                    tenantId: null != (g = e.tenantId) ? g : "",
                                    numberOfUsers: null == (p = s[0]) ? void 0 : p.totalUsers,
                                    createdAt: void 0,
                                    children: []
                                }
                            }), await l({
                                jwt: a,
                                _tenantId: null != (h = null == e ? void 0 : e.tenantId) ? h : ""
                            });
                        } catch (e) {
                            s({
                                key: i,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: i,
                                value: !1
                            });
                        }
                    },
                    loadNumberOfUsersForSelectedSubAccount: async (e)=>{
                        const { tenantId: a, jwt: i } = e, r = nr.LOAD_NUMBER_OF_USERS_FOR_ACCOUNT;
                        try {
                            n({
                                key: r,
                                value: !0
                            });
                            const e = await t.tenants.getTenantsUsersCount({
                                tenantIds: [
                                    a
                                ]
                            }, {
                                jwt: i
                            });
                            o({
                                numberOfUsersObject: e[0]
                            });
                        } catch (e) {
                            s({
                                key: r,
                                value: Kn(e)
                            });
                        } finally{
                            n({
                                key: r,
                                value: !1
                            });
                        }
                    }
                };
            }, dr = (e, t, a)=>({
                    setAllAccountDialogsState: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState, t);
                    },
                    resetAllAccountDialogsState: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState"
                        ], tr);
                    },
                    openCreateSubAccountDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.createSubAccountDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeCreateSubAccountDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "createSubAccountDialog"
                        ], tr.createSubAccountDialog);
                    },
                    openUpdateSubAccountDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.updateSubAccountDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeUpdateSubAccountDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "updateSubAccountDialog"
                        ], tr.updateSubAccountDialog);
                    },
                    openEnableSubAccountManagementDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.enableSubAccountManagementDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeEnableSubAccountManagementDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "enableSubAccountManagementDialog"
                        ], tr.enableSubAccountManagementDialog);
                    },
                    openUpdateSubAccountHierarchySettingsDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.updateSubAccountHierarchySettingsDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeUpdateSubAccountHierarchySettingsDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "updateSubAccountHierarchySettingsDialog"
                        ], tr.updateSubAccountHierarchySettingsDialog);
                    },
                    openDisableSubAccountManagementDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.disableSubAccountManagementDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeDisableSubAccountManagementDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "disableSubAccountManagementDialog"
                        ], tr.disableSubAccountManagementDialog);
                    },
                    openDeleteSubAccountDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.deleteSubAccountDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeDeleteSubAccountDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "deleteSubAccountDialog"
                        ], tr.deleteSubAccountDialog);
                    },
                    openAddUsersToAccountDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.addUsersToAccountDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeAddUsersToAccountDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "addUsersToAccountDialog"
                        ], tr.addUsersToAccountDialog);
                    },
                    openDeleteUserFromAccountDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.deleteUserFromAccountDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeDeleteUserFromAccountDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "deleteUserFromAccountDialog"
                        ], tr.deleteUserFromAccountDialog);
                    },
                    openEditUserRolesDialog: (t)=>{
                        Object.assign(e.auth.allAccountsDialogsState.editUserRolesDialog, v({}, t, {
                            open: !0
                        }));
                    },
                    closeEditUserRolesDialog: ()=>{
                        Wn(e, [
                            "auth",
                            "allAccountsDialogsState",
                            "editUserRolesDialog"
                        ], tr.editUserRolesDialog);
                    }
                }), gr = {
                devices: [],
                loading: !1,
                error: null
            }, pr = (e)=>hn(gr, e), hr = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.passkeysState, t);
                };
                return {
                    setPasskeysState: s,
                    resetPasskeysState: ()=>{
                        Wn(e, [
                            "auth",
                            "passkeysState"
                        ], gr);
                    },
                    loadWebAuthnDevices: async ()=>{
                        s({
                            loading: !0
                        });
                        try {
                            const { devices: e } = await t.auth.getWebAuthnDevices();
                            s({
                                devices: e,
                                loading: !1
                            });
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e, null)
                            });
                        }
                    },
                    deleteWebAuthnDevice: async (a)=>{
                        const { callback: n, deviceId: i } = a;
                        s({
                            loading: !0
                        });
                        try {
                            await t.auth.deleteWebAuthnDevice(i);
                            const a = e.auth.passkeysState.devices.filter((e)=>e.id !== i);
                            s({
                                devices: a,
                                loading: !1
                            }), null == n || n(!0);
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e, null)
                            }), null == n || n(null, e);
                        }
                    },
                    __shouldShowPromptPasskeys: async function() {
                        const { publicAuthStrategyPolicy: a } = e.auth.securityPolicyState, { policy: i } = a, o = await async function(e) {
                            var t;
                            return !(null == e || null == (t = e.secondaryAuthStrategies) || !t.some(({ isActive: e, strategy: t })=>e && t === Ze.Passkeys));
                        }(i), r = "Passkeys" === localStorage.getItem("preferred-login-method"), l = "true" === localStorage.getItem("dont-show-again-prompt-passkeys"), [c] = await n.getFeatureFlags([
                            "show-passkeys-new"
                        ]);
                        if (!c || !o || r || l) return !1;
                        {
                            const { devices: e } = await t.auth.getWebAuthnDevices();
                            return s({
                                devices: null != e ? e : []
                            }), 0 === (null != e && e.length ? e.length : 0);
                        }
                    }
                };
            }, yr = {
                loading: !1,
                error: null
            }, Sr = (e)=>hn(yr, e), vr = [
                "callback",
                "profilePictureUrl"
            ], fr = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.profileState, t);
                };
                return {
                    setProfileState: s,
                    resetProfileState: ()=>{
                        Wn(e, [
                            "auth",
                            "profileState"
                        ], yr);
                    },
                    loadProfile: async ()=>{
                        s({
                            loading: !0
                        });
                        try {
                            const a = await Fn(t.teams.getProfile, 3, 2e3), i = e.auth.user;
                            n.setUser(v({}, i, a)), s({
                                profile: a,
                                loading: !1
                            });
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    saveProfile: async (a)=>{
                        const { callback: i, profilePictureUrl: o } = a, r = f(a, vr);
                        s({
                            saving: !0,
                            error: null,
                            loading: !0
                        });
                        try {
                            var l;
                            const a = null != (l = e.auth.profileState.profile) ? l : {};
                            let s = a.profilePictureUrl;
                            if (o !== a.profilePictureUrl && o && (o || "").match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/)) {
                                const e = Hi(o, "image");
                                if (e) {
                                    s = await t.teams.updateProfileImage(e);
                                    const a = Date.now().toString(), n = new URL(s);
                                    n.searchParams.set("t", a), s = n.href;
                                }
                            }
                            const c = v({}, a, r, {
                                profilePictureUrl: s
                            }), u = await t.users.updateUserProfileV2(c), d = e.auth.user;
                            n.setUser(v({}, d, u)), n.setProfileState({
                                profile: u,
                                saving: !1,
                                loading: !1
                            }), null == i || i(c);
                        } catch (e) {
                            s({
                                saving: !1,
                                error: Kn(e),
                                loading: !1
                            }), null == i || i(null, e);
                        }
                    },
                    changePassword: async (e)=>{
                        s({
                            loading: !0
                        });
                        try {
                            var a;
                            await t.teams.changePassword(e), s({
                                loading: !1,
                                error: void 0
                            }), null == (a = e.callback) || a.call(e, !0);
                        } catch (t) {
                            var n;
                            s({
                                loading: !1,
                                error: Kn(t)
                            }), null == (n = e.callback) || n.call(e, null, t);
                        }
                    },
                    updateEmail: async (e)=>{
                        const { email: a, callback: n } = e;
                        s({
                            saving: !0,
                            error: null,
                            loading: !0
                        });
                        try {
                            await t.teams.updateEmail(a), s({
                                saving: !1,
                                error: null,
                                loading: !1
                            }), null == n || n(!0);
                        } catch (e) {
                            s({
                                saving: !1,
                                error: Kn(e),
                                loading: !1
                            }), null == n || n(null, e);
                        }
                    },
                    verifyEmail: async (e)=>{
                        const { email: a, code: i, callback: o } = e;
                        s({
                            saving: !0,
                            error: null,
                            loading: !0
                        });
                        try {
                            await t.teams.verifyEmail(a, i), await n.__refreshToken(), s({
                                saving: !1,
                                error: null,
                                loading: !1
                            }), null == o || o(!0);
                        } catch (e) {
                            s({
                                saving: !1,
                                error: Kn(e),
                                loading: !1
                            }), null == o || o(null, e);
                        }
                    }
                };
            }, mr = {
                loading: !1
            }, br = (e)=>hn(mr, e), Ar = [
                "callback"
            ], wr = [
                "id"
            ], Tr = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.provisioningState, t);
                }, s = async (e, a)=>{
                    const { count: n } = await xn(()=>t.directory.countConfigurationUsers(e.id), a);
                    return v({}, e, {
                        count: n
                    });
                };
                return {
                    setProvisioningState: n,
                    resetProvisioningState: ()=>{
                        Wn(e, [
                            "auth",
                            "provisioningState"
                        ], mr);
                    },
                    __loadCountForConnection: s,
                    loadProvisionConnections: async (e)=>{
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            const a = null == e ? void 0 : e.retryConfig, i = await xn(()=>t.directory.getConfigs(), a), o = await Promise.all(i.map((e)=>s(e, a)));
                            n({
                                connections: o,
                                loading: !1
                            });
                        } catch (e) {
                            n({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    createProvisionConnection: async (e)=>{
                        const { callback: a } = e, i = f(e, Ar);
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            const e = await t.directory.createConfiguration(i), o = await t.directory.getConfigs(), r = await Promise.all(o.map((e)=>s(e)));
                            n({
                                connections: r,
                                loading: !1
                            }), null == a || a(e);
                        } catch (e) {
                            n({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    deleteProvisionConnection: async (e)=>{
                        const { id: a, callback: i } = e;
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await t.directory.deleteConfiguration(a, e.deleteAll);
                            const o = await t.directory.getConfigs(), r = await Promise.all(o.map((e)=>s(e)));
                            n({
                                connections: r,
                                loading: !1
                            }), null == i || i(!0);
                        } catch (e) {
                            n({
                                error: Kn(e),
                                loading: !1
                            }), null == i || i(!1, e);
                        }
                    },
                    updateProvisionConnection: async (e)=>{
                        const { id: a } = e, i = f(e, wr);
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await t.directory.updateConfiguration(a, i);
                            const e = await t.directory.getConfigs(), o = await Promise.all(e.map((e)=>s(e)));
                            n({
                                connections: o,
                                loading: !1
                            });
                        } catch (e) {
                            n({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    }
                };
            };
            let Er;
            !function(e) {
                e.ResetPhoneNumber = "ResetPhoneNumber", e.VerifyResetPhoneNumber = "VerifyResetPhoneNumber", e.ChangePhoneNumber = "ChangePhoneNumber";
            }(Er || (Er = {}));
            const Pr = {
                step: Er.ResetPhoneNumber,
                loading: !1
            }, Ir = (e)=>hn(Pr, e), Or = [
                "callback"
            ], kr = [
                "callback"
            ], _r = [
                "callback"
            ], Rr = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.resetPhoneNumberState, t);
                };
                return {
                    setResetPhoneNumberState: s,
                    resetResetPhoneNumberState: ()=>{
                        Wn(e, [
                            "auth",
                            "resetPhoneNumberState"
                        ], Pr);
                    },
                    resetPhoneNumber: async (e)=>{
                        const { callback: a } = e, i = f(e, Or);
                        s({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.resetPhoneNumber(i);
                            s({
                                loading: !1,
                                error: void 0,
                                resetPhoneNumberToken: e.resetPhoneNumberToken,
                                step: Er.VerifyResetPhoneNumber
                            }), n.setLoginState({
                                email: i.email
                            });
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    verifyResetPhoneNumber: async (e)=>{
                        const { callback: a } = e, n = f(e, kr);
                        s({
                            loading: !0
                        });
                        try {
                            const e = await t.auth.verifyResetPhoneNumber(n);
                            s({
                                loading: !1,
                                error: void 0,
                                changePhoneNumberToken: e.changePhoneNumberToken,
                                step: Er.ChangePhoneNumber
                            }), null == a || a(!0);
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    changePhoneNumber: async (a)=>{
                        const { callback: i } = a, o = f(a, _r);
                        s({
                            loading: !0
                        });
                        try {
                            const { onRedirectTo: a, routes: r } = e.auth;
                            await t.auth.changePhoneNumber({
                                phoneNumber: o.phoneNumber,
                                changePhoneNumberToken: o.changePhoneNumberToken
                            }), n.setLoginState({
                                step: On.loginWithSmsOtc
                            }), await n.passwordlessPreLogin({
                                type: M.SmsCode,
                                email: o.email,
                                recaptchaToken: o.recaptchaToken
                            }), a(r.loginUrl), s({
                                loading: !1
                            }), null == i || i(!0);
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e)
                            }), null == i || i(null, e);
                        }
                    }
                };
            }, Ur = {
                loaders: {},
                errors: {},
                roles: [],
                permissions: [],
                permissionCategories: []
            }, Lr = (e)=>hn(Ur, e);
            let Cr;
            !function(e) {
                e.EDIT_ROLE_DIALOG = "editRoleDialog", e.DELETE_ROLE_DIALOG = "deleteRoleDialog", e.LOAD_ROLES = "loadRoles", e.ADD_ROLE = "addRole", e.MANAGE_PERMISSIONS = "managePermissions";
            }(Cr || (Cr = {}));
            const Dr = [
                "callback"
            ], Nr = [
                "callback"
            ], Mr = [
                "callback"
            ], Fr = [
                "callback"
            ], xr = [
                "callback"
            ], $r = [
                "callback"
            ], Gr = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.rolesState, t);
                }, s = (t)=>{
                    Object.assign(e.auth.rolesState, {
                        loaders: v({}, e.auth.rolesState.loaders, {
                            [t.key]: t.value
                        })
                    });
                }, i = (t)=>{
                    Object.assign(e.auth.rolesState, {
                        errors: v({}, e.auth.rolesState.errors, {
                            [t.key]: t.value
                        }),
                        loaders: v({}, e.auth.rolesState.loaders, {
                            [t.key]: !1
                        })
                    });
                }, o = async (a)=>{
                    var o;
                    const r = Cr.LOAD_ROLES;
                    s({
                        key: r,
                        value: !(null != (o = null == a ? void 0 : a.silentLoading) && o)
                    });
                    try {
                        const s = null == a ? void 0 : a.retryConfig, [i, o, r] = await Promise.all([
                            xn(()=>t.roles.getRoles(), s),
                            xn(()=>t.roles.getPermissions(), s),
                            xn(()=>t.roles.getPermissionCategories(), s)
                        ]), { selectedRole: l } = e.auth.rolesState, c = null == i ? void 0 : i.find(({ id: e })=>(null == l ? void 0 : l.id) === e);
                        n({
                            roles: i,
                            permissions: o,
                            permissionCategories: r,
                            selectedRole: c
                        });
                    } catch (e) {
                        i({
                            key: r,
                            value: Kn(e)
                        });
                    } finally{
                        s({
                            key: r,
                            value: !1
                        });
                    }
                }, r = async (e)=>{
                    const { callback: a } = e, r = f(e, xr), l = Cr.MANAGE_PERMISSIONS;
                    s({
                        key: l,
                        value: !0
                    });
                    try {
                        const e = await t.roles.attachPermissionsToRole(r);
                        await o({
                            silentLoading: !0
                        }), n({
                            saving: !1
                        }), null == a || a(e);
                    } catch (e) {
                        i({
                            key: l,
                            value: Kn(e)
                        }), null == a || a(null, e);
                    } finally{
                        s({
                            key: l,
                            value: !1
                        });
                    }
                };
                return {
                    setRolesState: n,
                    setRolesStateLoader: s,
                    setRolesStateError: i,
                    resetRolesState: ()=>{
                        Wn(e, [
                            "auth",
                            "rolesState"
                        ], Ur);
                    },
                    loadRolesAndPermissions: o,
                    addRole: async (e)=>{
                        const { callback: a } = e, n = f(e, Dr), r = Cr.ADD_ROLE;
                        s({
                            key: r,
                            value: !0
                        });
                        try {
                            const e = await t.roles.addRole(n);
                            await o({
                                silentLoading: !0
                            }), null == a || a(e);
                        } catch (e) {
                            i({
                                key: r,
                                value: Kn(e)
                            }), null == a || a(null, e);
                        } finally{
                            s({
                                key: r,
                                value: !1
                            });
                        }
                    },
                    addRoleV2: async (e)=>{
                        const { callback: a } = e, n = f(e, Nr), r = Cr.ADD_ROLE;
                        s({
                            key: r,
                            value: !0
                        });
                        try {
                            const e = await t.roles.addRoleV2(n);
                            await o({
                                silentLoading: !0
                            }), null == a || a(e);
                        } catch (e) {
                            i({
                                key: r,
                                value: Kn(e)
                            }), null == a || a(null, e);
                        } finally{
                            s({
                                key: r,
                                value: !1
                            });
                        }
                    },
                    updateRole: async (e)=>{
                        const { callback: a } = e, r = f(e, Mr), l = Cr.EDIT_ROLE_DIALOG;
                        s({
                            key: l,
                            value: !0
                        });
                        try {
                            const e = await t.roles.updateRole(r);
                            await o({
                                silentLoading: !0
                            }), n({
                                saving: !1
                            }), null == a || a(e);
                        } catch (e) {
                            i({
                                key: l,
                                value: Kn(e)
                            }), null == a || a(null, e);
                        } finally{
                            s({
                                key: l,
                                value: !1
                            });
                        }
                    },
                    deleteRole: async (e)=>{
                        const { callback: a } = e, r = f(e, Fr), l = Cr.DELETE_ROLE_DIALOG;
                        s({
                            key: l,
                            value: !0
                        });
                        try {
                            await t.roles.deleteRole(r), await o({
                                silentLoading: !0
                            }), n({
                                saving: !1
                            }), null == a || a(!0);
                        } catch (e) {
                            i({
                                key: l,
                                value: Kn(e)
                            }), null == a || a(!1, e);
                        } finally{
                            s({
                                key: l,
                                value: !1
                            });
                        }
                    },
                    attachPermissionsToRole: r,
                    attachPermissionToRoles: async (e)=>{
                        const { callback: t } = e, a = f(e, $r), n = Cr.MANAGE_PERMISSIONS;
                        s({
                            key: n,
                            value: !0
                        });
                        try {
                            await Promise.all(a.roleIds.map((e)=>r({
                                    roleId: e,
                                    permissionIds: [
                                        a.permissionId
                                    ]
                                }))), await o({
                                silentLoading: !0
                            }), null == t || t(!0);
                        } catch (e) {
                            i({
                                key: n,
                                value: Kn(e)
                            }), null == t || t(null, e);
                        } finally{
                            s({
                                key: n,
                                value: !1
                            });
                        }
                    }
                };
            }, jr = {
                ipRestrictions: {
                    loading: !1,
                    pagination: {
                        _offset: 0,
                        _limit: 4,
                        _filter: Xe.ALLOW
                    },
                    totalPages: 1,
                    userIpValid: !1
                },
                emailDomainRestrictions: {
                    loading: !1
                }
            }, Vr = (e)=>hn(jr, e), Br = [
                "callback"
            ], Wr = [
                "callback"
            ], zr = [
                "callback"
            ], Hr = [
                "callback"
            ], Kr = (e, t, a)=>{
                const n = a, s = (e)=>{
                    var t, a, n;
                    return {
                        _filter: null != (t = null == e ? void 0 : e._filter) ? t : Xe.ALLOW,
                        _limit: null != (a = null == e ? void 0 : e._limit) ? a : 10,
                        _offset: null != (n = null == e ? void 0 : e._offset) ? n : 0
                    };
                }, i = (e)=>async (...t)=>{
                        const [a] = await n.getFeatureFlags([
                            "security-center-admin-portal-major-version"
                        ]);
                        await e(...t), a && (await n.loadRecommendations($n()), await n.loadInsights($n()));
                    }, o = (t)=>{
                    Object.assign(e.auth.restrictionsState.ipRestrictions, t);
                }, r = (t)=>{
                    Object.assign(e.auth.restrictionsState.emailDomainRestrictions, t);
                }, l = async ()=>{
                    try {
                        const { valid: e } = await t.auth.testCurrentIpInAllowList();
                        o({
                            userIpValid: e
                        });
                    } catch (e) {
                        o({
                            error: Kn(e)
                        });
                    }
                }, c = i(async ()=>{
                    o({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = e.auth.restrictionsState.ipRestrictions, n = await t.auth.getIPRestrictionsConfig(), i = s({
                            _filter: n.strategy,
                            _limit: a.pagination._limit,
                            _offset: a.pagination._offset
                        }), { items: r, _metadata: { totalPages: l } } = await t.auth.getIPRestrictions(i);
                        o({
                            data: {
                                restrictions: r,
                                config: n
                            },
                            totalPages: l,
                            pagination: i,
                            loading: !1
                        });
                    } catch (e) {
                        o({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }), u = i(async (a)=>{
                    const { callback: n } = a, i = f(a, Br);
                    o({
                        saving: !0,
                        error: null
                    });
                    try {
                        var r, c;
                        await t.auth.createIPRestriction(i);
                        const a = e.auth.restrictionsState.ipRestrictions, u = s(a.pagination), { items: d, _metadata: { totalPages: g } } = await t.auth.getIPRestrictions(u), p = d;
                        await l(), o({
                            data: {
                                config: null != (r = null == (c = a.data) ? void 0 : c.config) ? r : {
                                    isActive: !1,
                                    strategy: Xe.ALLOW
                                },
                                restrictions: p
                            },
                            pagination: u,
                            totalPages: g,
                            saving: !1
                        }), null == n || n(!0);
                    } catch (e) {
                        o({
                            saving: !1,
                            error: Kn(e)
                        }), null == n || n(null, e);
                    }
                }), d = i(async (a)=>{
                    const { callback: n } = a, i = f(a, Wr);
                    o({
                        saving: !0,
                        error: null
                    });
                    try {
                        await t.auth.updateIPRestrictionConfig(i);
                        const a = e.auth.restrictionsState.ipRestrictions, r = await t.auth.getIPRestrictionsConfig(), c = s(v({}, a.pagination, {
                            _filter: r.strategy
                        })), { items: u, _metadata: { totalPages: d } } = await t.auth.getIPRestrictions(c), g = u;
                        await l(), o({
                            data: {
                                config: r,
                                restrictions: g
                            },
                            pagination: c,
                            totalPages: d,
                            saving: !1
                        }), null == n || n(!0);
                    } catch (e) {
                        o({
                            saving: !1,
                            error: Kn(e)
                        }), null == n || n(null, e);
                    }
                }), g = i(async (a)=>{
                    const { id: n, callback: i } = a;
                    o({
                        saving: !0,
                        error: null
                    });
                    try {
                        var r;
                        await t.auth.deleteIPRestriction(n);
                        const a = e.auth.restrictionsState.ipRestrictions, c = s(a.pagination), { items: u, _metadata: { totalPages: d } } = await t.auth.getIPRestrictions(c), g = u;
                        await l(), o({
                            data: {
                                config: (null == (r = a.data) ? void 0 : r.config) || {
                                    isActive: !1,
                                    strategy: Xe.ALLOW
                                },
                                restrictions: g
                            },
                            pagination: c,
                            totalPages: d,
                            saving: !1
                        }), null == i || i(!0);
                    } catch (e) {
                        o({
                            saving: !1,
                            error: Kn(e)
                        }), null == i || i(null, e);
                    }
                }), p = i(l), h = i(async (a)=>{
                    const { callback: n } = a;
                    o({
                        saving: !0,
                        error: null
                    });
                    try {
                        var i, r;
                        const a = null != (i = (null == (r = e.auth.userIpData) ? void 0 : r.ip) || e.auth.userIp) ? i : "";
                        await Promise.all([
                            t.auth.createIPRestriction({
                                ip: a,
                                isActive: !0,
                                description: "My IP",
                                strategy: Xe.ALLOW
                            }),
                            t.auth.updateIPRestrictionConfig({
                                isActive: !0
                            })
                        ]);
                        const l = e.auth.restrictionsState.ipRestrictions, c = s(l.pagination), { items: u, _metadata: { totalPages: d } } = await t.auth.getIPRestrictions(c), g = u;
                        o({
                            data: {
                                config: {
                                    isActive: !0,
                                    strategy: Xe.ALLOW
                                },
                                restrictions: g
                            },
                            userIpValid: !0,
                            pagination: c,
                            totalPages: d,
                            saving: !1
                        }), null == n || n(!0);
                    } catch (e) {
                        o({
                            saving: !1,
                            error: e
                        }), null == n || n(!1, e);
                    }
                }), y = i(async ()=>{
                    r({
                        loading: !0,
                        error: null
                    });
                    try {
                        const e = await t.auth.getDomainRestrictionsConfig(), a = (await t.auth.getDomainRestrictions()).items.filter((t)=>t.type === e.listType);
                        r({
                            data: {
                                restrictions: a,
                                config: e
                            },
                            loading: !1
                        });
                    } catch (e) {
                        r({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }), S = i(async (a)=>{
                    const { callback: n } = a, s = f(a, zr);
                    r({
                        saving: !0,
                        error: null
                    });
                    const i = e.auth.restrictionsState.emailDomainRestrictions;
                    try {
                        var o;
                        await t.auth.createDomainRestriction(s);
                        const e = (await t.auth.getDomainRestrictions()).items.filter((e)=>{
                            var t;
                            return e.type === (null == (t = i.data) ? void 0 : t.config.listType);
                        });
                        r({
                            data: {
                                config: (null == (o = i.data) ? void 0 : o.config) || {
                                    active: !1,
                                    blockPublicDomains: !1,
                                    listType: s.type
                                },
                                restrictions: e
                            },
                            saving: !1
                        }), null == n || n(!0);
                    } catch (e) {
                        r({
                            saving: !1,
                            error: Kn(e)
                        }), null == n || n(null, e);
                    }
                }), m = i(async (e)=>{
                    const { callback: a } = e, n = f(e, Hr);
                    r({
                        saving: !0,
                        error: null
                    });
                    try {
                        const e = await t.auth.updateDomainRestrictionConfig(n), s = (await t.auth.getDomainRestrictions()).items.filter((t)=>t.type === e.listType);
                        r({
                            data: {
                                config: e,
                                restrictions: s
                            },
                            saving: !1
                        }), null == a || a(!0);
                    } catch (e) {
                        r({
                            saving: !1,
                            error: Kn(e)
                        }), null == a || a(null, e);
                    }
                }), b = i(async (a)=>{
                    const { id: n } = a;
                    r({
                        saving: !0,
                        error: null
                    });
                    const s = e.auth.restrictionsState.emailDomainRestrictions;
                    try {
                        var i;
                        await t.auth.deleteDomainRestriction(n);
                        const e = (await t.auth.getDomainRestrictions()).items.filter((e)=>{
                            var t;
                            return e.type === (null == (t = s.data) ? void 0 : t.config.listType);
                        });
                        r({
                            data: {
                                config: (null == (i = s.data) ? void 0 : i.config) || {
                                    active: !1,
                                    blockPublicDomains: !1,
                                    listType: Xe.ALLOW
                                },
                                restrictions: e
                            },
                            saving: !1
                        });
                    } catch (e) {
                        r({
                            saving: !1,
                            error: Kn(e)
                        });
                    }
                });
                return {
                    setRestrictionsState: (t)=>{
                        Object.assign(e.auth.restrictionsState, t);
                    },
                    setIpRestrictionsState: o,
                    setEmailDomainRestrictionsState: r,
                    __securityCenterSagaWrapper: i,
                    loadIpRestrictions: c,
                    saveIpRestriction: u,
                    saveIpRestrictionsConfig: d,
                    deleteIpRestriction: g,
                    checkIfUserIpValid: p,
                    addCurrentUserIpAndActivate: h,
                    loadEmailDomainRestrictions: y,
                    saveEmailDomainRestriction: S,
                    saveEmailDomainRestrictionsConfig: m,
                    deleteEmailDomainRestriction: b
                };
            }, qr = {
                loaders: {},
                errors: {},
                recommendations: void 0,
                insights: void 0,
                hasSecurityChanges: !1,
                score: 0,
                breachedPasswordUsersTable: {
                    users: [],
                    usersPageOffset: 0,
                    totalUsersItems: 0,
                    totalUsersPages: 0,
                    queryParams: {
                        _offset: 0,
                        _limit: 10
                    }
                },
                unenrolledMfaUsersTable: {
                    users: [],
                    usersPageOffset: 0,
                    totalUsersItems: 0,
                    totalUsersPages: 0,
                    queryParams: {
                        _offset: 0,
                        _limit: 10
                    }
                },
                inactiveUsersTable: {
                    users: [],
                    usersPageOffset: 0,
                    totalUsersItems: 0,
                    totalUsersPages: 0,
                    queryParams: {
                        _offset: 0,
                        _limit: 10,
                        _maxInactiveSeconds: 7776e3
                    }
                }
            }, Yr = (e)=>hn(qr, e);
            let Jr;
            !function(e) {
                e.RECOMMENDATIONS = "recommendations", e.INSIGHTS = "insights", e.SEND_BULK_RESET_BREACHED_PASSWORD_EMAILS = "sendBulkResetBreachedPasswordEmails", e.SEND_BREACHED_PASSWORD_EMAIL = "sendBreachedPasswordEmail", e.BREACHED_PASSWORD_USERS_TABLE = "breachedPasswordUsersTable", e.UNENROLLED_MFA_USERS_TABLE = "unenrolledMfaUsersTable", e.INACTIVE_USERS_TABLE = "inactiveUsersTable";
            }(Jr || (Jr = {}));
            const Qr = [
                "callback"
            ], Xr = (e, t, a)=>{
                const n = a, s = async (e)=>{
                    var a, s, l, c;
                    const { key: u, tableState: d, updateStateKey: g, _offset: p, _limit: h, _preset: y, _email: S, _maxInactiveSeconds: f } = e;
                    r({
                        key: u,
                        value: !1
                    }), o({
                        key: u,
                        value: !0
                    });
                    const m = null != (a = null != p ? p : null == d || null == (s = d.queryParams) ? void 0 : s._offset) ? a : 0, b = null != (l = null != h ? h : null == d || null == (c = d.queryParams) ? void 0 : c._limit) ? l : 10, A = v({
                        _offset: m,
                        _limit: b,
                        _includeSubTenants: !1,
                        _preset: y,
                        _maxInactiveSeconds: f
                    }, !!S && {
                        _email: S
                    });
                    try {
                        const { items: e, _metadata: { totalItems: a, totalPages: s } } = await t.users.getUsersV3(A), o = {
                            totalUsersItems: a,
                            totalUsersPages: s,
                            usersPageOffset: m,
                            queryParams: v({
                                _offset: m,
                                _limit: b,
                                _maxInactiveSeconds: f
                            }, !!S && {
                                _email: S
                            })
                        };
                        if (e.length) {
                            const a = await (async (e)=>{
                                const a = e.map((e)=>e.id), n = await t.roles.getRoles(), s = await t.users.getUsersRoles({
                                    ids: a
                                });
                                return e.map((e)=>{
                                    var t, a;
                                    const i = null == s || null == (t = s.find((t)=>t.userId === e.id)) ? void 0 : t.roleIds;
                                    return v({}, e, {
                                        roles: null != (a = null == i ? void 0 : i.map((e)=>{
                                            var t;
                                            return null != (t = null == n ? void 0 : n.find((t)=>t.id === e)) ? t : [];
                                        })) ? a : []
                                    });
                                });
                            })(e);
                            n.setSecurityCenterState({
                                [g]: v({
                                    users: a
                                }, o)
                            });
                        } else i({
                            [g]: v({
                                users: []
                            }, o)
                        });
                    } catch (e) {
                        r({
                            key: u,
                            value: Kn(e)
                        });
                    } finally{
                        o({
                            key: u,
                            value: !1
                        });
                    }
                }, i = (t)=>{
                    Object.assign(e.auth.securityCenterState, t);
                }, o = (t)=>{
                    Object.assign(e.auth.securityCenterState, {
                        loaders: v({}, e.auth.securityCenterState.loaders, {
                            [t.key]: t.value
                        })
                    });
                }, r = (t)=>{
                    Object.assign(e.auth.securityCenterState, {
                        errors: v({}, e.auth.securityCenterState.errors, {
                            [t.key]: t.value
                        }),
                        loaders: v({}, e.auth.securityCenterState.loaders, {
                            [t.key]: !1
                        })
                    });
                };
                return {
                    setSecurityCenterState: i,
                    resetSecurityCenterState: ()=>{
                        Wn(e, [
                            "auth",
                            "securityCenterState"
                        ], qr);
                    },
                    setSecurityCenterStateLoader: o,
                    setSecurityCenterStateError: r,
                    loadRecommendations: async (e)=>{
                        const a = Jr.RECOMMENDATIONS;
                        o({
                            key: a,
                            value: !0
                        });
                        try {
                            var n;
                            const { recommendations: a, scoring: s } = await xn(()=>t.securityCenter.getRecommendations(), null == e ? void 0 : e.retryConfig);
                            i({
                                recommendations: a.items,
                                score: null != (n = null == s ? void 0 : s.score) ? n : 0
                            });
                        } catch (e) {
                            r({
                                key: a,
                                value: Kn(e)
                            });
                        } finally{
                            o({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    loadInsights: async (e)=>{
                        const a = Jr.INSIGHTS;
                        o({
                            key: a,
                            value: !0
                        });
                        try {
                            const { insights: a } = await await xn(()=>t.securityCenter.getInsights(), null == e ? void 0 : e.retryConfig);
                            i({
                                insights: a.items
                            });
                        } catch (e) {
                            r({
                                key: a,
                                value: Kn(e)
                            });
                        } finally{
                            o({
                                key: a,
                                value: !1
                            });
                        }
                    },
                    sendResetBreachedPasswordEmail: async (e)=>{
                        const { callback: a } = e, n = f(e, Qr), s = Jr.SEND_BREACHED_PASSWORD_EMAIL;
                        r({
                            key: s,
                            value: !1
                        }), o({
                            key: s,
                            value: !0
                        });
                        try {
                            await t.auth.forgotPassword(n), null == a || a(!0);
                        } catch (e) {
                            r({
                                key: s,
                                value: Kn(e)
                            }), null == a || a(!1, e);
                        } finally{
                            o({
                                key: s,
                                value: !1
                            });
                        }
                    },
                    sendBulkResetBreachedPasswordEmails: async (e)=>{
                        const { callback: a } = e, n = Jr.SEND_BULK_RESET_BREACHED_PASSWORD_EMAILS;
                        r({
                            key: n,
                            value: !1
                        }), o({
                            key: n,
                            value: !0
                        });
                        try {
                            await t.users.sendResetBreachedPasswordEmails(), null == a || a(!0);
                        } catch (e) {
                            r({
                                key: n,
                                value: Kn(e)
                            }), null == a || a(!1);
                        } finally{
                            o({
                                key: n,
                                value: !1
                            });
                        }
                    },
                    loadBreachedPasswordUsers: async (t)=>{
                        var a;
                        const n = Jr.BREACHED_PASSWORD_USERS_TABLE, i = null == (a = e.auth.securityCenterState) ? void 0 : a.breachedPasswordUsersTable;
                        await s(v({
                            key: n,
                            updateStateKey: "breachedPasswordUsersTable",
                            _preset: Za.BREACHED_PASSWORDS,
                            tableState: i
                        }, t));
                    },
                    loadUnenrolledMfaUsers: async (t)=>{
                        var a;
                        const n = Jr.UNENROLLED_MFA_USERS_TABLE, i = null == (a = e.auth.securityCenterState) ? void 0 : a.unenrolledMfaUsersTable;
                        await s(v({
                            key: n,
                            updateStateKey: "unenrolledMfaUsersTable",
                            _preset: Za.MFA_UNENROLLED,
                            tableState: i
                        }, t));
                    },
                    loadInactiveUsers: async (t)=>{
                        var a;
                        const n = Jr.INACTIVE_USERS_TABLE, i = null == (a = e.auth.securityCenterState) ? void 0 : a.inactiveUsersTable;
                        await s(v({
                            key: n,
                            updateStateKey: "inactiveUsersTable",
                            _preset: Za.INACTIVE,
                            tableState: i
                        }, t));
                    },
                    markSecurityCenterStateAsChanged: (e = !0)=>{
                        i({
                            hasSecurityChanges: e
                        });
                    }
                };
            }, Zr = {
                globalPolicy: {
                    loading: !0
                },
                publicPolicy: {
                    loading: !1
                },
                vendorMfaPolicy: {
                    loading: !0
                },
                mfaPolicy: {
                    loading: !0
                },
                vendorLockoutPolicy: {
                    loading: !0
                },
                lockoutPolicy: {
                    loading: !0
                },
                captchaPolicy: {
                    loading: !0
                },
                passwordHistoryPolicy: {
                    loading: !0
                },
                passwordPolicy: {
                    loading: !0
                },
                vendorPasswordHistoryPolicy: {
                    loading: !0
                },
                publicAuthStrategyPolicy: {
                    loading: !0
                },
                passwordRotationPolicy: {
                    loading: !0
                }
            }, el = (e)=>hn(Zr, e);
            function tl(e, t) {
                const a = null != t, n = null != e;
                if (a || n) return a ? n ? Math.min(e, t) : t : e;
            }
            const al = [
                "callback"
            ], nl = [
                "callback"
            ], sl = [
                "callback"
            ], il = [
                "callback"
            ], ol = (e, t, a)=>{
                const n = a, s = async (e, t)=>{
                    var a, s;
                    if (!await n.customLoginEnabled()) return e;
                    const o = await i(t);
                    return null != o && null != (a = o.mainAuthStrategies) && null != (s = a[0]) && s.strategy ? v({}, e, {
                        authStrategy: o.mainAuthStrategies[0].strategy
                    }) : e;
                }, i = async (a)=>{
                    let n;
                    return n = e.auth.isAuthenticated ? await xn(t.auth.getPublicAuthStrategiesConfigForAuthenticatedUser, a) : await xn(t.auth.getVendorPublicAuthStrategiesConfig, a), n;
                }, o = (t)=>{
                    Object.assign(e.auth.securityPolicyState.globalPolicy, t);
                }, r = (t)=>{
                    Object.assign(e.auth.securityPolicyState.publicPolicy, t);
                }, l = (t)=>{
                    Object.assign(e.auth.securityPolicyState.mfaPolicy, t);
                }, c = (t)=>{
                    Object.assign(e.auth.securityPolicyState.vendorMfaPolicy, t);
                }, u = (t)=>{
                    Object.assign(e.auth.securityPolicyState.lockoutPolicy, t);
                }, d = (t)=>{
                    Object.assign(e.auth.securityPolicyState.vendorLockoutPolicy, t);
                }, g = (t)=>{
                    Object.assign(e.auth.securityPolicyState.captchaPolicy, t);
                }, p = (t)=>{
                    Object.assign(e.auth.securityPolicyState.passwordHistoryPolicy, t);
                }, h = (t)=>{
                    Object.assign(e.auth.securityPolicyState.vendorPasswordHistoryPolicy, t);
                }, y = (t)=>{
                    Object.assign(e.auth.securityPolicyState.passwordRotationPolicy, t);
                }, S = (t)=>{
                    Object.assign(e.auth.securityPolicyState.passwordPolicy, t);
                }, m = (t)=>{
                    Object.assign(e.auth.securityPolicyState.publicAuthStrategyPolicy, t);
                }, b = async (e)=>{
                    o({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await xn(()=>t.auth.getGlobalSecurityPolicy(), null == e ? void 0 : e.retryConfig);
                        o({
                            policy: a,
                            loading: !1
                        });
                    } catch (e) {
                        o({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }, A = async (e)=>{
                    l({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await xn(()=>t.auth.getMfaPolicy(), null == e ? void 0 : e.retryConfig);
                        l({
                            policy: a,
                            loading: !1
                        });
                    } catch (e) {
                        l({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }, w = async (e)=>{
                    l({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await xn(()=>t.auth.getVendorMfaPolicy(), null == e ? void 0 : e.retryConfig);
                        c({
                            policy: a,
                            loading: !1
                        });
                    } catch (e) {
                        c({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }, T = async (e)=>{
                    u({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await xn(()=>t.auth.getLockoutPolicy(), null == e ? void 0 : e.retryConfig);
                        u({
                            policy: a,
                            loading: !1
                        });
                    } catch (e) {
                        u({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }, E = async (e)=>{
                    d({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await xn(()=>t.auth.getVendorLockoutPolicy(), null == e ? void 0 : e.retryConfig);
                        d({
                            policy: a,
                            loading: !1
                        });
                    } catch (e) {
                        d({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }, P = async (e)=>{
                    u({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await xn(()=>t.auth.getCaptchaPolicy(), null == e ? void 0 : e.retryConfig);
                        g({
                            policy: a,
                            loading: !1
                        });
                    } catch (e) {
                        g({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }, I = async (e)=>{
                    h({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await xn(()=>t.auth.getVendorPasswordHistoryPolicy(), null == e ? void 0 : e.retryConfig);
                        h({
                            policy: a,
                            loading: !1
                        });
                    } catch (e) {
                        h({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                }, O = async (t)=>{
                    m({
                        loading: !0,
                        error: null
                    });
                    try {
                        var a, s, o;
                        const l = await i(null == t ? void 0 : t.retryConfig);
                        await (async (t)=>{
                            var a, s;
                            const i = await n.customLoginEnabled();
                            if (!t || !i) return;
                            const { policy: o } = null != (a = null == (s = e.auth.securityPolicyState) ? void 0 : s.publicPolicy) ? a : {
                                policy: null
                            };
                            r({
                                policy: v({}, o, {
                                    authStrategy: t
                                }),
                                loading: !1
                            });
                        })(null == l || null == (a = l.mainAuthStrategies) || null == (s = a[0]) ? void 0 : s.strategy), m({
                            policy: l,
                            loading: !1
                        }), null == t || null == (o = t.callback) || o.call(t, l);
                    } catch (e) {
                        var l;
                        m({
                            error: Kn(e),
                            loading: !1
                        }), null == t || null == (l = t.callback) || l.call(t, null, e);
                    }
                };
                return {
                    setSecurityPolicyState: (t)=>{
                        Object.assign(e.auth.securityPolicyState, t);
                    },
                    setSecurityPolicyGlobalState: o,
                    setSecurityPolicyPublicState: r,
                    setSecurityPolicyMfaState: l,
                    setSecurityPolicyVendorMfaState: c,
                    setSecurityPolicyLockoutState: u,
                    setSecurityPolicyVendorLockoutState: d,
                    setSecurityPolicyCaptchaState: g,
                    setSecurityPolicyPasswordHistoryState: p,
                    setSecurityPolicyVendorPasswordHistoryState: h,
                    setSecurityPolicyPasswordRotationState: y,
                    resetSecurityPolicyState: ()=>{
                        Wn(e, [
                            "auth",
                            "securityPolicyState"
                        ], Zr);
                    },
                    setSecurityPolicyPasswordState: S,
                    setSecurityPolicyAuthStrategyPublicState: m,
                    loadSecurityPolicy: async (e)=>{
                        const t = {
                            retryConfig: null == e ? void 0 : e.retryConfig
                        };
                        await Promise.all([
                            b(),
                            A(),
                            w(t),
                            T(t),
                            E(t),
                            I(),
                            P(t),
                            O(t)
                        ]);
                    },
                    loadGlobalSecurityPolicy: b,
                    loadPublicSecurityPolicy: async (e)=>{
                        r({
                            loading: !0,
                            error: null
                        });
                        try {
                            const a = await t.auth.getVendorConfig(), n = await s(a, null == e ? void 0 : e.retryConfig);
                            r({
                                policy: n,
                                loading: !1
                            });
                        } catch (e) {
                            r({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    loadVendorPasswordConfig: async (e)=>{
                        S({
                            loading: !0,
                            error: null
                        });
                        try {
                            var a;
                            const n = await xn(()=>t.auth.getPasswordConfigPolicy(), null == e ? void 0 : e.retryConfig);
                            S({
                                policy: n,
                                loading: !1
                            }), null == e || null == (a = e.callback) || a.call(e, n);
                        } catch (t) {
                            var n;
                            S({
                                error: Kn(t),
                                loading: !1
                            }), null == e || null == (n = e.callback) || n.call(e, null, t);
                        }
                    },
                    loadSecurityPolicyMfa: A,
                    loadSecurityPolicyVendorMfa: w,
                    loadSecurityPolicyLockout: T,
                    loadSecurityPolicyVendorLockout: E,
                    loadSecurityPolicyCaptcha: P,
                    loadSecurityPolicyPasswordHistory: async ()=>{
                        p({
                            loading: !0,
                            error: null
                        });
                        try {
                            const e = await t.auth.getPasswordHistoryPolicy();
                            p({
                                policy: e,
                                loading: !1
                            });
                        } catch (e) {
                            p({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    loadSecurityPolicyVendorPasswordHistory: I,
                    loadSecurityPolicyPasswordRotation: async ()=>{
                        y({
                            loading: !0,
                            error: null
                        });
                        try {
                            const e = await t.securityPolicy.getPasswordRotationPolicy(), a = await t.securityPolicy.getVendorPasswordRotationPolicy(), n = {
                                passwordRotationVendorConfig: a
                            };
                            e && (null != a && a.isActive ? n.passwordRotationTenantConfig = null != e && e.isActive ? v({}, e, {
                                rotationPeriod: tl(a.rotationPeriod, e.rotationPeriod)
                            }) : a : n.passwordRotationTenantConfig = e), y({
                                policy: v({}, n),
                                loading: !1
                            });
                        } catch (e) {
                            y({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    loadPublicAuthStrategiesPolicy: O,
                    saveSecurityPolicyMfa: async (e)=>{
                        const { callback: a } = e, n = f(e, al);
                        l({
                            saving: !0,
                            error: null
                        });
                        try {
                            const e = await t.auth.securityPolicy.saveMfaPolicy(n);
                            l({
                                policy: e,
                                saving: !1
                            }), null == a || a(e);
                        } catch (e) {
                            l({
                                saving: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    saveSecurityPolicyLockout: async (e)=>{
                        const { callback: a } = e, n = f(e, nl);
                        u({
                            saving: !0,
                            error: null
                        });
                        try {
                            const e = await t.auth.saveLockoutPolicy(n);
                            u({
                                policy: e,
                                saving: !1
                            }), null == a || a(e);
                        } catch (e) {
                            u({
                                saving: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    saveSecurityPolicyPasswordHistory: async (e)=>{
                        const { callback: a } = e, n = f(e, sl);
                        p({
                            saving: !0,
                            error: null
                        });
                        try {
                            const e = await t.auth.savePasswordHistoryPolicy(n);
                            p({
                                policy: e,
                                saving: !1
                            }), null == a || a(e);
                        } catch (e) {
                            p({
                                saving: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    saveSecurityPolicyPasswordRotation: async (e)=>{
                        const { callback: a } = e, n = f(e, il);
                        y({
                            saving: !0,
                            error: null
                        });
                        try {
                            await t.securityPolicy.savePasswordRotationPolicy(n.passwordRotationTenantConfig || {}), y({
                                policy: n,
                                saving: !1
                            }), null == a || a(n);
                        } catch (e) {
                            y({
                                saving: !1,
                                error: Kn(e)
                            }), null == a || a(null, e);
                        }
                    },
                    __getSecurityPolicyPublicStateWithCustomLogin: s
                };
            }, rl = {
                loading: !1,
                configurations: {}
            }, ll = (e)=>hn(rl, e), cl = [
                "callback"
            ], ul = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.sessionsPolicyState, t);
                };
                return {
                    setSessionsPolicyState: s,
                    resetSessionsPolicyState: ()=>{
                        Wn(e, [
                            "auth",
                            "sessionsPolicyState"
                        ], rl);
                    },
                    loadSessionsPolicy: async ()=>{
                        s({
                            loading: !0,
                            error: null
                        });
                        try {
                            const e = await t.auth.getSessionConfigurations();
                            s({
                                configurations: e,
                                loading: !1
                            });
                        } catch (e) {
                            n.setSessionsState({
                                error: e,
                                loading: !1
                            });
                        }
                    },
                    createOrUpdateSessionsPolicy: async (e)=>{
                        const { callback: a } = e, i = f(e, cl);
                        try {
                            s({
                                loading: !0,
                                error: null
                            }), await t.auth.createOrUpdateSessionConfigrations(i), await n.loadSessionsPolicy(), null == a || a(!0);
                        } catch (e) {
                            s({
                                error: e,
                                loading: !1
                            });
                        }
                    }
                };
            }, dl = {
                loading: !1,
                sessions: []
            }, gl = (e)=>hn(dl, e), pl = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.sessionsState, t);
                }, s = async (e)=>{
                    n({
                        loading: !0,
                        error: null
                    });
                    try {
                        const a = await xn(()=>t.auth.getCurrentUserSessions(), null == e ? void 0 : e.retryConfig);
                        n({
                            sessions: a,
                            loading: !1
                        });
                    } catch (e) {
                        n({
                            error: Kn(e),
                            loading: !1
                        });
                    }
                };
                return {
                    setSessionsState: n,
                    resetSessionsState: ()=>{
                        Wn(e, [
                            "auth",
                            "sessionsState"
                        ], dl);
                    },
                    loadUserSessions: s,
                    loadCurrentUserSession: async ()=>{
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            const e = await t.auth.getCurrentUserSession();
                            n({
                                currentSession: e,
                                loading: !1
                            });
                        } catch (e) {
                            n({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    deleteUserSession: async (e)=>{
                        const { id: a } = e;
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await t.auth.deleteSessionForUser(a), await s();
                        } catch (e) {
                            n({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    deleteAllUserSessions: async ()=>{
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await t.auth.deleteAllSessionsForUser(), await s();
                        } catch (e) {
                            n({
                                error: Kn(e),
                                loading: !1
                            });
                        }
                    },
                    revokeUserSessions: async (e)=>{
                        const { callback: a, userId: s } = e;
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            await t.auth.revokeSessionsForUser(s), n({
                                loading: !1
                            }), null == a || a(!0);
                        } catch (e) {
                            n({
                                error: Kn(e),
                                loading: !1
                            }), null == a || a(!1);
                        }
                    }
                };
            };
            let hl;
            !function(e) {
                e.SignUp = "SignUp", e.SignUpSuccess = "SignUpSuccess", e.VerifyPhone = "VerifyPhone";
            }(hl || (hl = {}));
            const yl = {
                loading: !1,
                allowSignUps: !1,
                allowNotVerifiedUsersLogin: !1,
                firstLoad: !0,
                stage: hl.SignUp,
                strategies: {
                    [x.Email]: {
                        enabled: !0,
                        required: !0
                    },
                    [x.PhoneNumber]: {
                        enabled: !1,
                        required: !1
                    },
                    [x.Username]: {
                        enabled: !1,
                        required: !1
                    }
                }
            }, Sl = (e)=>hn(yl, e), vl = [
                "events",
                "url"
            ], fl = [
                "events",
                "url"
            ], ml = [
                "events",
                "url"
            ], bl = (e, t, a)=>{
                const n = a, s = L.for(e.root.appName), i = (t)=>{
                    Object.assign(e.auth.signUpState, t);
                }, o = ()=>{
                    Wn(e, [
                        "auth",
                        "signUpState"
                    ], yl);
                }, r = (e, t, a, n, s, i = ss.PASSWORD)=>{
                    var o;
                    const { email: r, name: l, companyName: c, phoneNumber: u, url: d } = e, g = {
                        email: r,
                        name: l,
                        companyName: c,
                        url: d,
                        phoneNumber: u || void 0,
                        authenticationType: i,
                        id: t,
                        tenantId: a,
                        createdAt: new Date,
                        activationToken: n
                    };
                    null == s || null == (o = s.signUpComplete) || o.call(s, g), cs(rs.SIGNUP_COMPLETED, g);
                };
                return {
                    setSignUpState: i,
                    resetSignUpState: o,
                    resetSignUpStateSoft: ()=>{
                        const { allowSignUps: t, allowNotVerifiedUsersLogin: a } = e.auth.signUpState;
                        o(), i({
                            allowSignUps: t,
                            allowNotVerifiedUsersLogin: a
                        });
                    },
                    signUpUser: async (a)=>{
                        const { events: o } = a, l = f(a, ml);
                        i({
                            loading: !0
                        });
                        const c = e.auth.signUpState.strategies.phoneNumber;
                        if (null != c && c.required && null != c && c.enabled && l.phoneNumber) return (async (a)=>{
                            const { events: o } = a, l = f(a, vl);
                            if (i({
                                loading: !0
                            }), !l.phoneNumber) throw new Error("Phone number is required for phone number signup");
                            try {
                                var c, u, d;
                                const { routes: a, onRedirectTo: s } = e.auth, { tenantId: i, userId: g, activationToken: p } = await t.auth.signUpUserWithPhoneNumber(Cs(l));
                                l.invitationToken || r(l, g, i, p, o, ss.PHONE_NUMBER);
                                const { enabled: h, siteKey: y } = null != (c = e.auth.securityPolicyState.captchaPolicy.policy) ? c : {}, S = h && y ? await (null == (u = window.grecaptcha) || null == (d = u.execute) ? void 0 : d.call(u, {
                                    action: "login"
                                })) : "";
                                n.passwordlessPreLogin({
                                    recaptchaToken: S,
                                    phoneNumber: l.phoneNumber,
                                    type: M.SmsCode,
                                    callback: (e, t)=>{
                                        if (!e && t) throw t;
                                        s(a.loginUrl), n.setLoginState({
                                            step: On.loginWithSmsOtc,
                                            phoneNumber: l.phoneNumber
                                        });
                                    }
                                });
                            } catch (e) {
                                s.setAccessToken(null), s.setUser(null), i({
                                    error: Kn(e)
                                });
                            } finally{
                                i({
                                    loading: !1
                                });
                            }
                        })(a);
                        const u = e.auth.signUpState.strategies.username;
                        if (null != u && u.required && null != u && u.enabled && l.username) return (async (a)=>{
                            const { events: o } = a, l = f(a, fl);
                            if (i({
                                loading: !0
                            }), !l.username) throw new Error("Username is required for username signup");
                            try {
                                const { routes: a, onRedirectTo: s } = e.auth, { shouldActivate: c, user: u, tenantId: d, userId: g, tenants: p = [], activeTenant: h, activationToken: y } = await t.auth.signUpUserWithUsername(Cs(l));
                                if (l.invitationToken || r(l, g, d, y, o, ss.USERNAME), !c && u && _s(u, e.root.appName)) {
                                    const e = await n.getMfaRequiredState(u, Nn, !0, l.email);
                                    n.setAuthState(e), s(a.loginUrl);
                                } else if (c && y) {
                                    const e = new URLSearchParams({
                                        userId: g || "",
                                        token: y || ""
                                    }), t = `${a.activateWithOTCUrl}?${e.toString()}`;
                                    i({
                                        loading: !1,
                                        shouldActivate: c,
                                        stage: hl.SignUpSuccess
                                    }), s(t);
                                } else {
                                    const t = e.auth.tenantsState;
                                    i({
                                        loading: !1,
                                        shouldActivate: c,
                                        stage: hl.SignUpSuccess
                                    }), n.setAuthState({
                                        user: u,
                                        isAuthenticated: !(null == u || !u.accessToken),
                                        tenantsState: v({}, t, {
                                            tenants: p,
                                            activeTenant: h
                                        })
                                    });
                                }
                            } catch (e) {
                                s.setAccessToken(null), s.setUser(null), i({
                                    error: Kn(e)
                                });
                            } finally{
                                i({
                                    loading: !1
                                });
                            }
                        })(a);
                        try {
                            const { routes: a, onRedirectTo: s } = e.auth, { shouldActivate: c, user: u, tenantId: d, userId: g, tenants: p = [], activeTenant: h, activationToken: y } = await t.auth.signUpUser(Cs(l));
                            if (l.invitationToken || r(l, g, d, y, o), !c && u && _s(u, e.root.appName)) {
                                const e = await n.getMfaRequiredState(u, Nn, !0, l.email);
                                n.setAuthState(e), s(a.loginUrl);
                            } else if (c && y) {
                                const e = new URLSearchParams({
                                    userId: g || "",
                                    token: y || ""
                                }), t = `${a.activateWithOTCUrl}?${e.toString()}`;
                                i({
                                    loading: !1,
                                    shouldActivate: c,
                                    stage: hl.SignUpSuccess
                                }), s(t);
                            } else {
                                const t = e.auth.tenantsState;
                                i({
                                    loading: !1,
                                    shouldActivate: c,
                                    stage: hl.SignUpSuccess
                                }), n.setAuthState({
                                    user: u,
                                    isAuthenticated: !(null == u || !u.accessToken),
                                    tenantsState: v({}, t, {
                                        tenants: p,
                                        activeTenant: h
                                    })
                                });
                            }
                        } catch (e) {
                            s.setAccessToken(null), s.setUser(null), i({
                                error: Kn(e)
                            });
                        } finally{
                            i({
                                loading: !1
                            });
                        }
                    },
                    loadAllowSignUps: async (e)=>{
                        i({
                            loading: !0
                        });
                        try {
                            var a;
                            const s = await xn(t.auth.getVendorConfig, null == e ? void 0 : e.retryConfig), o = await n.__getSecurityPolicyPublicStateWithCustomLogin(s, null == e ? void 0 : e.retryConfig), { allowSignups: r, allowNotVerifiedUsersLogin: l } = s;
                            i({
                                loading: !1,
                                allowSignUps: r,
                                allowNotVerifiedUsersLogin: l,
                                firstLoad: !1
                            }), n.setSecurityPolicyPublicState({
                                policy: o,
                                loading: !1
                            }), null == e || null == (a = e.callback) || a.call(e, o || s);
                        } catch (t) {
                            var s;
                            i({
                                loading: !1,
                                error: Kn(t),
                                firstLoad: !1
                            }), null == e || null == (s = e.callback) || s.call(e, null, t);
                        }
                    },
                    loadSignUpStrategies: async ()=>{
                        try {
                            const e = await t.auth.getSignUpStrategies();
                            i({
                                strategies: e.reduce((e, { isActive: t, strategy: a, isRequired: n })=>(e[a] = {
                                        enabled: t,
                                        required: n
                                    }, e), {})
                            });
                        } catch (e) {}
                    }
                };
            }, Al = {
                loading: !1,
                error: null,
                phoneNumbers: void 0
            }, wl = (e)=>hn(Al, e), Tl = [
                "callback"
            ], El = [
                "callback"
            ], Pl = [
                "callback"
            ], Il = [
                "callback",
                "phoneId"
            ], Ol = [
                "callback",
                "phoneId"
            ], kl = [
                "callback"
            ], _l = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.smsState, t);
                }, s = async ()=>{
                    n({
                        loading: !0
                    });
                    const e = {
                        _limit: 10,
                        _offset: 0
                    };
                    try {
                        const { items: a } = await t.userPhoneNumbers.getUserPhoneNumbers(e);
                        n({
                            phoneNumbers: a
                        });
                    } catch (e) {
                        n({
                            error: Kn(e)
                        });
                    } finally{
                        n({
                            loading: !1
                        });
                    }
                }, i = async ()=>{
                    n({
                        loading: !0
                    });
                    try {
                        const e = await t.userPhoneNumbers.getUserOwnPhoneNumbers();
                        n({
                            phoneNumbers: e
                        });
                    } catch (e) {
                        n({
                            error: Kn(e)
                        });
                    } finally{
                        n({
                            loading: !1
                        });
                    }
                };
                return {
                    setSmsState: n,
                    resetSmsState: ()=>{
                        Wn(e, [
                            "auth",
                            "smsState"
                        ], Al);
                    },
                    loadPhoneNumbers: s,
                    loadUserOwnPhoneNumbers: i,
                    setUpPhoneNumber: async (e)=>{
                        const { callback: a } = e, i = f(e, El);
                        try {
                            const { otcToken: e } = await t.userPhoneNumbers.createPhoneNumber(i);
                            n({
                                otcToken: e
                            }), await s(), null == a || a(!0);
                        } catch (e) {
                            n({
                                error: Kn(e)
                            }), null == a || a(!1, e);
                        }
                    },
                    setUpOwnPhoneNumber: async (e)=>{
                        const { callback: a } = e, s = f(e, Tl);
                        try {
                            const { otcToken: e } = await t.userPhoneNumbers.createPhoneNumber(s);
                            n({
                                otcToken: e
                            }), await i(), null == a || a(!0);
                        } catch (e) {
                            n({
                                error: Kn(e)
                            }), null == a || a(!1, e);
                        }
                    },
                    verifyPhoneNumber: async (e)=>{
                        const { callback: a } = e, i = f(e, Pl);
                        n({
                            loading: !0
                        });
                        try {
                            await t.userPhoneNumbers.verifyPhoneNumber(i), await s(), null == a || a(!0);
                        } catch (e) {
                            n({
                                error: Kn(e)
                            }), null == a || a(!1, e);
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    },
                    deletePhoneNumber: async (e)=>{
                        const { callback: a, phoneId: s } = e;
                        f(e, Il), n({
                            loading: !0
                        });
                        try {
                            const { otcToken: e } = await t.userPhoneNumbers.deletePhoneNumber(s);
                            n({
                                otcToken: e
                            }), null == a || a(!0);
                        } catch (e) {
                            n({
                                error: Kn(e)
                            }), null == a || a(!1, e);
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    },
                    verifyDeletePhoneNumber: async (e)=>{
                        const { callback: a, phoneId: i } = e, o = f(e, Ol);
                        n({
                            loading: !0
                        });
                        try {
                            await t.userPhoneNumbers.verifyDeletePhoneNumber(i, o), await s(), null == a || a(!0);
                        } catch (e) {
                            n({
                                error: Kn(e)
                            }), null == a || a(!1, e);
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    },
                    preVerifyPhoneNumber: async (e)=>{
                        const { callback: a } = e, s = f(e, kl);
                        n({
                            loading: !0
                        });
                        try {
                            const { otcToken: e } = await t.userPhoneNumbers.preVerifyPhoneNumber(s);
                            n({
                                otcToken: e
                            }), null == a || a(!0);
                        } catch (e) {
                            n({
                                error: Kn(e)
                            }), null == a || a(!1, e);
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    }
                };
            }, Rl = {
                firstLoad: !0,
                loading: !1,
                error: ""
            }, Ul = (e)=>hn(Rl, e), Ll = [
                "authorizationUrl"
            ], Cl = [
                "events",
                "url"
            ], Dl = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.socialLoginState, t);
                };
                return {
                    setSocialLoginsState: s,
                    resetSocialLoginsState: ()=>{
                        Wn(e, [
                            "auth",
                            "socialLoginState"
                        ], Rl);
                    },
                    setSocialLoginError: (e)=>{
                        s({
                            error: e.error,
                            loading: !1,
                            firstLoad: !1
                        });
                    },
                    loadSocialLoginsConfiguration: async ()=>{
                        try {
                            s({
                                loading: !0
                            });
                            const e = await t.auth.getSocialLoginProviders();
                            s({
                                socialLoginsConfig: e,
                                loading: !1,
                                firstLoad: !1
                            });
                        } catch (e) {
                            s({
                                error: Kn(e),
                                loading: !1,
                                firstLoad: !1
                            });
                        }
                    },
                    loadSocialLoginsConfigurationV2: async (a)=>{
                        try {
                            var n;
                            const i = e.root.context;
                            s({
                                loading: !0
                            });
                            const o = await (async (a)=>{
                                let n;
                                return n = e.auth.isAuthenticated ? await xn(t.auth.getSocialLoginProvidersV2ForAuthenticatedUser, a) : await xn(t.auth.getSocialLoginProvidersV2, a), n;
                            })(null == a ? void 0 : a.retryConfig), { providers: r } = await xn(t.auth.getCustomSocialLoginProvidersV1, null == a ? void 0 : a.retryConfig), l = {
                                socialLoginsConfigV2: o.map((e)=>{
                                    let { authorizationUrl: a } = e, n = f(e, Ll);
                                    const s = t.fetch.getBaseUrl(i, null != a ? a : "");
                                    return v({}, n, {
                                        authorizationUrl: a ? `${s}${a}` : null
                                    });
                                }),
                                customSocialLoginsConfig: r,
                                loading: !1,
                                firstLoad: !1
                            };
                            s(l), null == a || null == (n = a.callback) || n.call(a, l);
                        } catch (e) {
                            var i;
                            null == a || null == (i = a.callback) || i.call(a, null, e), s({
                                error: Kn(e),
                                loading: !1,
                                firstLoad: !1
                            });
                        }
                    },
                    loginViaSocialLogin: async (e)=>{
                        const { events: a, url: i } = e, o = f(e, Cl);
                        try {
                            s({
                                loading: !0
                            });
                            const { email: e, isNewUser: c, userId: u, tenantId: d, name: g } = await t.auth.loginViaSocialLogin(o);
                            if (c) {
                                var r, l;
                                const t = {
                                    email: e,
                                    url: i,
                                    createdAt: new Date,
                                    id: u,
                                    tenantId: d
                                }, n = v({}, t, {
                                    socialProvider: o.provider,
                                    authenticationType: ss.SOCIAL_LOGIN
                                });
                                null == a || null == (r = a.signUpComplete) || r.call(a, n), cs(rs.SIGNUP_COMPLETED, n);
                                const s = v({}, t, {
                                    origin: ns.SOCIAL_LOGIN,
                                    name: g
                                });
                                null == a || null == (l = a.userVerified) || l.call(a, s), cs(rs.USER_VERIFIED, s);
                            }
                            u && localStorage.setItem("userId", u), n.setLoginState({
                                email: e,
                                isNewUser: c
                            }), n.refreshTokenForSocialLogins(), localStorage.removeItem("register-quick-login"), s({
                                loading: !1
                            });
                        } catch (e) {
                            s({
                                loading: !1,
                                error: Kn(e, "Failed to authenticate"),
                                firstLoad: !1
                            });
                        }
                    }
                };
            }, Nl = {
                firstLoad: !0,
                loading: !0,
                saving: !1,
                errors: {},
                loaders: {},
                ssoConfigurations: []
            }, Ml = (e)=>hn(Nl, e), Fl = [
                "callback",
                "samlVendor"
            ], xl = [
                "callback"
            ], $l = [
                "callback",
                "ssoConfigId"
            ], Gl = [
                "callback",
                "ssoConfigId"
            ], jl = [
                "callback",
                "ssoConfigId"
            ], Vl = (e, t, a)=>v({}, ((e, t, a)=>{
                    const n = a, s = async ()=>{
                        try {
                            const e = await t.auth.getSamlRoles(), a = await t.auth.getSamlRolesGroups();
                            i({
                                authorizationRoles: e.roleIds,
                                rolesGroups: a,
                                error: void 0
                            });
                        } catch (e) {
                            i({
                                error: Kn(e)
                            });
                        }
                    }, i = (t)=>{
                        Object.assign(e.auth.ssoState, t);
                    };
                    return {
                        setSSOState: i,
                        resetSSOState: ()=>{
                            Wn(e, [
                                "auth",
                                "ssoState"
                            ], Nl);
                        },
                        setSSOLoader: (t)=>{
                            Object.assign(e.auth.ssoState, {
                                loaders: v({}, e.auth.ssoState.loaders, {
                                    [t.key]: t.value
                                })
                            });
                        },
                        setSSOError: (t)=>{
                            Object.assign(e.auth.ssoState, {
                                errors: v({}, e.auth.ssoState.errors, {
                                    [t.key]: t.value
                                }),
                                loaders: v({}, e.auth.ssoState.loaders, {
                                    [t.key]: !1
                                })
                            });
                        },
                        loadSSOConfigurations: async ()=>{
                            try {
                                var e, a;
                                i({
                                    loading: !0
                                });
                                const n = await t.auth.getSamlConfiguration(), s = await t.auth.getOidcConfiguration(), o = await t.metadata.getSamlMetadata();
                                n.acsUrl = null == o || null == (e = o.configuration) ? void 0 : e.acsUrl, n.spEntityId = null == o || null == (a = o.configuration) ? void 0 : a.spEntityId, n.isSamlActive = null == o ? void 0 : o.isActive, i({
                                    samlConfiguration: n,
                                    oidcConfiguration: s,
                                    loading: !1,
                                    firstLoad: !1
                                });
                            } catch (e) {
                                i({
                                    error: Kn(e),
                                    loading: !1
                                });
                            }
                        },
                        saveSSOConfigurations: async (a)=>{
                            const { callback: n, samlVendor: s } = a, o = f(a, Fl), r = e.auth.ssoState.samlConfiguration, l = v({}, r, o);
                            let c = "saving";
                            (null == l ? void 0 : l.enabled) !== (null == r ? void 0 : r.enabled) && (c = "loading");
                            try {
                                if (null == l || !l.domain) return void i({
                                    samlConfiguration: v({}, r, l)
                                });
                                if (i({
                                    error: void 0,
                                    [c]: !0
                                }), a.type === Po.Saml) {
                                    var u, d;
                                    const e = await t.metadata.getSamlMetadata();
                                    l.acsUrl = null == e || null == (u = e.configuration) ? void 0 : u.acsUrl, l.spEntityId = null == e || null == (d = e.configuration) ? void 0 : d.spEntityId;
                                }
                                const e = jn(l, [
                                    "validated",
                                    "generatedVerification",
                                    "createdAt",
                                    "updatedAt"
                                ]);
                                (null == r ? void 0 : r.domain) !== (null == e ? void 0 : e.domain) && (e.ssoEndpoint = "", e.publicCertificate = "", e.signRequest = !1), e.type = null == s ? void 0 : s.toLowerCase();
                                const o = await t.auth.updateSamlConfiguration(e);
                                o.isSamlActive = null == r ? void 0 : r.isSamlActive, i({
                                    samlConfiguration: o,
                                    error: void 0,
                                    [c]: !1
                                }), null == n || n(!0);
                            } catch (e) {
                                i({
                                    samlConfiguration: r,
                                    error: Kn(e),
                                    [c]: !1
                                }), null == n || n(null, e);
                            }
                        },
                        saveSSOConfigurationsFile: async (a)=>{
                            const n = e.auth.ssoState.samlConfiguration, s = "saving";
                            i({
                                error: void 0,
                                [s]: !0
                            });
                            try {
                                const e = await qi(a[0]), o = await t.auth.updateSamlVendorMetadata({
                                    metadata: e
                                });
                                o.isSamlActive = null == n ? void 0 : n.isSamlActive, i({
                                    samlConfiguration: o,
                                    error: void 0,
                                    [s]: !1
                                });
                            } catch (e) {
                                i({
                                    samlConfiguration: n,
                                    error: Kn(e),
                                    [s]: !1
                                });
                            }
                        },
                        saveSSOConfigurationsFileWithCallback: async (a)=>{
                            const { configFile: n, callback: s } = a, o = e.auth.ssoState.samlConfiguration, r = "saving";
                            i({
                                error: void 0,
                                [r]: !0
                            });
                            try {
                                const e = await qi(n), a = await t.auth.updateSamlVendorMetadata({
                                    metadata: e
                                });
                                a.isSamlActive = null == o ? void 0 : o.isSamlActive, i({
                                    samlConfiguration: a,
                                    error: void 0,
                                    [r]: !1
                                }), null == s || s(!0);
                            } catch (e) {
                                i({
                                    samlConfiguration: o,
                                    error: Kn(e),
                                    [r]: !1
                                }), null == s || s(null, e);
                            }
                        },
                        validateSSODomain: async (a)=>{
                            const { callback: n } = null != a ? a : {}, s = e.auth.ssoState.samlConfiguration;
                            if (!s) {
                                const e = new Error("IllegalState: samlConfiguration is not defined");
                                return console.error(e), void (null == n || n(null, e));
                            }
                            try {
                                i({
                                    error: void 0,
                                    saving: !0
                                }), await t.auth.validateSamlDomain(), i({
                                    samlConfiguration: v({}, s, {
                                        validated: !0
                                    }),
                                    error: void 0,
                                    saving: !1
                                }), null == n || n(!0);
                            } catch (e) {
                                i({
                                    samlConfiguration: v({}, s, {
                                        validated: !1
                                    }),
                                    error: Kn(e),
                                    saving: !1
                                }), null == n || n(null, e);
                            }
                        },
                        loadSSOAuthorizationRoles: async ()=>{
                            try {
                                const e = await t.auth.getSamlRoles(), a = await t.auth.getSamlRolesGroups();
                                i({
                                    authorizationRoles: e.roleIds,
                                    rolesGroups: a,
                                    error: void 0
                                });
                            } catch (e) {
                                i({
                                    error: Kn(e)
                                });
                            }
                        },
                        updateSSOAuthorizationRoles: async (e)=>{
                            const { callback: a, authorizationRoles: n, groups: o } = e;
                            try {
                                i({
                                    error: void 0,
                                    saving: !0
                                }), await t.auth.updateSamlRoles({
                                    roleIds: n
                                }), o && await (async (e)=>{
                                    try {
                                        await Promise.all(e.map((e)=>t.auth.updateSamlGroup({
                                                id: e.id,
                                                roleIds: e.roleIds,
                                                group: e.group
                                            })));
                                    } catch (e) {
                                        i({
                                            error: Kn(e)
                                        });
                                    }
                                })(o), await s(), i({
                                    error: void 0,
                                    saving: !1
                                }), null == a || a(!0);
                            } catch (e) {
                                i({
                                    error: Kn(e),
                                    saving: !1
                                }), null == a || a(null, e);
                            }
                        },
                        deleteSamlGroup: async (e)=>{
                            const { id: a, callback: n } = e;
                            try {
                                i({
                                    error: void 0,
                                    saving: !0
                                }), await t.auth.deleteSamlGroup({
                                    id: a
                                }), await s(), i({
                                    error: void 0,
                                    saving: !1
                                }), null == n || n(!0);
                            } catch (e) {
                                i({
                                    error: Kn(e),
                                    saving: !1
                                }), null == n || n(null, e);
                            }
                        },
                        createSamlGroup: async (e)=>{
                            const { group: a, roleIds: n, callback: o } = e;
                            try {
                                i({
                                    error: void 0,
                                    saving: !0
                                }), await t.auth.createSamlGroup({
                                    group: a,
                                    roleIds: n
                                }), await s(), i({
                                    error: void 0,
                                    saving: !1
                                }), null == o || o(!0);
                            } catch (e) {
                                i({
                                    error: Kn(e),
                                    saving: !1
                                }), null == o || o(null, e);
                            }
                        },
                        oidcPostlogin: async (e)=>{
                            const a = {
                                code: e.code,
                                redirectUri: e.redirectUri,
                                RelayState: e.state
                            };
                            try {
                                i({
                                    loading: !0
                                }), await t.auth.oidcPostLoginV2(a), await n.__refreshToken(), i({
                                    loading: !1
                                });
                            } catch (e) {
                                i({
                                    loading: !1,
                                    error: Kn(e, "Failed to authenticate"),
                                    firstLoad: !1
                                });
                            }
                        }
                    };
                })(e, t, a), ((e, t, a)=>{
                    const n = a, s = async (e)=>{
                        try {
                            return await xn(()=>t.auth.getOidcConfiguration(), e);
                        } catch (e) {
                            return null;
                        }
                    }, i = async (e)=>{
                        try {
                            return await xn(()=>t.metadata.getSamlMetadata(), e);
                        } catch (e) {
                            return null;
                        }
                    }, o = async (e, t, a)=>{
                        n.setSSOLoader({
                            key: e,
                            value: !0
                        });
                        try {
                            await a();
                        } catch (a) {
                            n.setSSOError({
                                key: e,
                                value: Kn(a)
                            }), null == t || t(null, a);
                        } finally{
                            n.setSSOLoader({
                                key: e,
                                value: !1
                            });
                        }
                    };
                    return {
                        loadSSOConfigurationsV2: async (e)=>{
                            await o(Eo.LOAD_SSO_CONFIGURATIONS, void 0, async ()=>{
                                const [a, o] = await Promise.all([
                                    s(null == e ? void 0 : e.retryConfig),
                                    i(null == e ? void 0 : e.retryConfig)
                                ]), r = await xn(()=>t.auth.getSSOConfigurations(), null == e ? void 0 : e.retryConfig);
                                n.setSSOState({
                                    ssoConfigurations: r,
                                    oidcConfiguration: a,
                                    samlMetadata: o
                                });
                            });
                        },
                        saveSSOConfigurationV2: async (a)=>{
                            const { callback: s } = a, i = f(a, xl), r = e.auth.ssoState.ssoConfigurations;
                            await o(Eo.SAVE_SSO_CONFIGURATION, s, async ()=>{
                                var e;
                                const a = await t.auth.createSSOConfiguration(v({}, i, {
                                    enabled: null != (e = i.enabled) && e
                                }));
                                n.setSSOState({
                                    ssoConfigurations: [
                                        ...r,
                                        a
                                    ]
                                }), null == s || s(a);
                            });
                        },
                        updateSSOConfiguration: async (a)=>{
                            const { callback: s, ssoConfigId: i } = a, r = f(a, $l), l = e.auth.ssoState.ssoConfigurations;
                            await o(Eo.UPDATE_SSO_CONFIGURATION, s, async ()=>{
                                const e = await t.auth.updateSSOConfiguration(i, r), a = l.map((t)=>t.id === i ? e : t);
                                n.setSSOState({
                                    ssoConfigurations: a
                                }), null == s || s(e);
                            });
                        },
                        deleteSSOConfiguration: async (a)=>{
                            const { ssoConfigId: s, callback: i } = a, r = e.auth.ssoState.ssoConfigurations;
                            await o(Eo.DELETE_SSO_CONFIGURATION, i, async ()=>{
                                await t.auth.deleteSSOConfiguration(s), n.setSSOState({
                                    ssoConfigurations: r.filter(({ id: e })=>e !== s)
                                }), null == i || i(!0);
                            });
                        },
                        saveSSODomain: async (a)=>{
                            const { callback: s, ssoConfigId: i } = a, r = f(a, Gl), l = e.auth.ssoState.ssoConfigurations;
                            await o(Eo.SAVE_SSO_DOMAIN, s, async ()=>{
                                const e = await t.auth.createSSODomain(i, r), a = l.map((t)=>t.id === i ? v({}, t, {
                                        domains: [
                                            ...t.domains,
                                            e
                                        ]
                                    }) : t);
                                n.setSSOState({
                                    ssoConfigurations: a
                                }), null == s || s(e);
                            });
                        },
                        deleteSSODomain: async (a)=>{
                            const { ssoConfigId: s, domainId: i, callback: r } = a, l = e.auth.ssoState.ssoConfigurations;
                            await o(Eo.DELETE_SSO_DOMAIN, r, async ()=>{
                                await t.auth.deleteSSODomain(s, i);
                                const e = l.map((e)=>e.id === s ? v({}, e, {
                                        domains: e.domains.filter(({ id: e })=>e !== i)
                                    }) : e);
                                n.setSSOState({
                                    ssoConfigurations: e
                                }), null == r || r(!0);
                            });
                        },
                        validateSSODomainV2: async (a)=>{
                            const { callback: s, domainId: i, ssoConfigId: r } = a;
                            await o(Eo.VALIDATE_SSO_DOMAIN, s, async ()=>{
                                const a = e.auth.ssoState.ssoConfigurations;
                                await t.auth.validateSSODomainV2(r, i);
                                const o = a.map((e)=>e.id === r ? v({}, e, {
                                        domains: e.domains.map((e)=>e.id === i ? v({}, e, {
                                                validated: !0
                                            }) : e)
                                    }) : e);
                                n.setSSOState({
                                    ssoConfigurations: o
                                }), null == s || s(!0);
                            });
                        },
                        setSSOGroups: async (a)=>{
                            const { groupsToAdd: s, groupsToDelete: i, ssoConfigId: r, callback: l } = a;
                            await o(Eo.SAVE_SSO_GROUPS, l, async ()=>{
                                const a = e.auth.ssoState.ssoConfigurations;
                                await Promise.all(i.map((e)=>t.auth.deleteSSOGroup(r, e))), await Promise.all(s.map((e)=>t.auth.createSSOGroup(r, e)));
                                const o = await t.auth.getSSOGroups(r), c = a.map((e)=>e.id === r ? v({}, e, {
                                        groups: o
                                    }) : e);
                                n.setSSOState({
                                    ssoConfigurations: c
                                }), null == l || l(!0);
                            });
                        },
                        updateSSOGroups: async (e)=>{
                            const { ssoConfigId: a, changedGroups: n, callback: s } = e;
                            await o(Eo.SAVE_SSO_GROUPS, s, async ()=>{
                                await Promise.all(n.map((e)=>t.auth.updateSSOGroup(a, e))), null == s || s(!0);
                            });
                        },
                        setSSODefaultRoles: async (a)=>{
                            const { callback: s, ssoConfigId: i, roleIds: r } = a;
                            await o(Eo.UPDATE_SSO_DEFAULT_ROLES, s, async ()=>{
                                const a = e.auth.ssoState.ssoConfigurations;
                                await t.auth.setSSODefaultRoles(i, {
                                    roleIds: r
                                });
                                const o = a.map((e)=>e.id === i ? v({}, e, {
                                        roleIds: r
                                    }) : e);
                                n.setSSOState({
                                    ssoConfigurations: o
                                }), null == s || s(!0);
                            });
                        },
                        saveSSOConfigurationByMetadata: async (a)=>{
                            const { configFile: s, callback: i } = a;
                            await o(Eo.SAVE_SSO_CONFIGURATION_BY_METADATA, i, async ()=>{
                                const a = e.auth.ssoState.ssoConfigurations, o = await qi(s), r = await t.auth.createSSOConfigurationByMetadata({
                                    metadata: o
                                });
                                n.setSSOState({
                                    ssoConfigurations: [
                                        ...a,
                                        r
                                    ]
                                }), null == i || i(r);
                            });
                        },
                        updateSSOConfigurationByMetadata: async (a)=>{
                            const { callback: s, ssoConfigId: i, configFile: r } = a;
                            await o(Eo.UPDATE_SSO_CONFIGURATION_BY_METADATA, s, async ()=>{
                                const a = e.auth.ssoState.ssoConfigurations, o = await qi(r), l = await t.auth.updateSSOConfigurationByMetadata(i, {
                                    metadata: o
                                }), c = a.map((e)=>e.id === i ? l : e);
                                n.setSSOState({
                                    ssoConfigurations: c
                                }), null == s || s(l);
                            });
                        },
                        saveSSOConfigurationByUrl: async (a)=>{
                            const { metadataUrl: s, configMetadata: i, ssoConfigId: r, callback: l } = a;
                            await o(Eo.SAVE_SSO_CONFIGURATION_BY_METADATA, l, async ()=>{
                                const a = e.auth.ssoState.ssoConfigurations, o = {
                                    url: s,
                                    configMetadata: i
                                };
                                let c, u;
                                r ? (c = await t.auth.updateSSOConfigurationByMetadataUrl(r, o), u = a.map((e)=>e.id === r ? c : e)) : (c = await t.auth.createSSOConfigurationByMetadataUrl(o), u = [
                                    c,
                                    ...a
                                ]), n.setSSOState({
                                    ssoConfigurations: u
                                }), null == l || l(c);
                            });
                        },
                        saveSSOConfigurationByData: async (a)=>{
                            const { callback: s, ssoConfigId: i } = a, r = f(a, jl), l = e.auth.ssoState.ssoConfigurations;
                            await o(Eo.SAVE_SSO_CONFIGURATION, s, async ()=>{
                                let e, a;
                                i ? (e = await t.auth.updateSSOConfiguration(i, r), a = l.map((t)=>t.id === i ? e : t)) : (e = await t.auth.createSSOConfiguration(r), a = [
                                    e,
                                    ...l
                                ]), n.setSSOState({
                                    ssoConfigurations: a
                                }), null == s || s(e);
                            });
                        }
                    };
                })(e, t, a)), Bl = {
                loading: !1,
                mfaDevices: void 0,
                mfaToken: ""
            }, Wl = (e)=>hn(Bl, e), zl = (e, t, a)=>{
                const n = a;
                return v({
                    setStepUpState: (t)=>{
                        Object.assign(e.auth.stepUpState, t);
                    },
                    resetStepUpState: ()=>{
                        Wn(e, [
                            "auth",
                            "stepUpState"
                        ], Bl);
                    },
                    stepUpWithAuthenticator: async (e)=>{
                        await n.mfaWithAuthenticator(e, n.setStepUpState, !0);
                    },
                    preVerifyMFASMSForStepUp: async (e)=>{
                        await n.preVerifyMFASMS(e, n.setStepUpState);
                    },
                    verifyMFASMSForStepUp: async (e)=>{
                        await n.verifyMFASMS(e, n.setStepUpState, !0);
                    },
                    preVerifyMFAWebAuthnForStepUp: async (e)=>{
                        await n.preVerifyMFAWebAuthn(e, n.setStepUpState);
                    },
                    verifyMFAWebAuthnForStepUp: async (e)=>{
                        await n.verifyMFAWebAuthn(e, n.setStepUpState, !0);
                    },
                    preVerifyMFAEmailCodeForStepUp: async (e)=>{
                        await n.preVerifyMFAEmailCode(e, n.setStepUpState);
                    },
                    verifyMFAEmailCodeForStepUp: async (e)=>{
                        await n.verifyMFAEmailCode(e, n.setStepUpState);
                    }
                }, ((e, t, a)=>{
                    const n = a;
                    return {
                        generateStepUpSession: async (a)=>{
                            const { maxAge: s, callback: i } = a;
                            n.setStepUpState({
                                mfaDevices: void 0,
                                mfaToken: ""
                            });
                            try {
                                const e = await t.auth.generateStepupSession({
                                    maxAge: s
                                });
                                e.hasOwnProperty("user") ? await (async (e)=>{
                                    await n.afterAuthenticationStateUpdate(e), await n.afterStepUpAuthNavigation();
                                })(e) : await (async ({ mfaToken: e, mfaDevices: t })=>{
                                    n.setStepUpState({
                                        mfaDevices: t,
                                        mfaToken: e
                                    });
                                    const a = await vs(t);
                                    n.setMfaState({
                                        step: a
                                    });
                                })(e), null == i || i(!0);
                            } catch (t) {
                                null == i || i(!1), await (async (t)=>{
                                    if (((e)=>"MFA is not enrolled" === (null == e ? void 0 : e.message))(t)) return void n.setMfaState({
                                        step: ls.noMFAEnrolledStepUp
                                    });
                                    window.localStorage.setItem(Pn, "true");
                                    const a = e.auth.routes;
                                    L.for(e.root.appName).onRedirectTo(a.logoutUrl, {
                                        preserveQueryParams: !0
                                    });
                                })(t);
                            }
                        }
                    };
                })(e, t, a), ((e, t, a)=>{
                    const n = a;
                    return {
                        stepUpHostedLogin: async (t)=>{
                            var a, s;
                            const i = {
                                acr_values: wn
                            }, { maxAge: o } = t || {};
                            void 0 !== o && (i.max_age = o.toString());
                            const r = null == (a = e.auth.tenantsState) || null == (s = a.activeTenant) ? void 0 : s.alias;
                            r && (i.organization = r), Ps(), window.localStorage.setItem(Pn, "true"), await n.__requestHostedLoginAuthorize(i);
                        }
                    };
                })(e, 0, a));
            }, Hl = {
                loaders: {},
                pageOffset: 0,
                pageSize: 20,
                errors: {},
                users: [],
                allUsers: [],
                roles: [],
                permissions: [],
                totalPages: 0,
                shouldShowSubTenantUsersIfReseller: !1,
                allUsersQueryParams: {
                    _filter: null,
                    _offset: 0,
                    _limit: 20,
                    _order: "DESC",
                    _sortBy: "name"
                },
                addUserDialogState: {
                    loading: !1,
                    open: !1
                },
                deleteUserDialogState: {
                    loading: !1,
                    open: !1
                },
                lockUserDialogState: {
                    loading: !1,
                    open: !1
                },
                enableUserDialogState: {
                    loading: !1,
                    open: !1
                },
                disableUserDialogState: {
                    loading: !1,
                    open: !1
                }
            }, Kl = (e)=>hn(Hl, e), ql = [
                "callback",
                "appIds"
            ], Yl = [
                "roles"
            ], Jl = [
                "callback",
                "profileImage"
            ], Ql = [
                "callback"
            ], Xl = [
                "callback"
            ], Zl = [
                "callback"
            ], ec = [
                "callback",
                "userId"
            ], tc = [
                "callback"
            ], ac = [
                "callback"
            ], nc = [
                "callback"
            ], sc = [
                "callback"
            ], ic = [
                "callback"
            ], oc = [
                "callback"
            ], rc = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.teamState, t);
                };
                return v({
                    setTeamLoader: (t)=>{
                        Object.assign(e.auth.teamState, {
                            loaders: v({}, e.auth.teamState.loaders, {
                                [t.key]: t.value
                            })
                        });
                    },
                    setTeamError: (t)=>{
                        Object.assign(e.auth.teamState, {
                            errors: v({}, e.auth.teamState.errors, {
                                [t.key]: t.value
                            }),
                            loaders: v({}, e.auth.teamState.loaders, {
                                [t.key]: !1
                            })
                        });
                    },
                    setTeamState: n,
                    resetTeamState: ()=>{
                        Wn(e, [
                            "auth",
                            "teamState"
                        ], Hl);
                    },
                    openAddUserDialog: (e)=>{
                        n({
                            addUserDialogState: v({
                                open: !0,
                                loading: !1,
                                error: !1
                            }, e)
                        });
                    },
                    closeAddUserDialog: (t)=>{
                        var a, s;
                        null == (a = (s = e.auth.teamState.addUserDialogState).onClose) || a.call(s, t), n({
                            addUserDialogState: {
                                loading: !1,
                                error: !1,
                                open: !1
                            }
                        });
                    },
                    openDeleteUserDialog: (e)=>{
                        n({
                            deleteUserDialogState: v({
                                open: !0,
                                loading: !1,
                                error: !1
                            }, e)
                        });
                    },
                    closeDeleteUserDialog: (t)=>{
                        var a, s;
                        null == (a = (s = e.auth.teamState.deleteUserDialogState).onClose) || a.call(s, t), n({
                            deleteUserDialogState: {
                                loading: !1,
                                error: !1,
                                open: !1
                            }
                        });
                    },
                    lockUser: async (e)=>{}
                }, ((e, t, a)=>{
                    const n = a, s = async (e)=>{
                        try {
                            const { groups: a } = await xn(()=>t.groups.getGroups({
                                    _groupsRelations: Ja.roles
                                }), e);
                            return a;
                        } catch (e) {
                            return [];
                        }
                    }, i = async (e, n)=>{
                        const { shouldLoadRoles: i = !0, shouldLoadApps: o, shouldLoadEmails: r = !1, retryConfig: l } = n, u = e.map((e)=>e.id), [{ items: d }, { items: g }, { items: p }, h, y, S, { items: f }, m] = await Promise.all([
                            u.length > 0 ? t.users.getUsersUsernames({
                                userIds: u
                            }) : {
                                items: []
                            },
                            u.length > 0 ? t.userPhoneNumbers.getUsersPhoneNumberV2({
                                userIds: u.join(",")
                            }) : {
                                items: []
                            },
                            t.teams.loadAvailableRoles(),
                            t.teams.loadAvailablePermissions(),
                            u.length > 0 ? t.users.getUsersRoles({
                                ids: u
                            }) : [],
                            u.length > 0 ? t.users.getUsersGroups({
                                ids: u
                            }) : [],
                            r && u.length > 0 ? t.usersEmails.getUsersEmailsV1({
                                userIds: u.join(",")
                            }) : {
                                items: []
                            },
                            s(l),
                            i ? c({
                                retryConfig: l
                            }) : void 0
                        ]), b = e.map((e)=>{
                            var t, a, n;
                            const s = y.find((t)=>t.userId === e.id), i = (null == s ? void 0 : s.roleIds) || [], o = p.filter((e)=>i.includes(e.id)), l = S.find((t)=>t.userId === e.id), c = (null == l ? void 0 : l.groupIds) || [], u = m.filter((e)=>c.includes(e.id)), h = null == d || null == (t = d.find((t)=>t.userId === e.id)) ? void 0 : t.username, b = null == g || null == (a = g.find((t)=>t.userId === e.id)) ? void 0 : a.phoneNumber, A = (null == f ? void 0 : f.filter((t)=>t.userId === e.id)) || [], w = null == (n = A.find((e)=>e.isPrimary)) ? void 0 : n.email, T = A.map((e)=>({
                                    email: e.email,
                                    isPrimary: e.isPrimary
                                }));
                            return e.name || (e.name = h), v({}, e, {
                                username: h,
                                phoneNumber: b
                            }, r && w ? {
                                email: w
                            } : {}, r && T.length > 0 ? {
                                emails: T
                            } : {}, {
                                roles: o,
                                roleIds: i,
                                groups: u,
                                permissions: o.flatMap((e)=>e.permissions)
                            });
                        });
                        return {
                            enrichedUsers: await a.mapUsersWithApplicationData({
                                shouldLoadApps: o,
                                users: b,
                                retryConfig: l
                            }),
                            roles: p,
                            permissions: h
                        };
                    }, o = (e, t, s, i, o, r)=>{
                        a.setTeamState({
                            users: e,
                            totalPages: i,
                            totalItems: o,
                            roles: t,
                            permissions: s
                        }), n.setTeamLoader({
                            key: Ns.USERS,
                            value: !1
                        }), null == r || r(e);
                    }, r = (e, t, a)=>{
                        a && console.error(a, e), n.setTeamError({
                            key: Ns.USERS,
                            value: Kn(e)
                        }), n.setTeamState({
                            totalPages: 0,
                            users: []
                        }), n.setTeamLoader({
                            key: Ns.USERS,
                            value: !1
                        }), null == t || t(null, e);
                    }, l = async (s, l, c = !0, u)=>{
                        var d, g, p;
                        const { silentLoading: h, callback: y, shouldLoadEmails: S = !1, retryConfig: v } = s, f = e.auth.teamState, m = null != (d = s._limit) ? d : f.pageSize, b = null != (g = s._offset) ? g : f.pageOffset, A = null != (p = null == s ? void 0 : s.shouldShowSubTenantUsersIfReseller) ? p : null == f ? void 0 : f.shouldShowSubTenantUsersIfReseller;
                        n.setTeamLoader({
                            key: Ns.USERS,
                            value: !h
                        }), n.setTeamState({
                            pageSize: m,
                            pageOffset: b
                        });
                        try {
                            const e = await l(b, m);
                            if (!e.items || 0 === e.items.length) return a.setTeamState({
                                users: [],
                                totalPages: 0,
                                totalItems: 0
                            }), n.setTeamLoader({
                                key: Ns.USERS,
                                value: !1
                            }), void (null == y || y([]));
                            const s = e.items.map((e)=>e.userId), { items: r } = await t.users.getUsersV3({
                                ids: s.join(","),
                                _includeSubTenants: A
                            }), { enrichedUsers: d, roles: g, permissions: p } = await i(r, {
                                shouldLoadRoles: c,
                                shouldLoadApps: u,
                                shouldLoadEmails: S,
                                retryConfig: v
                            });
                            o(d, g, p, e._metadata.totalPages, e._metadata.totalItems, y);
                        } catch (e) {
                            r(e, y, `Failed to load users by search criteria in fetch function: ${l.name}`);
                        }
                    }, c = async (e)=>{
                        n.setTeamLoader({
                            key: Ns.ROLES_AND_PERMISSIONS,
                            value: !0
                        });
                        try {
                            var a;
                            const s = null == e ? void 0 : e.retryConfig, [{ items: i }, { items: o }] = await Promise.all([
                                xn(()=>t.teams.loadAvailableRoles(), s),
                                xn(()=>t.teams.loadAvailablePermissions(), s)
                            ]);
                            n.setTeamState({
                                roles: i,
                                permissions: o
                            }), null == e || null == (a = e.callback) || a.call(e, {
                                roles: i,
                                permissions: o
                            });
                        } catch (t) {
                            var s;
                            null == e || null == (s = e.callback) || s.call(e, null, t), n.setTeamError({
                                key: Ns.ROLES_AND_PERMISSIONS,
                                value: Kn(t)
                            });
                        } finally{
                            n.setTeamLoader({
                                key: Ns.ROLES_AND_PERMISSIONS,
                                value: !1
                            });
                        }
                    };
                    return {
                        loadRoles: c,
                        loadUsers: async (a)=>{
                            var s, i, o, r;
                            const { silentLoading: l, callback: u } = a, d = e.auth.teamState, g = null != (s = a.pageSize) ? s : d.pageSize, p = null != (i = a.pageOffset) ? i : d.pageOffset, h = null != (o = a.filter) ? o : d.filter, y = null != (r = a.sort) ? r : d.sort;
                            n.setTeamLoader({
                                key: Ns.USERS,
                                value: !l
                            }), n.setTeamState({
                                pageSize: g,
                                pageOffset: p,
                                filter: h,
                                sort: y
                            });
                            try {
                                const [{ items: e, totalPages: a, totalItems: s }] = await Promise.all([
                                    t.teams.loadUsers({
                                        pageSize: g,
                                        pageOffset: p,
                                        filter: h,
                                        sort: y
                                    }),
                                    c()
                                ]);
                                n.setTeamState({
                                    users: e,
                                    totalPages: a,
                                    totalItems: s
                                }), null == u || u(e);
                            } catch (e) {
                                n.setTeamError({
                                    key: Ns.USERS,
                                    value: Kn(e)
                                }), n.setTeamState({
                                    totalPages: 0,
                                    users: []
                                }), null == u || u(null, e);
                            }
                            n.setTeamLoader({
                                key: Ns.USERS,
                                value: !1
                            });
                        },
                        loadUsersV2: async (i)=>{
                            var o, r, l, u, d;
                            const { silentLoading: g, callback: p, shouldLoadRoles: h = !0, shouldLoadApps: y, retryConfig: S } = i, f = e.auth.teamState, m = null != (o = i.pageSize) ? o : f.pageSize, b = null != (r = i.pageOffset) ? r : f.pageOffset, A = null != (l = i.filter) ? l : f.filterV2, w = null != (u = i.sort) ? u : f.sortV2, T = null != (d = null == i ? void 0 : i.shouldShowSubTenantUsersIfReseller) ? d : null == f ? void 0 : f.shouldShowSubTenantUsersIfReseller;
                            n.setTeamLoader({
                                key: Ns.USERS,
                                value: !g
                            }), n.setTeamState({
                                pageSize: m,
                                pageOffset: b,
                                filterV2: A,
                                sortV2: w
                            });
                            try {
                                const [{ items: e, _metadata: { totalPages: n, totalItems: o } }, { items: r }, { items: l }, u] = await Promise.all([
                                    xn(()=>t.users.getUsersV2(v({}, (null == A ? void 0 : A.length) && {
                                            _filter: A
                                        }, w && {
                                            _sortBy: w
                                        }, i.order && {
                                            _order: i.order
                                        }, {
                                            _offset: b,
                                            _limit: m,
                                            _includeSubTenants: T
                                        })), S),
                                    xn(()=>t.teams.loadAvailableRoles(), S),
                                    xn(()=>t.teams.loadAvailablePermissions(), S),
                                    s(S),
                                    h ? c({
                                        retryConfig: S
                                    }) : void 0
                                ]), d = e.map((e)=>{
                                    var t;
                                    return v({}, e, {
                                        groups: null == e || null == (t = e.groups) ? void 0 : t.map((e)=>u.filter((t)=>t.id === e.id)).flat()
                                    });
                                }).map((e)=>v({}, e, {
                                        roleIds: e.roles.map((e)=>e.id)
                                    })), g = await a.mapUsersWithApplicationData({
                                    shouldLoadApps: y,
                                    users: d,
                                    retryConfig: S
                                });
                                a.setTeamState({
                                    users: g,
                                    totalPages: n,
                                    totalItems: o,
                                    roles: r,
                                    permissions: l
                                }), null == p || p(e);
                            } catch (e) {
                                console.error("Failed to load users", e), n.setTeamError({
                                    key: Ns.USERS,
                                    value: Kn(e)
                                }), n.setTeamState({
                                    totalPages: 0,
                                    users: []
                                }), null == p || p(null, e);
                            }
                            n.setTeamLoader({
                                key: Ns.USERS,
                                value: !1
                            });
                        },
                        loadUsersV3: async (a)=>{
                            var s, l, c, u;
                            const { silentLoading: d, callback: g, shouldLoadRoles: p = !0, shouldLoadApps: h, shouldLoadEmails: y = !1, retryConfig: S } = a, f = e.auth.teamState, m = null != (s = a.pageSize) ? s : f.pageSize, b = null != (l = a.pageOffset) ? l : f.pageOffset, A = null != (c = a.sort) ? c : f.sortV2, w = null != (u = null == a ? void 0 : a.shouldShowSubTenantUsersIfReseller) ? u : null == f ? void 0 : f.shouldShowSubTenantUsersIfReseller;
                            n.setTeamLoader({
                                key: Ns.USERS,
                                value: !d
                            }), n.setTeamState({
                                pageSize: m,
                                pageOffset: b
                            });
                            try {
                                const { items: e, _metadata: { totalPages: n, totalItems: s } } = await t.users.getUsersV3(v({}, A && {
                                    _sortBy: A
                                }, a.order && {
                                    _order: a.order
                                }, {
                                    _offset: b,
                                    _limit: m,
                                    _includeSubTenants: w
                                }, ((e)=>{
                                    const { identifier: t, identifierType: a, email: n, namePrefix: s } = e;
                                    return null != n && n.length ? {
                                        _email: n
                                    } : null != s && s.length ? {
                                        _namePrefix: s
                                    } : "username" === a && null != t && t.length ? {
                                        _identifier: t,
                                        _identifierType: "username"
                                    } : {};
                                })(a))), { enrichedUsers: r, roles: l, permissions: c } = await i(e, {
                                    shouldLoadRoles: p,
                                    shouldLoadApps: h,
                                    shouldLoadEmails: y,
                                    retryConfig: S
                                });
                                o(r, l, c, n, s, g);
                            } catch (e) {
                                r(e, g, "Failed to load users v3");
                            }
                        },
                        loadUsersByGetUsersPhoneNumberV2: async (e)=>{
                            const { _phoneNumber: a, shouldLoadRoles: n = !0, shouldLoadApps: s, shouldLoadEmails: i = !1 } = e;
                            return l(e, (e, n)=>t.userPhoneNumbers.getUsersPhoneNumberV2({
                                    _phoneNumber: a,
                                    _offset: e,
                                    _limit: n
                                }), n, s);
                        },
                        loadUsersByGetUsernamesV1: async (e)=>{
                            const { _usernamePrefix: a, shouldLoadRoles: n = !0, shouldLoadApps: s, shouldLoadEmails: i = !1 } = e;
                            return l(e, (e, n)=>t.usernames.getUsernamesV1({
                                    _usernamePrefix: a,
                                    _offset: e,
                                    _limit: n
                                }), n, s);
                        },
                        loadUsersByGetEmailsV1: async (e)=>{
                            const { _email: a, shouldLoadRoles: n = !0, shouldLoadApps: s, shouldLoadEmails: i = !1 } = e;
                            return l(e, (e, n)=>t.usersEmails.getUsersEmailsV1({
                                    _email: a,
                                    _offset: e,
                                    _limit: n
                                }), n, s);
                        },
                        addUser: async (s)=>{
                            const { callback: i, appIds: o } = s, r = f(s, ql), l = e.auth.teamState;
                            n.setTeamState({
                                addUserDialogState: v({}, l.addUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                var c;
                                const e = await t.teams.addUser(r), { roles: s } = e, u = v({}, f(e, Yl), {
                                    roleIds: null != (c = null == s ? void 0 : s.map((e)=>e.id)) ? c : [],
                                    roles: s || [],
                                    groups: []
                                }), d = await a.assignNewUserToApps({
                                    appIds: o,
                                    user: u
                                });
                                d && (u.applications = d), null == i || i(u), n.setTeamState({
                                    users: [
                                        u,
                                        ...l.users
                                    ],
                                    addUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (e) {
                                console.error("Failed to add user", e), n.setTeamState({
                                    addUserDialogState: v({}, l.addUserDialogState, {
                                        loading: !1,
                                        error: Kn(e)
                                    })
                                }), null == i || i(null, e);
                            }
                        },
                        addUsersBulk: async (a)=>{
                            const { callback: s } = a, i = e.auth.teamState;
                            n.setTeamState({
                                addUserDialogState: v({}, i.addUserDialogState, {
                                    loading: !0
                                })
                            });
                            const o = [], r = [], l = a.emails.map((e)=>v({
                                    email: e,
                                    roleIds: a.roleIds
                                }, a.expirationInSeconds && {
                                    expirationInSeconds: a.expirationInSeconds
                                }));
                            n.setTeamState({
                                addUserDialogState: {
                                    open: !0,
                                    loading: !0
                                }
                            });
                            for(let e = 0; e < l.length; e++){
                                const a = l.at(e);
                                try {
                                    await t.teams.addUser(a), o.push(a.email);
                                } catch (e) {
                                    r.push(a.email);
                                }
                            }
                            const c = {
                                pageOffset: 0,
                                pageSize: 10,
                                filter: "",
                                silentLoading: a.emails.length > 0
                            };
                            await n.loadUsersV2(c), n.setTeamState({
                                addUserDialogState: {
                                    loading: !1
                                }
                            }), null == s || s({
                                unallowedEmails: r,
                                allowedEmails: o
                            });
                        },
                        updateUser: async (a)=>{
                            const { callback: s } = a, i = f(a, Jl), { id: o } = i, r = e.auth.teamState, l = r.users.find((e)=>e.id === i.id);
                            if (void 0 !== l) {
                                n.setTeamLoader({
                                    key: Ns.UPDATE_USER,
                                    value: o || ""
                                }), n.setTeamState({
                                    addUserDialogState: v({}, r.addUserDialogState, {
                                        loading: !0
                                    })
                                }), n.setTeamState({
                                    addUserDialogState: v({}, r.addUserDialogState, {
                                        loading: !0
                                    }),
                                    users: r.users.map((e)=>e.id === i.id ? v({}, e, i) : e)
                                });
                                try {
                                    var c;
                                    l.roleIds.length > 0 && 0 === (null == (c = i.roleIds) ? void 0 : c.length) && (i.roleIds = [
                                        ""
                                    ]);
                                    const { item: e } = await t.teams.updateUser(i);
                                    null == s || s(e), n.setTeamState({
                                        users: r.users.map((t)=>t.id === e.id ? v({}, t, e, {
                                                groups: t.groups,
                                                createdAt: t.createdAt,
                                                customData: t.customData,
                                                lastLogin: t.lastLogin
                                            }) : t)
                                    }), n.setTeamLoader({
                                        key: Ns.UPDATE_USER,
                                        value: !1
                                    });
                                } catch (e) {
                                    n.setTeamState({
                                        addUserDialogState: v({}, r.addUserDialogState, {
                                            loading: !1,
                                            error: Kn(e)
                                        }),
                                        users: r.users.map((e)=>e.id === i.id ? v({}, e, l) : e)
                                    }), n.setTeamLoader({
                                        key: Ns.UPDATE_USER,
                                        value: !1
                                    }), null == s || s(null, e);
                                }
                            } else null == s || s(null, "User not in state");
                        },
                        deleteUser: async (a)=>{
                            const { callback: s } = a, i = f(a, Ql), o = e.auth.teamState;
                            n.setTeamState({
                                deleteUserDialogState: v({}, o.deleteUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await t.teams.deleteUser(i), null == s || s(!0), n.setTeamState({
                                    users: o.users.filter((e)=>e.id !== i.userId),
                                    deleteUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (e) {
                                n.setTeamState({
                                    deleteUserDialogState: v({}, o.deleteUserDialogState, {
                                        loading: !1,
                                        error: Kn(e)
                                    })
                                }), null == s || s(null, e);
                            }
                        },
                        enableUser: async (a)=>{
                            const { callback: s, userId: i } = a, o = e.auth.teamState;
                            n.setTeamState({
                                enableUserDialogState: v({}, o.enableUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await t.teams.enableUser(i), null == s || s(!0), n.setTeamState({
                                    users: o.users.map((e)=>e.id === i ? v({}, e, {
                                            isDisabled: !1
                                        }) : e),
                                    enableUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (e) {
                                n.setTeamState({
                                    enableUserDialogState: v({}, o.enableUserDialogState, {
                                        loading: !1,
                                        error: Kn(e)
                                    })
                                }), null == s || s(null, e);
                            }
                        },
                        disableUser: async (a)=>{
                            const { callback: s, userId: i } = a, o = e.auth.teamState;
                            n.setTeamState({
                                disableUserDialogState: v({}, o.disableUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await t.teams.disableUser(i), null == s || s(!0), n.setTeamState({
                                    users: o.users.map((e)=>e.id === i ? v({}, e, {
                                            isDisabled: !0
                                        }) : e),
                                    disableUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (e) {
                                n.setTeamState({
                                    disableUserDialogState: v({}, o.disableUserDialogState, {
                                        loading: !1,
                                        error: Kn(e)
                                    })
                                }), null == s || s(null, e);
                            }
                        },
                        getTemporaryUsersConfig: async (e)=>{
                            n.setTeamError({
                                key: Ns.CONFIG_TEMPORARY_USERS,
                                value: !1
                            });
                            try {
                                const a = await xn(()=>t.teams.getTemporaryUserConfiguration(), null == e ? void 0 : e.retryConfig);
                                n.setTeamState({
                                    temporaryUsersConfig: a
                                });
                            } catch (e) {
                                n.setTeamError({
                                    key: Ns.CONFIG_TEMPORARY_USERS,
                                    value: Kn(e)
                                });
                            }
                        },
                        updateUserExpirationTime: async (a)=>{
                            const { callback: s } = a, i = f(a, Xl), o = e.auth.teamState;
                            n.setTeamLoader({
                                key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                value: !0
                            });
                            try {
                                const e = await t.teams.updateUserExpirationTime(i);
                                n.setTeamState({
                                    users: o.users.map((t)=>t.id === i.userId ? v({}, t, {
                                            temporaryExpirationDate: new Date(e.temporaryExpirationDate)
                                        }) : t)
                                }), null == s || s(!0);
                            } catch (e) {
                                n.setTeamError({
                                    key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                    value: Kn(e)
                                }), null == s || s(null, e);
                            } finally{
                                n.setTeamLoader({
                                    key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                    value: !1
                                });
                            }
                        },
                        setUserAsPermanent: async (a)=>{
                            const { callback: s } = a, i = f(a, Zl), o = e.auth.teamState;
                            n.setTeamLoader({
                                key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                value: !0
                            });
                            try {
                                await t.teams.setPermanentUser(i.userId), n.setTeamState({
                                    users: o.users.map((e)=>e.id === i.userId ? v({}, e, {
                                            temporaryExpirationDate: void 0
                                        }) : e)
                                }), null == s || s(!0);
                            } catch (e) {
                                n.setTeamError({
                                    key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                    value: Kn(e)
                                }), null == s || s(null, e);
                            } finally{
                                n.setTeamLoader({
                                    key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                    value: !1
                                });
                            }
                        }
                    };
                })(e, t, a), ((e, t, a)=>{
                    const n = a;
                    return {
                        loadAllSubTenantsUsers: async (a)=>{
                            var s, i, o, r, l;
                            const { silentLoading: c, callback: u } = a, d = e.auth.teamState.allUsersQueryParams, g = {
                                _limit: (null != (s = a._limit) ? s : d._limit) || 20,
                                _offset: (null != (i = a._offset) ? i : d._offset) || 0,
                                _filter: (null != (o = a._filter) ? o : d._filter) || "",
                                _sortBy: (null != (r = a._sortBy) ? r : d._sortBy) || "name",
                                _order: (null != (l = a._order) ? l : d._order) || "DESC"
                            };
                            n.setTeamLoader({
                                key: Ns.USERS,
                                value: !c
                            }), n.setTeamState({
                                allUsersQueryParams: g,
                                pageOffset: g._offset
                            });
                            try {
                                const [{ items: e, _metadata: { totalPages: a, totalItems: s } }, { items: i }, { items: o }] = await Promise.all([
                                    t.subTenants.loadAllUsers(v({}, g)),
                                    t.teams.loadAvailableRoles(),
                                    t.teams.loadAvailablePermissions()
                                ]);
                                n.setTeamState({
                                    allUsers: e,
                                    totalPages: a,
                                    totalItems: s,
                                    roles: i,
                                    permissions: o
                                }), null == u || u(e);
                            } catch (e) {
                                n.setTeamError({
                                    key: Ns.USERS,
                                    value: Kn(e)
                                }), n.setTeamState({
                                    totalPages: 0,
                                    users: []
                                }), null == u || u(null, e);
                            }
                            n.setTeamLoader({
                                key: Ns.USERS,
                                value: !1
                            });
                        },
                        setUserRolesForSubTenants: async (a)=>{
                            const { callback: s, userId: i } = a, o = f(a, ec), r = e.auth.teamState;
                            n.setTeamState({
                                addUserDialogState: v({}, r.addUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await t.subTenants.setUserRolesForSubTenants(i, o);
                                const e = r.allUsers.find((e)=>e.id === i);
                                let a = [];
                                e && (a = e.tenants.map((e)=>{
                                    var t;
                                    return v({}, e, {
                                        roles: (null == (t = o.subTenantsRoles.find((t)=>t.tenantId === e.tenantId)) ? void 0 : t.roleIds.map((e)=>r.roles.find(({ id: t })=>e === t)).filter((e)=>e)) || e.roles
                                    });
                                })), n.setTeamState({
                                    allUsers: [
                                        ...r.allUsers.filter((e)=>e.id !== i),
                                        ...e ? [
                                            v({}, e, {
                                                tenants: a
                                            })
                                        ] : []
                                    ],
                                    addUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                }), null == s || s(!0);
                            } catch (e) {
                                n.setTeamState({
                                    addUserDialogState: v({}, r.addUserDialogState, {
                                        loading: !1,
                                        error: Kn(e)
                                    })
                                }), null == s || s(null, e);
                            }
                        },
                        deleteUserFromSubTenants: async (a)=>{
                            const { callback: s } = a, i = f(a, tc), o = e.auth.teamState;
                            n.setTeamState({
                                deleteUserDialogState: v({}, o.deleteUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await t.subTenants.removeUserFromTenantAndSubTenants(i), null == s || s(!0), n.setTeamState({
                                    allUsers: o.allUsers.filter((e)=>e.id !== i.userId && e.tenants.length === i.subTenants.length),
                                    deleteUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                });
                            } catch (e) {
                                n.setTeamState({
                                    deleteUserDialogState: v({}, o.deleteUserDialogState, {
                                        loading: !1,
                                        error: Kn(e)
                                    })
                                }), null == s || s(null, e);
                            }
                        },
                        addUserToSubTenants: async (a)=>{
                            const { callback: s } = a, i = f(a, ac), o = e.auth.teamState;
                            n.setTeamState({
                                addUserDialogState: v({}, o.addUserDialogState, {
                                    loading: !0
                                })
                            });
                            try {
                                await t.subTenants.addUserToTenantAndSubTenants(i);
                                const { items: e, _metadata: { totalPages: a, totalItems: o } } = await t.subTenants.loadAllUsers({
                                    _limit: 20,
                                    _offset: 0,
                                    _filter: "",
                                    _sortBy: "name",
                                    _order: "DESC"
                                });
                                n.setTeamState({
                                    allUsers: e,
                                    totalPages: a,
                                    totalItems: o,
                                    addUserDialogState: {
                                        open: !1,
                                        loading: !1
                                    }
                                }), null == s || s(null);
                            } catch (e) {
                                n.setTeamState({
                                    addUserDialogState: v({}, o.addUserDialogState, {
                                        loading: !1,
                                        error: Kn(e)
                                    })
                                }), null == s || s(null, e);
                            }
                        }
                    };
                })(e, t, a), ((e, t, a)=>{
                    const n = a, s = async (e, t, a, s)=>{
                        n.setTeamLoader({
                            key: e,
                            value: t
                        });
                        try {
                            await s();
                        } catch (t) {
                            n.setTeamError({
                                key: e,
                                value: Kn(t)
                            }), null == a || a(null, t);
                        } finally{
                            n.setTeamLoader({
                                key: e,
                                value: !1
                            });
                        }
                    };
                    return {
                        resendActivationLink: async (e)=>{
                            const { callback: a } = e, n = f(e, nc);
                            await s(Ns.RESEND_ACTIVATE_LINK, n.userId, a, async ()=>{
                                await t.teams.resendActivationLink(n), null == a || a(!0);
                            });
                        },
                        resendInvitationLink: async (e)=>{
                            const { callback: a } = e, n = f(e, sc);
                            await s(Ns.RESEND_INVITATION_LINK, n.email, a, async ()=>{
                                await t.teams.resendInvitationLink(n), null == a || a(!0);
                            });
                        },
                        resendInvitationEmail: async (e)=>{
                            const { callback: a } = e, n = f(e, ic);
                            await s(Ns.RESEND_INVITATION_LINK, a, n.email, async ()=>{
                                await t.auth.resendInvitationEmail(n), null == a || a(!0);
                            });
                        },
                        resendInvitationLinkToAllSubTenants: async (e)=>{
                            const { callback: a } = e, n = f(e, oc);
                            await s(Ns.RESEND_INVITATION_LINK, n.email, a, async ()=>{
                                await t.teams.resendInvitationLinkToAllTenants(n), null == a || a(!0);
                            });
                        }
                    };
                })(0, t, a), ((e, t, a)=>{
                    const n = a, s = async (e)=>{
                        n.setTeamError({
                            key: Ns.CONFIG_TOKEN_LINK,
                            value: !1
                        });
                        try {
                            const a = await xn(()=>t.teams.getInviteLinkConfiguration(), e);
                            n.setTeamState({
                                inviteTokenState: v({}, a)
                            });
                        } catch (e) {
                            n.setTeamError({
                                key: Ns.CONFIG_TOKEN_LINK,
                                value: Kn(e)
                            });
                        }
                    };
                    return {
                        getInvitationLink: async (a)=>{
                            n.setTeamError({
                                key: Ns.GET_TOKEN_LINK,
                                value: !1
                            });
                            try {
                                const i = null == a ? void 0 : a.retryConfig;
                                await s(i);
                                const o = await xn(()=>t.teams.getInviteUserLink(), i), { inviteTokenState: r } = e.auth.teamState;
                                n.setTeamState({
                                    inviteTokenState: v({}, r, o)
                                });
                            } catch (e) {
                                n.setTeamError({
                                    key: Ns.GET_TOKEN_LINK,
                                    value: Kn(e)
                                });
                            }
                        },
                        createInvitationLink: async (a)=>{
                            const { callback: s, expiresInMinutes: i, shouldSendEmail: o, roleIds: r } = a;
                            n.setTeamError({
                                key: Ns.CREATE_TOKEN_LINK,
                                value: !1
                            });
                            const { inviteTokenState: l } = e.auth.teamState;
                            try {
                                const [e] = await n.getFeatureFlags([
                                    "invite_user_modal_enhancements_frontend"
                                ]);
                                let a;
                                a = e ? await t.teams.createInviteUserLinkV2({
                                    expiresInMinutes: null != i ? i : 43200,
                                    shouldSendEmail: null == o || o,
                                    roleIds: null != r ? r : []
                                }) : await t.teams.createInviteUserLink({
                                    expiresInMinutes: 43200
                                }), n.setTeamState({
                                    inviteTokenState: v({}, l, a)
                                }), null == s || s(a.token);
                            } catch (e) {
                                null == s || s(null, e), n.setTeamError({
                                    key: Ns.CREATE_TOKEN_LINK,
                                    value: Kn(e)
                                });
                            }
                        },
                        updateInvitationLink: async (a)=>{
                            const { callback: s, expiresInMinutes: i, shouldSendEmail: o } = a;
                            n.setTeamError({
                                key: Ns.UPDATE_TOKEN_LINK,
                                value: !1
                            });
                            try {
                                const { inviteTokenState: a } = e.auth.teamState, r = await t.teams.updateInviteUserLink({
                                    expiresInMinutes: i,
                                    shouldSendEmail: o
                                });
                                n.setTeamState({
                                    inviteTokenState: v({}, a, r)
                                }), null == s || s(!0);
                            } catch (e) {
                                null == s || s(null, e), n.setTeamError({
                                    key: Ns.UPDATE_TOKEN_LINK,
                                    value: Kn(e)
                                });
                            }
                        },
                        deleteInvitationLink: async (e)=>{
                            const { callback: a } = null != e ? e : {};
                            n.setTeamError({
                                key: Ns.DELETE_TOKEN_LINK,
                                value: !1
                            });
                            try {
                                await t.teams.deleteInviteUserLink(), await s(), null == a || a(!0);
                            } catch (e) {
                                n.setTeamError({
                                    key: Ns.DELETE_TOKEN_LINK,
                                    value: Kn(e)
                                }), null == a || a(!1, e);
                            }
                        }
                    };
                })(e, t, a));
            }, lc = {
                tenants: [],
                subTenants: [],
                switchingTenant: !1,
                loading: !0,
                tenantTree: null
            }, cc = (e)=>hn(lc, e), uc = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auth.tenantsState, t);
                };
                return {
                    setTenantsState: s,
                    resetTenantsState: ()=>{
                        Wn(e, [
                            "auth",
                            "tenantsState"
                        ], lc);
                    },
                    switchTenant: async (a)=>{
                        const { tenantId: s, silentReload: i, callback: o } = a;
                        i ? n.setTenantsState({
                            switchingTenant: !0
                        }) : n.setAuthState({
                            isLoading: !0
                        });
                        try {
                            await t.tenants.switchTenant({
                                tenantId: s
                            }), i && n.resetAuthState({
                                isLoading: !1,
                                isAuthenticated: !0,
                                user: e.auth.user
                            }), await n.__refreshToken(), (null == o ? void 0 : o(!0)) || (i ? n.setTenantsState({
                                switchingTenant: !1
                            }) : n.setAuthState({
                                isLoading: !1
                            }));
                        } catch (e) {
                            i ? n.setTenantsState({
                                switchingTenant: !1
                            }) : n.setAuthState({
                                isLoading: !1
                            }), null == o || o(!1, e);
                        }
                    },
                    loadTenants: async (t)=>{
                        s({
                            loading: !0
                        });
                        try {
                            var a;
                            const n = yt(e.root.appName), i = await n();
                            s({
                                tenants: i.tenants,
                                activeTenant: i.activeTenant,
                                loading: !1
                            }), null == t || null == (a = t.callback) || a.call(t, []);
                        } catch (e) {
                            var n;
                            null == t || null == (n = t.callback) || n.call(t, [], e), s({
                                loading: !1
                            });
                        }
                    },
                    loadSubTenants: async (e)=>{
                        s({
                            loading: !0
                        });
                        try {
                            var a;
                            const n = await retryIfNeeded(()=>t.tenants.getSubTenants(), null == e ? void 0 : e.retryConfig);
                            s({
                                subTenants: n,
                                loading: !1
                            }), null == e || null == (a = e.callback) || a.call(e, !0);
                        } catch (t) {
                            var n;
                            s({
                                loading: !1
                            }), null == e || null == (n = e.callback) || n.call(e, null, t);
                        }
                    },
                    loadSubTenantsTree: async (e)=>{
                        s({
                            loading: !0
                        });
                        try {
                            var a;
                            const n = await t.tenants.getSubTenantsAsTree();
                            s({
                                tenantTree: n,
                                loading: !1
                            }), null == e || null == (a = e.callback) || a.call(e, !0);
                        } catch (t) {
                            var n;
                            s({
                                loading: !1
                            }), null == e || null == (n = e.callback) || n.call(e, null, t);
                        }
                    }
                };
            }, dc = {
                loading: !1,
                error: null,
                username: void 0,
                fetching: !0
            }, gc = (e)=>hn(dc, e), pc = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.usernamesState, t);
                }, s = async (e)=>{
                    n({
                        loading: !0
                    });
                    try {
                        await t.usernames.deleteUsername(e), n({
                            username: void 0,
                            loading: !1
                        });
                    } catch (e) {
                        n({
                            error: Kn(e)
                        });
                    } finally{
                        n({
                            loading: !1
                        });
                    }
                };
                return {
                    resetUsernamesState: ()=>{
                        Wn(e, [
                            "auth",
                            "usernamesState"
                        ], dc);
                    },
                    loadUserOwnUsername: async ()=>{
                        n({
                            loading: !0
                        });
                        try {
                            const e = await t.usernames.getUserOwnUsername();
                            n({
                                username: null == e ? void 0 : e.username,
                                loading: !1,
                                fetching: !1
                            });
                        } catch (e) {
                            n({
                                error: Kn(e),
                                fetching: !1
                            });
                        } finally{
                            n({
                                loading: !1,
                                fetching: !1
                            });
                        }
                    },
                    saveUserUsername: async (a)=>{
                        n({
                            loading: !0
                        });
                        try {
                            var i, o, r;
                            if (e.auth.usernamesState.username === a.username) return void (null == (i = a.callback) || i.call(a));
                            if (e.auth.usernamesState.username && e.auth.usernamesState.username !== a.username && (await s(e.auth.usernamesState.username), !a.username)) return n({
                                username: void 0,
                                loading: !1
                            }), void (null == (o = a.callback) || o.call(a));
                            a.username && (await t.usernames.createUsername(a), n({
                                username: a.username,
                                loading: !1
                            }), null == (r = a.callback) || r.call(a));
                        } catch (e) {
                            n({
                                error: Kn(e)
                            });
                        } finally{
                            n({
                                loading: !1
                            });
                        }
                    },
                    deleteUserUsername: s
                };
            }, hc = {
                userEmailPolicyConfig: null,
                loading: !1
            }, yc = (e)=>hn(hc, e), Sc = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auth.userEmailPolicyState, t);
                };
                return {
                    loadUserEmailPolicyState: async ()=>{
                        n({
                            loading: !0
                        });
                        try {
                            const e = await t.userEmailPolicy.getUserEmailPolicyConfig();
                            n({
                                loading: !1,
                                userEmailPolicyConfig: e
                            });
                        } catch (e) {
                            n({
                                loading: !1,
                                error: Kn(e)
                            });
                        }
                    },
                    setUserEmailPolicyState: n
                };
            }, vc = (e, t, a)=>{
                const n = (t)=>{
                    e.auth.user && (e.auth.user.entitlements = t);
                }, s = (t)=>{
                    var a;
                    To(null == (a = e.auth.user) ? void 0 : a.entitlements, t) || n(t);
                };
                return {
                    setEntitlements: n,
                    handleFetchedEntitlements: s,
                    loadEntitlements: async (e)=>{
                        const a = null == e ? void 0 : e.callback;
                        try {
                            const e = await t.entitlements.loadEntitlementsV2();
                            s(e), null == a || a(!0);
                        } catch (e) {
                            null == a || a(!1);
                        }
                    }
                };
            };
            let fc;
            !function(e) {
                e[e.Email = 0] = "Email", e[e.Otc = 1] = "Otc", e[e.Success = 2] = "Success";
            }(fc || (fc = {}));
            const mc = [
                "routes"
            ], bc = [
                "requestName"
            ], Ac = (e)=>{
                const t = null != e ? e : {}, { routes: a } = t, n = f(t, mc);
                return hn(v({
                    routes: v({}, Ln, a),
                    onRedirectTo: ()=>{},
                    isAuthenticated: !1,
                    isLoading: !0,
                    isSSOAuth: !1,
                    user: null,
                    error: void 0,
                    errorByRequest: {},
                    userIp: void 0,
                    userIpData: {
                        loading: !1
                    }
                }, n, {
                    acceptInvitationState: vn(null == n ? void 0 : n.acceptInvitationState),
                    accountSettingsState: Jn(null == n ? void 0 : n.accountSettingsState),
                    activateAccountState: ts(null == n ? void 0 : n.activateAccountState),
                    unlockAccountState: zs(null == n ? void 0 : n.unlockAccountState),
                    approvalFlowState: Ys(null == n ? void 0 : n.approvalFlowState),
                    apiTokensState: ei(null == n ? void 0 : n.apiTokensState),
                    applicationsState: si(null == n ? void 0 : n.applicationsState),
                    customLoginState: ri(null == n ? void 0 : n.customLoginState),
                    forgotPasswordState: gi(null == n ? void 0 : n.forgotPasswordState),
                    passwordRotationState: fi(null == n ? void 0 : n.passwordRotationState),
                    groupsState: Ai(null == n ? void 0 : n.groupsState),
                    groupsDialogsState: Oi(null == n ? void 0 : n.groupsDialogsState),
                    impersonateState: Ui(null == n ? void 0 : n.impersonateState),
                    loginState: Ni(null == n ? void 0 : n.loginState),
                    mfaState: Bo(null == n ? void 0 : n.mfaState),
                    allAccountsState: er(null == n ? void 0 : n.allAccountsState),
                    allAccountsDialogsState: ar(null == n ? void 0 : n.allAccountsDialogsState),
                    passkeysState: pr(null == n ? void 0 : n.passkeysState),
                    profileState: Sr(null == n ? void 0 : n.profileState),
                    provisioningState: br(null == n ? void 0 : n.provisioningState),
                    resetPhoneNumberState: Ir(null == n ? void 0 : n.resetPhoneNumberState),
                    rolesState: Lr(null == n ? void 0 : n.rolesState),
                    restrictionsState: Vr(null == n ? void 0 : n.restrictionsState),
                    securityCenterState: Yr(null == n ? void 0 : n.securityCenterState),
                    securityPolicyState: el(null == n ? void 0 : n.securityPolicyState),
                    sessionsPolicyState: ll(null == n ? void 0 : n.sessionsPolicyState),
                    sessionsState: gl(null == n ? void 0 : n.sessionsState),
                    signUpState: Sl(null == n ? void 0 : n.signUpState),
                    smsState: wl(null == n ? void 0 : n.smsState),
                    socialLoginState: Ul(null == n ? void 0 : n.socialLoginState),
                    ssoState: Ml(null == n ? void 0 : n.ssoState),
                    stepUpState: Wl(null == n ? void 0 : n.stepUpState),
                    teamState: Kl(null == n ? void 0 : n.teamState),
                    tenantsState: cc(null == n ? void 0 : n.tenantsState),
                    usernamesState: gc(null == n ? void 0 : n.usernamesState),
                    userEmailPolicyState: yc(null == n ? void 0 : n.userEmailPolicyState)
                }));
            }, wc = (e, t, a, n)=>{
                const s = (t)=>{
                    Object.keys(t).forEach((a)=>{
                        const n = a;
                        Vn(e.auth[n]) ? Object.assign(e.auth[n], t[n]) : e.auth[n] = t[n];
                    });
                }, i = {
                    acceptInvitationActions: qn(e, t),
                    accountSettingsActions: Xn(e, t, a),
                    activateAccountActions: Bs(e, t, a),
                    unlockAccountActions: Hs(e, t),
                    approvalFlowActions: Xs(e, t),
                    apiTokensActions: ai(e, t),
                    applicationsActions: ii(e, t, a),
                    customLoginActions: ci(e, t, a),
                    entitlementsActions: vc(e, t),
                    forgotPasswordActions: yi(e, t),
                    passwordRotationActions: mi(e),
                    groupsActions: Pi(e, t),
                    groupsDialogsActions: ki(e),
                    impersonateActions: Ci(e, t, a),
                    loginActions: jo(e, t, a),
                    mfaActions: Xo(e, t, a),
                    allAccountsActions: ur(e, t, a),
                    allAccountsDialogActions: dr(e),
                    passkeysActions: hr(e, t, a),
                    profileActions: fr(e, t, a),
                    provisioningActions: Tr(e, t),
                    resetPhoneNumberActions: Rr(e, t, a),
                    rolesActions: Gr(e, t),
                    restrictionsActions: Kr(e, t, a),
                    securityCenterActions: Xr(e, t, a),
                    securityPolicyActions: ol(e, t, a),
                    sessionsPolicyActions: ul(e, t, a),
                    sessionsActions: pl(e, t),
                    signUpActions: bl(e, t, a),
                    smsActions: _l(e, t),
                    socialLoginActions: Dl(e, t, a),
                    ssoActions: Vl(e, t, a),
                    stepUpActions: zl(e, t, a),
                    teamActions: rc(e, t, a),
                    tenantsActions: uc(e, t, a),
                    usernamesActions: pc(e, t),
                    usersEmailsPolicyActions: Sc(e, t)
                };
                return [
                    v({
                        setAuthState: s,
                        setErrorByRequestName: (t)=>{
                            let { requestName: a } = t, n = f(t, bc);
                            e.auth.errorByRequest = v({}, e.auth.errorByRequest, {
                                [a]: v({}, n, {
                                    isError: !0
                                })
                            });
                        },
                        setState: s,
                        resetAuthState: (t = {})=>{
                            Wn(e, [
                                "auth"
                            ], v({}, n, t));
                        },
                        setUser: (e)=>{
                            s({
                                user: e
                            });
                        }
                    }, Object.values(i).reduce((e, t)=>v({}, e, t), {})),
                    i
                ];
            }, Tc = {
                isLoading: !1,
                isSaving: !1,
                list: [],
                processIds: [],
                slackChannels: {
                    isLoading: !1
                }
            }, Ec = (e)=>hn(Tc, e), Pc = [
                "email",
                "slack",
                "sms",
                "webhook"
            ], Ic = {
                sms: {
                    title: "connectivity.sms",
                    events: (e)=>(null == e ? void 0 : e.length) || 0,
                    isActive: (e)=>{
                        var t;
                        return null != (t = null == e ? void 0 : e.some(({ enabled: e })=>e)) && t;
                    },
                    image: "sms"
                },
                email: {
                    title: "common.email",
                    events: (e)=>(null == e ? void 0 : e.length) || 0,
                    isActive: (e)=>{
                        var t;
                        return null != (t = null == e ? void 0 : e.some(({ enabled: e })=>e)) && t;
                    },
                    image: "email"
                },
                slack: {
                    title: "connectivity.slack",
                    events: (e)=>{
                        var t;
                        return (null == e || null == (t = e.slackSubscriptions) ? void 0 : t.length) || 0;
                    },
                    isActive: (e)=>!(null == e || !e.slackSubscriptions.some(({ isActive: e })=>e)),
                    image: "slack"
                },
                webhook: {
                    title: "connectivity.webhook",
                    events: (e)=>(null == e ? void 0 : e.length) || 0,
                    isActive: (e)=>{
                        var t;
                        return null != (t = null == e ? void 0 : e.some(({ isActive: e })=>e)) && t;
                    },
                    image: "webhook"
                }
            }, Oc = [
                "id"
            ], kc = [
                "id",
                "enabled"
            ], _c = (e, t, a)=>{
                const n = {
                    slack: t.connectivity.getSlackConfiguration,
                    email: t.connectivity.getEmailConfiguration,
                    sms: t.connectivity.getSMSConfiguration,
                    webhook: t.connectivity.getWebhooksConfigurations,
                    categories: t.connectivity.getCategories,
                    channelMap: t.connectivity.getChannelMaps
                }, s = [
                    "categories",
                    "channelMap"
                ], i = {
                    slack: t.connectivity.postSlackConfiguration,
                    email: t.connectivity.postEmailConfiguration,
                    sms: t.connectivity.postSMSConfiguration,
                    webhook: t.connectivity.postWebhooksConfiguration
                }, o = (t)=>{
                    Object.assign(e.connectivity, t);
                }, r = (t)=>{
                    var a;
                    const n = null != (a = e.connectivity.retryResult) ? a : {};
                    e.connectivity.retryResult = v({}, n, t);
                }, l = ()=>{
                    Wn(e, [
                        "connectivity"
                    ], Tc);
                }, c = async (e, t, a)=>{
                    try {
                        return await xn(()=>n[e](t), a);
                    } catch (e) {
                        return;
                    }
                }, u = async ()=>{
                    try {
                        o({
                            slackChannels: {
                                isLoading: !0
                            }
                        });
                        const e = await t.connectivity.getSlackChannels();
                        o({
                            error: void 0,
                            slackChannels: {
                                isLoading: !1,
                                data: e
                            }
                        });
                    } catch (e) {
                        o({
                            error: void 0,
                            slackChannels: {
                                isLoading: !1
                            }
                        });
                    }
                }, d = async (e)=>{
                    const t = null != e ? e : Pc;
                    o({
                        isLoading: !0
                    });
                    try {
                        const e = await Promise.all([
                            ...t.map((e)=>c(e, void 0, Nn)),
                            c("categories", void 0, Nn),
                            (async ()=>(await Promise.all(t.map((e)=>c("channelMap", e, Nn)))).reduce((e, a, n)=>v({}, e, {
                                        [`${t[n]}`]: a
                                    }), {}))()
                        ]), a = await c("webhook", void 0, Nn), n = e.reduce((a, n, i)=>t[i] ? e[e.length - 1][t[i]].length ? v({}, a, {
                                [`${t[i]}`]: n,
                                list: [
                                    ...a.list,
                                    {
                                        id: i,
                                        key: t[i],
                                        events: Ic[t[i]].events(n),
                                        active: Ic[t[i]].isActive(n),
                                        platform: Ic[t[i]].title,
                                        image: Ic[t[i]].image
                                    }
                                ]
                            }) : a : v({}, a, {
                                [`${s[i - t.length]}`]: n
                            }), {
                            list: [],
                            webhook: a
                        });
                        o(v({}, n, {
                            error: void 0,
                            isSaving: !1,
                            isLoading: !1
                        }));
                    } catch (e) {
                        o({
                            isLoading: !1,
                            error: Kn(e)
                        });
                    }
                }, g = async (t, a)=>{
                    const { list: n } = e.connectivity, s = n.find(({ key: e })=>e === t);
                    if (!s) return;
                    const i = Ic[t].isActive(a);
                    i !== s.active && o({
                        list: n.map((e)=>e.key === t ? v({}, e, {
                                active: i
                            }) : e)
                    });
                }, p = async (a)=>{
                    const { platform: n, data: s, callback: r } = a, l = e.connectivity.processIds;
                    try {
                        if (o({
                            isSaving: !0,
                            processIds: "webhook" === n ? [
                                s._id,
                                ...l
                            ] : l
                        }), "slack" === n ? await (async (a)=>{
                            var n;
                            const s = null == (n = e.connectivity.slack) ? void 0 : n.slackSubscriptions;
                            if (!s) return;
                            const { slackSubscriptions: o } = a;
                            await Promise.all([
                                ...o.reduce((e, t)=>{
                                    var a, n;
                                    return !t.id && t.slackEvents && null != (a = t.slackEvents[0].channelIds) && a.length || (null == s ? void 0 : s.find((e)=>{
                                        let { id: a } = e, n = f(e, Oc);
                                        return a === t.id && JSON.stringify(v({
                                            id: a
                                        }, n)) !== JSON.stringify(t);
                                    })) && t.slackEvents && null != (n = t.slackEvents[0].channelIds) && n.length ? [
                                        ...e,
                                        t
                                    ] : e;
                                }, []).map((e)=>i.slack(e)),
                                ...o.reduce((e, t)=>t.id && !t.slackEvents[0].channelIds.length ? [
                                        ...e,
                                        t
                                    ] : e, []).map((e)=>t.connectivity.deleteSlackConfiguration(e))
                            ]);
                        })(s) : [
                            "sms",
                            "email"
                        ].includes(n) ? await (async (a, n)=>{
                            const s = e.connectivity.processIds, i = e.connectivity[n];
                            if (!i) return;
                            let r = [];
                            try {
                                r = await Promise.all([
                                    ...a.reduce((e, t)=>!i.find(({ eventKey: e })=>e === t.eventKey) && t.subscriptions[0].recipients.filter((e)=>e).length ? [
                                            ...e,
                                            t
                                        ] : e, []).map((e)=>"email" === n ? t.connectivity.postEmailConfiguration(e) : t.connectivity.postSMSConfiguration(e)),
                                    ...a.reduce((e, t)=>{
                                        const a = i.find(({ eventKey: e })=>e === t.eventKey);
                                        return a && JSON.stringify(a) !== JSON.stringify(t) ? [
                                            ...e,
                                            t
                                        ] : e;
                                    }, []).map((e)=>{
                                        const { subscriptions: a, eventKey: s } = e, i = a[0], { id: o = "", enabled: r } = i, l = f(i, kc);
                                        return Promise.all([
                                            "email" === n ? t.connectivity.patchEmailConfiguration({
                                                eventKey: s,
                                                enabled: r
                                            }) : t.connectivity.patchSMSConfiguration({
                                                eventKey: s,
                                                enabled: r
                                            }),
                                            "email" === n ? t.connectivity.putEmailSubscriptions(o, s, v({}, l, {
                                                enabled: r
                                            })) : t.connectivity.putSMSSubscriptions(o, s, v({}, l, {
                                                enabled: r
                                            }))
                                        ]);
                                    }),
                                    ...a.reduce((e, t)=>{
                                        const a = i.find(({ eventKey: e })=>e === t.eventKey);
                                        return a && a.subscriptions[0].recipients.length && !t.subscriptions[0].recipients.filter((e)=>!!e).length ? [
                                            ...e,
                                            t
                                        ] : e;
                                    }, []).map(({ eventKey: e, subscriptions: a })=>"email" === n ? t.connectivity.deleteEmailSubscriptions(e, a[0].id || "") : t.connectivity.deleteSMSSubscriptions(e, a[0].id || ""))
                                ]);
                            } catch  {}
                            if (r.length) {
                                const e = await c(n);
                                o({
                                    error: void 0,
                                    isSaving: !1,
                                    [`${n}`]: e,
                                    processIds: e.id ? s.filter((t)=>t !== e.id) : s
                                }), await g(n, e);
                            } else o({
                                error: void 0,
                                isSaving: !1,
                                [`${n}`]: i,
                                processIds: s
                            });
                        })(s, n) : await i[n](s), ![
                            "sms",
                            "email"
                        ].includes(n)) {
                            const e = await c(n);
                            "webhook" === n && (e.id = s._id), o({
                                error: void 0,
                                isSaving: !1,
                                [`${n}`]: e,
                                processIds: e.id ? l.filter((t)=>t !== e.id) : l
                            }), await g(n, e), null == r || r(!0);
                        }
                    } catch (e) {
                        o({
                            error: Kn(e),
                            isSaving: !1,
                            isLoading: !1
                        });
                    }
                }, h = async (e)=>{
                    try {
                        await t.connectivity.postSlackCode(e);
                    } catch  {}
                    o({
                        error: void 0,
                        isSaving: !1
                    });
                }, y = async ()=>{
                    const a = e.connectivity.slackChannels;
                    try {
                        o({
                            slackChannels: v({}, a, {
                                isLoadingScope: !0
                            })
                        });
                        const { clientId: e } = await t.connectivity.getSlackScope();
                        o({
                            slackChannels: {
                                error: void 0,
                                clientId: e,
                                isLoadingScope: !1,
                                isLoading: !1
                            }
                        });
                    } catch  {
                        o({
                            slackChannels: {
                                error: void 0,
                                isLoadingScope: !1,
                                isLoading: !1
                            }
                        });
                    }
                }, S = async (a)=>{
                    const { callback: n, webhookId: s } = a, i = e.connectivity.processIds;
                    try {
                        o({
                            isSaving: !0
                        }), await t.connectivity.deleteWebhooksConfiguration(s);
                    } catch (e) {
                        null == n || n(null, Kn(e));
                    }
                    const r = await c("webhook");
                    r && o({
                        error: void 0,
                        isSaving: !1,
                        webhook: r,
                        processIds: r.id ? i.filter((e)=>e !== r.id) : i
                    }), null == n || n(!0);
                }, m = async (e)=>{
                    try {
                        o({
                            isTesting: !0
                        });
                        const { statusCode: a, body: n } = await t.connectivity.postWebhookTest(e);
                        if ([
                            201,
                            200
                        ].includes(a)) {
                            const e = JSON.stringify(n, null, 2);
                            o({
                                isTesting: !1,
                                testResult: {
                                    status: "success",
                                    message: e
                                }
                            });
                        } else o({
                            isTesting: !1,
                            testResult: {
                                status: "failed"
                            }
                        });
                    } catch (e) {
                        o({
                            isTesting: !1,
                            testResult: {
                                status: "failed",
                                message: Kn(e)
                            }
                        });
                    }
                }, b = async (e)=>{
                    try {
                        const { statusCode: a } = await t.connectivity.postWebhookRetry(e);
                        r({
                            [e]: {
                                isProcess: !1,
                                success: 202 === a
                            }
                        });
                    } catch (t) {
                        r({
                            [e]: {
                                isProcess: !1,
                                success: !1
                            }
                        });
                    }
                }, A = async (a)=>{
                    const { id: n, limit: s, offset: i } = a, r = e.connectivity.webhookLogs;
                    try {
                        o({
                            webhookLogs: v({}, r, {
                                isLoading: !0
                            })
                        });
                        const e = await t.connectivity.getWebhookLog(n, i, s);
                        o({
                            error: void 0,
                            webhookLogs: v({
                                isLoading: !1
                            }, e)
                        });
                    } catch (e) {
                        o({
                            error: void 0,
                            webhookLogs: {
                                isLoading: !1
                            }
                        });
                    }
                };
                return {
                    setConnectivityState: o,
                    initData: l,
                    resetConnectivityState: l,
                    loadSlackActions: u,
                    loadSlackChannels: u,
                    loadDataAction: d,
                    loadConnectivityChannels: d,
                    postDataAction: p,
                    postChannelData: p,
                    postCodeAction: h,
                    postSlackCode: h,
                    loadScope: y,
                    loadSlackPermissions: y,
                    deleteWebhookConfigAction: S,
                    deleteWebhookConfig: S,
                    postWebhookTestAction: m,
                    postWebhookTest: m,
                    postWebhookRetryAction: b,
                    postWebhookRetry: b,
                    loadWebhookLogsAction: A,
                    loadWebhookLogs: A,
                    cleanWebhookTestData: ()=>{
                        o({
                            testResult: void 0
                        });
                    },
                    cleanWebhookLogsData: async ()=>{
                        o({
                            webhookLogs: void 0
                        });
                    },
                    cleanWebhookTestMessage: async (e)=>{
                        var t;
                        o({
                            testResult: {
                                status: null == (t = e.testResult) ? void 0 : t.status,
                                message: void 0
                            }
                        });
                    },
                    cleanError: async ()=>{
                        o({
                            error: void 0
                        });
                    },
                    cleanSlackData: async ()=>{
                        o({
                            slackChannels: {
                                isLoading: !1
                            }
                        });
                    }
                };
            };
            let Rc;
            !function(e) {
                e.UNKNWON = "unknown", e.CARD = "card";
            }(Rc || (Rc = {}));
            const Uc = {
                loading: !1,
                error: null,
                fetching: !0,
                config: null
            }, Lc = (e)=>hn(Uc, e);
            let Cc, Dc, Nc;
            !function(e) {
                e.STRIPE = "Stripe";
            }(Cc || (Cc = {})), function(e) {
                e.ACTIVE = "ACTIVE", e.CANCELED = "CANCELED", e.INCOMPLETE = "INCOMPLETE", e.EXPIRED = "EXPIRED", e.TRIALING = "TRIALING";
            }(Dc || (Dc = {})), function(e) {
                e.AT_PERIOD_END = "atPeriodEnd";
            }(Nc || (Nc = {}));
            const Mc = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.subscriptions.config, t);
                }, s = (t)=>{
                    Object.assign(e.subscriptions.config, {
                        error: t,
                        loading: !1,
                        fetching: !1
                    });
                };
                return {
                    setPaymentConfigState: n,
                    resetPaymentConfigState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "config"
                        ], Uc);
                    },
                    loadPaymentConfiguration: async ()=>{
                        n({
                            loading: !0
                        });
                        try {
                            var e;
                            (null != (e = await t.subscriptions.getPaymentProviders()) ? e : []).find((e)=>"1" === e.status && e.providerType === W.Stripe) ? await (async ()=>{
                                n({
                                    loading: !0
                                });
                                try {
                                    const e = await t.subscriptions.getStripePaymentProviderConfiguration(), a = {
                                        paymentProvider: Cc.STRIPE,
                                        apiKey: e.publishableKey
                                    };
                                    n({
                                        config: a
                                    }), n({
                                        loading: !1,
                                        fetching: !1
                                    });
                                } catch (e) {
                                    s(Kn(e));
                                }
                            })() : s(Kn("Payment provider not configured"));
                        } catch (e) {
                            s(Kn(e));
                        }
                    }
                };
            }, Fc = {
                loading: !1,
                error: null,
                fetching: !0
            }, xc = (e)=>hn(Fc, e);
            function $c({ policy: e }) {
                return {
                    policy: Nc.AT_PERIOD_END
                };
            }
            function Gc(e) {
                switch(e){
                    case j.ACTIVE:
                        return Dc.ACTIVE;
                    case j.INCOMPLETE:
                        return Dc.INCOMPLETE;
                    case j.CANCELED:
                        return Dc.CANCELED;
                    case j.EXPIRED:
                        return Dc.EXPIRED;
                    case j.TRIALING:
                        return Dc.TRIALING;
                    default:
                        return Dc.EXPIRED;
                }
            }
            const jc = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.subscriptions.billing.information, t);
                }, i = (e)=>{
                    s({
                        error: e,
                        loading: !1,
                        fetching: !1
                    });
                }, o = async (a, o)=>{
                    s({
                        loading: !0
                    });
                    try {
                        var r, l;
                        const i = await t.subscriptions.getSubscriptionSummaries(a), { currentPlanId: c, externallyManaged: u } = i;
                        let d, g = null;
                        u ? d = await t.subscriptions.getSubscriptionPlan(c) : ([, d] = await Promise.all([
                            n.loadSubscription(),
                            t.subscriptions.getSubscriptionPlan(c)
                        ]), g = e.subscriptions.billing.subscription.subscription || null), s(v({
                            loading: !1,
                            fetching: !1,
                            summary: i
                        }, g ? {
                            subscription: {
                                id: g.id,
                                externalId: g.externalId,
                                startDate: g.startDate,
                                currentPeriodStart: g.currentPeriodStart,
                                currentPeriodEnd: g.currentPeriodEnd,
                                status: o ? Dc.ACTIVE : Gc(g.status),
                                cancellation: g.cancellation && $c(g.cancellation),
                                trialEnd: g.trialEnd ? g.trialEnd : null
                            }
                        } : {}, d ? {
                            plan: {
                                id: d.id,
                                name: d.name,
                                description: d.description,
                                price: (null == (r = d.price) ? void 0 : r.amount) || 0,
                                currency: (null == (l = d.price) ? void 0 : l.currency) || "usd",
                                recurringInterval: "month",
                                slug: d.slug
                            }
                        } : {}));
                    } catch (e) {
                        i(Kn(e));
                    }
                };
                return {
                    setBillingInformationState: s,
                    resetBillingInformationState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "billing",
                            "information"
                        ], Fc);
                    },
                    loadSummaries: o,
                    loadBillingInformation: async (t)=>{
                        var a, n;
                        const s = null == (a = e.subscriptions.config.config) ? void 0 : a.paymentProvider, r = null == (n = e.auth.user) ? void 0 : n.tenantId;
                        s && r ? await o(r, t) : i(new K(s ? "Not authorized" : "Internal feature failure", 500, null));
                    }
                };
            }, Vc = {
                loading: !1,
                error: null,
                fetching: !0,
                invoices: [],
                invoiceDownload: {
                    loading: !1,
                    error: null
                }
            }, Bc = (e)=>hn(Vc, e), Wc = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.subscriptions.billing.invoices, t);
                }, s = (t)=>{
                    Object.assign(e.subscriptions.billing.invoices.invoiceDownload, t);
                }, i = async ()=>{
                    n({
                        loading: !0
                    });
                    try {
                        const e = (await t.subscriptions.getSubscriptionInvoices()).map((e)=>({
                                id: e.id,
                                externalId: e.externalId,
                                subscriptionId: e.subscriptionId,
                                paymentDate: new Date(Date.parse(e.paymentDate)),
                                totalAmount: +((e.totalAmount || 0) / 100).toFixed(2),
                                currency: e.currency || "usd",
                                paid: e.paid || !1,
                                receiptNumber: e.receiptNumber
                            }));
                        n({
                            loading: !1,
                            fetching: !1,
                            invoices: e
                        });
                    } catch (t) {
                        e = Kn(t), n({
                            error: e,
                            loading: !1,
                            fetching: !1
                        });
                    }
                    var e;
                }, o = async (e)=>{
                    s({
                        loading: !0,
                        error: null
                    });
                    try {
                        await t.subscriptions.getSubscriptionInvoicePdf(e.invoiceId, e.filename), s({
                            loading: !1,
                            error: null
                        });
                    } catch (e) {
                        s({
                            loading: !1,
                            error: Kn(e, null)
                        });
                    }
                };
                return {
                    setBillingInvoiceState: n,
                    resetBillingInvoiceState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "billing",
                            "invoices"
                        ], Vc);
                    },
                    loadInvoices: i,
                    loadBillingInvoices: i,
                    downloadInvoice: o,
                    downloadBillingInvoice: o
                };
            }, zc = {
                loading: !1,
                error: null,
                fetching: !0
            }, Hc = (e)=>hn(zc, e), Kc = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.subscriptions.billing.paymentMethod, t);
                }, s = (e)=>{
                    n({
                        loading: e
                    });
                }, i = (e)=>{
                    n({
                        error: e,
                        loading: !1,
                        fetching: !1
                    });
                }, o = async ()=>{
                    s(!0);
                    try {
                        const e = (await t.subscriptions.getPaymentMethods())[0];
                        n({
                            paymentMethod: e,
                            loading: !1,
                            fetching: !1
                        });
                    } catch (e) {
                        i(Kn(e));
                    }
                };
                return {
                    setBillingPaymentMethodState: n,
                    resetBillingPaymentMethodState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "billing",
                            "paymentMethod"
                        ], zc);
                    },
                    loadPaymentMethod: o,
                    submitPaymentMethod: async ()=>{
                        s(!0);
                    },
                    submitPaymentMethodError: async (e)=>{
                        i(e);
                    },
                    submitPaymentMethodSuccess: async ()=>await o(),
                    updatePaymentMethodBillingDetails: async (e)=>{
                        s(!0);
                        const { id: a, email: n, address: r, callback: l } = e;
                        try {
                            await t.subscriptions.updatePaymentMethodBillingDetails(a, v({
                                email: n
                            }, r)), await o(), null == l || l(!0);
                        } catch (e) {
                            i(Kn(e)), null == l || l(!1, e);
                        } finally{
                            s(!1);
                        }
                    }
                };
            }, qc = {
                loading: !1,
                error: null,
                fetching: !0,
                cancellation: {
                    loading: !1,
                    error: null
                },
                renewal: {
                    loading: !1,
                    error: null
                }
            }, Yc = (e)=>hn(qc, e), Jc = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.subscriptions.billing.subscription, t);
                }, i = (e)=>{
                    s({
                        error: e,
                        loading: !1,
                        fetching: !1
                    });
                }, o = (t)=>{
                    Object.assign(e.subscriptions.billing.subscription.cancellation, {
                        loading: t
                    });
                }, r = (t)=>{
                    Object.assign(e.subscriptions.billing.subscription.cancellation, {
                        error: t
                    });
                }, l = (t)=>{
                    Object.assign(e.subscriptions.billing.subscription.renewal, {
                        loading: t
                    });
                }, c = (t)=>{
                    Object.assign(e.subscriptions.billing.subscription.renewal, {
                        error: t
                    });
                }, u = async ()=>{
                    s({
                        loading: !0
                    });
                    try {
                        const [e] = await t.subscriptions.getManagedSubscriptions();
                        s({
                            subscription: e,
                            fetching: !1,
                            loading: !1,
                            error: null
                        });
                    } catch (e) {
                        i(Kn(e));
                    }
                };
                return {
                    setBillingSubscriptionState: s,
                    resetBillingSubscriptionState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "billing",
                            "subscription"
                        ], qc);
                    },
                    setCancellationLoading: o,
                    setCancellationError: r,
                    setRenewalLoading: l,
                    setRenewalError: c,
                    loadSubscription: u,
                    loadSubscriptionTenant: async ()=>{
                        var t;
                        const a = null == (t = e.auth.user) ? void 0 : t.tenantId;
                        a ? await n.loadSummaries(a) : i(new K("TenantId is not defined", 500, null));
                    },
                    cancelSubscription: async ()=>{
                        const { subscription: a } = e.subscriptions.billing.subscription;
                        if (!a) return void r(new K("Subscription not found", 500, null));
                        if (null != a && a.externallyManaged) return void r(new K("Billing is externally managed", 500, null));
                        const { id: n, cancellation: s, status: i } = a || {};
                        if (!s && i === j.ACTIVE) try {
                            o(!0), await t.subscriptions.cancelManagedSubscription(n), await u(), o(!1);
                        } catch (e) {
                            r(Kn(e));
                        }
                    },
                    renewSubscription: async ()=>{
                        const { subscription: a } = e.subscriptions.billing.subscription;
                        if (!a) return void c(new K("Subscription not found", 500, null));
                        if (null != a && a.externallyManaged) return void c(new K("Billing is externally managed", 500, null));
                        const { id: n, cancellation: s } = a || {};
                        if ((null == s ? void 0 : s.policy) === B.AT_PERIOD_END) try {
                            l(!0), await t.subscriptions.renewManagedSubscription(n), await u(), l(!1);
                        } catch (e) {
                            c(Kn(e));
                        }
                    }
                };
            }, Qc = (e)=>hn({
                    information: xc(null == e ? void 0 : e.information),
                    invoices: Bc(null == e ? void 0 : e.invoices),
                    paymentMethod: Hc(null == e ? void 0 : e.paymentMethod),
                    subscription: Yc(null == e ? void 0 : e.subscription)
                }), Xc = {
                loading: !1,
                error: null,
                fetching: !0,
                plans: []
            }, Zc = (e)=>hn(Xc, e), eu = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.subscriptions.plans, t);
                };
                return {
                    setPlansState: n,
                    resetPlansState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "plans"
                        ], Xc);
                    },
                    loadPlans: async ()=>{
                        n({
                            loading: !0
                        });
                        try {
                            const e = (await t.subscriptions.getSubscriptionPlans()).map((e)=>{
                                var t, a;
                                return {
                                    id: e.id,
                                    name: e.name,
                                    description: e.description,
                                    price: (null == (t = e.price) ? void 0 : t.amount) || 0,
                                    currency: (null == (a = e.price) ? void 0 : a.currency) || "usd",
                                    recurringInterval: "month",
                                    slug: e.slug
                                };
                            });
                            n({
                                fetching: !1,
                                loading: !1,
                                plans: e
                            });
                        } catch (t) {
                            e = Kn(t), n({
                                loading: !1,
                                fetching: !1,
                                error: e
                            });
                        }
                        var e;
                    }
                };
            }, tu = {
                fetching: !0,
                loading: !1,
                error: null,
                confirmed: !1
            }, au = (e)=>hn(tu, e), nu = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.subscriptions.checkout, t);
                };
                return {
                    setCheckoutState: s,
                    resetCheckoutState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "checkout"
                        ], tu);
                    },
                    loadCheckout: ()=>{
                        s({
                            fetching: !1,
                            loading: !1,
                            error: null,
                            confirmed: !1
                        });
                    },
                    resetCheckout: ()=>{
                        s({
                            loading: !1,
                            error: null,
                            confirmed: !1
                        });
                    },
                    submitCheckout: ()=>{
                        s({
                            loading: !0,
                            error: null
                        });
                    },
                    confirmCheckout: async (a)=>{
                        const { paymentMethodId: i, planId: o } = a, r = e.subscriptions.billing.subscription.subscription, l = e.subscriptions.billing.information.summary, c = (null == r ? void 0 : r.status) === j.TRIALING, u = !(null == l || !l.paymentMethodId);
                        if (r) {
                            if (s({
                                loading: !0,
                                error: null
                            }), c && u) return s({
                                loading: !1,
                                error: null,
                                confirmed: !0
                            }), void n.setBillingSubscriptionState({
                                subscription: v({}, r, {
                                    status: j.ACTIVE
                                })
                            });
                            try {
                                await t.subscriptions.updateManagedSubscription(r.id, {
                                    paymentMethodId: i,
                                    planId: o
                                }), await Promise.all([
                                    n.loadBillingInformation(),
                                    n.loadPaymentMethod(),
                                    n.loadInvoices()
                                ]), s({
                                    loading: !1,
                                    error: null,
                                    confirmed: !0
                                });
                            } catch (e) {
                                s({
                                    loading: !1,
                                    error: Kn(e)
                                });
                            }
                        } else s({
                            loading: !1,
                            error: new K("Subscription not found", 500, null)
                        });
                    },
                    errorCheckout: (e)=>{
                        s({
                            loading: !1,
                            error: e
                        });
                    }
                };
            }, su = {
                loading: !1,
                error: null,
                cardSetupIntentSecret: null
            }, iu = (e)=>hn(su, e), ou = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.subscriptions.stripe, t);
                };
                return {
                    createCardSetupIntentSecret: async (a)=>{
                        n({
                            loading: !0,
                            error: null,
                            cardSetupIntentSecret: null
                        });
                        try {
                            const e = {};
                            a && (e.paymentMethodId = a);
                            const { setupIntentSecret: s } = await t.subscriptions.createStripePaymentMethodSetupIntentSecret(e);
                            n({
                                cardSetupIntentSecret: s,
                                loading: !1
                            });
                        } catch (t) {
                            s = Kn(t), Object.assign(e.subscriptions.stripe, {
                                error: s,
                                loading: !1,
                                fetching: !1
                            });
                        }
                        var s;
                    },
                    setStripeState: n,
                    resetStripeState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "stripe"
                        ], su);
                    }
                };
            }, ru = {
                loading: !1,
                fetching: !0,
                vendorPublicConfig: null
            }, lu = (e)=>hn(ru, e), cu = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.subscriptions.vendorPublicConfig, t);
                }, s = (t)=>{
                    Object.assign(e.subscriptions.vendorPublicConfig, {
                        error: t,
                        loading: !1,
                        fetching: !1
                    });
                }, i = (t)=>{
                    Object.assign(e.subscriptions.vendorPublicConfig, {
                        error: null,
                        loading: t
                    });
                };
                return {
                    setVendorPublicConfigState: n,
                    resetVendorPublicConfigState: ()=>{
                        Wn(e, [
                            "subscriptions",
                            "vendorPublicConfig"
                        ], ru);
                    },
                    setVendorPublicConfigError: s,
                    setVendorPublicConfigLoading: i,
                    loadVendorPublicConfiguration: async ()=>{
                        i(!0);
                        try {
                            const e = await t.subscriptions.getVendorPublicConfigurations();
                            n({
                                fetching: !1,
                                loading: !1,
                                vendorPublicConfig: e
                            });
                        } catch (e) {
                            s(Kn(e));
                        }
                    }
                };
            }, uu = (e)=>hn({
                    config: Lc(null == e ? void 0 : e.config),
                    billing: Qc(null == e ? void 0 : e.billing),
                    plans: Zc(null == e ? void 0 : e.plans),
                    checkout: au(null == e ? void 0 : e.checkout),
                    stripe: iu(null == e ? void 0 : e.stripe),
                    vendorPublicConfig: lu(null == e ? void 0 : e.vendorPublicConfig)
                }), du = (e, t, a)=>{
                const n = Mc(e, t), [s, i] = ((e, t, a)=>{
                    const n = jc(e, t, a), s = Kc(e, t), i = Wc(e, t), o = Jc(e, t, a);
                    return [
                        v({}, n, s, i, o),
                        {
                            information: n,
                            invoices: i,
                            paymentMethod: s,
                            subscription: o
                        }
                    ];
                })(e, t, a), o = eu(e, t), r = nu(e, t, a), l = ou(e, t), c = cu(e, t);
                return [
                    v({}, n, s, o, r, l, c),
                    {
                        config: n,
                        billing: i,
                        plans: o,
                        checkout: r,
                        stripe: l,
                        vendorPublicConfig: c
                    }
                ];
            }, gu = {
                loading: !1
            }, pu = (e)=>hn(gu, e), hu = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.vendor, t);
                }, s = async (e)=>{
                    n({
                        loading: !0
                    });
                    try {
                        var a;
                        const s = await xn(()=>t.vendor.getVendorPublicInfo(), null == e ? void 0 : e.retryConfig);
                        s.whiteLabelMode = null != (a = s.whiteLabelMode) && a, n(v({}, s, {
                            loading: !1
                        }));
                    } catch (e) {
                        n({
                            loading: !1
                        }), console.error("failed to getVendorPublicInfo - ", e);
                    }
                };
                return {
                    setVendorState: n,
                    resetVendorState: ()=>{
                        Wn(e, [
                            "vendor"
                        ], gu);
                    },
                    loadVendorPublicInfo: s,
                    loadVendorPublicConfiguration: s
                };
            }, yu = {
                loading: !0,
                pageOffset: 0,
                pageSize: 20,
                logs: [],
                sort: [],
                filter: [],
                totalPages: 0,
                isDownloadingCsv: !1
            }, Su = (e)=>hn(yu, e), vu = (e, t, a)=>{
                const n = a, s = (t)=>{
                    Object.assign(e.auditLogs.auditLogsState, t);
                };
                return {
                    setAuditLogsState: s,
                    resetAuditLogsState: ()=>{
                        Wn(e, [
                            "auditLogs",
                            "auditLogsState"
                        ], yu);
                    },
                    exportAuditsCsv: async ()=>{
                        const a = e.auditLogs.auditLogsState, { columns: n } = e.auditLogs.auditsMetadataState;
                        try {
                            const e = a.filter, i = a.sort.reduce((e, t)=>v({}, e, {
                                    sortBy: t.id,
                                    sortDirection: t.desc ? "desc" : "asc"
                                }), {}), o = e.reduce((e, t)=>v({}, e, {
                                    [t.id]: t.value
                                }), {});
                            s({
                                isDownloadingCsv: !0
                            });
                            const r = "audits.csv";
                            await t.audits.exportAudits(v({
                                endpoint: "csv/v2",
                                headerProps: n,
                                offset: 0,
                                outputFileName: r
                            }, i, o));
                        } catch (e) {
                            console.error("failed to export audits - ", e);
                        }
                        s({
                            isDownloadingCsv: !1
                        });
                    },
                    loadAuditLogs: async (a)=>{
                        s({
                            loading: !(null != a && a.silentLoading),
                            error: null
                        });
                        const i = e.auditLogs.auditLogsState, o = null == a ? void 0 : a.retryConfig, { columns: r } = e.auditLogs.auditsMetadataState;
                        try {
                            var l, c, u, d, g;
                            const e = null != (l = a.pageSize) ? l : i.pageSize, p = null != (c = a.pageOffset) ? c : i.pageOffset, h = null != (u = a.filter) ? u : i.filter, y = null != (d = a.sort) ? d : i.sort;
                            s({
                                pageSize: e,
                                pageOffset: p,
                                filter: h,
                                sort: y
                            });
                            const S = y.reduce((e, t)=>v({}, e, {
                                    sortBy: t.id,
                                    sortDirection: t.desc ? "desc" : "asc"
                                }), {}), f = h.reduce((e, t)=>v({}, e, {
                                    [t.id]: t.value
                                }), {});
                            r || await n.loadAuditsMetadata({
                                retryConfig: o
                            });
                            const { data: m, total: b } = await xn(()=>t.audits.getAudits(v({
                                    offset: p,
                                    count: e
                                }, S, f)), o);
                            s({
                                loading: !1,
                                logs: null != m ? m : [],
                                totalPages: +Math.ceil(b / e)
                            }), null == a || null == (g = a.callback) || g.call(a, !0);
                        } catch (e) {
                            var p;
                            s({
                                loading: !1,
                                error: Kn(e)
                            }), null == a || null == (p = a.callback) || p.call(a, null, e);
                        }
                    }
                };
            }, fu = {
                loading: !0
            }, mu = (e)=>hn(fu, e), bu = (e, t, a)=>{
                const n = (t)=>{
                    Object.assign(e.auditLogs.auditsMetadataState, t);
                };
                return {
                    setAuditsMetadataState: n,
                    resetAuditsMetadataState: ()=>{
                        Wn(e, [
                            "auditLogs",
                            "auditsMetadataState"
                        ], fu);
                    },
                    loadAuditsMetadata: async (e)=>{
                        n({
                            loading: !0,
                            error: null
                        });
                        try {
                            const { properties: a } = await xn(()=>t.metadata.getAuditsMetadata(), null == e ? void 0 : e.retryConfig);
                            n({
                                columns: a,
                                loading: !1
                            });
                        } catch (e) {
                            n({
                                error: e,
                                loading: !1
                            });
                        }
                    }
                };
            }, Au = (e)=>({
                    auditLogsState: Su(null == e ? void 0 : e.auditLogsState),
                    auditsMetadataState: mu(null == e ? void 0 : e.auditsMetadataState)
                }), wu = (e, t, a)=>v({}, vu(e, t, a), bu(e, t)), Tu = {
                total: 0,
                offset: 0,
                filter: "",
                sortBy: "createdAt",
                context: null,
                filters: [],
                rowsData: [],
                lastUpdated: new Date,
                isLoading: !0,
                isFetchMore: !1,
                totalToday: 0,
                currentPage: 0,
                headerProps: [],
                sortDirection: "desc",
                severeThisWeek: 0,
                predefinedFilters: [],
                isDownloadingCsv: !1,
                virtualScroll: !1
            }, Eu = (e, t)=>Object.keys(e).reduce((a, n)=>{
                    const s = n;
                    return t.includes(n) ? v({}, a, {
                        [n]: e[s]
                    }) : v({}, a, {
                        [n]: ()=>{
                            console.debug(`Action ${String(n)} was called`);
                        }
                    });
                }, {}), Pu = {
                clientId: "CLIENT_ID_16806d3d-8fc3-4450-be97-abdaf66b723e",
                secret: "SECRET_16806d3d-8fc3-4450-be97-abdaf66b723e",
                createdAt: "createdAt",
                description: "Demo API Token (preview only)"
            }, Iu = v({}, Pu, {
                roleIds: [],
                tenantId: "my-tenant-id",
                createdByUserId: "createdByUserId"
            }), Ou = [
                {
                    id: "a040dcf6-b907-4e83-9970-6bd23c88fd40",
                    key: "ReadOnly",
                    name: "Read Only",
                    description: null,
                    isDefault: !1,
                    createdAt: new Date,
                    updatedAt: new Date,
                    permissions: [
                        "8d71b676-754c-4600-afe7-ca5add1e6809",
                        "04dbcc11-61db-40a9-9577-9b73e50d1d03"
                    ],
                    vendorId: "vendorId"
                },
                {
                    id: "b43b2c4b-e056-4eec-8c55-d200a475bbc0",
                    key: "Admin",
                    name: "Admin",
                    description: null,
                    isDefault: !0,
                    createdAt: new Date,
                    updatedAt: new Date,
                    permissions: [
                        "8d71b676-754c-4600-afe7-ca5add1e6809",
                        "04dbcc11-61db-40a9-9577-9b73e50d1d03",
                        "16647407-ed6f-4ca6-83a0-86225d921959",
                        "f403c6b9-1abe-4ec7-9971-aa032255fc25",
                        "a43e059d-d731-44b1-94bb-fb6b16c62210"
                    ],
                    vendorId: "vendorId"
                },
                {
                    id: "1234",
                    key: "Support",
                    name: "Support",
                    description: null,
                    isDefault: !0,
                    createdAt: new Date,
                    updatedAt: new Date,
                    permissions: [
                        "8d71b676-754c-4600-afe7-ca5add1e6809",
                        "04dbcc11-61db-40a9-9577-9b73e50d1d03",
                        "f26b00f8-ffe0-4739-b15c-7db15c27ea26",
                        "a9c803b0-ebfa-49b9-9607-f0d3a390ee61"
                    ],
                    tenantId: "tenantId",
                    vendorId: "vendorId"
                }
            ], ku = {
                sub: "",
                tenants: [],
                id: "testId",
                name: "Demo User Name",
                email: "demo-user@frontegg.com",
                mfaEnrolled: !0,
                profilePictureUrl: "https://www.gravatar.com/avatar/42b2ad2bad6fc9b9db5086dfcf8072ac?d=https://ui-avatars.com/api/fe/128/random?t=1617261890875?t=1617261917434",
                roles: [
                    {
                        id: "roleId",
                        key: "admin",
                        isDefault: !1,
                        name: "Admin",
                        description: null,
                        permissions: [
                            "8d71b676-754c-4600-afe7-ca5add1e6809",
                            "04dbcc11-61db-40a9-9577-9b73e50d1d03"
                        ],
                        tenantId: "tenantId",
                        vendorId: "vendorId",
                        createdAt: new Date,
                        updatedAt: new Date
                    }
                ],
                permissions: [
                    {
                        id: "8d71b676-754c-4600-afe7-ca5add1e6809",
                        key: "fe.*",
                        name: "General Admin",
                        description: "description",
                        categoryId: "category",
                        fePermission: !0,
                        createdAt: new Date,
                        updatedAt: new Date,
                        roleIds: []
                    }
                ],
                tenantId: "my-tenant-id",
                tenantIds: [
                    "my-tenant-id"
                ],
                activatedForTenant: !0,
                metadata: JSON.stringify({
                    phoneNumber: "+972-54123456",
                    jobTitle: "Developer",
                    address: {
                        city: "Tel Aviv",
                        country: "Israel"
                    }
                }),
                verified: !1
            }, _u = v({}, ku, {
                accessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI1MTY5YmY0Zi02YmI5LTQ5NGMtOGNkZS05MDc4NDQ0NWY4MDciLCJuYW1lIjoiRHVtbXkgVXNlciIsImVtYWlsIjoiZHVtbXlAZnJvbnRlZ2cuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsIm1ldGFkYXRhIjp7fSwicm9sZXMiOlsiYWRtaW4iXSwicGVybWlzc2lvbnMiOlsiZmUuKiJdLCJ0ZW5hbnRJZCI6Im15LXRlbmFudC1pZCIsInRlbmFudElkcyI6WyJteS10ZW5hbnQtaWQiXSwicHJvZmlsZVBpY3R1cmVVcmwiOiJodHRwczovL3d3dy5ncmF2YXRhci5jb20vYXZhdGFyLzQyYjJhZDJiYWQ2ZmM5YjlkYjUwODZkZmNmODA3MmFjP2Q9aHR0cHM6Ly91aS1hdmF0YXJzLmNvbS9hcGkvZmUvMTI4L3JhbmRvbT90PTE2MTcyNjE4OTA4NzU_dD0xNjE3MjYxOTE3NDM0IiwidHlwZSI6InVzZXJUb2tlbiIsImlhdCI6MTYxNzkwNjMyNCwiZXhwIjoxNjE3OTkyNzI0LCJpc3MiOiJmcm9udGVnZyJ9.paaXLkpWEWbQmUtoK2P8IwXCxK4WJp7XhXonvzF8g1I",
                expiresIn: 86400,
                mfaRequired: !1,
                refreshToken: "refresh-token-dummy-de39dc9c-9d22-4852-b7f5-c3c0aa613b58",
                type: "userToken",
                iat: 1617906324,
                exp: 1617992724,
                iss: "frontegg",
                email_verified: !0
            }), Ru = {
                loading: !1,
                error: void 0,
                saving: !0,
                profile: ku
            }, Uu = {
                id: "id",
                enforceMFAType: "DontForce",
                createdAt: new Date,
                updatedAt: new Date,
                allowOverrideEnforcePasswordHistory: !0,
                allowOverridePasswordComplexity: !1,
                allowOverridePasswordExpiration: !1,
                allowSignups: !0,
                apiTokensEnabled: !0,
                cookieSameSite: "cookieSameSite",
                defaultRefreshTokenExpiration: 0,
                defaultTokenExpiration: 1,
                publicKey: "publicKey"
            }, Lu = {
                allowSignups: !0,
                allowNotVerifiedUsersLogin: !1,
                apiTokensEnabled: !0,
                forcePermissions: !1,
                authStrategy: M.EmailAndPassword,
                machineToMachineAuthStrategy: F.ClientCredentials
            }, Cu = {
                id: "id",
                enforceMFAType: "DontForce",
                createdAt: new Date,
                updatedAt: new Date
            }, Du = {
                id: "id",
                enabled: !0,
                maxAttempts: 1,
                createdAt: new Date,
                updatedAt: new Date
            }, Nu = {
                id: "id",
                enabled: !0,
                historySize: 1,
                createdAt: new Date,
                updatedAt: new Date
            }, Mu = {
                enabled: !0,
                domain: "domain",
                validated: !0,
                generatedVerification: "generatedVerification",
                ssoEndpoint: "ssoEndpoint",
                publicCertificate: "publicCertificate",
                signRequest: !0,
                createdAt: new Date,
                updatedAt: new Date,
                acsUrl: void 0,
                spEntityId: void 0,
                oidcClientId: void 0,
                oidcSecret: void 0,
                type: void 0
            }, Fu = {
                id: "id",
                createdAt: "createdAt",
                updatedAt: "updatedAt",
                properties: [],
                vendorId: "vendorId",
                entityName: "saml",
                isActive: !0,
                configuration: {
                    acsUrl: "acsUrl",
                    spEntityId: "spEntityId"
                }
            }, xu = [
                {
                    id: "id",
                    description: "description",
                    key: "key",
                    name: "name",
                    permissions: [],
                    permissionLevel: 1
                }
            ], $u = {
                firstLoad: !1,
                loading: !1,
                error: void 0,
                saving: !1,
                samlConfiguration: Mu,
                roles: xu,
                authorizationRoles: [],
                errors: {},
                loaders: {},
                ssoConfigurations: []
            }, Gu = [
                {
                    description: "string",
                    fePermission: !0,
                    id: "id",
                    key: "key",
                    name: "name",
                    roleIds: [],
                    createdAt: new Date,
                    updatedAt: new Date,
                    categoryId: "categoryId"
                }
            ], ju = {
                id: "id2",
                email: "demo-user2@frontegg.com",
                name: "Demo User Name2",
                phone: void 0,
                profileImage: void 0,
                profileImageUrl: void 0,
                tenantId: "tenantId",
                vendorId: "vendorId",
                roleIds: [],
                activatedForTenant: !0,
                verified: !1,
                createdAt: (new Date).toISOString(),
                customData: void 0,
                lastLogin: void 0,
                mfaEnabled: void 0,
                roles: [
                    Ou[0]
                ],
                groups: [
                    {
                        id: "id2",
                        name: "Developers",
                        color: "#03A9F4",
                        roles: [
                            Ou[0]
                        ],
                        managedBy: Qa.FRONTEGG
                    }
                ]
            }, Vu = {
                id: ju.id,
                email: ju.email,
                name: ju.name,
                phoneNumber: void 0,
                profileImage: void 0,
                tenantId: "tenantId",
                activatedForTenant: !0,
                createdAt: new Date(2022, 4, 1),
                verified: !0,
                lastLogin: new Date(2022, 5, 25),
                mfaEnrolled: !1,
                roles: [
                    Ou[1]
                ],
                tenantIds: [],
                metadata: "",
                sub: "",
                tenants: []
            }, Bu = {
                id: "id",
                email: "demo-user@frontegg.com",
                name: "Demo User Name",
                phone: void 0,
                profileImage: void 0,
                profileImageUrl: void 0,
                tenantId: "tenantId",
                vendorId: "vendorId",
                roleIds: [],
                activatedForTenant: !0,
                createdAt: new Date(2022, 4, 1).toISOString(),
                verified: !0,
                customData: void 0,
                lastLogin: new Date(2022, 5, 25).toISOString(),
                mfaEnabled: void 0,
                roles: [
                    Ou[1]
                ],
                groups: [
                    {
                        id: "id1",
                        name: "Designers",
                        color: "#E1F5E2",
                        roles: [
                            Ou[0]
                        ],
                        managedBy: Qa.FRONTEGG
                    }
                ]
            }, Wu = {
                id: Bu.id,
                email: Bu.email,
                name: Bu.name,
                phoneNumber: void 0,
                profileImage: void 0,
                tenantId: "tenantId",
                activatedForTenant: !0,
                createdAt: new Date(2022, 4, 1),
                verified: !0,
                lastLogin: new Date(2022, 5, 25),
                mfaEnrolled: !1,
                roles: [
                    Ou[1]
                ],
                tenantIds: [],
                metadata: "",
                sub: "",
                tenants: []
            }, zu = {
                metadata: "",
                mfaEnrolled: !1,
                provider: "",
                sub: "",
                tenantIds: [],
                tenants: [],
                verified: !1,
                id: "id",
                email: "email",
                name: "name",
                tenantId: "tenantId",
                createdAt: new Date
            }, Hu = [
                Bu,
                ju
            ], Ku = [
                Wu,
                Vu
            ], qu = [
                zu
            ], Yu = [
                {
                    id: "my-tenant-id",
                    isReseller: !1,
                    name: "Frontegg demo",
                    deletedAt: null,
                    metadata: void 0,
                    tenantId: "my-tenant-id",
                    vendorId: "vendorId",
                    createdAt: new Date,
                    updatedAt: new Date,
                    address: void 0,
                    timezone: void 0,
                    dateFormat: void 0,
                    timeFormat: void 0,
                    currency: void 0,
                    logo: void 0
                }
            ], Ju = [
                {
                    id: "laptop",
                    userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.0 Safari/605.1.15",
                    createdAt: new Date,
                    ipAddress: "190.194.88.251",
                    current: !0
                },
                {
                    id: "iphone",
                    userAgent: "Mozilla/5.0 (iPhone; CPU iPhone OS 15_2_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.2 Mobile/15E148 Safari/604.1",
                    createdAt: new Date(Date.now() - 1e4),
                    ipAddress: "191.49.203.21"
                },
                {
                    id: "tablet",
                    userAgent: "Mozilla/5.0 (Linux; Android 6.0.1; SGP771 Build/32.2.A.0.253; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/52.0.2743.98 Safari/537.36",
                    createdAt: new Date(Date.now() - 3e4),
                    ipAddress: "130.19.196.136"
                },
                {
                    id: "anotherlaptop",
                    userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.0 Safari/605.1.15",
                    createdAt: new Date(Date.now() - 1002232300),
                    ipAddress: "2.228.163.92"
                }
            ], Qu = {
                isActive: !0,
                strategy: Xe.ALLOW
            }, Xu = [
                {
                    updatedAt: new Date,
                    createdAt: new Date,
                    id: "1",
                    ip: "255.255.255.255",
                    isActive: !0,
                    strategy: Xe.ALLOW,
                    description: "My IP"
                },
                {
                    updatedAt: new Date,
                    createdAt: new Date,
                    id: "2",
                    ip: "255.255.255.254",
                    isActive: !0,
                    strategy: Xe.ALLOW,
                    description: "IP 2"
                },
                {
                    updatedAt: new Date,
                    createdAt: new Date,
                    id: "3",
                    ip: "255.255.255.253",
                    isActive: !0,
                    strategy: Xe.BLOCK,
                    description: "IP 3"
                },
                {
                    updatedAt: new Date,
                    createdAt: new Date,
                    id: "4",
                    ip: "255.255.255.253",
                    isActive: !0,
                    strategy: Xe.BLOCK,
                    description: "IP 4"
                }
            ], Zu = (e)=>{
                const t = [];
                return Array.from({
                    length: e
                }).forEach((e, a)=>{
                    t.push(v({}, Bu, {
                        name: "Demo User",
                        id: `id${a}`,
                        profilePictureUrl: null,
                        createdAt: new Date
                    }));
                }), t;
            }, ed = (e)=>({
                    id: "b43b2c4b-e056-4eec-8c55-d200a475bbc0" + e,
                    key: e,
                    name: e,
                    description: null,
                    isDefault: !0,
                    createdAt: new Date,
                    updatedAt: new Date,
                    permissions: [],
                    tenantId: "tenantId",
                    vendorId: "vendorId"
                }), td = [
                {
                    id: "id1",
                    name: "Designers",
                    color: "#E1F5E2",
                    description: "The whole design team",
                    users: Zu(6),
                    roles: [
                        ed("Editor")
                    ],
                    metadata: '{"lastTermsCheck":"2022-08-16T10:31:11.270Z"}',
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id2",
                    name: "Developers",
                    color: "#03A9F4",
                    description: "All frontend and backend developers",
                    users: Zu(44),
                    roles: [
                        ed("Editor")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id3",
                    name: "Product",
                    color: "#E1583E",
                    description: "PMs and team leads",
                    users: Zu(8),
                    roles: [
                        ed("Viewer")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id4",
                    name: "Management",
                    color: "#9AE0FF",
                    description: "Executives",
                    users: Zu(5),
                    roles: [
                        ed("Admin")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id5",
                    name: "Sales",
                    color: "#ED8E7C",
                    users: Zu(21),
                    description: "BDR, AE, and inside sales",
                    roles: [
                        ed("Viewer")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id6",
                    name: "Support",
                    color: "#A79D7B",
                    users: Zu(23),
                    description: "Dev success and customer success",
                    roles: [
                        ed("Admin")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id7",
                    name: "Marketing",
                    color: "#2CA744",
                    users: Zu(10),
                    description: "The marketing department",
                    roles: [
                        ed("Viewer")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id8",
                    name: "HR",
                    color: "#EAE1C2",
                    users: Zu(4),
                    description: "Human resources",
                    roles: [
                        ed("Viewer")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id9",
                    name: "Finance",
                    color: "#5587C0",
                    users: Zu(3),
                    roles: [
                        ed("Viewer")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id10",
                    name: "Operations",
                    color: "#B1CAE7",
                    users: Zu(8),
                    roles: [
                        ed("Editor")
                    ],
                    managedBy: Qa.FRONTEGG
                },
                {
                    id: "id11",
                    name: "Legal",
                    color: "#2CA744",
                    users: Zu(4),
                    roles: [
                        ed("Viewer")
                    ],
                    managedBy: Qa.FRONTEGG
                }
            ], ad = {
                scoring: {
                    score: 79
                },
                recommendations: {
                    items: [
                        {
                            code: an.FORCE_MFA,
                            severity: on.WARNING,
                            category: rn.MFA
                        },
                        {
                            code: an.ENABLE_FORCE_RELOGIN,
                            severity: on.WARNING,
                            category: rn.SESSIONS
                        }
                    ]
                }
            }, nd = {
                insights: {
                    items: [
                        {
                            category: rn.MFA,
                            code: nn.PARTIALLY_FORCED_MFA,
                            metadata: {
                                totalUsers: 2,
                                mfa: {
                                    enrolledUsersCount: 1
                                }
                            }
                        },
                        {
                            category: rn.SESSIONS,
                            code: nn.PARTIAL_SESSION_SETTINGS,
                            metadata: {
                                totalUsers: 2,
                                sessions: {
                                    idleTimeoutRecommendation: 1800
                                }
                            }
                        },
                        {
                            category: rn.PASSWORD,
                            code: nn.IMPROVE_PASSWORD_HISTORY_POLICY,
                            metadata: {
                                password: {
                                    userLockoutRecommendation: 5,
                                    historyRecommendations: 5
                                }
                            }
                        },
                        {
                            category: rn.DOMAIN,
                            code: nn.NO_IP_RESTRICTIONS,
                            metadata: {
                                restrictions: {
                                    ipsCount: 1,
                                    domainsCount: 1
                                }
                            }
                        }
                    ]
                }
            }, sd = {
                users: Ku,
                totalUsersItems: 2,
                totalUsersPages: 1,
                usersPageOffset: 0
            }, id = {
                users: [
                    Ku[0]
                ],
                totalUsersItems: 1,
                totalUsersPages: 1,
                usersPageOffset: 0,
                queryParams: {
                    _maxInactiveSeconds: 7776e3
                }
            }, od = {
                users: [
                    Ku[1]
                ],
                totalUsersItems: 1,
                totalUsersPages: 1,
                usersPageOffset: 0
            };
            Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE, Ga.ASSIGNABLE;
            var rd, ld = new Uint8Array(16);
            function cd() {
                if (!rd && !(rd = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                return rd(ld);
            }
            const ud = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            for(var dd = [], gd = 0; gd < 256; ++gd)dd.push((gd + 256).toString(16).substr(1));
            const pd = function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, a = (dd[e[t + 0]] + dd[e[t + 1]] + dd[e[t + 2]] + dd[e[t + 3]] + "-" + dd[e[t + 4]] + dd[e[t + 5]] + "-" + dd[e[t + 6]] + dd[e[t + 7]] + "-" + dd[e[t + 8]] + dd[e[t + 9]] + "-" + dd[e[t + 10]] + dd[e[t + 11]] + dd[e[t + 12]] + dd[e[t + 13]] + dd[e[t + 14]] + dd[e[t + 15]]).toLowerCase();
                if (!function(e) {
                    return "string" == typeof e && ud.test(e);
                }(a)) throw TypeError("Stringified UUID is invalid");
                return a;
            }, hd = function(e, t, a) {
                var n = (e = e || {}).random || (e.rng || cd)();
                if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, t) {
                    a = a || 0;
                    for(var s = 0; s < 16; ++s)t[a + s] = n[s];
                    return t;
                }
                return pd(n);
            }, yd = [
                "callback"
            ], Sd = [
                "callback"
            ], vd = [
                "callback",
                "profilePictureUrl"
            ], fd = [
                "callback"
            ], md = [
                "callback"
            ], bd = [
                "callback"
            ], Ad = [
                "callback"
            ], wd = [
                "callback"
            ], Td = [
                "callback"
            ], Ed = [
                "callback"
            ], Pd = [
                "callback"
            ], Id = [
                "callback",
                "samlVendor"
            ], Od = [
                "callback"
            ], kd = [
                "callback"
            ], _d = [
                "callback",
                "profileImage"
            ], Rd = [
                "callback"
            ], Ud = [
                "callback"
            ], Ld = [
                "callback"
            ], Cd = [
                "callback"
            ], Dd = [
                "callback"
            ], Nd = [
                "callback"
            ], Md = [
                "callback"
            ], Fd = [
                "callback"
            ], xd = [
                "requestName"
            ], $d = (e)=>"createdAt" !== e.id, Gd = {
                total: 20,
                data: Array.from(Array(5).keys()).map((e)=>v({
                        ip: "198.143.51.1",
                        user: "Demo User Name",
                        email: "demo-user@frontegg.com"
                    }, (()=>{
                        switch(Math.floor(6 * Math.random())){
                            case 0:
                                return {
                                    action: "Updated profile",
                                    description: "User updated profile details",
                                    severity: "Info"
                                };
                            case 1:
                                return {
                                    action: "User logged in",
                                    severity: "Info",
                                    description: "User logged in to the product"
                                };
                            case 2:
                                return {
                                    action: "User failed to login",
                                    severity: "High",
                                    description: "User failed to login with password"
                                };
                            case 3:
                                return {
                                    action: "Added user",
                                    severity: "Info",
                                    description: "Added user david+535@frontegg.com to tenant"
                                };
                            case 4:
                                return {
                                    action: "Assigned roles",
                                    severity: "Info",
                                    description: "Assigned 0 roles for user"
                                };
                            case 5:
                                return {
                                    action: "Removed user david+108@frontegg.com from account",
                                    severity: "Info",
                                    description: "Removed access from the account for user david+108@frontegg.com"
                                };
                        }
                    })(), {
                        json: {
                            key1: "value1",
                            key2: "value2",
                            key3: "value3",
                            key4: "value4"
                        },
                        tenantId: "my-tenant-id",
                        vendorId: "my-vendor-id",
                        userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.114 Safari/537.36",
                        createdAt: `2022-04-07 10:${50 - e}:40.201`
                    }))
            }, jd = {
                properties: [
                    {
                        showInTable: !0,
                        name: "createdAt",
                        displayName: "Time",
                        type: "Timestamp",
                        sortable: !0,
                        filterable: !0,
                        showInMoreInfo: "Always",
                        chosen: !1,
                        selected: !1,
                        isPredefined: !1
                    },
                    {
                        showInTable: !0,
                        name: "email",
                        displayName: "User",
                        type: "Email",
                        filterable: !0,
                        sortable: !0,
                        isPredefined: !0,
                        chosen: !1,
                        selected: !1
                    },
                    {
                        showInTable: !0,
                        name: "action",
                        displayName: "Action",
                        type: "AlphaNumeric",
                        sortable: !0,
                        filterable: !0,
                        showInMoreInfo: "Always",
                        chosen: !1,
                        selected: !1,
                        isPredefined: !0
                    },
                    {
                        showInTable: !0,
                        name: "description",
                        type: "AlphaNumeric",
                        sortable: !1,
                        filterable: !1,
                        displayName: "Description",
                        isPredefined: !0,
                        chosen: !1,
                        selected: !1
                    },
                    {
                        showInTable: !0,
                        name: "ip",
                        displayName: "IP Address",
                        type: "IpAddress",
                        sortable: !0,
                        filterable: !0,
                        showInMoreInfo: "Always",
                        chosen: !1,
                        selected: !1,
                        isPredefined: !0
                    },
                    {
                        showInTable: !1,
                        name: "severity",
                        displayName: "Severity",
                        type: "Severity",
                        sortable: !0,
                        filterable: !0,
                        showInMoreInfo: "Always",
                        chosen: !1,
                        selected: !1,
                        isPredefined: !0
                    },
                    {
                        showInTable: !1,
                        name: "userAgent",
                        displayName: "User Agent",
                        type: "AlphaNumeric",
                        filterable: !0,
                        sortable: !0,
                        isPredefined: !0,
                        chosen: !1,
                        selected: !1
                    },
                    {
                        showInTable: !1,
                        name: "json",
                        type: "Json",
                        sortable: !0,
                        filterable: !0,
                        displayName: "Json Data",
                        showInMoreInfo: "Always",
                        isPredefined: !1
                    }
                ]
            }, Vd = (e, t, a)=>{
                const n = ((e, t, a)=>{
                    const n = vu(e, t, a), s = Eu(n, [
                        "setAuditLogsState",
                        "resetAuditLogsState"
                    ]);
                    return s.loadAuditLogs = async (t)=>{
                        s.setAuditLogsState({
                            loading: !t.silentLoading,
                            error: null
                        });
                        const n = e.auditLogs.auditLogsState, { columns: i } = e.auditLogs.auditsMetadataState;
                        try {
                            var o, r, l, c, u;
                            const e = null != (o = t.pageSize) ? o : n.pageSize, d = null != (r = t.pageOffset) ? r : n.pageOffset, g = null != (l = t.filter) ? l : n.filter, p = null != (c = t.sort) ? c : n.sort;
                            s.setAuditLogsState({
                                pageSize: e,
                                pageOffset: d,
                                filter: g,
                                sort: p
                            }), i || await a.loadAuditsMetadata();
                            const { data: h, total: y } = ((e, t)=>{
                                const { data: a } = Gd;
                                let n = a.filter(((e)=>(t)=>e.filter($d).every((e)=>t[e.id].includes(e.value)))(e));
                                if (t.length) {
                                    const { id: e, desc: a = !1 } = t[0];
                                    n = n.sort(((e, t)=>(a, n)=>a[e] > n[e] ? t ? -1 : 1 : n[e] > a[e] ? t ? 1 : -1 : 0)(e, a));
                                }
                                return {
                                    data: n,
                                    total: n.length
                                };
                            })(g, p);
                            s.setAuditLogsState({
                                loading: !1,
                                logs: null != h ? h : [],
                                totalPages: +Math.ceil(y / e)
                            }), null == t || null == (u = t.callback) || u.call(t, !0);
                        } catch (e) {
                            var d;
                            s.setAuditLogsState({
                                loading: !1,
                                error: Kn(e)
                            }), null == t || null == (d = t.callback) || d.call(t, null, e);
                        }
                    }, s;
                })(e, t, a), s = ((e, t)=>{
                    const a = bu(e, t), n = Eu(a, [
                        "setAuditsMetadataState",
                        "resetAuditsMetadataState"
                    ]);
                    return n.loadAuditsMetadata = async ()=>{
                        n.setAuditsMetadataState({
                            loading: !0,
                            error: null
                        });
                        try {
                            const { properties: e } = jd;
                            n.setAuditsMetadataState({
                                columns: e,
                                loading: !1
                            });
                        } catch (e) {
                            n.setAuditsMetadataState({
                                error: e,
                                loading: !1
                            });
                        }
                    }, n;
                })(e, t);
                return v({}, n, s);
            }, Bd = {
                id: "sub_1JbhYVEwsu4qiqnnfMhYAdY6",
                externalId: "sub_1JbhYVEwsu4qiqnnfMhYAdY6",
                startDate: "2021-09-20T08:08:51.000Z",
                status: j.ACTIVE,
                externallyManaged: !1,
                cancellation: null,
                currentPeriodStart: "2021-09-20T08:08:51.000Z",
                currentPeriodEnd: "2021-10-20T08:08:51.000Z",
                plan: {
                    slug: "test"
                }
            }, Wd = [
                {
                    id: "prod_J60fUEvI7qV1eL",
                    externalId: "prod_J60fUEvI7qV1eL",
                    name: "Premium",
                    description: "",
                    price: {
                        id: "price_1IToe8Ewsu4qiqnndAV76J69",
                        externalId: "price_1IToe8Ewsu4qiqnndAV76J69",
                        currency: "usd",
                        amount: 1e4
                    },
                    slug: "premium"
                },
                {
                    id: "prod_J60duauCpXfcur",
                    externalId: "prod_J60duauCpXfcur",
                    name: "Free",
                    description: "Totally free plan. Nothing to pay.",
                    price: {
                        id: "price_1ITocfEwsu4qiqnnnBHDx9fQ",
                        externalId: "price_1ITocfEwsu4qiqnnnBHDx9fQ",
                        currency: "usd",
                        amount: 0
                    },
                    slug: "free"
                }
            ], zd = [
                {
                    id: "in_1JbhYWEwsu4qiqnnrUh6hsHa",
                    externalId: "in_1JbhYWEwsu4qiqnnrUh6hsHa",
                    subscriptionId: "sub_1JbhYVEwsu4qiqnnfMhYAdY6",
                    paymentDate: "2021-09-20T08:08:51.000Z",
                    totalAmount: 1e4,
                    currency: "usd",
                    paid: !0,
                    receiptNumber: ""
                },
                {
                    id: "in_1JbhYWEwsu4qiqnnrUh6hsHa",
                    externalId: "in_1JbhYWEwsu4qiqnnrUh6hsHa",
                    subscriptionId: "sub_1JbhYVEwsu4qiqnnfMhYAdY6",
                    paymentDate: "2021-08-20T08:08:51.000Z",
                    totalAmount: 1e4,
                    currency: "usd",
                    paid: !0,
                    receiptNumber: ""
                }
            ], Hd = [
                {
                    id: "id",
                    externalId: "externalId",
                    type: V.CARD,
                    isDefault: !0,
                    last4: "4242",
                    expMonth: 11,
                    expYear: 25,
                    brand: "visa",
                    billingDetails: {
                        name: "Dummy",
                        email: "dummy@email.com"
                    }
                }
            ], Kd = {
                allowPlanDowngrade: !0,
                allowPlanCancellation: !0
            }, qd = (e, t, a)=>{
                const n = ((e, t)=>{
                    const a = Mc(e, t), n = Eu(a, [
                        "setPaymentConfigState",
                        "resetPaymentConfigState"
                    ]);
                    return n.loadPaymentConfiguration = async ()=>{
                        n.setPaymentConfigState({
                            loading: !0
                        }), await Mn(500), n.setPaymentConfigState({
                            loading: !1,
                            fetching: !1,
                            config: {
                                paymentProvider: Cc.STRIPE,
                                apiKey: ""
                            }
                        });
                    }, n;
                })(e, t), [s, i] = ((e, t, a)=>{
                    const n = ((e, t, a)=>{
                        const n = jc(e, t, a), s = Eu(n, [
                            "setBillingInformationState",
                            "resetBillingInformationState"
                        ]);
                        return s.loadBillingInformation = async ()=>{
                            var e, t;
                            s.setBillingInformationState({
                                loading: !0
                            }), await Mn(500), s.setBillingInformationState({
                                loading: !1,
                                fetching: !1,
                                summary: {
                                    subscriptionId: Bd.id,
                                    paymentMethodId: "mockPaymentMethodId",
                                    tenantConfigurationId: "mockTenantConfigurationId",
                                    providerType: W.Stripe,
                                    externallyManaged: !1,
                                    currentPlanId: Wd[0].id,
                                    defaultPlanId: Wd[0].id
                                },
                                plan: v({}, Wd[0], {
                                    price: null == (e = Wd[0].price) ? void 0 : e.amount,
                                    currency: null == (t = Wd[0].price) ? void 0 : t.currency,
                                    recurringInterval: "month"
                                })
                            });
                        }, s;
                    })(e, t, a), s = ((e, t)=>{
                        const a = Kc(e, t), n = Eu(a, [
                            "setBillingPaymentMethodState",
                            "resetBillingPaymentMethodState"
                        ]);
                        return n.loadPaymentMethod = async ()=>{
                            n.setBillingPaymentMethodState({
                                loading: !0
                            }), await Mn(500), n.setBillingPaymentMethodState({
                                paymentMethod: Hd[0],
                                loading: !1,
                                fetching: !1
                            });
                        }, n;
                    })(e, t), i = ((e, t)=>{
                        const a = Wc(e, t), n = Eu(a, [
                            "setBillingInvoiceState",
                            "resetBillingInvoiceState"
                        ]);
                        return n.loadBillingInvoices = async ()=>{
                            n.setBillingInvoiceState({
                                loading: !0
                            }), await Mn(500), n.setBillingInvoiceState({
                                loading: !1,
                                fetching: !1,
                                invoices: zd.map((e)=>v({}, e, {
                                        selectedPlan: "Premium",
                                        paymentDate: new Date(Date.parse(e.paymentDate)),
                                        totalAmount: +((e.totalAmount || 0) / 100).toFixed(2)
                                    }))
                            });
                        }, n.loadInvoices = n.loadBillingInvoices, n;
                    })(e, t), o = ((e, t, a)=>{
                        const n = Jc(e, t, a), s = Eu(n, [
                            "setBillingSubscriptionState",
                            "resetBillingSubscriptionState",
                            "setCancellationLoading",
                            "setCancellationError",
                            "setRenewalLoading",
                            "setRenewalError"
                        ]);
                        return s.loadSubscription = async ()=>{
                            s.setBillingSubscriptionState({
                                loading: !0
                            }), await Mn(500), s.setBillingSubscriptionState({
                                subscription: Bd,
                                fetching: !1,
                                loading: !1,
                                error: null
                            });
                        }, s;
                    })(e, t, a);
                    return [
                        v({}, n, s, i, o),
                        {
                            information: n,
                            invoices: i,
                            paymentMethod: s,
                            subscription: o
                        }
                    ];
                })(e, t, a), o = ((e, t)=>{
                    const a = eu(e, t), n = Eu(a, [
                        "setPlansState",
                        "resetPlansState"
                    ]);
                    return n.loadPlans = async ()=>{
                        n.setPlansState({
                            loading: !0
                        }), await Mn(500), n.setPlansState({
                            fetching: !1,
                            loading: !1,
                            plans: Wd.map((e)=>{
                                var t, a;
                                return v({}, e, {
                                    price: (null == (t = e.price) ? void 0 : t.amount) || 0,
                                    currency: (null == (a = e.price) ? void 0 : a.currency) || "usd",
                                    recurringInterval: "month"
                                });
                            })
                        });
                    }, n;
                })(e, t), r = ((e, t, a)=>{
                    const n = nu(e, t, a);
                    return Eu(n, [
                        "setCheckoutState",
                        "resetCheckoutState",
                        "errorCheckout",
                        "resetCheckout"
                    ]);
                })(e, t, a), l = ((e, t)=>{
                    const a = ou(e, t);
                    return Eu(a, []);
                })(e, t), c = ((e, t)=>{
                    const a = cu(e, t), n = Eu(a, [
                        "setVendorPublicConfigState",
                        "resetVendorPublicConfigState",
                        "setVendorPublicConfigError",
                        "setVendorPublicConfigLoading"
                    ]);
                    return n.loadVendorPublicConfiguration = async ()=>{
                        n.setVendorPublicConfigLoading(!0), await Mn(), n.setVendorPublicConfigState({
                            fetching: !1,
                            loading: !1,
                            vendorPublicConfig: Kd
                        });
                    }, n;
                })(e, t);
                return [
                    v({}, n, s, o, r, l, c),
                    {
                        config: n,
                        billing: i,
                        plans: o,
                        checkout: r,
                        stripe: l,
                        vendorPublicConfig: c
                    }
                ];
            }, Yd = (e, t, a, n)=>{
                const { authActions: s, authStateActions: i } = ((e, t, a, n)=>{
                    const s = ((e, t)=>{
                        const a = qn(e, t);
                        return Eu(a, [
                            "setAcceptInvitationState",
                            "resetAcceptInvitationState"
                        ]);
                    })(e, t), i = ((e, t, a)=>{
                        const n = Xn(e, t, a), s = Eu(n, [
                            "setAccountSettingsState",
                            "resetAccountSettingsState"
                        ]);
                        return s.saveAccountSettings = async (t)=>{
                            var a;
                            s.setAccountSettingsState({
                                loading: !0
                            }), await Mn();
                            const n = e.auth.accountSettingsState, { address: i, timezone: o, dateFormat: r, timeFormat: l, currency: c, logo: u } = n, d = v({
                                address: i,
                                timezone: o,
                                dateFormat: r,
                                timeFormat: l,
                                currency: c,
                                logo: u
                            }, t);
                            s.setAccountSettingsState(v({}, d, {
                                loading: !1
                            })), null == (a = t.callback) || a.call(t, d);
                        }, s.loadAccountSettings = async (e)=>{
                            s.setAccountSettingsState({
                                loading: !(null != e && e.silentLoading),
                                error: null
                            }), await Mn(), s.setAccountSettingsState(v({
                                address: "Tel-aviv",
                                timezone: "Asia/Jerusalem",
                                dateFormat: "DD/MM/YYYY",
                                timeFormat: "HH:mm",
                                currency: "USD",
                                loading: !1
                            }, e));
                        }, s;
                    })(e, t, a), o = ((e, t)=>{
                        const a = Hs(e, t);
                        return Eu(a, [
                            "setUnlockAccountState",
                            "resetUnlockAccountState"
                        ]);
                    })(e, t), r = ((e, t, a)=>{
                        const n = Bs(e, t, a);
                        return Eu(n, [
                            "setActivateState",
                            "resetActivateState",
                            "setActivateStrategyState"
                        ]);
                    })(e, t, a), l = ((e, t)=>{
                        const a = Xs(e, t);
                        return Eu(a, [
                            "setApprovalFlowState",
                            "resetApprovalFlowState",
                            "getApprovalExecutionData"
                        ]);
                    })(e, t), c = ((e, t, a)=>{
                        const n = ur(e, t, a);
                        return Eu(n, [
                            "setAllAccountsLoader",
                            "setAllAccountsError",
                            "setAllAccountsState",
                            "setSelectedAccountState",
                            "resetAllAccountsState",
                            "clearSelectedAccount"
                        ]);
                    })(e, t, a), u = dr(e), d = ((e, t)=>{
                        const a = ai(e, t), n = Eu(a, [
                            "setApiTokensState",
                            "resetApiTokensState",
                            "setApiTokensLoader",
                            "setApiTokensError"
                        ]);
                        return n.addTenantApiToken = async (t)=>{
                            const { description: a, roleIds: s, callback: i } = t;
                            n.setApiTokensLoader({
                                key: ti.ADD_API_TOKEN,
                                value: !0
                            });
                            const { apiTokensDataTenant: o } = e.auth.apiTokensState, r = v({}, Iu, {
                                description: a,
                                roleIds: s,
                                clientId: `CLIENT_ID_${hd()}`
                            });
                            n.setApiTokensState({
                                showAddTokenDialog: !1
                            }), await Mn(200), n.setApiTokensState({
                                apiTokensDataTenant: [
                                    ...o,
                                    r
                                ],
                                successDialog: {
                                    open: !0,
                                    secret: r.secret,
                                    clientId: r.clientId
                                }
                            }), await Mn(200), n.setApiTokensLoader({
                                key: ti.ADD_API_TOKEN,
                                value: !1
                            }), null == i || i(null);
                        }, n.deleteTenantApiToken = async (e)=>{
                            n.setApiTokensLoader({
                                key: ti.DELETE_API_TOKEN,
                                value: !0
                            }), await Mn(200);
                            const t = [
                                Iu
                            ];
                            n.setApiTokensState({
                                apiTokensDataTenant: t.filter((t)=>t.clientId !== e),
                                deleteTokenDialog: {
                                    open: !1,
                                    clientId: e
                                }
                            }), n.setApiTokensLoader({
                                key: ti.DELETE_API_TOKEN,
                                value: !1
                            });
                        }, n.loadApiTokens = async (e)=>{
                            var t;
                            null != e && e.silentLoading || n.setApiTokensLoader({
                                key: ti.LOAD_API_TOKENS,
                                value: !0
                            });
                            const a = [
                                Pu
                            ], s = [
                                Iu
                            ];
                            n.setApiTokensState({
                                apiTokensDataUser: a,
                                apiTokensDataTenant: s
                            }), await Mn(200), n.setApiTokensLoader({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (t = e.callback) || t.call(e, !0);
                        }, n.loadUserApiTokens = async (e)=>{
                            var t;
                            null != e && e.silentLoading || n.setApiTokensLoader({
                                key: ti.LOAD_API_TOKENS,
                                value: !0
                            });
                            const a = [
                                Pu
                            ];
                            n.setApiTokensState({
                                apiTokensDataUser: a
                            }), await Mn(200), n.setApiTokensLoader({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (t = e.callback) || t.call(e, !0);
                        }, n.loadTenantApiTokens = async (e)=>{
                            var t;
                            null != e && e.silentLoading || n.setApiTokensLoader({
                                key: ti.LOAD_API_TOKENS,
                                value: !0
                            });
                            const a = [
                                Iu
                            ];
                            n.setApiTokensState({
                                apiTokensDataTenant: a
                            }), await Mn(200), n.setApiTokensLoader({
                                key: ti.LOAD_API_TOKENS,
                                value: !1
                            }), null == e || null == (t = e.callback) || t.call(e, !0);
                        }, n;
                    })(e, t), g = ((e, t, a)=>{
                        const n = ii(e, t, a);
                        return Eu(n, [
                            "setApplicationsState",
                            "resetApplicationsState"
                        ]);
                    })(e, t, a), p = ((e, t, a)=>{
                        const n = ci(e, t, a), s = Eu(n, [
                            "setCustomLoginState",
                            "resetCustomLoginState"
                        ]);
                        return s.loadTenantMetadata = async ()=>{
                            s.setCustomLoginState({
                                loading: !0
                            }), await Mn(), s.setCustomLoginState({
                                loading: !1
                            });
                        }, s.updateTenantMetadata = async (e)=>{
                            const { callback: t } = e;
                            s.setCustomLoginState({
                                loading: !0,
                                error: null
                            }), await Mn(), s.setCustomLoginState({
                                loading: !1,
                                error: null
                            }), null == t || t(!0);
                        }, s;
                    })(e, t, a), h = ((e, t)=>{
                        const a = vc(e, t);
                        return Eu(a, [
                            "setEntitlements",
                            "handleFetchedEntitlements"
                        ]);
                    })(e, t), y = ((e, t)=>{
                        const a = yi(e, t), n = Eu(a, [
                            "setForgotPasswordState",
                            "resetForgotPasswordState"
                        ]);
                        return n.loadPasswordConfig = async (e)=>{
                            n.setForgotPasswordState({
                                loading: !0
                            });
                            try {
                                n.setForgotPasswordState({
                                    loading: !1,
                                    passwordConfig: {
                                        allowPassphrases: !0,
                                        maxLength: 128,
                                        minLength: 6,
                                        minPhraseLength: 6,
                                        minOptionalTestsToPass: 1
                                    }
                                });
                            } catch (e) {
                                n.setForgotPasswordState({
                                    loading: !1,
                                    error: Kn(e)
                                });
                            }
                        }, n;
                    })(e, t), S = ((e)=>{
                        const t = mi(e), a = Eu(t, [
                            "setStep"
                        ]);
                        return a.setStep(Si.success), a;
                    })(e), m = ((e, t)=>{
                        const a = Pi(e, t), n = Eu(a, [
                            "setGroupsState",
                            "resetUsersGroupsState",
                            "setUsersGroupsLoader",
                            "setUsersGroupsError"
                        ]);
                        return n.loadGroups = async ()=>{
                            const e = wi.GET_GROUPS;
                            n.setUsersGroupsLoader({
                                key: e,
                                value: !0
                            });
                            const t = td;
                            n.setGroupsState({
                                groups: t
                            }), n.setUsersGroupsLoader({
                                key: e,
                                value: !1
                            });
                        }, n.createGroup = async (t)=>{
                            var a;
                            const s = wi.CREATE_GROUP, { groups: i } = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: s,
                                value: !0
                            }), await Mn(500), n.setGroupsState({
                                groups: [
                                    v({}, t, {
                                        id: `${t.name}ID`,
                                        managedBy: Qa.FRONTEGG
                                    }),
                                    ...null != i ? i : []
                                ]
                            }), null == t || null == (a = t.callback) || a.call(t, !0), n.setUsersGroupsLoader({
                                key: s,
                                value: !1
                            });
                        }, n.updateGroup = async (t)=>{
                            var a, s, i, o, r;
                            const l = wi.UPDATE_GROUP, c = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: l,
                                value: !0
                            }), await Mn(500), n.setGroupsState({
                                groups: null == c || null == (a = c.groups) ? void 0 : a.map((e)=>{
                                    var a;
                                    return e.id === t.groupId ? v({}, t, {
                                        id: t.groupId,
                                        name: null != (a = null == t ? void 0 : t.name) ? a : "",
                                        managedBy: Qa.FRONTEGG
                                    }) : e;
                                }),
                                selectedGroup: v({}, null == c ? void 0 : c.selectedGroup, {
                                    name: null != (s = null == t ? void 0 : t.name) ? s : "",
                                    color: null != (i = null == t ? void 0 : t.color) ? i : "",
                                    description: null != (o = null == t ? void 0 : t.description) ? o : ""
                                })
                            }), null == t || null == (r = t.callback) || r.call(t, !0), n.setUsersGroupsLoader({
                                key: l,
                                value: !1
                            });
                        }, n.deleteGroup = async (t)=>{
                            var a, s;
                            const i = wi.DELETE_GROUP, o = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await Mn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.filter((e)=>e.id !== t.groupId)
                            }), null == t || null == (s = t.callback) || s.call(t, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.addRolesToGroup = async (t)=>{
                            var a, s;
                            const i = wi.ADD_ROLES_TO_GROUP, o = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await Mn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.map((e)=>{
                                    var a;
                                    return e.id === t.groupId ? v({}, e, {
                                        roles: [
                                            ...null != (a = null == e ? void 0 : e.roles) ? a : [],
                                            ...t.roleIds.map((e)=>({
                                                    id: e,
                                                    name: e
                                                }))
                                        ]
                                    }) : e;
                                })
                            }), null == t || null == (s = t.callback) || s.call(t, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.deleteRolesFromGroup = async (t)=>{
                            var a, s;
                            const i = wi.DELETE_ROLES_FROM_GROUP, o = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await Mn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.map((e)=>{
                                    var a;
                                    return e.id === t.groupId ? v({}, e, {
                                        roles: null == e || null == (a = e.roles) ? void 0 : a.filter((e)=>!t.roleIds.includes(e.id))
                                    }) : e;
                                })
                            }), null == t || null == (s = t.callback) || s.call(t, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.addUsersToGroup = async (t)=>{
                            var a, s;
                            const i = wi.ADD_USERS_TO_GROUP, o = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await Mn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.map((e)=>{
                                    var a;
                                    return e.id === t.groupId ? v({}, e, {
                                        users: [
                                            ...null != (a = null == e ? void 0 : e.users) ? a : [],
                                            ...t.userIds.map((e)=>({
                                                    id: e,
                                                    name: e
                                                }))
                                        ]
                                    }) : e;
                                })
                            }), null == t || null == (s = t.callback) || s.call(t, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.deleteUsersFromGroup = async (t)=>{
                            var a, s;
                            const i = wi.DELETE_USERS_FROM_GROUP, o = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: i,
                                value: !0
                            }), await Mn(500), n.setGroupsState({
                                groups: null == o || null == (a = o.groups) ? void 0 : a.map((e)=>{
                                    var a;
                                    return e.id === t.groupId ? v({}, e, {
                                        users: null == e || null == (a = e.users) ? void 0 : a.filter((e)=>!t.userIds.includes(e.id))
                                    }) : e;
                                })
                            }), null == t || null == (s = t.callback) || s.call(t, !0), n.setUsersGroupsLoader({
                                key: i,
                                value: !1
                            });
                        }, n.getGroupConfiguration = async ()=>{
                            const t = wi.GET_GROUP_CONFIGURATION, { groupsConfiguration: a } = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: t,
                                value: !0
                            }), a && n.setGroupsState({
                                groupsConfiguration: v({}, a)
                            }), n.setUsersGroupsLoader({
                                key: t,
                                value: !1
                            });
                        }, n.updateGroupConfiguration = async (t)=>{
                            const a = wi.UPDATE_GROUP_CONFIGURATION, { groupsConfiguration: s } = e.auth.groupsState;
                            n.setUsersGroupsLoader({
                                key: a,
                                value: !0
                            }), s && n.setGroupsState({
                                groupsConfiguration: v({}, s, t)
                            }), n.setUsersGroupsLoader({
                                key: a,
                                value: !1
                            });
                        }, n;
                    })(e, t), b = ki(e), A = ((e, t, a)=>{
                        const n = Ci(e, t, a);
                        return Eu(n, [
                            "setImpersonateState",
                            "resetImpersonateState"
                        ]);
                    })(e, t, a), w = ((e, t, a)=>{
                        const n = a, s = jo(e, t, n), i = Eu(s, [
                            "setLoginState",
                            "resetLoginState",
                            "afterAuthNavigation"
                        ]);
                        return i.requestAuthorize = async (e)=>{
                            e && n.setAuthState({
                                isLoading: !0
                            });
                            const t = _u;
                            await n.loadTenants(), n.setAuthState({
                                user: t,
                                isAuthenticated: !0,
                                isLoading: !1
                            });
                        }, i.getUserIP = async (e)=>{
                            const { callback: t } = e;
                            try {
                                const { ip: e } = Xu[0];
                                await n.setAuthState({
                                    userIpData: {
                                        ip: e
                                    },
                                    userIp: e
                                }), null == t || t(!0, e);
                            } catch (e) {
                                null == t || t(!1, e);
                            }
                        }, i;
                    })(e, t, a), T = ((e, t, a)=>{
                        const n = a, s = Xo(e, t, n), i = Eu(s, [
                            "setMfaState",
                            "resetMfaState"
                        ]);
                        return i.enrollMfa = async ()=>{
                            i.setMfaState({
                                saving: !0
                            }), i.setMfaState({
                                saving: !1,
                                error: void 0,
                                qrCode: "test"
                            });
                        }, i.verifyMfa = async (t)=>{
                            const { callback: a } = t, { mfaDevices: s = {
                                webauthn: [],
                                phones: [],
                                authenticators: [],
                                emails: []
                            } } = (f(t, yd), e.auth.mfaState);
                            i.setMfaState({
                                saving: !0
                            }), await Mn();
                            const o = {
                                token: "token",
                                recoveryCode: "recoveryCode"
                            }, r = {
                                step: ls.recoveryCode,
                                loading: !1,
                                error: void 0,
                                saving: !1,
                                mfaDevices: v({}, s, {
                                    authenticators: [
                                        {
                                            id: "authenticator-id"
                                        }
                                    ]
                                })
                            };
                            null != o && o.recoveryCode && (r.recoveryCode = o.recoveryCode), i.setMfaState(r), n.setUser(v({}, _u, {
                                mfaEnrolled: !0
                            })), null == a || a(r.recoveryCode);
                        }, i.disableMfa = async (t)=>{
                            var a;
                            const { mfaDevices: s = {
                                webauthn: [],
                                phones: [],
                                authenticators: [],
                                emails: []
                            } } = e.auth.mfaState;
                            i.setMfaState({
                                saving: !0
                            }), await Mn(), i.setMfaState({
                                saving: !1,
                                error: void 0,
                                mfaDevices: v({}, s, {
                                    authenticators: []
                                })
                            }), n.setUser(v({}, _u)), null == (a = t.callback) || a.call(t, !0);
                        }, i.verifyMfaAfterForce = async (e)=>{
                            const { callback: t } = e, a = f(e, Sd);
                            i.setMfaState({
                                loading: !0
                            }), await Mn();
                            const s = v({}, a, {
                                recoveryCode: "recoveryCode"
                            }), o = {
                                step: ls.recoveryCode,
                                loading: !1,
                                error: void 0,
                                saving: !1
                            };
                            null != s && s.recoveryCode && (o.recoveryCode = s.recoveryCode), i.setMfaState(o), await Mn(), n.setUser(v({}, _u, {
                                mfaEnrolled: !0
                            })), null == t || t(o.recoveryCode);
                        }, i.preDisableMfaSms = async (e)=>{
                            i.setMfaState({
                                saving: !0
                            });
                            try {
                                var t;
                                i.setMfaState({
                                    saving: !1,
                                    error: void 0,
                                    otcToken: "otc-token",
                                    phoneNumber: "+972504589346"
                                }), null == (t = e.callback) || t.call(e, !0);
                            } catch (t) {
                                var a;
                                i.setMfaState({
                                    saving: !1,
                                    error: Kn(t)
                                }), null == (a = e.callback) || a.call(e, !1, t);
                            }
                        }, i.disableMfaSms = async (t)=>{
                            var a;
                            const { mfaDevices: s = {
                                webauthn: [],
                                phones: [],
                                authenticators: [],
                                emails: []
                            } } = e.auth.mfaState;
                            i.setMfaState({
                                saving: !0
                            }), await Mn(), i.setMfaState({
                                loading: !1,
                                error: void 0,
                                mfaDevices: v({}, s, {
                                    phones: []
                                })
                            }), n.setUser(v({}, _u)), null == (a = t.callback) || a.call(t, !0);
                        }, i.preEnrollMfaSms = async (e)=>{
                            var t;
                            i.setMfaState({
                                saving: !0
                            }), await Mn(), i.setMfaState({
                                saving: !1,
                                error: void 0,
                                otcToken: "otc-token",
                                phoneNumber: "+972504589346"
                            }), null == (t = e.callback) || t.call(e, !0);
                        }, i.enrollMfaSms = async (t)=>{
                            const { callback: a } = t, { mfaDevices: s = {
                                webauthn: [],
                                phones: [],
                                authenticators: [],
                                emails: []
                            } } = e.auth.mfaState;
                            i.setMfaState({
                                saving: !0
                            }), await Mn();
                            const o = {
                                token: "token",
                                recoveryCode: "recoveryCode"
                            }, r = {
                                step: ls.recoveryCode,
                                loading: !1,
                                error: void 0,
                                saving: !1,
                                mfaDevices: v({}, s, {
                                    phones: [
                                        {
                                            id: "phone-id",
                                            phoneNumber: "+972504589346"
                                        }
                                    ]
                                })
                            };
                            null != o && o.recoveryCode && (r.recoveryCode = o.recoveryCode), i.setMfaState(r), n.setUser(v({}, _u, {
                                mfaEnrolled: !0
                            })), null == a || a(r.recoveryCode);
                        }, i;
                    })(e, t, a), E = ((e, t, a)=>{
                        const n = hr(e, t, a);
                        return Eu(n, [
                            "setPasskeysState",
                            "resetPasskeysState"
                        ]);
                    })(e, t, a), P = ((e, t, a)=>{
                        const n = fr(e, t, a), s = Eu(n, [
                            "setProfileState",
                            "resetProfileState"
                        ]);
                        return s.loadProfile = async ()=>{
                            s.setProfileState({
                                loading: !0
                            }), await Mn(), a.setUser(v({}, _u, ku)), s.setProfileState({
                                loading: !1,
                                profile: ku
                            });
                        }, s.saveProfile = async (e)=>{
                            const { callback: t, profilePictureUrl: n } = e, i = f(e, vd);
                            s.setProfileState({
                                saving: !0,
                                error: null
                            });
                            const o = Ru;
                            let r = o.profile.profilePictureUrl;
                            n !== o.profile.profilePictureUrl && n && (n || "").match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/) && (r = n);
                            const l = v({}, o.profile, i, {
                                profilePictureUrl: r
                            }), c = _u;
                            await Mn(), a.setUser(v({}, c, l)), s.setProfileState({
                                loading: !1,
                                error: null,
                                saving: !1,
                                profile: l
                            }), null == t || t(l);
                        }, s.changePassword = async (e)=>{
                            var t;
                            s.setProfileState({
                                loading: !0
                            }), await Mn(), s.setProfileState({
                                loading: !1,
                                error: void 0
                            }), null == (t = e.callback) || t.call(e, !0);
                        }, s.updateEmail = async (e)=>{
                            var t;
                            s.setProfileState({
                                saving: !0,
                                error: null,
                                loading: !0
                            }), await Mn(), s.setProfileState({
                                saving: !1,
                                error: null,
                                loading: !1
                            }), null == (t = e.callback) || t.call(e, !0);
                        }, s.verifyEmail = async (e)=>{
                            var t;
                            s.setProfileState({
                                saving: !0,
                                error: null,
                                loading: !0
                            }), await Mn(), s.setProfileState({
                                saving: !1,
                                error: null,
                                loading: !1
                            }), null == (t = e.callback) || t.call(e, !0);
                        }, s;
                    })(e, t, a), I = ((e, t)=>{
                        const a = Tr(e, t);
                        return Eu(a, [
                            "setProvisioningState",
                            "resetProvisioningState"
                        ]);
                    })(e, t), O = ((e, t, a)=>{
                        const n = Rr(e, t, a);
                        return Eu(n, [
                            "setResetPhoneNumberState",
                            "resetResetPhoneNumberState"
                        ]);
                    })(e, t, a), k = ((e, t, a)=>{
                        const n = Kr(e, t, a), s = Eu(n, [
                            "setRestrictionsState",
                            "setIpRestrictionsState",
                            "setEmailDomainRestrictionsState"
                        ]);
                        return s.loadIpRestrictions = async ()=>{
                            s.setIpRestrictionsState({
                                loading: !0,
                                error: null
                            }), s.setIpRestrictionsState({
                                data: {
                                    restrictions: Xu.filter((e)=>e.strategy === Qu.strategy),
                                    config: Qu
                                },
                                totalPages: 1,
                                pagination: {
                                    _filter: Xe.ALLOW,
                                    _limit: 50,
                                    _offset: 0
                                },
                                loading: !1
                            });
                        }, s.loadEmailDomainRestrictions = async ()=>{
                            s.setEmailDomainRestrictionsState({
                                loading: !0,
                                error: null
                            }), s.setEmailDomainRestrictionsState({
                                loading: !1,
                                data: {
                                    restrictions: [
                                        {
                                            domain: "mock.com",
                                            id: "1",
                                            type: Xe.ALLOW
                                        }
                                    ],
                                    config: {
                                        active: !0,
                                        listType: Xe.ALLOW,
                                        blockPublicDomains: !1
                                    }
                                }
                            });
                        }, s.saveIpRestriction = async (t)=>{
                            var a, n, i;
                            const { callback: o } = t, r = f(t, fd);
                            s.setIpRestrictionsState({
                                saving: !0,
                                error: null
                            });
                            const l = e.auth.restrictionsState.ipRestrictions, c = l.data.restrictions.filter((e)=>e.ip !== r.ip);
                            s.setIpRestrictionsState({
                                data: {
                                    config: null != (a = null == (n = l.data) ? void 0 : n.config) ? a : {
                                        isActive: !1,
                                        strategy: Xe.ALLOW
                                    },
                                    restrictions: [
                                        ...c,
                                        v({}, r, {
                                            createdAt: new Date,
                                            updatedAt: new Date,
                                            id: hd(),
                                            isActive: null == (i = r.isActive) || i,
                                            strategy: l.data.config.strategy
                                        })
                                    ]
                                },
                                totalPages: 1,
                                pagination: {
                                    _filter: Xe.ALLOW,
                                    _limit: 50,
                                    _offset: 0
                                },
                                saving: !1
                            }), null == o || o(!0);
                        }, s.saveIpRestrictionsConfig = async (t)=>{
                            var a, n, i;
                            const { callback: o } = t, r = f(t, md), l = e.auth.restrictionsState.ipRestrictions;
                            s.setIpRestrictionsState({
                                saving: !0,
                                error: null
                            }), s.setIpRestrictionsState({
                                data: {
                                    config: v({}, null == (a = l.data) ? void 0 : a.config, r),
                                    restrictions: null != (n = null == (i = l.data) ? void 0 : i.restrictions) ? n : []
                                },
                                pagination: {
                                    _filter: Xe.ALLOW,
                                    _limit: 50,
                                    _offset: 0
                                },
                                totalPages: 1,
                                saving: !1
                            }), s.setIpRestrictionsState({
                                saving: !1,
                                error: null
                            }), null == o || o(!0);
                        }, s.deleteIpRestriction = async (t)=>{
                            var a;
                            const { callback: n, id: i } = t;
                            s.setIpRestrictionsState({
                                saving: !0,
                                error: null
                            });
                            const o = e.auth.restrictionsState.ipRestrictions;
                            s.setIpRestrictionsState({
                                data: {
                                    config: (null == (a = o.data) ? void 0 : a.config) || {
                                        isActive: !1,
                                        strategy: Xe.ALLOW
                                    },
                                    restrictions: o.data.restrictions.filter((e)=>e.id !== i)
                                },
                                pagination: {
                                    _filter: Xe.ALLOW,
                                    _limit: 50,
                                    _offset: 0
                                },
                                totalPages: 1,
                                saving: !1,
                                error: null
                            }), null == n || n(!0);
                        }, s.checkIfUserIpValid = async ()=>{
                            s.setIpRestrictionsState({
                                loading: !0,
                                error: null
                            });
                            try {
                                const t = e.auth.restrictionsState.ipRestrictions, a = Xu[0].ip, n = !!t.data.restrictions.find((e)=>e.isActive && e.ip === a);
                                s.setIpRestrictionsState({
                                    userIpValid: n,
                                    loading: !1
                                });
                            } catch (e) {
                                s.setIpRestrictionsState({
                                    error: Kn(e),
                                    loading: !1
                                });
                            }
                        }, s.saveEmailDomainRestriction = async (t)=>{
                            var a, n;
                            const { callback: i } = t, o = f(t, bd), r = e.auth.restrictionsState.emailDomainRestrictions;
                            s.setEmailDomainRestrictionsState({
                                saving: !0,
                                error: null
                            }), await Mn(), null == i || i(!0), s.setEmailDomainRestrictionsState({
                                data: {
                                    config: (null == (a = r.data) ? void 0 : a.config) || {
                                        active: !1,
                                        blockPublicDomains: !1,
                                        listType: o.type
                                    },
                                    restrictions: [
                                        ...(null == (n = r.data) ? void 0 : n.restrictions) || [],
                                        v({}, o, {
                                            id: Date.now().toString()
                                        })
                                    ]
                                },
                                saving: !1
                            });
                        }, s.saveEmailDomainRestrictionsConfig = async (t)=>{
                            var a;
                            const { callback: n } = t, i = f(t, Ad), o = e.auth.restrictionsState.emailDomainRestrictions;
                            s.setEmailDomainRestrictionsState({
                                saving: !0,
                                error: null
                            }), await Mn(), null == n || n(!0), s.setEmailDomainRestrictionsState({
                                data: {
                                    config: {
                                        active: i.active,
                                        blockPublicDomains: i.blockPublicDomains || !1,
                                        listType: i.type || Xe.ALLOW
                                    },
                                    restrictions: [
                                        ...(null == (a = o.data) ? void 0 : a.restrictions) || []
                                    ]
                                },
                                saving: !1
                            });
                        }, s.deleteEmailDomainRestriction = async (t)=>{
                            var a, n;
                            const { id: i } = t, o = e.auth.restrictionsState.emailDomainRestrictions;
                            s.setEmailDomainRestrictionsState({
                                saving: !0,
                                error: null
                            }), await Mn(), s.setEmailDomainRestrictionsState({
                                data: {
                                    config: (null == (a = o.data) ? void 0 : a.config) || {
                                        active: !1,
                                        blockPublicDomains: !1,
                                        listType: Xe.ALLOW
                                    },
                                    restrictions: ((null == (n = o.data) ? void 0 : n.restrictions) || []).filter((e)=>e.id === i)
                                },
                                saving: !1
                            });
                        }, s;
                    })(e, t, a), _ = ((e, t)=>{
                        const a = Gr(e, t), n = Eu(a, [
                            "setRolesState",
                            "setRolesStateError",
                            "setRolesStateLoader",
                            "resetRolesState"
                        ]);
                        return n.loadRolesAndPermissions = async (e)=>{
                            var t;
                            const a = Cr.LOAD_ROLES;
                            n.setRolesStateLoader({
                                key: a,
                                value: !(null != (t = null == e ? void 0 : e.silentLoading) && t)
                            });
                            try {
                                n.setRolesState({
                                    roles: Ou
                                });
                            } catch (e) {
                                n.setRolesStateError({
                                    key: a,
                                    value: Kn(e)
                                });
                            } finally{
                                n.setRolesStateLoader({
                                    key: a,
                                    value: !1
                                });
                            }
                        }, n;
                    })(e, t), R = ((e, t, a)=>{
                        const n = Xr(e, t, a), s = Eu(n, [
                            "setSecurityCenterState",
                            "setSecurityCenterStateError",
                            "setSecurityCenterStateLoader",
                            "resetSecurityCenterState"
                        ]);
                        return s.loadRecommendations = async ()=>{
                            const e = Jr.RECOMMENDATIONS;
                            s.setSecurityCenterStateLoader({
                                key: e,
                                value: !0
                            }), await Mn(), s.setSecurityCenterState({
                                recommendations: ad.recommendations.items,
                                score: ad.scoring.score
                            }), s.setSecurityCenterStateLoader({
                                key: e,
                                value: !1
                            });
                        }, s.loadInsights = async ()=>{
                            const e = Jr.INSIGHTS;
                            s.setSecurityCenterStateLoader({
                                key: e,
                                value: !0
                            }), await Mn(), s.setSecurityCenterState({
                                insights: nd.insights.items
                            }), s.setSecurityCenterStateLoader({
                                key: e,
                                value: !1
                            });
                        }, s.loadBreachedPasswordUsers = async ()=>{
                            const e = Jr.BREACHED_PASSWORD_USERS_TABLE;
                            s.setSecurityCenterStateLoader({
                                key: e,
                                value: !0
                            }), await Mn(), s.setSecurityCenterState({
                                breachedPasswordUsersTable: sd
                            }), s.setSecurityCenterStateLoader({
                                key: e,
                                value: !1
                            });
                        }, s.loadUnenrolledMfaUsers = async ()=>{
                            const e = Jr.UNENROLLED_MFA_USERS_TABLE;
                            s.setSecurityCenterStateLoader({
                                key: e,
                                value: !0
                            }), await Mn(), s.setSecurityCenterState({
                                unenrolledMfaUsersTable: od
                            }), s.setSecurityCenterStateLoader({
                                key: e,
                                value: !1
                            });
                        }, s.loadInactiveUsers = async ()=>{
                            const e = Jr.INACTIVE_USERS_TABLE;
                            s.setSecurityCenterStateLoader({
                                key: e,
                                value: !0
                            }), await Mn(), s.setSecurityCenterState({
                                inactiveUsersTable: id
                            }), s.setSecurityCenterStateLoader({
                                key: e,
                                value: !1
                            });
                        }, s.sendResetBreachedPasswordEmail = async (e)=>{
                            const { callback: t } = e, a = Jr.SEND_BREACHED_PASSWORD_EMAIL;
                            s.setSecurityCenterStateLoader({
                                key: a,
                                value: !0
                            }), await Mn(), null == t || t(!0), s.setSecurityCenterStateLoader({
                                key: a,
                                value: !1
                            });
                        }, s;
                    })(e, t, a), U = ((e, t, a)=>{
                        const n = ol(e, t, a), s = Eu(n, [
                            "setSecurityPolicyState",
                            "setSecurityPolicyGlobalState",
                            "setSecurityPolicyPublicState",
                            "setSecurityPolicyMfaState",
                            "setSecurityPolicyVendorMfaState",
                            "setSecurityPolicyLockoutState",
                            "setSecurityPolicyVendorLockoutState",
                            "setSecurityPolicyCaptchaState",
                            "setSecurityPolicyPasswordHistoryState",
                            "setSecurityPolicyVendorPasswordHistoryState",
                            "resetSecurityPolicyState",
                            "setSecurityPolicyPasswordState",
                            "setSecurityPolicyAuthStrategyPublicState"
                        ]);
                        return s.loadSecurityPolicy = async ()=>{
                            s.setSecurityPolicyGlobalState({
                                loading: !0,
                                error: null
                            }), await Promise.all([
                                s.loadSecurityPolicyMfa(),
                                s.loadSecurityPolicyVendorMfa(),
                                s.loadSecurityPolicyLockout(),
                                s.loadSecurityPolicyVendorLockout(),
                                s.loadSecurityPolicyPasswordHistory(),
                                s.loadSecurityPolicyVendorPasswordHistory(),
                                s.loadSecurityPolicyCaptcha()
                            ]), await Mn(), s.setSecurityPolicyGlobalState({
                                policy: Uu,
                                loading: !1
                            });
                        }, s.loadPublicSecurityPolicy = async ()=>{
                            s.setSecurityPolicyPublicState({
                                loading: !0,
                                error: null
                            });
                            try {
                                s.setSecurityPolicyPublicState({
                                    policy: Lu,
                                    loading: !1
                                });
                            } catch (e) {
                                s.setSecurityPolicyPublicState({
                                    error: Kn(e),
                                    loading: !1
                                });
                            }
                        }, s.saveSecurityPolicyMfa = async (e)=>{
                            var t;
                            const { callback: a } = e, n = f(e, wd);
                            s.setSecurityPolicyMfaState({
                                saving: !0,
                                error: null
                            });
                            const i = v({}, Du, {
                                id: null != (t = n.id) ? t : Du.id,
                                enforceMFAType: n.enforceMFAType
                            });
                            await Mn(), s.setSecurityPolicyMfaState({
                                policy: i,
                                saving: !1
                            }), null == a || a(i);
                        }, s.loadSecurityPolicyMfa = async ()=>{
                            s.setSecurityPolicyMfaState({
                                loading: !0,
                                error: null
                            }), await Mn(), s.setSecurityPolicyMfaState({
                                policy: Cu,
                                loading: !1
                            });
                        }, s.loadSecurityPolicyVendorMfa = async ()=>{
                            s.setSecurityPolicyVendorMfaState({
                                loading: !0,
                                error: null
                            }), await Mn(), s.setSecurityPolicyVendorMfaState({
                                policy: Cu,
                                loading: !1
                            });
                        }, s.saveSecurityPolicyLockout = async (e)=>{
                            const { callback: t } = e, a = f(e, Td);
                            s.setSecurityPolicyLockoutState({
                                saving: !0,
                                error: null
                            }), await Mn();
                            const n = v({}, Du, a, {
                                id: a.id ? a.id : Du.id
                            });
                            null == t || t(n), s.setSecurityPolicyLockoutState({
                                policy: n,
                                saving: !1
                            });
                        }, s.loadSecurityPolicyLockout = async ()=>{
                            s.setSecurityPolicyLockoutState({
                                loading: !0,
                                error: null
                            }), await Mn(), s.setSecurityPolicyLockoutState({
                                policy: Du,
                                loading: !1
                            });
                        }, s.loadSecurityPolicyVendorLockout = async ()=>{
                            s.setSecurityPolicyVendorLockoutState({
                                loading: !0,
                                error: null
                            }), await Mn(), s.setSecurityPolicyVendorLockoutState({
                                policy: Du,
                                loading: !1
                            });
                        }, s.loadSecurityPolicyCaptcha = async ()=>{
                            s.setSecurityPolicyLockoutState({
                                loading: !0,
                                error: null
                            }), await Mn(), s.setSecurityPolicyLockoutState({
                                policy: Du,
                                loading: !1
                            });
                        }, s.saveSecurityPolicyPasswordHistory = async (e)=>{
                            const { callback: t } = e, a = f(e, Ed);
                            s.setSecurityPolicyPasswordHistoryState({
                                saving: !0,
                                error: null
                            }), await Mn();
                            const n = v({}, Nu, a, {
                                id: a.id ? a.id : Nu.id
                            });
                            null == t || t(n), s.setSecurityPolicyPasswordHistoryState({
                                policy: n,
                                saving: !1
                            });
                        }, s.loadSecurityPolicyPasswordHistory = async ()=>{
                            s.setSecurityPolicyPasswordHistoryState({
                                loading: !0,
                                error: null
                            }), await Mn(), s.setSecurityPolicyPasswordHistoryState({
                                policy: Nu,
                                loading: !1
                            });
                        }, s.loadSecurityPolicyVendorPasswordHistory = async ()=>{
                            s.setSecurityPolicyVendorPasswordHistoryState({
                                loading: !0,
                                error: null
                            }), await Mn(), s.setSecurityPolicyVendorPasswordHistoryState({
                                policy: Nu,
                                loading: !1
                            });
                        }, s;
                    })(e, t, a), L = ((e, t)=>{
                        const a = pl(e, t), n = Eu(a, [
                            "setSessionsState",
                            "resetSessionsState"
                        ]);
                        return n.loadUserSessions = async ()=>{
                            n.setSessionsState({
                                loading: !0,
                                error: null
                            }), n.setSessionsState({
                                sessions: Ju,
                                loading: !1
                            });
                        }, n.deleteUserSession = async (t)=>{
                            const { id: a } = t;
                            n.setSessionsState({
                                loading: !0,
                                error: null
                            });
                            const s = e.auth.sessionsState.sessions.filter((e)=>e.id !== a);
                            n.setSessionsState({
                                sessions: s,
                                loading: !1
                            });
                        }, n.deleteAllUserSessions = async ()=>{
                            n.setSessionsState({
                                loading: !0,
                                error: null
                            });
                            const e = Ju.filter((e)=>e.current);
                            n.setSessionsState({
                                sessions: e,
                                loading: !1
                            });
                        }, n;
                    })(e, t), C = ((e, t, a)=>{
                        const n = ul(e, t, a), s = Eu(n, [
                            "setSessionsPolicyState",
                            "resetSessionsPolicyState"
                        ]);
                        return s.loadSessionsPolicy = async ()=>{
                            s.setSessionsPolicyState({
                                loading: !0,
                                error: null
                            });
                            const t = e.auth.sessionsPolicyState;
                            s.setSessionsPolicyState(v({}, t, {
                                loading: !1
                            }));
                        }, s.createOrUpdateSessionsPolicy = async (e)=>{
                            const { callback: t } = e, a = f(e, Pd);
                            s.setSessionsPolicyState({
                                loading: !0,
                                error: null
                            }), null == t || t(!0), s.setSessionsPolicyState({
                                configurations: a,
                                loading: !1
                            });
                        }, s;
                    })(e, t, a), D = ((e, t, a)=>{
                        const n = bl(e, t, a);
                        return Eu(n, [
                            "setSignUpState",
                            "resetSignUpState",
                            "resetSignUpStateSoft"
                        ]);
                    })(e, t, a), N = ((e, t)=>{
                        const a = _l(e, t);
                        return Eu(a, [
                            "setSmsState",
                            "resetSmsState"
                        ]);
                    })(e, t), M = ((e, t, a)=>{
                        const n = Dl(e, t, a);
                        return Eu(n, [
                            "setSocialLoginsState",
                            "resetSocialLoginsState",
                            "setSocialLoginError"
                        ]);
                    })(e, t, a), F = ((e, t, a)=>{
                        const n = Vl(e, t, a), s = Eu(n, [
                            "setSSOState",
                            "resetSSOState"
                        ]);
                        return s.loadSSOConfigurations = async ()=>{
                            s.setSSOState({
                                loading: !0
                            }), await Mn(), s.setSSOState({
                                samlConfiguration: Mu,
                                loading: !1,
                                firstLoad: !1
                            });
                        }, s.saveSSOConfigurations = async (e)=>{
                            var t, a;
                            const { callback: n, samlVendor: i } = e, o = f(e, Id), r = $u.samlConfiguration, l = v({}, r, o);
                            let c = "saving";
                            if ((null == l ? void 0 : l.enabled) !== r.enabled && (c = "loading"), null == l || !l.domain) return void s.setSSOState({
                                samlConfiguration: v({}, r, l)
                            });
                            s.setSSOState({
                                error: void 0,
                                [c]: !0
                            }), await Mn(), l.acsUrl = null == Fu || null == (t = Fu.configuration) ? void 0 : t.acsUrl, l.spEntityId = null == Fu || null == (a = Fu.configuration) ? void 0 : a.spEntityId;
                            const u = jn(l, [
                                "validated",
                                "generatedVerification",
                                "createdAt",
                                "updatedAt"
                            ]);
                            (null == r ? void 0 : r.domain) !== (null == u ? void 0 : u.domain) && (u.ssoEndpoint = "", u.publicCertificate = "", u.signRequest = !1), u.type = null == i ? void 0 : i.toLowerCase(), await Mn(), s.setSSOState({
                                samlConfiguration: u,
                                error: void 0,
                                [c]: !1
                            }), null == n || n(!0);
                        }, s.saveSSOConfigurationsFile = async (t)=>{
                            const a = "saving";
                            s.setSSOState({
                                error: void 0,
                                [a]: !0
                            });
                            const n = v({}, e.auth.ssoState.samlConfiguration, {
                                enabled: !0
                            }, t[0]);
                            s.setSSOState({
                                samlConfiguration: n,
                                error: void 0,
                                [a]: !1
                            });
                        }, s.validateSSODomain = async (e)=>{
                            const { callback: t } = null != e ? e : {}, a = $u.samlConfiguration;
                            s.setSSOState({
                                error: void 0,
                                saving: !0
                            }), await Mn(), s.setSSOState({
                                samlConfiguration: v({}, a, {
                                    validated: !0
                                }),
                                error: void 0,
                                saving: !1
                            }), null == t || t(!0);
                        }, s.loadSSOAuthorizationRoles = async ()=>{
                            await Mn(), s.setSSOState({
                                authorizationRoles: [
                                    "1",
                                    "2",
                                    "3"
                                ],
                                error: void 0
                            });
                        }, s.updateSSOAuthorizationRoles = async (e)=>{
                            const { callback: t, authorizationRoles: a } = e;
                            s.setSSOState({
                                error: void 0,
                                saving: !0
                            }), await Mn(), s.setSSOState({
                                authorizationRoles: a,
                                error: void 0,
                                saving: !1
                            }), null == t || t(!0);
                        }, s;
                    })(e, t, a), x = ((e, t, a)=>{
                        const n = zl(e, t, a);
                        return Eu(n, [
                            "setStepUpState",
                            "resetStepUpState"
                        ]);
                    })(e, t, a), $ = ((e, t, a)=>{
                        const n = rc(e, t, a), s = Eu(n, [
                            "setTeamState",
                            "resetTeamState",
                            "setTeamLoader",
                            "setTeamError",
                            "openAddUserDialog",
                            "closeAddUserDialog",
                            "openDeleteUserDialog",
                            "closeDeleteUserDialog"
                        ]);
                        return s.loadUsersV3 = async (t)=>{
                            var a, n, i, o;
                            const { silentLoading: r, callback: l } = t, c = e.auth.teamState, u = null != (a = t.pageSize) ? a : c.pageSize, d = null != (n = t.pageOffset) ? n : c.pageOffset, g = null != (i = t.filter) ? i : c.filterV2, p = null != (o = t.sort) ? o : c.sortV2;
                            s.setTeamLoader({
                                key: Ns.USERS,
                                value: !r
                            }), s.setTeamState({
                                pageSize: u,
                                pageOffset: d,
                                filterV2: g,
                                sortV2: p
                            }), await Mn(), s.setTeamState({
                                users: Hu,
                                totalPages: 2,
                                totalItems: 10,
                                roles: xu,
                                permissions: Gu
                            }), s.setTeamLoader({
                                key: Ns.USERS,
                                value: !1
                            }), null == l || l(Hu);
                        }, s.loadAllSubTenantsUsers = async (t)=>{
                            var a, n, i, o, r;
                            const { silentLoading: l, callback: c } = t, u = e.auth.teamState, d = null != (a = t._limit) ? a : u.allUsersQueryParams._limit, g = null != (n = t._offset) ? n : u.allUsersQueryParams._offset, p = null != (i = t._filter) ? i : u.allUsersQueryParams._filter, h = null != (o = t._sortBy) ? o : u.allUsersQueryParams._sortBy, y = null != (r = t._order) ? r : u.allUsersQueryParams._order;
                            s.setTeamLoader({
                                key: Ns.USERS,
                                value: !l
                            }), s.setTeamState({
                                allUsersQueryParams: {
                                    _limit: d,
                                    _offset: g,
                                    _filter: p,
                                    _sortBy: h,
                                    _order: y
                                }
                            }), await Mn(), s.setTeamState({
                                allUsers: qu,
                                totalPages: 2,
                                totalItems: 10,
                                roles: xu,
                                permissions: Gu
                            }), s.setTeamLoader({
                                key: Ns.USERS,
                                value: !1
                            }), null == c || c(qu);
                        }, s.loadRoles = async (e)=>{
                            var t;
                            s.setTeamLoader({
                                key: Ns.ROLES_AND_PERMISSIONS,
                                value: !0
                            }), await Mn(), s.setTeamState({
                                roles: xu,
                                permissions: Gu
                            }), s.setTeamLoader({
                                key: Ns.ROLES_AND_PERMISSIONS,
                                value: !0
                            }), null == e || null == (t = e.callback) || t.call(e, {
                                roles: xu,
                                permissions: Gu
                            });
                        }, s.addUser = async (t)=>{
                            const { callback: a } = t, n = f(t, Od), i = e.auth.teamState;
                            s.setTeamState({
                                addUserDialogState: v({}, i.addUserDialogState, {
                                    loading: !0
                                })
                            }), await Mn();
                            const o = new Date, r = v({}, Bu, {
                                groups: []
                            }, n, {
                                id: `${hd()}`,
                                temporaryExpirationDate: n.expirationInSeconds ? new Date(o.setSeconds(o.getSeconds() + n.expirationInSeconds)) : void 0
                            });
                            null == a || a(r), s.setTeamState({
                                users: [
                                    r,
                                    ...i.users
                                ],
                                addUserDialogState: {
                                    open: !1,
                                    loading: !1
                                }
                            });
                        }, s.addUserToSubTenants = async (t)=>{
                            const { callback: a } = t, n = f(t, kd), i = e.auth.teamState;
                            s.setTeamState({
                                addUserDialogState: v({}, i.addUserDialogState, {
                                    loading: !0
                                })
                            }), await Mn();
                            const o = v({}, Bu, n, {
                                id: `${hd()}`
                            });
                            s.setTeamState({
                                users: [
                                    o,
                                    ...i.users
                                ],
                                addUserDialogState: {
                                    open: !1,
                                    loading: !1
                                }
                            }), null == a || a(null);
                        }, s.updateUser = async (t)=>{
                            var a;
                            const { callback: n } = t, i = f(t, _d), { id: o } = i, r = e.auth.teamState, l = r.users.find((e)=>e.id === i.id);
                            s.setTeamLoader({
                                key: Ns.UPDATE_USER,
                                value: o || ""
                            }), s.setTeamState({
                                addUserDialogState: v({}, r.addUserDialogState, {
                                    loading: !0
                                })
                            }), s.setTeamState({
                                addUserDialogState: v({}, r.addUserDialogState, {
                                    loading: !0
                                }),
                                users: r.users.map((e)=>e.id === i.id ? v({}, e, i) : e)
                            }), l.roleIds.length > 0 && 0 === (null == (a = i.roleIds) ? void 0 : a.length) && (i.roleIds = [
                                ""
                            ]), await Mn();
                            const c = v({}, l, i);
                            null == n || n(c), s.setTeamState({
                                users: r.users.map((e)=>e.id === c.id ? v({}, e, c, {
                                        createdAt: e.createdAt,
                                        customData: e.customData,
                                        lastLogin: e.lastLogin
                                    }) : e)
                            }), s.setTeamLoader({
                                key: Ns.UPDATE_USER,
                                value: !1
                            });
                        }, s.deleteUser = async (t)=>{
                            const { callback: a } = t, n = f(t, Rd), i = e.auth.teamState;
                            s.setTeamState({
                                deleteUserDialogState: v({}, i.deleteUserDialogState, {
                                    loading: !0
                                })
                            }), await Mn(), null == a || a(!0), s.setTeamState({
                                users: i.users.filter((e)=>e.id !== n.userId),
                                deleteUserDialogState: {
                                    open: !1,
                                    loading: !1
                                }
                            });
                        }, s.updateUserExpirationTime = async (t)=>{
                            const { callback: a } = t, n = f(t, Ud), i = e.auth.teamState;
                            s.setTeamLoader({
                                key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                value: !0
                            });
                            const o = new Date;
                            s.setTeamState({
                                users: i.users.map((e)=>e.id === n.userId ? v({}, e, {
                                        temporaryExpirationDate: n.expirationInSeconds ? new Date(o.setSeconds(o.getSeconds() + n.expirationInSeconds)) : void 0
                                    }) : e)
                            }), await Mn(), null == a || a(!0), s.setTeamLoader({
                                key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                value: !1
                            });
                        }, s.setUserAsPermanent = async (t)=>{
                            const { callback: a } = t, n = f(t, Ld), i = e.auth.teamState;
                            s.setTeamLoader({
                                key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                value: !0
                            }), s.setTeamState({
                                users: i.users.map((e)=>e.id === n.userId ? v({}, e, {
                                        temporaryExpirationDate: void 0
                                    }) : e)
                            }), await Mn(), null == a || a(!0), s.setTeamLoader({
                                key: Ns.UPDATE_USER_EXPIRATION_TIME,
                                value: !1
                            });
                        }, s.deleteUserFromSubTenants = async (t)=>{
                            const { callback: a } = t, n = f(t, Cd), i = e.auth.teamState;
                            s.setTeamState({
                                deleteUserDialogState: v({}, i.deleteUserDialogState, {
                                    loading: !0
                                })
                            }), await Mn(), null == a || a(!0), s.setTeamState({
                                allUsers: i.allUsers.filter((e)=>e.id !== n.userId),
                                deleteUserDialogState: {
                                    open: !1,
                                    loading: !1
                                }
                            });
                        }, s.resendActivationLink = async (e)=>{
                            const { callback: t } = e, a = f(e, Dd);
                            s.setTeamLoader({
                                key: Ns.RESEND_ACTIVATE_LINK,
                                value: a.userId
                            }), await Mn(), null == t || t(!0), s.setTeamLoader({
                                key: Ns.RESEND_ACTIVATE_LINK,
                                value: !1
                            });
                        }, s.resendInvitationLink = async (e)=>{
                            const { callback: t } = e, a = f(e, Nd);
                            s.setTeamLoader({
                                key: Ns.RESEND_INVITATION_LINK,
                                value: a.email
                            }), await Mn(), null == t || t(!0), s.setTeamLoader({
                                key: Ns.RESEND_INVITATION_LINK,
                                value: !1
                            });
                        }, s.resendInvitationEmail = async (e)=>{
                            const { callback: t } = e, a = f(e, Md);
                            s.setTeamLoader({
                                key: Ns.RESEND_INVITATION_LINK,
                                value: a.email
                            }), await Mn(), null == t || t(!0), s.setTeamLoader({
                                key: Ns.RESEND_INVITATION_LINK,
                                value: !1
                            });
                        }, s.resendInvitationLinkToAllSubTenants = async (e)=>{
                            const { callback: t } = e, a = f(e, Fd);
                            s.setTeamLoader({
                                key: Ns.RESEND_INVITATION_LINK,
                                value: a.email
                            }), await Mn(), null == t || t(!0), s.setTeamLoader({
                                key: Ns.RESEND_INVITATION_LINK,
                                value: !1
                            });
                        }, s;
                    })(e, t, a), G = ((e, t, a)=>{
                        const n = uc(e, t, a), s = Eu(n, [
                            "setTenantsState",
                            "resetTenantsState"
                        ]);
                        return s.loadTenants = async ()=>{
                            s.setTenantsState({
                                loading: !0
                            }), s.setTenantsState({
                                tenants: Yu,
                                activeTenant: Yu[0],
                                loading: !1
                            });
                        }, s;
                    })(e, t, a), j = pc(e, t), V = ((e, t)=>{
                        const a = Sc(e, t);
                        return Eu(a, [
                            "setUserEmailPolicyState"
                        ]);
                    })(e, t), B = {
                        acceptInvitationActions: s,
                        accountSettingsActions: i,
                        unlockAccountActions: o,
                        activateAccountActions: r,
                        approvalFlowActions: l,
                        allAccountsActions: c,
                        allAccountsDialogActions: u,
                        apiTokensActions: d,
                        applicationsActions: g,
                        customLoginActions: p,
                        entitlementsActions: h,
                        forgotPasswordActions: y,
                        passwordRotationActions: S,
                        groupsActions: m,
                        groupsDialogsActions: b,
                        impersonateActions: A,
                        loginActions: w,
                        mfaActions: T,
                        passkeysActions: E,
                        profileActions: P,
                        provisioningActions: I,
                        resetPhoneNumberActions: O,
                        restrictionsActions: k,
                        rolesActions: _,
                        securityCenterActions: R,
                        securityPolicyActions: U,
                        sessionsActions: L,
                        sessionsPolicyActions: C,
                        signUpActions: D,
                        smsActions: N,
                        socialLoginActions: M,
                        ssoActions: F,
                        stepUpActions: x,
                        teamActions: $,
                        tenantsActions: G,
                        usernamesActions: j,
                        usersEmailsPolicyActions: V
                    }, W = (t)=>{
                        Object.keys(t).forEach((a)=>{
                            const n = a;
                            Vn(e.auth[n]) ? Object.assign(e.auth[n], t[n]) : e.auth[n] = t[n];
                        });
                    };
                    return {
                        authActions: v({
                            setState: W,
                            setAuthState: W,
                            setErrorByRequestName: (t)=>{
                                let { requestName: a } = t, n = f(t, xd);
                                e.auth.errorByRequest = v({}, e.auth.errorByRequest, {
                                    [a]: v({}, n, {
                                        isError: !0
                                    })
                                });
                            },
                            resetAuthState: ()=>{
                                Wn(e, [
                                    "auth"
                                ], n);
                            },
                            setUser: (e)=>{
                                W({
                                    user: e
                                });
                            }
                        }, s, i, r, o, l, c, u, d, g, p, h, y, S, m, b, A, w, T, E, P, I, O, k, _, R, U, L, C, D, N, M, F, x, $, G, j, V),
                        authStateActions: B
                    };
                })(e, t, a, n), o = ((e, t, a)=>{
                    const n = _c(e, t, a);
                    return Eu(n, [
                        "setConnectivityState",
                        "resetConnectivityState",
                        "initData",
                        "resetConnectivityState",
                        "cleanWebhookTestData",
                        "cleanWebhookLogsData",
                        "cleanWebhookTestMessage",
                        "cleanError",
                        "cleanSlackData"
                    ]);
                })(e, t, a), [r, l] = qd(e, t, a), c = ((e, t, a)=>{
                    const n = hu(e, t, a), s = Eu(n, [
                        "setVendorState",
                        "resetVendorState"
                    ]);
                    return s.loadVendorPublicInfo = async ()=>{
                        try {
                            s.setVendorState({
                                whiteLabelMode: !1
                            }), await Mn();
                        } catch (e) {
                            console.error("failed to getVendorPublicInfo - ", e);
                        }
                    }, s.loadVendorPublicConfiguration = s.loadVendorPublicInfo, s;
                })(e, t, a);
                return {
                    authActions: s,
                    authStateActions: i,
                    connectivityActions: o,
                    subscriptionsActions: r,
                    subscriptionsStateActions: l,
                    vendorActions: c,
                    auditsActions: Vd(e, t, a)
                };
            }, Jd = (e, t, a = !1, n, s, i = !1, o = "path")=>Qd({
                    name: e.appName,
                    context: e.context,
                    storeHolder: t,
                    previewMode: a,
                    builderMode: i,
                    urlStrategy: o,
                    initialState: {
                        root: v({}, e),
                        auth: v({}, null == s ? void 0 : s.auth, n),
                        connectivity: v({}, null == s ? void 0 : s.connectivity),
                        subscriptions: v({}, null == s ? void 0 : s.subscriptions),
                        vendor: v({}, null == s ? void 0 : s.vendor),
                        auditLogs: v({}, null == s ? void 0 : s.auditLogs),
                        audits: v({}, null == s ? void 0 : s.audits)
                    }
                }), Qd = (e)=>{
                var t, a, n, s, i, o, r;
                const { storeHolder: l } = e;
                let c = l;
                if ("undefined" == typeof window && null == l) throw Error("createFronteggStore(initState, storeHolder) failed, storeHolder must not be null in Server-Side rendering");
                if (c || (c = window), c.store) return c.store;
                const u = e.name || "default", { context: d, previewMode: g = !1, builderMode: p = !1, urlStrategy: h = "path" } = e, y = L.for(u);
                g || p || y.setContext(d), void 0 === d.requestCredentials && (d.requestCredentials = "include");
                const S = Ac(null == (t = e.initialState) ? void 0 : t.auth), m = Ec(null == (a = e.initialState) ? void 0 : a.connectivity), b = uu(null == (n = e.initialState) ? void 0 : n.subscriptions), A = pu(null == (s = e.initialState) ? void 0 : s.vendor), w = Au(null == (i = e.initialState) ? void 0 : i.auditLogs), T = (E = null == (o = e.initialState) ? void 0 : o.audits, hn(Tu, E));
                var E;
                const P = null == (r = e.initialState) ? void 0 : r.auth;
                P && Object.keys(P).forEach((e)=>{
                    An()(S, e, P[e], {
                        merge: !0
                    });
                });
                const I = JSON.parse(JSON.stringify(S)), _ = hn({
                    root: {
                        appName: u,
                        context: d,
                        urlStrategy: h,
                        previewMode: g
                    },
                    auth: S,
                    connectivity: m,
                    subscriptions: b,
                    vendor: A,
                    auditLogs: w,
                    audits: T
                });
                "undefined" != typeof window && window.localStorage && "true" === window.localStorage.DEBUG_FRONTEGG_STORE && function(e, t) {
                    "string" == typeof t && (t = {
                        name: t
                    });
                    const a = t || {}, { enabled: n, name: s = "" } = a, i = f(a, R);
                    let o;
                    try {
                        o = n && window.__REDUX_DEVTOOLS_EXTENSION__;
                    } catch  {}
                    if (!o) return;
                    let r = !1;
                    const l = o.connect(v({
                        name: s
                    }, i));
                    O(e, (t)=>{
                        const a = t.filter(([e, t])=>t[0] !== U).map(([e, t])=>`${e}:${t.map(String).join(".")}`).join(", ");
                        if (a) {
                            if (r) r = !1;
                            else {
                                const t = Object.assign({}, k(e));
                                delete t[U], l.send({
                                    type: a,
                                    updatedAt: (new Date).toLocaleString()
                                }, t);
                            }
                        }
                    }), l.subscribe((t)=>{
                        var a, n;
                        if ("ACTION" === t.type && t.payload) try {
                            Object.assign(e, JSON.parse(t.payload));
                        } catch (e) {
                            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
                        }
                        if ("DISPATCH" === t.type && t.state) {
                            var s, i;
                            if ("JUMP_TO_ACTION" === (null == (s = t.payload) ? void 0 : s.type) || "JUMP_TO_STATE" === (null == (i = t.payload) ? void 0 : i.type)) {
                                r = !0;
                                const a = JSON.parse(t.state);
                                Object.assign(e, a);
                            }
                            e[U] = t;
                        } else if ("DISPATCH" === t.type && "COMMIT" === (null == (a = t.payload) ? void 0 : a.type)) l.init(k(e));
                        else if ("DISPATCH" === t.type && "IMPORT_STATE" === (null == (n = t.payload) ? void 0 : n.type)) {
                            var o, c;
                            const a = null == (o = t.payload.nextLiftedState) ? void 0 : o.actionsById, n = (null == (c = t.payload.nextLiftedState) ? void 0 : c.computedStates) || [];
                            r = !0, n.forEach(({ state: t }, n)=>{
                                const s = a[n] || "No action found";
                                Object.assign(e, t), 0 === n ? l.init(k(e)) : l.send(s, k(e));
                            });
                        }
                    });
                    l.init(k(e));
                }(_, {
                    name: `${u} Store`,
                    enabled: !0
                });
                const C = {}, D = {};
                y.setContext(e.context), y.setAppName(u);
                const N = v({}, un(u), {
                    fetch: new He(u)
                });
                if (e.previewMode || e.builderMode) {
                    const { authActions: t, authStateActions: a, connectivityActions: n, subscriptionsActions: s, subscriptionsStateActions: i, vendorActions: o, auditsActions: r } = Yd(_, N, D, I);
                    C.auth = a, C.connectivity = n, C.subscriptions = i, C.vendor = o, C.auditLogs = r, C.audits = {}, Object.assign(D, v({}, t, n, s, o, r));
                    const l = {
                        dispatch: (e)=>{
                            setTimeout(()=>{
                                const [a, ...i] = e.type.split("/"), r = i.join("/");
                                "auth" === a && "function" == typeof t[r] ? t[r](e.payload) : "connectivity" === a && "function" == typeof n[r] ? n[r](e.payload) : "subscriptions" === a && "function" == typeof s[r] ? s[r](e.payload) : "vendor" === a && "function" == typeof o[r] && o[r](e.payload);
                            });
                        },
                        getState: ()=>_,
                        subscribe: (e)=>O(_, e),
                        subscribeStateChanged: (e)=>O(_, ()=>e(_)),
                        store: _,
                        actions: D,
                        stateActions: C
                    };
                    return e.previewMode && l.dispatch({
                        type: "auth/requestAuthorize",
                        payload: !0
                    }), c && (c.store = l), l;
                }
                {
                    const [e, t] = wc(_, N, D, I), a = _c(_, N, D), [n, s] = du(_, N, D), i = hu(_, N, D), o = wu(_, N, D), r = ((e, t)=>{
                        const a = ()=>{
                            e.audits.isLoading = !1;
                        }, n = (t)=>{
                            var a;
                            e.audits.error = null != (a = e.audits.error) ? a : {}, Object.assign(e.audits.error, {
                                [t.name]: t.error
                            });
                        }, s = (t)=>{
                            e.audits.filters = t, e.audits.currentPage = 0, e.audits.offset = 0, e.audits.isLoading = !0;
                        }, i = async ()=>{
                            const { sortBy: a, sortDirection: s } = e.audits;
                            try {
                                i = await t.audits.getAuditsStats({
                                    sortBy: a,
                                    sortDirection: s,
                                    count: 20
                                }), e.audits.error = void 0, e.audits.totalToday = i.totalToday, e.audits.severeThisWeek = i.severeThisWeek;
                            } catch (e) {
                                const t = {
                                    name: "stats",
                                    error: e
                                };
                                console.error("failed to load stats - ", e), n(t);
                            }
                            var i;
                        }, o = async ()=>{
                            try {
                                a = await t.metadata.getAuditsMetadata(), e.audits.error = {}, e.audits.headerProps = a.properties, e.audits.themeAudits = a.theme ? a.theme.styles : {};
                            } catch (e) {
                                const t = {
                                    name: "metadata",
                                    error: e
                                };
                                console.error("failed to load metadata - ", e), n(t);
                            }
                            var a;
                        }, r = (e)=>e.reduce((e, t)=>(e[t.key] = t.value, e), {}), l = async (s)=>{
                            const { filters: i, sortBy: o, sortDirection: l, filter: c, offset: u, virtualScroll: d } = e.audits, { appendMode: g = d, onlyOneLoad: p = !0, offset: h = 0 } = s || {}, { rowsData: y } = g ? e.audits : {
                                rowsData: []
                            };
                            try {
                                const n = r(i), { data: s, total: g } = await t.audits.getAudits(v({}, d && {
                                    paginationMode: "virtual"
                                }, {
                                    sortDirection: l,
                                    sortBy: o,
                                    filter: c
                                }, n, {
                                    offset: d ? y.length + h || y.length + u : h || u,
                                    count: 20
                                }));
                                ((t)=>{
                                    e.audits.error = {}, e.audits.rowsData = t.rowsData, e.audits.lastUpdated = new Date, e.audits.total = t.total;
                                })({
                                    rowsData: [
                                        ...y,
                                        ...s
                                    ],
                                    total: g
                                }), p && a();
                            } catch (e) {
                                const t = {
                                    name: "audits",
                                    error: e
                                };
                                console.error("failed to load audits - ", e), n(t);
                            }
                        };
                        return {
                            initData: async ()=>{
                                e.audits.isLoading = !0, await Promise.all([
                                    i(),
                                    o(),
                                    l({
                                        onlyOneLoad: !1
                                    })
                                ]), a();
                            },
                            loadAudits: l,
                            removeFilter: async (t)=>{
                                const { filters: a } = e.audits, n = a.findIndex((e)=>e.key === t.key);
                                if (n < 0) return;
                                const i = [
                                    ...a.slice(0, n),
                                    ...a.slice(n + 1)
                                ];
                                s(i);
                            },
                            filterData: async (t)=>{
                                const { filters: a } = e.audits;
                                let n = a.findIndex((e)=>e.key === t.key);
                                n < 0 && (n = a.length);
                                const i = [
                                    ...a.slice(0, n),
                                    t,
                                    ...a.slice(n + 1)
                                ];
                                s(i);
                            },
                            exportCSV: async ()=>{
                                const { filters: a, sortBy: n, sortDirection: s, filter: i, headerProps: o = [] } = e.audits, l = r(a);
                                e.audits.isDownloadingCsv = !0;
                                try {
                                    await t.audits.exportAudits(v({
                                        endpoint: "csv/v2",
                                        headerProps: o,
                                        sortDirection: s,
                                        sortBy: n,
                                        filter: i
                                    }, l, {
                                        offset: 0,
                                        outputFileName: "audits.csv"
                                    }));
                                } catch (e) {
                                    console.error("failed to export audits - ", e);
                                } finally{
                                    e.audits.isDownloadingCsv = !1;
                                }
                            }
                        };
                    })(_, N);
                    return C.auth = t, C.connectivity = a, C.subscriptions = s, C.vendor = i, C.auditLogs = o, C.audits = r, Object.assign(D, v({}, e, a, n, i, o)), {
                        dispatch: (t)=>{
                            const [s, ...o] = t.type.split("/"), r = o.join("/");
                            "auth" === s && "function" == typeof e[r] ? e[r](t.payload) : "connectivity" === s && "function" == typeof a[r] ? a[r](t.payload) : "subscriptions" === s && "function" == typeof n[r] ? n[r](t.payload) : "vendor" === s && "function" == typeof i[r] && i[r](t.payload);
                        },
                        getState: ()=>_,
                        subscribe: (e)=>O(_, e),
                        subscribeStateChanged: (e)=>O(_, ()=>e(_)),
                        store: _,
                        actions: D,
                        stateActions: C
                    };
                }
            };
            let Xd, Zd, eg, tg, ag, ng, sg, ig, og, rg, lg, cg, ug, dg;
            !function(e) {
                e.phoneNumber = "phoneNumber", e.username = "username";
            }(Xd || (Xd = {})), function(e) {
                e.ALLOWED = "allowedCountries", e.BLOCKED = "blockedCountries";
            }(Zd || (Zd = {})), function(e) {
                e.Name = "name", e.Username = "username", e.PhoneNumber = "phoneNumber", e.Address = "address", e.JobTitle = "jobTitle";
            }(eg || (eg = {})), function(e) {
                e.LoginSessions = "loginSessions", e.Mfa = "mfa";
            }(tg || (tg = {})), function(e) {
                e.Name = "name", e.PhoneNumber = "phoneNumber", e.Username = "username";
            }(ag || (ag = {})), function(e) {
                e.CompanyName = "companyName", e.Address = "address", e.Website = "website", e.Timezone = "timezone", e.Currency = "currency";
            }(ng || (ng = {})), function(e) {
                e.FullName = "fullName", e.Email = "email", e.Groups = "groups", e.Roles = "roles", e.Status = "status", e.LastSeen = "lastSeen", e.ManagedBy = "managedBy", e.Username = "username", e.PhoneNumber = "phoneNumber";
            }(sg || (sg = {})), function(e) {
                e.Invoices = "invoices";
            }(ig || (ig = {})), function(e) {
                e.SessionManagement = "sessionManagement", e.GeneralSettings = "generalSettings", e.IpRestrictions = "ipRestrictions", e.DomainRestrictions = "domainRestrictions";
            }(og || (og = {})), function(e) {
                e.IdleSessionTimeout = "idleSessionTimeout", e.ForceReLogin = "forceReLogin", e.MaximumConcurrentSessions = "maximumConcurrentSessions";
            }(rg || (rg = {})), function(e) {
                e.Mfa = "mfa", e.UserLockout = "userLockout", e.PasswordHistory = "passwordHistory";
            }(lg || (lg = {})), function(e) {
                e.IpAddressRestrictions = "ipAddressRestrictions";
            }(cg || (cg = {})), function(e) {
                e.RestrictSignupByEmailDomain = "restrictSignupByEmailDomain";
            }(ug || (ug = {})), function(e) {
                e.Settings = "settings", e.CustomLogin = "customLogin";
            }(dg || (dg = {}));
            const gg = {
                hidden: "hidden",
                viewOnly: "viewOnly",
                edit: "edit"
            }, pg = {
                hidden: "hidden",
                edit: "edit"
            }, hg = {
                hidden: "hidden",
                always: "always"
            };
            function yg(e, t = 0, a = 1) {
                return Math.min(Math.max(t, e), a);
            }
            function Sg(e) {
                if (e.type) return e;
                if ("#" === e.charAt(0)) return Sg(function(e) {
                    e = e.substr(1);
                    const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
                    let a = e.match(t);
                    return a && 1 === a[0].length && (a = a.map((e)=>e + e)), a ? `rgb${4 === a.length ? "a" : ""}(${a.map((e, t)=>t < 3 ? parseInt(e, 16) : Math.round(parseInt(e, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
                }(e));
                const t = e.indexOf("("), a = e.substring(0, t);
                if (-1 === [
                    "rgb",
                    "rgba",
                    "hsl",
                    "hsla",
                    "color"
                ].indexOf(a)) throw new Error("MUI: Unsupported `%s` color.\nThe following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color(). " + e);
                const n = e.substring(t + 1, e.length - 1);
                let s, i;
                if ("color" === a) {
                    if (i = n.split(" "), s = i.shift(), 4 === i.length && "/" === i[3].charAt(0) && (i[3] = i[3].substr(1)), -1 === [
                        "srgb",
                        "display-p3",
                        "a98-rgb",
                        "prophoto-rgb",
                        "rec-2020"
                    ].indexOf(s)) throw new Error("MUI: unsupported `%s` color space.\nThe following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020." + s);
                } else i = n.split(",");
                return {
                    type: a,
                    values: i.map((e)=>parseFloat(e)),
                    colorSpace: s
                };
            }
            function vg(e) {
                const { type: t, colorSpace: a } = e;
                let { values: n } = e;
                return -1 !== t.indexOf("rgb") ? n = n.map((e, t)=>t < 3 ? parseInt(e, 10) : e) : -1 !== t.indexOf("hsl") && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), n = -1 !== t.indexOf("color") ? `${a} ${n.join(" ")}` : `${n.join(", ")}`, `${t}(${n})`;
            }
            function fg(e) {
                if (0 === e.indexOf("#")) return e;
                const { values: t } = Sg(e);
                return `#${t.map((e, t)=>(function(e) {
                        const t = e.toString(16);
                        return 1 === t.length ? `0${t}` : t;
                    })(3 === t ? Math.round(255 * e) : e)).join("")}`;
            }
            function mg(e, t) {
                return e = Sg(e), t = yg(t), "rgb" !== e.type && "hsl" !== e.type || (e.type += "a"), "color" === e.type ? e.values[3] = `/${t}` : e.values[3] = t, vg(e);
            }
            function bg(e, t) {
                if (e = Sg(e), t = yg(t), -1 !== e.type.indexOf("hsl")) e.values[2] *= 1 - t;
                else if (-1 !== e.type.indexOf("rgb") || -1 !== e.type.indexOf("color")) for(let a = 0; a < 3; a += 1)e.values[a] *= 1 - t;
                return vg(e);
            }
            function Ag(e, t) {
                if (e = Sg(e), t = yg(t), -1 !== e.type.indexOf("hsl")) e.values[2] += (100 - e.values[2]) * t;
                else if (-1 !== e.type.indexOf("rgb")) for(let a = 0; a < 3; a += 1)e.values[a] += (255 - e.values[a]) * t;
                else if (-1 !== e.type.indexOf("color")) for(let a = 0; a < 3; a += 1)e.values[a] += (1 - e.values[a]) * t;
                return vg(e);
            }
            const wg = (e)=>{
                if (e) return {
                    main: e,
                    light: fg(Ag(e, .4)),
                    dark: fg(bg(e, .15)),
                    hover: fg(bg(e, .15)),
                    active: fg(bg(e, .2))
                };
            }, Tg = (e)=>{
                if (e) return {
                    main: e,
                    light: Ag(e, .7),
                    dark: bg(e, .2)
                };
            }, Eg = (e, t)=>{
                var a, n, s, i, o, r, l, c, u, d, g, p;
                return null != e && e.palette && "string" == typeof (null == e || null == (a = e.palette) ? void 0 : a.primary) ? v({}, t, {
                    palette: {
                        primary: v({}, wg(null == e || null == (n = e.palette) ? void 0 : n.primary), {
                            contrastText: null != (s = null == e || null == (i = e.palette) ? void 0 : i.primaryText) ? s : "#000000"
                        }),
                        secondary: v({}, wg(null == e || null == (o = e.palette) ? void 0 : o.secondary), {
                            contrastText: null != (r = null == e || null == (l = e.palette) ? void 0 : l.secondaryText) ? r : "#000000"
                        }),
                        danger: v({}, wg(null == e || null == (c = e.palette) ? void 0 : c.error), {
                            contrastText: "#FFF"
                        }),
                        success: v({}, Tg(null == e || null == (u = e.palette) ? void 0 : u.success), {
                            contrastText: "#FFF"
                        }),
                        error: v({}, Tg(null == e || null == (d = e.palette) ? void 0 : d.error), {
                            contrastText: "#FFF"
                        }),
                        warning: v({}, Tg(null == e || null == (g = e.palette) ? void 0 : g.warning), {
                            contrastText: "#FFF"
                        }),
                        info: v({}, Tg(null == e || null == (p = e.palette) ? void 0 : p.info), {
                            contrastText: "#FFF"
                        })
                    }
                }) : {};
            }, Pg = {
                theme: {},
                themeV2: {},
                localizations: {},
                navigation: {
                    usage: {
                        visibility: "hidden",
                        permissions: [
                            "fe.usage.read"
                        ],
                        featureFlag: "fe-usage-page"
                    },
                    webhooks: {
                        visibility: "hidden",
                        permissions: [
                            "fe.connectivity.read.webhooks"
                        ]
                    },
                    roles: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.roles"
                        ]
                    },
                    users: {
                        visibility: "always",
                        permissions: [
                            "fe.secure.read.users"
                        ],
                        inviteDialog: {
                            phoneNumberField: "optional"
                        }
                    },
                    personalApiTokens: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.userApiTokens"
                        ]
                    },
                    apiTokens: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.tenantApiTokens"
                        ]
                    },
                    profile: {
                        visibility: "always"
                    },
                    privacy: {
                        visibility: "always"
                    },
                    account: {
                        visibility: "always",
                        permissions: [
                            "fe.secure.read.accountSettings"
                        ]
                    },
                    security: {
                        visibility: "always",
                        permissions: [
                            "fe.secure.read.securityPolicy"
                        ]
                    },
                    sso: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.samlConfiguration"
                        ]
                    },
                    provisioning: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.provisioningConfiguration"
                        ]
                    },
                    audits: {
                        visibility: "always",
                        permissions: [
                            "fe.secure.read.audits"
                        ]
                    },
                    subscriptions: {
                        visibility: "hidden",
                        permissions: [
                            "fe.subscriptions.*"
                        ]
                    },
                    allAccounts: {
                        visibility: "byPermissions",
                        permissions: [
                            "fe.account-hierarchy.read.subAccount"
                        ]
                    },
                    groups: {
                        visibility: "hidden",
                        permissions: [
                            "fe.secure.read.groups"
                        ]
                    }
                }
            };
            class Ig {
                constructor(){
                    this._theme = Pg.theme, this._themeV2 = Pg.themeV2, this._navigation = Pg.navigation, this._localizations = Pg.localizations, this._integrations = Pg.integrations;
                }
                static getInstance(e = "default") {
                    return this._instances[e];
                }
                static set(e, t = "default") {
                    const a = new Ig;
                    return a.set(e), Ig._instances[t] = a, a;
                }
                get theme() {
                    var e;
                    return null != (e = this._theme) ? e : {};
                }
                get themeV2() {
                    var e;
                    return null != (e = this._themeV2) ? e : {};
                }
                get navigation() {
                    var e;
                    return null != (e = this._navigation) ? e : {};
                }
                get localizations() {
                    var e;
                    return null != (e = this._localizations) ? e : {};
                }
                get integrations() {
                    var e;
                    return null != (e = this._integrations) ? e : {};
                }
                set(e) {
                    try {
                        var t, a, n, s, i, o, r, l, c;
                        this._navigation = pn().all([
                            null != (t = Pg.navigation) ? t : {},
                            null != (a = null == e ? void 0 : e.navigation) ? a : {}
                        ]), this._theme = pn().all([
                            null != (n = Pg.theme) ? n : {},
                            Eg(null == e ? void 0 : e.theme, Pg.theme)
                        ]), this._themeV2 = pn().all([
                            null != (s = Pg.themeV2) ? s : {},
                            null != (i = null == e ? void 0 : e.themeV2) ? i : {}
                        ]), this._localizations = pn().all([
                            null != (o = Pg.localizations) ? o : {},
                            null != (r = null == e ? void 0 : e.localizations) ? r : {}
                        ]), this._integrations = pn().all([
                            null != (l = Pg.integrations) ? l : {},
                            null != (c = null == e ? void 0 : e.integrations) ? c : {}
                        ]);
                    } catch (e) {
                        this._navigation = Pg.navigation, this._theme = Pg.theme, this._themeV2 = Pg.themeV2, this._localizations = Pg.localizations, this._integrations = Pg.integrations;
                    }
                }
            }
            Ig._instances = {};
            var Og = function(e) {
                return e.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map(function(e) {
                    return e.toLowerCase();
                }).join("");
            }, kg = function(e, t) {
                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = document.createElement(t);
                return Object.keys(a).forEach(function(e) {
                    return n.setAttribute(e, a[e]);
                }), e.appendChild(n), n;
            }, _g = function(e) {
                return new Promise(function(t, a) {
                    var n = 4e3, s = setInterval(function() {
                        return null != e.themeSetter ? (clearInterval(s), void t(!0)) : n < 0 ? (a("Failed to load Renderer with themeSetter"), void clearInterval(s)) : void (n -= 50);
                    }, 50);
                });
            }, Rg = function(e) {
                var t = e.toString();
                if (t) {
                    var a = new URL(window.location.href);
                    a.search = t, window.history.pushState(null, "", a.toString());
                }
            };
            const Ug = "7.99.0";
            var Lg = {
                admin_portal_ip_restrictions: "on",
                admin_portal_domain_restrictions: "on",
                "new-mfa-pages": "on",
                "show-passkeys-new": "on",
                "groups-admin-box-new": "on",
                "msp-all-accounts-new": "on",
                "temporary-users": "on"
            }, Cg = function(e) {
                var t, a = Ig.getInstance(e), n = null == a || null == (t = a.integrations) ? void 0 : t.gtm;
                null == n || n.filter(function(e) {
                    var t = e.id;
                    return e.enabled && /^GTM-[a-zA-Z0-9]+$/.test(t);
                }).forEach(function(e) {
                    var t = e.id, a = document.createElement("script");
                    a.innerHTML = "\n        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer','".concat(t, "');\n      "), document.body.appendChild(a);
                });
            }, Dg = function() {
                var e = p(y().mark(function e(t, a, n) {
                    var s, i, o, r;
                    return y().wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (i = null == (s = t.metadataOverrides) ? void 0 : s.url) {
                                    e.next = 3;
                                    break;
                                }
                                return e.abrupt("return", t);
                            case 3:
                                return e.prev = 3, e.next = 6, xn(function() {
                                    return a.sendRequest({
                                        url: i,
                                        method: "GET",
                                        credentials: "omit"
                                    });
                                }, n);
                            case 6:
                                if (!(o = e.sent)) {
                                    e.next = 10;
                                    break;
                                }
                                return r = pn()(t, o), e.abrupt("return", r);
                            case 10:
                                e.next = 15;
                                break;
                            case 12:
                                e.prev = 12, e.t0 = e.catch(3), console.error("Failed to get metadata overrides", e.t0);
                            case 15:
                                return e.abrupt("return", t);
                            case 16:
                            case "end":
                                return e.stop();
                        }
                    }, e, null, [
                        [
                            3,
                            12
                        ]
                    ]);
                }));
                return function(t, a, n) {
                    return e.apply(this, arguments);
                };
            }(), Ng = function() {
                function a(e, t) {
                    var n, s, o, r = this, l = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], u = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                    i(this, a), this.name = void 0, this.iframeRendering = void 0, this.options = void 0, this.loading = !0, this.cdnUrl = "https://assets.frontegg.com/admin-box/".concat(Ug), this.assetsUrl = "https://adminBox.frontegg.com/admin-box/".concat(Ug), this.customElementName = "", this.adminPortalEl = void 0, this.adminPortalRenderer = void 0, this.loginBoxEl = void 0, this.checkoutDialogEl = void 0, this.checkoutDialogRenderer = void 0, this.adminPortalContainer = void 0, this.loginBoxContainer = void 0, this.checkoutDialogContainer = void 0, this.loginBoxRenderer = void 0, this.store = void 0, this.loadingListeners = [], this.fetchClient = void 0, this.apiClient = void 0, this.updateLocalizations = void 0, this.loadAdminBoxMetadata = p(y().mark(function e() {
                        var t, a, n, s, i;
                        return y().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    if (r.options.metadata) {
                                        e.next = 21;
                                        break;
                                    }
                                    return e.prev = 1, e.next = 4, xn(function() {
                                        return r.fetchClient.get("/metadata", {
                                            entityName: "adminBox"
                                        });
                                    }, Nn);
                                case 4:
                                    return s = e.sent, i = null != (t = null == s || null == (a = s.rows) || null == (n = a[0]) ? void 0 : n.configuration) ? t : {}, e.prev = 6, e.next = 9, Dg(i, r.fetchClient, Nn);
                                case 9:
                                    r.options.metadata = e.sent, e.next = 15;
                                    break;
                                case 12:
                                    e.prev = 12, e.t0 = e.catch(6), console.error("failed to get admin portal overridden metadata", e.t0);
                                case 15:
                                    e.next = 21;
                                    break;
                                case 17:
                                    e.prev = 17, e.t1 = e.catch(1), console.error("failed to get admin portal metadata", e.t1), r.dispatchErrorByRequestName(e.t1, as.LOAD_ADMIN_BOX_METADATA);
                                case 21:
                                    Ig.set(r.options.metadata, r.name);
                                case 22:
                                case "end":
                                    return e.stop();
                            }
                        }, e, null, [
                            [
                                1,
                                17
                            ],
                            [
                                6,
                                12
                            ]
                        ]);
                    })), this.requestAuthorize = p(y().mark(function e() {
                        var t, a, n;
                        return y().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    n = null == (t = r.options.authOptions) || null == (a = t.hostedLoginOptions) ? void 0 : a.loadUserOnFirstLoad, r.options.builderMode || "nextjs" === r.options.framework || (r.options.hostedLoginBox && !r.options.customLoginBox ? n && r.store.dispatch({
                                        type: "auth/requestHostedLoginAuthorizeV2",
                                        payload: {
                                            shouldRedirectToLogin: !1,
                                            firstTime: !0
                                        }
                                    }) : r.store.dispatch({
                                        type: "auth/requestAuthorize",
                                        payload: !0
                                    }));
                                case 2:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    })), this.loadFeatureFlags = p(y().mark(function e() {
                        var t;
                        return y().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    if (!r.options.previewMode && !r.options.builderMode) {
                                        e.next = 4;
                                        break;
                                    }
                                    it.set(Lg, r.name), e.next = 16;
                                    break;
                                case 4:
                                    return e.prev = 4, e.next = 7, xn(function() {
                                        return r.apiClient.featureFlags.loadFeatureFlags();
                                    }, Nn);
                                case 7:
                                    t = e.sent, r.options.overrideFeatureFlags && Object.assign(t, r.options.overrideFeatureFlags), it.set(t, r.name), e.next = 16;
                                    break;
                                case 12:
                                    e.prev = 12, e.t0 = e.catch(4), console.error("failed to get admin portal feature flags", e.t0), r.dispatchErrorByRequestName(e.t0, as.LOAD_FEATURE_FLAGS);
                                case 16:
                                case "end":
                                    return e.stop();
                            }
                        }, e, null, [
                            [
                                4,
                                12
                            ]
                        ]);
                    })), this.setFeatureFlagsForPreview = function(e) {
                        it.set(Object.assign({}, Lg, e), r.name);
                    }, this.queryFeatureFlags = function(e) {
                        return it.getFeatureFlags(e, r.name);
                    }, this.updateLocalizationsSetter = function(e) {
                        r.updateLocalizations = e;
                    }, this.getEntitlementsFromStore = function() {
                        var e;
                        return null == (e = r.store.getState().auth.user) ? void 0 : e.entitlements;
                    }, this.getUserFromStore = function() {
                        return r.store.getState().auth.user;
                    }, this.getEntitlementsQueryData = function(e) {
                        var t = r.getUserFromStore();
                        return {
                            entitlements: r.getEntitlementsFromStore(),
                            attributes: {
                                custom: e,
                                jwt: t
                            }
                        };
                    }, this.createCMCRenderOptions = function(e, t) {
                        return {
                            injector: r,
                            options: r.options,
                            props: e,
                            themeOptions: t.themeOptions,
                            localizations: t.localizations,
                            containerStyle: t.containerStyle
                        };
                    }, this.renderUsersTable = function() {
                        var e = p(y().mark(function e(t, a, n) {
                            var s;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, r.loadScript("FronteggAdminPortal");
                                    case 2:
                                        return s = e.sent, e.abrupt("return", s.renderUsersTable(t, r.createCMCRenderOptions(a, n)));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t, a, n) {
                            return e.apply(this, arguments);
                        };
                    }(), this.renderInviteUserDialog = function() {
                        var e = p(y().mark(function e(t, a, n) {
                            var s;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, r.loadScript("FronteggAdminPortal");
                                    case 2:
                                        return s = e.sent, e.abrupt("return", s.renderInviteUserDialog(t, r.createCMCRenderOptions(a, n)));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t, a, n) {
                            return e.apply(this, arguments);
                        };
                    }(), this.renderChangePasswordForm = function() {
                        var e = p(y().mark(function e(t, a, n) {
                            var s;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, r.loadScript("FronteggAdminPortal");
                                    case 2:
                                        return s = e.sent, e.abrupt("return", s.renderChangePasswordForm(t, r.createCMCRenderOptions(a, n)));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t, a, n) {
                            return e.apply(this, arguments);
                        };
                    }(), this.renderProfilePage = function() {
                        var e = p(y().mark(function e(t, a, n) {
                            var s;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, r.loadScript("FronteggAdminPortal");
                                    case 2:
                                        return s = e.sent, e.abrupt("return", s.renderProfilePage(t, r.createCMCRenderOptions(a, n)));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t, a, n) {
                            return e.apply(this, arguments);
                        };
                    }(), this.renderEditEmailForm = function() {
                        var e = p(y().mark(function e(t, a, n) {
                            var s;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, r.loadScript("FronteggAdminPortal");
                                    case 2:
                                        return s = e.sent, e.abrupt("return", s.renderEditEmailForm(t, r.createCMCRenderOptions(a, n)));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t, a, n) {
                            return e.apply(this, arguments);
                        };
                    }(), this.getUsersTableStore = function() {
                        var e = p(y().mark(function e(t) {
                            var a;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, r.loadScript("FronteggAdminPortal");
                                    case 2:
                                        return a = e.sent, e.abrupt("return", a.useUsersTableStore(t));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t) {
                            return e.apply(this, arguments);
                        };
                    }(), this.getInviteUserDialogStore = function() {
                        var e = p(y().mark(function e(t) {
                            var a;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, r.loadScript("FronteggAdminPortal");
                                    case 2:
                                        return a = e.sent, e.abrupt("return", a.useInviteUserDialogStore(t));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t) {
                            return e.apply(this, arguments);
                        };
                    }();
                    var d = Og(t), g = "frontegg-app-".concat(d);
                    this.iframeRendering = l, this.name = d, this.options = Object.assign({}, e, {
                        contextOptions: Object.assign({
                            requestCredentials: "include"
                        }, e.contextOptions)
                    }), this.fetchClient = new He(this.name), this.apiClient = un(this.name), this.options.cdnUrl && (this.cdnUrl = this.options.cdnUrl), this.options.assetsUrl && (this.assetsUrl = this.options.assetsUrl), L.for(this.name).setCdnUrl(this.cdnUrl), L.for(this.name).setAssetsUrl(this.assetsUrl), this.customElementName = g;
                    var h, S, v = this.options.authOptions ? Object.assign({}, this.options.authOptions, {
                        hostedLoginBox: this.options.hostedLoginBox
                    }) : {
                        hostedLoginBox: this.options.hostedLoginBox
                    };
                    if (v.onRedirectTo = e.onRedirectTo, v.disableSilentRefresh = null == (n = this.options.authOptions) ? void 0 : n.disableSilentRefresh, this.options.store) {
                        if (this.store = this.options.store, !u && this.options.store.getState().root.appName !== t) throw Error("Mismatch in store names");
                    } else this.store = Qd({
                        context: this.options.contextOptions,
                        name: this.name,
                        builderMode: this.options.builderMode,
                        previewMode: this.options.previewMode,
                        storeHolder: this,
                        urlStrategy: this.options.urlStrategy,
                        initialState: {
                            auth: Object.assign({}, v, null != (h = this.options.authOptions) ? h : {}),
                            auditLogs: Object.assign({}, null != (S = this.options.auditsOptions) ? S : {})
                        }
                    });
                    c.setInstance(d, this);
                    var f = L.for(d);
                    f.setAppName(d), this.setEntitlementsOptions(e.entitlementsOptions), this.setSessionContext({
                        enableSessionPerTenant: null == (s = e.authOptions) ? void 0 : s.enableSessionPerTenant,
                        skipUserLoading: null == (o = e.authOptions) ? void 0 : o.skipUserLoading
                    });
                    var m = e.basename;
                    m && f.setBasename(m);
                }
                var n, o, r, u;
                return l(a, [
                    {
                        key: "setEntitlementsOptions",
                        value: function(e) {
                            L.for(this.name).setEntitlementsOptions(Object.assign({}, e));
                        }
                    },
                    {
                        key: "setSessionContext",
                        value: function(e) {
                            L.for(this.name).setSessionContext(Object.assign({}, e));
                        }
                    },
                    {
                        key: "dispatchErrorByRequestName",
                        value: function(e, t) {
                            (null == e ? void 0 : e.statusCode) < 500 || this.store.dispatch({
                                type: "auth/setErrorByRequestName",
                                payload: {
                                    requestName: t,
                                    traceId: Gn(e)
                                }
                            });
                        }
                    },
                    {
                        key: "initContainers",
                        value: (u = p(y().mark(function e(t) {
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        this.adminPortalEl = t.adminPortalEl, this.loginBoxEl = t.loginBoxEl, this.checkoutDialogEl = t.checkoutDialogEl, this.adminPortalContainer = t.adminPortalContainer, this.loginBoxContainer = t.loginBoxContainer, this.checkoutDialogContainer = t.checkoutDialogContainer;
                                        try {
                                            "nextjs" !== this.options.framework && document.body.classList.add("frontegg-loading");
                                        } catch (e) {
                                            console.error("Failed to add frontegg-loading to body classList");
                                        }
                                        return e.next = 9, Promise.all([
                                            this.loadFeatureFlags(),
                                            this.loadAdminBoxMetadata(),
                                            this.requestAuthorize()
                                        ]);
                                    case 9:
                                        this.options.previewMode || this.options.customLoginBox || (this.loadLoginBox(), Cg(this.name)), this.options.lazyLoadAdminPortal || this.loadScript("FronteggAdminPortal");
                                    case 11:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        })), function(e) {
                            return u.apply(this, arguments);
                        })
                    },
                    {
                        key: "updateMetadata",
                        value: function(e) {
                            var t;
                            Ig.set(e, this.name), null != e && e.localizations && (null == (t = this.updateLocalizations) || t.call(this, e.localizations));
                        }
                    },
                    {
                        key: "addOnLoadedListener",
                        value: function(e) {
                            this.loading ? this.loadingListeners.push(e) : e();
                        }
                    },
                    {
                        key: "ready",
                        value: function(e) {
                            this.loading ? e() : this.addOnLoadedListener(e);
                        }
                    },
                    {
                        key: "loginWithRedirect",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            this.store.dispatch({
                                type: "auth/setState",
                                payload: {
                                    isLoading: !0
                                }
                            }), this.store.dispatch({
                                type: "auth/requestHostedLoginAuthorize",
                                payload: e
                            });
                        }
                    },
                    {
                        key: "loginWithRedirectV2",
                        value: function(e) {
                            this.store.dispatch({
                                type: "auth/requestHostedLoginAuthorizeV2",
                                payload: e
                            });
                        }
                    },
                    {
                        key: "logout",
                        value: function(e) {
                            this.store.dispatch({
                                type: "auth/setState",
                                payload: {
                                    isLoading: !0
                                }
                            }), this.store.dispatch({
                                type: "auth/logout",
                                payload: e
                            });
                        }
                    },
                    {
                        key: "loadScript",
                        value: function(a) {
                            var n = this;
                            return new Promise(function(i, o) {
                                var r = window;
                                if (r[a]) i(r[a]);
                                else {
                                    var l = document.createElement("script");
                                    l.src = "".concat(n.cdnUrl, "/").concat({
                                        FronteggLoginBox: "login-box/index.js",
                                        FronteggAdminPortal: "admin-portal/index.js"
                                    }[a]), l.setAttribute("id", "".concat(a, "Script")), l.setAttribute("cdn-url", n.cdnUrl), l.onload = function() {
                                        r["".concat(a, "Init")] ? i(r["".concat(a, "Init")]({
                                            FronteggRestApi: e,
                                            FronteggTypes: s,
                                            FronteggReduxStore: t
                                        })) : i(r[a]);
                                    }, l.onerror = function(e) {
                                        console.log("Profile page error", e), o(e);
                                    }, document.body.append(l);
                                }
                            });
                        }
                    },
                    {
                        key: "loadLoginBox",
                        value: (r = p(y().mark(function e() {
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, this.loadScript("FronteggLoginBox");
                                    case 2:
                                        e.sent.render(this.loginBoxEl, {
                                            injector: this,
                                            options: this.options
                                        }), this.loading = !1, this.loadingListeners.forEach(function(e) {
                                            try {
                                                e();
                                            } catch (e) {
                                                console.error("Failed to call loadLoginBoxListener", e);
                                            }
                                        }), this.loadingListeners = [];
                                    case 7:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        })), function() {
                            return r.apply(this, arguments);
                        })
                    },
                    {
                        key: "showAdminPortal",
                        value: (o = p(y().mark(function e(t) {
                            var a, n, s, i, o;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return a = (null != t ? t : {
                                            isMultiApp: !1
                                        }).isMultiApp, n = this.queryFeatureFlags([
                                            "multi-apps-admin-portal"
                                        ]), s = d(n, 1), i = s[0], L.for(this.name).setRequestSource(Be.AdminPortal), e.next = 5, this.loadScript("FronteggAdminPortal");
                                    case 5:
                                        o = e.sent, this.adminPortalRenderer = o.render(this.adminPortalEl, {
                                            injector: this,
                                            options: Object.assign({
                                                isMultiApp: i && a
                                            }, this.options)
                                        });
                                    case 7:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        })), function(e) {
                            return o.apply(this, arguments);
                        })
                    },
                    {
                        key: "openHostedAdminPortal",
                        value: function() {
                            var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], t = this.options.contextOptions.baseUrl, a = "".concat(t, "/oauth/portal");
                            e ? window.open(a, "_blank") : window.location.href = a;
                        }
                    },
                    {
                        key: "hideAdminPortal",
                        value: function() {
                            try {
                                var e, t = new URLSearchParams(window.location.search);
                                null == (e = this.adminPortalRenderer) || e.unmount(), Rg(t), L.for(this.name).setRequestSource(null);
                            } catch (e) {
                                console.error("Failed to unmount admin portal", e);
                            }
                        }
                    },
                    {
                        key: "showCheckoutDialog",
                        value: (n = p(y().mark(function e(t) {
                            var a;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, this.loadScript("FronteggAdminPortal");
                                    case 2:
                                        a = e.sent, this.checkoutDialogRenderer = a.renderCheckoutDialog(this.checkoutDialogEl, Object.assign({
                                            injector: this
                                        }, t, {
                                            options: this.options
                                        }));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        })), function(e) {
                            return n.apply(this, arguments);
                        })
                    },
                    {
                        key: "hideCheckoutDialog",
                        value: function() {
                            try {
                                var e;
                                null == (e = this.checkoutDialogRenderer) || e.unmount();
                            } catch (e) {
                                console.error("Failed to unmount checkout dialog", e);
                            }
                        }
                    },
                    {
                        key: "getFeatureEntitlements",
                        value: function(e, t) {
                            var a = this.getEntitlementsQueryData(t), n = a.entitlements, s = a.attributes;
                            return Ao(n, e, s);
                        }
                    },
                    {
                        key: "getPermissionEntitlements",
                        value: function(e, t) {
                            var a = this.getEntitlementsQueryData(t), n = a.entitlements, s = a.attributes;
                            return bo(n, e, s);
                        }
                    },
                    {
                        key: "getEntitlements",
                        value: function(e, t) {
                            return "permissionKey" in e ? this.getPermissionEntitlements(e.permissionKey, t) : this.getFeatureEntitlements(e.featureKey, t);
                        }
                    },
                    {
                        key: "loadEntitlements",
                        value: function(e) {
                            this.store.dispatch({
                                type: "auth/loadEntitlements",
                                payload: {
                                    callback: e
                                }
                            });
                        }
                    },
                    {
                        key: "stepUp",
                        value: function(e) {
                            var t = this.store.getState(), a = (null == t ? void 0 : t.auth) || {}, n = a.hostedLoginBox, s = a.routes.stepUpUrl;
                            n ? this.store.dispatch({
                                type: "auth/stepUpHostedLogin",
                                payload: e
                            }) : Is(s, t.auth.onRedirectTo, null == e ? void 0 : e.maxAge);
                        }
                    },
                    {
                        key: "isSteppedUp",
                        value: function() {
                            var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = ((null == (e = this.store.getState()) ? void 0 : e.auth) || {}).user;
                            return Es(a, t);
                        }
                    },
                    {
                        key: "switchTenant",
                        value: function(e) {
                            this.store.dispatch({
                                type: "auth/switchTenant",
                                payload: e
                            });
                        }
                    },
                    {
                        key: "close",
                        value: function() {
                            this.hideAdminPortal(), this.hideCheckoutDialog();
                        }
                    }
                ]), a;
            }(), Mg = function() {
                function e() {
                    i(this, e);
                }
                return l(e, null, [
                    {
                        key: "setAuthentication",
                        value: function(e, t, a) {
                            var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "default", s = c.getInstance(n), i = L.for(n);
                            e && t ? (i.setAccessToken(t), i.setUser(Object.assign({}, a, {
                                accessToken: t
                            })), s.store.actions.setAuthState({
                                isLoading: !1,
                                isAuthenticated: e,
                                user: a
                            }), s.store.actions.loadTenants()) : (i.setAccessToken(null), i.setUser(null), s.store.actions.setAuthState({
                                isLoading: !1,
                                isAuthenticated: !1,
                                user: null
                            }));
                        }
                    }
                ]), e;
            }(), Fg = function() {
                function e() {
                    i(this, e);
                }
                return l(e, null, [
                    {
                        key: "show",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
                            c.getInstance(e).showAdminPortal();
                        }
                    },
                    {
                        key: "showMultiApp",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
                            c.getInstance(e).showAdminPortal({
                                isMultiApp: !0
                            });
                        }
                    },
                    {
                        key: "openHosted",
                        value: function() {
                            var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                            c.getInstance(t).openHostedAdminPortal(e);
                        }
                    },
                    {
                        key: "hide",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
                            c.getInstance(e).hideAdminPortal();
                        }
                    }
                ]), e;
            }(), xg = function() {
                function e() {
                    i(this, e);
                }
                return l(e, null, [
                    {
                        key: "show",
                        value: function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                            c.getInstance(t).showCheckoutDialog(e);
                        }
                    },
                    {
                        key: "hide",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
                            c.getInstance(e).hideCheckoutDialog();
                        }
                    }
                ]), e;
            }(), $g = function(e) {
                var t;
                return null != (t = window.FronteggAdminPortal.adminPortalStaticThemesDefaults[e]) ? t : void 0;
            }, Gg = function() {
                function e(t, a, n, s) {
                    var o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
                    i(this, e), this.app = void 0, this.options = void 0, this.store = void 0, this.setRoute = function() {}, this.themeSetter = void 0, this.localizationsSetter = void 0, this.themeOptions = {}, this.localizations = {};
                    var l = {
                        baseUrl: "preview"
                    };
                    if (n) {
                        if (this.store = n, !o && n.getState().root.appName !== t) throw Error("Mismatch in store names");
                    } else this.store = Jd({
                        context: l,
                        appName: t
                    }, this, !0, void 0, void 0, !0);
                    this.themeOptions = a, this.localizations = r, this.options = Object.assign({
                        themeOptions: a,
                        localizations: r,
                        iframeRendering: !0,
                        metadata: {},
                        previewMode: !0,
                        builderMode: !0,
                        store: this.store,
                        contextOptions: l
                    }, s), this.app = new Ng(this.options, t, !0), Ig.set({}, t);
                }
                var t;
                return l(e, [
                    {
                        key: "render",
                        value: (t = p(y().mark(function e(t) {
                            var a, n, s, i, o, r = this;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return (a = t.querySelector("#root")) || ((a = t.ownerDocument.createElement("div")).setAttribute("id", "root"), t.appendChild(a)), this.app.adminPortalContainer = t, this.app.adminPortalEl = a, n = function(e) {
                                            r.themeSetter = e;
                                        }, s = function(e) {
                                            r.localizationsSetter = e;
                                        }, i = function(e) {
                                            r.setRoute = e;
                                        }, e.next = 9, this.app.loadScript("FronteggAdminPortal");
                                    case 9:
                                        return o = e.sent, this.app.adminPortalRenderer = o.renderPage(a, {
                                            options: this.options,
                                            injector: this.app,
                                            setThemeSetter: n,
                                            setStaticRouteSetter: i,
                                            setLocalizationsSetter: s
                                        }), this.app.loading = !1, e.next = 14, _g(this);
                                    case 14:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        })), function(e) {
                            return t.apply(this, arguments);
                        })
                    },
                    {
                        key: "unmount",
                        value: function() {
                            try {
                                var e;
                                null == (e = this.app.adminPortalRenderer) || e.unmount();
                            } catch (e) {
                                console.error("Failed to unmount admin Portal renderer", e);
                            }
                        }
                    },
                    {
                        key: "setTheme",
                        value: function(e) {
                            var t;
                            this.themeOptions = e, this.themeSetter || console.warn("this.themeSetter is not defined yet"), null == (t = this.themeSetter) || t.call(this, this.themeOptions);
                        }
                    },
                    {
                        key: "setLocalization",
                        value: function(e) {
                            var t;
                            this.localizations = e, this.localizationsSetter || console.warn("this.localizationsSetter is not defined yet"), null == (t = this.localizationsSetter) || t.call(this, this.localizations);
                        }
                    },
                    {
                        key: "setStaticRoute",
                        value: function(e) {
                            var t;
                            this.setRoute || console.warn("this.setRoute is not defined yet"), null == (t = this.setRoute) || t.call(this, e);
                        }
                    }
                ]), e;
            }(), jg = "modern", Vg = function(e) {
                var t, a = window.FronteggAdminPortal.themes;
                return null != (t = a[e]) ? t : a[jg];
            }, Bg = function() {
                function e(t, a, n, s) {
                    var o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
                    i(this, e), this.app = void 0, this.options = void 0, this.store = void 0, this.themeSetter = void 0, this.localizationsSetter = void 0, this.setRoute = function() {}, this.themeOptions = {}, this.localizations = {};
                    var l = {
                        baseUrl: "preview"
                    };
                    if (n) {
                        if (this.store = n, !o && n.getState().root.appName !== t) throw Error("Mismatch in store names");
                    } else this.store = Jd({
                        context: l,
                        appName: t
                    }, this, !0, void 0, void 0, !0);
                    this.themeOptions = a, this.localizations = r, this.options = Object.assign({
                        themeOptions: a,
                        localizations: r,
                        iframeRendering: !0,
                        metadata: {},
                        previewMode: !0,
                        builderMode: !0,
                        store: this.store,
                        contextOptions: l,
                        onRedirectTo: function() {
                            console.debug("path");
                        }
                    }, s), this.app = new Ng(this.options, t, !0, o), Ig.set({}, t);
                }
                var t;
                return l(e, [
                    {
                        key: "render",
                        value: (t = p(y().mark(function e(t) {
                            var a, n, s, i, o, r, l = this, c = arguments;
                            return y().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return a = c.length > 1 && void 0 !== c[1] ? c[1] : "/account/login", (n = t.querySelector("#root")) || ((n = t.ownerDocument.createElement("div")).setAttribute("id", "root"), t.appendChild(n)), this.app.loginBoxContainer = t, this.app.loginBoxEl = n, s = function(e) {
                                            l.themeSetter = e;
                                        }, i = function(e) {
                                            l.localizationsSetter = e;
                                        }, o = function(e) {
                                            l.setRoute = e;
                                        }, e.next = 10, this.app.loadScript("FronteggLoginBox");
                                    case 10:
                                        return r = e.sent, this.app.loginBoxRenderer = r.renderPage(n, {
                                            options: this.options,
                                            injector: this.app,
                                            setThemeSetter: s,
                                            setStaticRouteSetter: o,
                                            setLocalizationsSetter: i,
                                            onFiberUpdateListener: this.options.onFiberUpdateListener,
                                            staticRoute: a
                                        }), e.next = 14, _g(this);
                                    case 14:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        })), function(e) {
                            return t.apply(this, arguments);
                        })
                    },
                    {
                        key: "unmount",
                        value: function() {
                            try {
                                var e;
                                null == (e = this.app.loginBoxRenderer) || e.unmount();
                            } catch (e) {
                                console.error("Failed to unmount login box renderer", e);
                            }
                        }
                    },
                    {
                        key: "setTheme",
                        value: function(e) {
                            var t;
                            this.themeOptions = e, this.themeSetter || console.warn("this.themeSetter is not defined yet"), null == (t = this.themeSetter) || t.call(this, this.themeOptions);
                        }
                    },
                    {
                        key: "setLocalization",
                        value: function(e) {
                            var t;
                            this.localizations = e, this.localizationsSetter || console.warn("this.localizationsSetter is not defined yet"), null == (t = this.localizationsSetter) || t.call(this, this.localizations);
                        }
                    },
                    {
                        key: "setStaticRoute",
                        value: function(e) {
                            var t;
                            this.setRoute || console.warn("this.setRoute is not defined yet"), null == (t = this.setRoute) || t.call(this, e);
                        }
                    },
                    {
                        key: "setStore",
                        value: function(e) {
                            this.store.dispatch({
                                type: "auth/setState",
                                payload: e
                            });
                        }
                    }
                ]), e;
            }();
            function Wg(e, t) {
                return Wg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, Wg(e, t);
            }
            function zg(e) {
                return zg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, zg(e);
            }
            function Hg(e, t, a) {
                return Hg = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }() ? Reflect.construct.bind() : function(e, t, a) {
                    var n = [
                        null
                    ];
                    n.push.apply(n, t);
                    var s = new (Function.bind.apply(e, n));
                    return a && Wg(s, a.prototype), s;
                }, Hg.apply(null, arguments);
            }
            function Kg(e) {
                var t = "function" == typeof Map ? new Map : void 0;
                return Kg = function(e) {
                    if (null === e || (a = e, -1 === Function.toString.call(a).indexOf("[native code]"))) return e;
                    var a;
                    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== t) {
                        if (t.has(e)) return t.get(e);
                        t.set(e, n);
                    }
                    function n() {
                        return Hg(e, arguments, zg(this).constructor);
                    }
                    return n.prototype = Object.create(e.prototype, {
                        constructor: {
                            value: n,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Wg(n, e);
                }, Kg(e);
            }
            function qg(e) {
                var t = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var a, n = zg(e);
                    if (t) {
                        var s = zg(this).constructor;
                        a = Reflect.construct(n, arguments, s);
                    } else a = n.apply(this, arguments);
                    return function(e, t) {
                        if (t && ("object" === o(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }(this, a);
                };
            }
            var Yg = function(e) {
                var t = new Ng(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default");
                if ("undefined" != typeof document) {
                    var a;
                    if (!e.contextOptions.baseUrl) {
                        var n = new Error('Edit <FronteggProvider/> options { ContextOptions: { baseUrl: "" } } in order to connect your application');
                        throw document.body.innerHTML = "", alert(n.message), n;
                    }
                    if (!customElements.get("frontegg-app")) {
                        var s = function(t) {
                            !function(e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), Object.defineProperty(e, "prototype", {
                                    writable: !1
                                }), t && Wg(e, t);
                            }(n, t);
                            var a = qg(n);
                            function n() {
                                var e;
                                i(this, n);
                                for(var t = arguments.length, s = new Array(t), o = 0; o < t; o++)s[o] = arguments[o];
                                return (e = a.call.apply(a, [
                                    this
                                ].concat(s))).app = null, e;
                            }
                            return l(n, [
                                {
                                    key: "connectedCallback",
                                    value: function() {
                                        this.updateContent();
                                    }
                                },
                                {
                                    key: "attributeChangedCallback",
                                    value: function(e, t, a) {
                                        if ("app-name" === e) {
                                            if (null === t) return;
                                            if (t === a) return;
                                            this.innerHTML = "", null === a ? this.remove() : this.updateContent();
                                        }
                                        console.debug("attributeChangedCallback", e, t, a);
                                    }
                                },
                                {
                                    key: "updateContent",
                                    value: function() {
                                        var t, a = null != (t = this.getAttribute("app-name")) ? t : "default", n = c.getInstance(a);
                                        if (null === n) throw Error("FronteggApp not found for appName: '".concat(a, "'"));
                                        this.setAttribute("id", "frontegg-app-".concat(n.name));
                                        var s = kg(this, "div", {
                                            id: "frontegg-admin-portal-container-".concat(n.name)
                                        }), i = kg(this, "div", {
                                            id: "frontegg-login-box-container-".concat(n.name)
                                        }), o = kg(this, "div", {
                                            id: "frontegg-checkout-dialog-container-".concat(n.name)
                                        }), r = s.attachShadow({
                                            mode: "open"
                                        }), l = e.iframeRendering ? i : i.attachShadow({
                                            mode: "open"
                                        }), u = o.attachShadow({
                                            mode: "open"
                                        }), d = kg(r, "div", {
                                            id: "frontegg-admin-portal-".concat(n.name),
                                            class: "frontegg-root-content"
                                        }), g = kg(l, "div", {
                                            id: "frontegg-login-box-".concat(n.name),
                                            class: "frontegg-root-content"
                                        }), p = kg(u, "div", {
                                            id: "frontegg-checkout-dialog-".concat(n.name),
                                            class: "frontegg-root-content"
                                        });
                                        n.initContainers({
                                            adminPortalEl: d,
                                            loginBoxEl: g,
                                            adminPortalContainer: s,
                                            loginBoxContainer: i,
                                            checkoutDialogContainer: o,
                                            checkoutDialogEl: p
                                        });
                                    }
                                }
                            ], [
                                {
                                    key: "observedAttributes",
                                    get: function() {
                                        return [
                                            "app-name"
                                        ];
                                    }
                                }
                            ]), n;
                        }(Kg(HTMLElement));
                        customElements.define("frontegg-app", s);
                    }
                    null == (a = document.querySelector('frontegg-app[app-name="'.concat(t.name, '"]'))) || a.remove();
                    var o = document.createElement("frontegg-app");
                    o.setAttribute("app-name", t.name), document.body.appendChild(o);
                }
                return t;
            };
        })(), n;
    })());

//# sourceMappingURL=provider-portal.9f2c9a2e.js.map
